// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27%23888%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 11L3 6h10l-5 5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27%23666%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 11L3 6h10l-5 5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ====================================
   P2P Module Styles
   All styles are scoped with .p2p- prefix
   to avoid conflicts with other project CSS
   
   Theme Color: #ffdc88 (Yellow/Gold - Dark Theme), #F4B609 (Yellow - Light Theme)
   Color Palette:
   - Primary (Dark): #ffdc88
   - Primary (Light): #F4B609
   - Primary Dark: #f4b609
   - Primary Light: #bd83cb
   ==================================== */

/* ====================================
   P2P Layout Styles
   ==================================== */

.p2p-layout-wrapper {
  display: flex;
  min-height: 100vh;
  background-color: #0a0a0f;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.p2p-main-content {
  flex: 1 1;
  margin-left: 260px;
  transition: margin-left 0.3s ease;
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.p2p-main-content.p2p-mobile {
  margin-left: 0;
}

.p2p-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background-color: rgba(13, 13, 20, 0.95);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;
}

.p2p-hamburger {
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.p2p-hamburger:hover {
  background-color: rgba(166, 95, 255, 0.2);
}

.p2p-hamburger-line {
  width: 20px;
  height: 2px;
  background-color: #fff;
  border-radius: 2px;
}

.p2p-mobile-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.p2p-mobile-logo-icon {
  width: 32px;
  height: 32px;
  background-color: #ffdc88;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p2p-mobile-logo-text {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.p2p-page-title {
  font-size: 12px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.p2p-page-content {
  padding: 30px 20px 20px;
  max-width: 1200px;
  margin: 0 auto;
  color: #fff;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.p2p-spacer {
  width: 40px;
}

@media (max-width: 991.98px) {
  .p2p-main-content {
    margin-left: 0;
  }
}

/* ====================================
     P2P Sidebar Styles
     ==================================== */

.p2p-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 998;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}


h4.p2p-profile-tab {
  background-color: transparent;
  border: none;
  cursor: default;
  padding: 0px;
  color: #cfcfcf;
}

h4.p2p-profile-tab:hover {
  background-color: transparent;
}

.p2p-sidebar-overlay.p2p-visible {
  opacity: 1;
  visibility: visible;
}

.p2p-sidebar {
  position: fixed;
  left: 0;
  top: 40px;
  bottom: 0;
  width: 260px;
  background: transparent;
  z-index: 999;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
  overflow-y: auto;
}

.p2p-sidebar.p2p-closed {
  transform: translateX(-100%);
}

.p2p-sidebar-logo {
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.p2p-sidebar-logo a {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.p2p-logo-icon {
  width: 38px;
  height: 38px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p2p-logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.5px;
}

.p2p-sidebar-nav {
  padding: 16px 12px 16px 0px;
  flex: 1 1;
}

.p2p-nav-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 16px 16px 16px 54px;
  border-radius: 0px 16px 16px 0px;
  color: #9ca3af;
  text-decoration: none;
  font-size: 15px;
  font-weight: 400;
  transition: all 0.2s ease;
  margin-bottom: 4px;
}

.p2p-nav-item:hover {
  background-color: #2B313C;
  color: #fff;
}

.p2p-nav-item.active {
  background: #2B313C;
  color: #ffffff;
  border-left: #2B313C;
  margin-left: 0px;
}

.p2p-nav-item.active .p2p-nav-icon {
  color: #ffffff;
}

.p2p-nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: inherit;
}

.p2p-sidebar-close {
  position: absolute;
  top: 16px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: background 0.2s ease;
}

.p2p-sidebar-close:hover {
  background: rgba(255, 220, 136, 0.2);
}

.p2p-sidebar-footer {
  padding: 16px;
  /* border-top: 1px solid rgba(255, 255, 255, 0.04); */
}

.p2p-back-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #9ca3af;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.p2p-back-link:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

/* Sidebar Scrollbar */
.p2p-sidebar::-webkit-scrollbar {
  width: 4px;
}

.p2p-sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.p2p-sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

.selectpaymetpop.modal.fade .modal-dialog {
  width: 480px;
  min-width: 480px;
}

.p2p-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* ====================================
     P2P Dashboard Styles
     ==================================== */

.p2p-dashboard-container {
  max-width: 100%;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  overflow-x: hidden;
}

/* Buy/Sell Toggle */
.p2p-buy-sell-toggle {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.p2p-toggle-wrapper {
  display: flex;
  background: #2B313C;
  border-radius: 6px;
  padding: 4px;
  gap: 4px;
}

.p2p-toggle-btn {
  padding: 7px 48px;
  border: none;
  width: 136px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  color: #87909F;

}

.p2p-dashboard-container input:focus {
  border: 1px solid #ffffff00 !important;
}

.p2p-dashboard-container select:focus-visible {
  outline: none !important;
}

.binance-chat-input input:focus {
  border: none !important;
}

.p2p-layout-wrapper button:disabled {
  background-color: #181a1f81 !important;
  color: #fff;
}

.p2p-toggle-btn.p2p-active-buy {
  background: #5EBA89;
  color: #fff;
}

.p2p-toggle-btn.p2p-active-sell {
  background: #E45561;
  color: #fff;
}

.p2p-toggle-btn.p2p-active-buy:hover {
  background: #5EBA89;
}

.p2p-toggle-btn:hover:not(.p2p-active-buy):not(.p2p-active-sell) {
  color: #fff;
  background: rgba(34, 197, 94, 0.1);
}

/* Filter Section */
.p2p-filter-section {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
  margin-bottom: 20px;
  padding: 0 8px;
}

.p2p-filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
  min-width: 150px;
}

.p2p-filter-label {
  font-size: 12px;
  color: #c9c9c9;
  /* text-transform: uppercase; */
  letter-spacing: 0.5px;
}

.p2p-filter-select {
  padding: 12px 16px;
  background: #2B313C;
  border: 1px solid #2B313C;
  border-radius: 8px;
  color: #A2A9B6;
  font-size: 13px;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 16px center;
  padding-right: 40px;
}

.p2p-filter-select:focus {
  outline: none;
  border-color: #ffdc88;
}

.p2p-find-orders-btn {
  padding: 12px 32px;
  background: #2b313c;
  border: 1px solid #2b313c;
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.p2p-find-orders-btn:hover {
  background: rgba(255, 220, 136, 0.1);
  border-color: #ffdc88;
}

/* Table Section */
.p2p-orders-table-wrapper {
  background: #2B313C;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #2B313C;
}

.p2p-orders-table {
  width: 100%;
  border-collapse: collapse;
}

.p2p-orders-table thead {
  background: #2B313C;
}

.p2p-orders-table th {
  padding: 10px 10px;
  text-align: left;
  font-size: 13px;
  font-weight: 400;
  color: #949AA4;
  border-bottom: 1px solid #454C59;
}

.p2p-orders-table th:last-child {
  text-align: right;
}

.p2p-trade-fee-badge {
  background: rgba(255, 220, 136, 0.15);
  color: #F3BB2B;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  margin-left: 8px;
}

.p2p-orders-table tbody tr {
  border-bottom: 1px solid #1e1e2d;
  transition: background 0.2s ease;
  cursor: pointer;
}

.p2p-orders-table tbody tr:hover {
  background: rgba(255, 220, 136, 0.05);
}

.p2p-orders-table tbody tr:last-child {
  border-bottom: none;
}

.p2p-orders-table td {
  padding: 20px;
  vertical-align: middle;
}

/* Advertiser Cell */
.p2p-advertiser-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-advertiser-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
}

.p2p-advertiser-info h4 {
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0 0 4px 0;
}

.p2p-advertiser-stats {
  font-size: 12px;
  color: #aaa;
  margin-bottom: 4px;
}

.p2p-advertiser-rating {
  display: flex;
  align-items: center;
  gap: 4px;
}

.p2p-star-icon {
  color: #fbbf24;
  font-size: 12px;
}

.p2p-rating-value {
  font-size: 12px;
  color: #a8b4c4;
  font-weight: 500;
}

/* Price Cell */
.p2p-price-value {
  font-size: 16px;
  font-weight: 500;
  color: #eaecef;
}

/* Limit Cell */
.p2p-limit-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.p2p-limit-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.p2p-limit-label {
  font-size: 12px;
  color: #aaa;
  min-width: 55px;
}

.p2p-limit-value {
  font-size: 13px;
  color: #eaecef;
}

/* Payment Cell */
.p2p-payment-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.p2p-payment-badge {
  padding: 6px 12px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.2);
  border-radius: 6px;
  font-size: 12px;
  color: #eaecef;
}

/* Trade Cell */
.p2p-trade-cell {
  text-align: right;
}

.p2p-buy-btn {
  padding: 10px 24px;
  background: #22c55e;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.p2p-buy-btn:hover {
  background: #16a34a;
}

.p2p-sell-btn {
  padding: 10px 24px;
  background: #ef4444;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.p2p-sell-btn:hover {
  background: #dc2626;
}

/* Pagination */
.p2p-pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 0px 10px;
  background: none;
  border-top: none;
  flex-wrap: wrap;
}

.p2p-pagination-info {
  font-size: 12px;
  color: #6b7280;
}

.p2p-pagination-buttons,
.p2p-pagination-controls {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.p2p-page-current {
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #e5e5e5;
  background: rgba(255, 220, 136, 0.2);
  border-radius: 6px;
}

.p2p-page-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a1a24;
  border: 1px solid #2a2a3a;
  border-radius: 6px;
  color: #888;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-page-btn:hover {
  border-color: #ffdc88;
  color: #fff;
}

.p2p-page-btn.p2p-active {
  background: #363c47;
  border-color: #363c47;
  color: #fff;
}

.p2p-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.p2p-page-dots {
  color: #aaa;
  padding: 0 8px;
}

/* Expanded Row */
/* .p2p-expanded-row {
    background: #0d0d14 !important;
  } */

.p2p-expanded-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  padding: 24px;
}

.p2p-expanded-left {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.p2p-expanded-user-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.p2p-expanded-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #fff;
  font-size: 18px;
  flex-shrink: 0;
}

.p2p-expanded-user-details h5 {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.p2p-expanded-user-details p {
  font-size: 13px;
  color: #aaa;
  margin: 0;
}

.p2p-expanded-stats {
  display: flex;
  gap: 24px;
}

.p2p-stat-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.p2p-stat-value {
  font-size: 15px;
  font-weight: 600;
  color: #a8b4c4;
}

.p2p-stat-label {
  font-size: 12px;
  color: #aaa;
}

.p2p-expanded-payments h6 {
  font-size: 13px;
  color: #888;
  margin: 0 0 12px 0;
}

.p2p-expanded-payment-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.p2p-expanded-payment-badge {
  padding: 6px 13px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.2);
  border-radius: 6px;
  font-size: 12px;
  color: #bd83cb;
}

.p2p-expanded-remarks h6 {
  font-size: 13px;
  color: #888;
  margin: 0 0 8px 0;
}

.p2p-expanded-remarks p {
  font-size: 13px;
  color: #ccc;
  margin: 0;
}

.p2p-expanded-right {
  background: transparent;
  border-radius: 12px;
  padding: 0;
  min-width: 320px;
}

.p2p-expanded-form-group {
  margin-bottom: 12px;
}

.p2p-expanded-form-group.has-error .p2p-input-header {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.08);
}

.p2p-expanded-form-group.has-error .p2p-expanded-input-wrapper {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}

.p2p-expanded-form-group.has-error .p2p-payment-selector-full,
.p2p-expanded-form-group.has-error .p2p-payment-selector {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}

.p2p-input-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding: 16px 20px 8px;
  background: #1a1a22;
  border-radius: 12px 12px 0 0;
  border: 1px solid #2a2a3a;
  border-bottom: none;
}

.p2p-input-header label {
  font-size: 13px;
  color: #888;
  margin: 0;
}

.p2p-input-range {
  font-size: 12px;
  color: #aaa;
}

.p2p-expanded-input-wrapper {
  display: flex;
  align-items: center;
  background: #1a1a22;
  border: 1px solid #2a2a3a;
  border-top: none;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  padding: 0 20px 16px;
}

.p2p-expanded-input-wrapper:focus-within {
  border-color: #ffdc88;
}

.p2p-expanded-input-wrapper.p2p-input-error {
  border-color: #ef4444 !important;
  background: rgba(239, 68, 68, 0.05);
}

.p2p-expanded-input-wrapper.p2p-input-error:focus-within {
  border-color: #ef4444;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.1);
}

.p2p-payment-selector-full.p2p-input-error,
.p2p-payment-selector.p2p-input-error {
  border-color: #ef4444 !important;
  background: rgba(239, 68, 68, 0.05);
}

.p2p-expanded-input-wrapper input {
  flex: 1 1;
  padding: 0;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 32px;
  font-weight: 500;
}

.p2p-expanded-input-wrapper input:focus {
  outline: none;
}

.p2p-expanded-input-wrapper input::placeholder {
  color: #444;
}

/* Remove number input spinners */
.p2p-expanded-input-wrapper input[type="number"]::-webkit-outer-spin-button,
.p2p-expanded-input-wrapper input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.p2p-expanded-input-wrapper input[type="number"] {
  -moz-appearance: textfield;
}

.p2p-input-currency {
  padding: 0;
  color: #888;
  font-size: 14px;
  font-weight: 500;
  background: transparent;
}

.p2p-expanded-input-error {
  font-size: 12px;
  color: #ef4444;
  margin-top: 6px;
  padding-left: 20px;
}

.p2p-price-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #888;
  font-size: 12px;
}

.p2p-price-info svg {
  color: #aaa;
}

.p2p-payment-selector-full {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 20px;
  background: #f59e0b0d;
  border: 1px solid #2a2a3a;
  border-top: none;
  border-radius: 0 0 12px 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-payment-selector-full:hover {
  border-color: #ffdc88;
}

.p2p-payment-selector-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.p2p-payment-indicator {
  width: 4px;
  height: 16px;
  background: #f59e0b;
  border-radius: 2px;
}

.p2p-payment-selector-full svg {
  color: #aaa;
}

.p2p-expanded-form-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.p2p-cancel-btn {
  flex: 1 1;
  padding: 14px 24px;
  background: transparent;
  border: 1px solid #2a2a3a;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.p2p-cancel-btn:hover {
  background: rgba(255, 220, 136, 0.1);
  border-color: #ffdc88;
}

.p2p-confirm-buy-btn {
  width: 100%;
  padding: 16px 24px;
  background: #22c55e;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.p2p-confirm-buy-btn:hover {
  background: #16a34a;
}

.p2p-confirm-sell-btn {
  width: 100%;
  padding: 16px 24px;
  background: #ef4444;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.p2p-confirm-sell-btn:hover {
  background: #dc2626;
}

/* Mobile Card View */
.p2p-mobile-orders-list {
  display: none;
}

.p2p-mobile-order-card {
  background: #12121a;
  border: 1px solid #1e1e2d;
  border-radius: 12px;
  padding: 16px;
}

.p2p-mobile-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.binance-chat-input .send-btn {
  padding: 0px;
}

.p2p-mobile-card-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-mobile-card-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
}

.p2p-mobile-card-user-info h4 {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.p2p-mobile-card-user-info p {
  font-size: 12px;
  color: #aaa;
  margin: 0 0 2px 0;
}

.p2p-mobile-card-user-info .p2p-rating {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #a8b4c4;
}

.p2p-mobile-card-price {
  text-align: right;
}

.p2p-mobile-card-price .p2p-value {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.p2p-mobile-card-price .p2p-currency {
  font-size: 12px;
  color: #aaa;
}

.p2p-mobile-card-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #1e1e2d;
}

.p2p-mobile-detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.p2p-mobile-detail-label {
  font-size: 11px;
  color: #aaa;
}

.p2p-mobile-detail-value {
  font-size: 13px;
  color: #fff;
}

.p2p-mobile-card-payments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.p2p-mobile-payment-badge {
  padding: 6px 10px;
  background: rgba(255, 220, 136, 0.1);
  border-radius: 4px;
  font-size: 11px;
  color: #bd83cb;
}

.p2p-mobile-card-action {
  width: 100%;
}

.p2p-mobile-buy-btn {
  width: 100%;
  padding: 12px;
  background: #22c55e;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.p2p-mobile-buy-btn:hover {
  background: #16a34a;
}

.p2p-mobile-sell-btn {
  width: 100%;
  padding: 12px;
  background: #ef4444;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.p2p-mobile-sell-btn:hover {
  background: #dc2626;
}

.p2p-mobile-expanded-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #1e1e2d;
}

/* Payment Modal */
.p2p-modal-content {
  background: #373E4B;
  border: 1px solid #373E4B;
  border-radius: 10px;
}

.p2p-modal-header {
  border-bottom: 1px solid #404754;
  padding: 20px 24px;
}

.payment_search_box {
  margin-bottom: 20px;
}

.payment_search_box input {
  width: 100%;
  padding: 14px 16px;
  background: #4B515D;
  border: 1px solid #4B515D;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
}

.p2p-modal-title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.p2p-modal-body {
  padding: 24px;
}

.p2p-modal-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.p2p-payment-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #4B515D;
  border: 1px solid #4B515D;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-payment-option:hover {
  border-color: #ffdc88;
}

.p2p-payment-option.p2p-selected {
  background: rgba(255, 220, 136, 0.15);
  border-color: #ffdc88;
}

.p2p-payment-option span {
  color: #fff;
  font-size: 14px;
}

.p2p-payment-option input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: #ffdc88;
  display: none;
}

.p2p-payment-option.p2p-selected input[type="checkbox"] {
  display: block;
}

.button.p2p-submit-button {
  background-color: #fff;
  border: none;
  border-radius: 50px;
  font-size: 15px;
  margin-top: 12px;
}

/* ====================================
     Responsive Styles
     ==================================== */

@media (max-width: 991.98px) {
  .p2p-sidebar {
    transform: translateX(-100%);
  }

  .p2p-sidebar.p2p-open {
    transform: translateX(0);
    background: #000;
  }

  .p2p-sidebar-close {
    display: flex;
  }
}

@media (min-width: 992px) {
  .p2p-sidebar-overlay {
    display: none !important;
  }
}

@media (max-width: 1024px) {
  .p2p-filter-section {
    flex-wrap: wrap;
  }

  .p2p-filter-group {
    min-width: calc(50% - 8px);
  }

  .p2p-find-orders-btn {
    width: 100%;
  }

  .p2p-orders-table th:nth-child(2),
  .p2p-orders-table td:nth-child(2) {
    display: none;
  }
}

@media (max-width: 768px) {
  .p2p-toggle-btn {
    padding: 10px 32px;
    font-size: 14px;
  }

  .p2p-filter-group {
    min-width: 100%;
  }


  .p2p-orders-table-wrapper {
    overflow-x: auto;
  }

  .p2p-orders-table {
    min-width: 600px;
  }

  .p2p-expanded-content {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .p2p-expanded-right {
    min-width: 100%;
    padding: 0;
  }

  .p2p-expanded-left {
    padding: 16px;
  }

  .p2p-input-header {
    padding: 14px 16px 6px;
  }

  .p2p-expanded-input-wrapper {
    padding: 0 16px 14px;
  }

  .p2p-expanded-input-wrapper input {
    font-size: 26px;
  }

  .p2p-payment-selector-full {
    padding: 14px 16px;
    font-size: 14px;
  }

  .p2p-confirm-buy-btn,
  .p2p-confirm-sell-btn {
    padding: 14px 20px;
    font-size: 14px;
  }

  .p2p-pagination-wrapper {
    justify-content: center;
    flex-wrap: wrap;
  }
}

@media (max-width: 640px) {
  .p2p-orders-table-wrapper {
    display: none;
  }

  .p2p-mobile-orders-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  /* Mobile expanded row styling */
  .p2p-expanded-row {
    display: block;
  }

  .p2p-expanded-row td {
    padding: 0 !important;
  }

  .p2p-expanded-content {
    display: flex;
    flex-direction: column;
    padding: 16px;
    background: #0d0d14;
    border-radius: 12px;
    margin: 8px 0;
  }

  .p2p-expanded-left {
    order: 2;
    border-top: 1px solid #2a2a3a;
    padding-top: 16px;
    margin-top: 16px;
  }

  .p2p-expanded-right {
    order: 1;
  }
}

@media (max-width: 576px) {
  .p2p-buy-sell-toggle {
    margin-bottom: 16px;
  }




  .p2p-toggle-wrapper {
    width: 100%;
  }

  .p2p-toggle-btn {
    flex: 1 1;
    padding: 10px 16px;
  }

  .p2p-filter-section {
    gap: 12px;
    padding: 0;
  }

  .p2p-orders-table th,
  .p2p-orders-table td {
    padding: 12px;
  }

  .p2p-advertiser-avatar {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .p2p-advertiser-info h4 {
    font-size: 13px;
  }

  .p2p-buy-btn,
  .p2p-sell-btn {
    padding: 8px 16px;
    font-size: 12px;
  }

  .p2p-expanded-stats {
    flex-wrap: wrap;
    gap: 16px;
  }

  .p2p-expanded-form-actions {
    flex-direction: column;
  }

  .p2p-pagination-wrapper.p2p-mobile {
    background: transparent;
    border: none;
    margin-top: 16px;
  }

  /* P2P Expanded Form Mobile Styles */
  .p2p-expanded-content {
    padding: 12px;
    gap: 16px;
  }

  .p2p-expanded-right {
    min-width: 100%;
  }

  .p2p-expanded-form-group {
    margin-bottom: 10px;
  }

  .p2p-input-header {
    padding: 12px 14px 4px;
    border-radius: 10px 10px 0 0;
  }

  .p2p-input-header label {
    font-size: 12px;
  }

  .p2p-input-range {
    font-size: 11px;
  }

  .p2p-expanded-input-wrapper {
    padding: 0 14px 12px;
    border-radius: 0 0 10px 10px;
  }

  .p2p-expanded-input-wrapper input {
    font-size: 22px;
  }

  .p2p-input-currency {
    font-size: 13px;
  }

  .p2p-price-info {
    font-size: 11px;
  }

  .p2p-payment-selector-full {
    padding: 12px 14px;
    font-size: 13px;
    border-radius: 0 0 10px 10px;
  }

  .p2p-payment-indicator {
    width: 3px;
    height: 14px;
  }

  .p2p-expanded-form-actions {
    margin-top: 12px;
  }

  .p2p-confirm-buy-btn,
  .p2p-confirm-sell-btn {
    padding: 12px 16px;
    font-size: 13px;
    border-radius: 8px;
  }

  .p2p-expanded-input-error {
    font-size: 11px;
    padding-left: 14px;
  }

  /* Expanded left section mobile */
  .p2p-expanded-left {
    padding: 12px;
  }

  .p2p-expanded-avatar {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }

  .p2p-expanded-user-details h5 {
    font-size: 14px;
  }

  .p2p-expanded-user-details p {
    font-size: 11px;
  }

  .p2p-expanded-stats {
    gap: 12px;
  }

  .p2p-stat-item {
    min-width: calc(50% - 6px);
  }

  .p2p-stat-value {
    font-size: 13px;
  }

  .p2p-stat-label {
    font-size: 10px;
  }

  .p2p-expanded-payments h6,
  .p2p-expanded-remarks h6 {
    font-size: 12px;
  }

  .p2p-expanded-payment-badge {
    font-size: 11px;
    padding: 4px 8px;
  }

  .p2p-expanded-remarks p {
    font-size: 12px;
  }
}

/* Extra small devices */
@media (max-width: 400px) {
  .p2p-expanded-input-wrapper input {
    font-size: 20px;
  }

  .p2p-input-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .p2p-payment-selector-full {
    font-size: 12px;
  }

  .p2p-stat-item {
    min-width: 100%;
  }
}

/* ====================================
     ENHANCED MOBILE RESPONSIVENESS - P2P Dashboard
     ==================================== */

/* Tablet breakpoint (992px - 768px) */
@media (max-width: 992px) and (min-width: 769px) {
  .p2p-dashboard-container {
    padding: 0 12px;
  }

  .p2p-toggle-btn {
    padding: 12px 36px;
    font-size: 14px;
  }

  .p2p-filter-section {
    gap: 12px;
  }

  .p2p-filter-group {
    min-width: calc(33.333% - 12px);
  }

  .p2p-orders-table th,
  .p2p-orders-table td {
    padding: 16px 12px;
    font-size: 13px;
  }

  .p2p-price-value {
    font-size: 15px;
  }
}

/* Mobile landscape and small tablets (768px) */
@media (max-width: 768px) {
  .p2p-dashboard-container {
    padding: 0 8px;
  }

  /* Hide desktop table at this breakpoint too */
  .p2p-orders-table-wrapper {
    display: none;
  }

  .p2p-mobile-orders-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .p2p-filter-section {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
    padding: 0 4px;
  }

  .p2p-filter-group {
    min-width: 100%;
    flex: none;
  }

  .p2p-filter-select {
    padding: 14px 16px;
    font-size: 15px;
    border-radius: 10px;
  }

  .p2p-find-orders-btn {
    padding: 14px;
    width: 100%;
    font-size: 15px;
    border-radius: 10px;
    margin-top: 4px;
  }

  .p2p-buy-sell-toggle {
    margin-bottom: 20px;
    padding: 0 4px;
  }

  .p2p-toggle-wrapper {
    width: 100%;
    border-radius: 10px;
    padding: 5px;
  }

  .p2p-toggle-btn {
    flex: 1 1;
    padding: 14px 20px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 8px;
  }

  /* Mobile order cards improved */
  .p2p-mobile-order-card {
    padding: 16px;
    border-radius: 14px;
    margin-bottom: 0;
  }

  .p2p-mobile-card-avatar {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }

  .p2p-mobile-card-user-info h4 {
    font-size: 15px;
    font-weight: 600;
  }

  .p2p-mobile-card-user-info p {
    font-size: 13px;
    color: #7d8087;
  }

  .p2p-mobile-card-price .p2p-value {
    font-size: 20px;
    font-weight: 700;
  }

  .p2p-mobile-card-price .p2p-currency {
    font-size: 13px;
  }

  .p2p-mobile-card-details {
    gap: 16px;
    margin-bottom: 16px;
    padding-bottom: 16px;
  }

  .p2p-mobile-detail-label {
    font-size: 12px;
    font-weight: 500;
  }

  .p2p-mobile-detail-value {
    font-size: 14px;
    font-weight: 500;
  }

  .p2p-mobile-payment-badge {
    padding: 8px 12px;
    font-size: 12px;
    border-radius: 6px;
  }

  .p2p-mobile-buy-btn,
  .p2p-mobile-sell-btn {
    padding: 9px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 10px;
    margin-top: 12px;
  }

  /* Expanded section mobile */
  .p2p-mobile-expanded-section {
    padding-top: 20px;
    margin-top: 20px;
  }

  .p2p-payment-method-header.mobileview {
    flex-direction: row;
    align-items: center;
  }

  .mobileview .p2p-payment-method-actions {
    width: auto;
  }

  .p2p-mobile-expanded-section .p2p-expanded-right {
    padding: 0;
  }

  /* Keep same design as desktop - card style inputs */
  .p2p-mobile-expanded-section .p2p-expanded-form-group {
    margin-bottom: 14px;
  }

  .p2p-mobile-expanded-section .p2p-input-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px 8px;
    background: #1a1a2200;
    border-radius: 10px 10px 0 0;
    border: 1px solid #424251;
    border-bottom: none;
  }

  .p2p-mobile-expanded-section .p2p-input-header label {
    font-size: 13px;
    color: #ffffff;
    margin: 0;
  }

  .p2p-mobile-expanded-section .p2p-input-range {
    font-size: 11px;
    color: #adabab;
  }

  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper {
    display: flex;
    align-items: center;
    background: #1a1a2200;
    border: 1px solid #424251;
    border-top: none;
    border-radius: 0 0 10px 10px;
    padding: 0 16px 14px;
  }

  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {
    flex: 1 1;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 26px;
    font-weight: 500;
    padding: 0;
    width: 100%;
  }

  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper input:focus {
    outline: none;
  }

  .p2p-mobile-expanded-section .p2p-input-currency {
    color: #888;
    font-size: 14px;
    font-weight: 500;
    background: transparent;
    padding: 0;
  }

  .p2p-mobile-expanded-section .p2p-price-info {
    font-size: 11px;
  }

  .p2p-mobile-expanded-section .p2p-payment-selector-full,
  .p2p-mobile-expanded-section .p2p-payment-selector {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    background: #1a1a2200;
    border: 1px solid #424251;
    border-radius: 10px;
    color: #888;
    font-size: 14px;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .p2p-mobile-expanded-section .p2p-payment-selector-full:hover,
  .p2p-mobile-expanded-section .p2p-payment-selector:hover {
    border-color: #3a3a4a;
  }

  .p2p-mobile-expanded-section .p2p-payment-indicator {
    width: 3px;
    height: 16px;
    background: #22c55e;
    border-radius: 2px;
    margin-right: 10px;
  }

  .p2p-mobile-expanded-section .p2p-expanded-form-actions {
    display: flex;
    gap: 12px;
    margin-top: 20px;
  }

  .p2p-mobile-expanded-section .p2p-cancel-btn {
    flex: 1 1;
    padding: 14px;
    background: transparent;
    border: 1px solid #2a2a3a;
    border-radius: 10px;
    color: #8b8b8b;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
  }

  .p2p-mobile-expanded-section .p2p-cancel-btn:hover {
    background: rgba(255, 255, 255, 0.05);
  }

  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,
  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {
    flex: 2 1;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 10px;
  }

  .p2p-mobile-expanded-section .p2p-expanded-input-error {
    font-size: 11px;
    color: #ef4444;
    margin-top: 6px;
    padding-left: 16px;
  }

  .p2p-mobile-expanded-section .p2p-available-balance {
    display: block;
    font-size: 12px;
    color: #aaa;
    margin-top: 6px;
    padding-left: 2px;
  }

  .payment_method_pop {
    padding-right: 0px !important;
  }

  .modal.fade {
    padding-right: 0px !important;
  }

  /* Pagination mobile */
  .p2p-pagination-wrapper {
    padding: 16px;
    margin-top: 16px;
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }

  .p2p-pagination-info {
    font-size: 13px;
    order: 2;
  }

  .p2p-pagination-controls {
    order: 1;
  }

  .p2p-page-btn {
    width: 36px;
    height: 36px;
    font-size: 13px;
  }

  /* Modal mobile */
  .p2p-modal-content {
    margin: 16px;
    max-height: calc(100vh - 32px);
  }

  .p2p-modal-header {
    padding: 16px;
  }

  .p2p-modal-title {
    font-size: 16px;
  }

  .p2p-modal-body {
    padding: 16px;
    max-height: calc(100vh - 150px);
    overflow-y: auto;
  }

  .p2p-payment-option {
    padding: 14px 16px;
  }

  .p2p-payment-option span {
    font-size: 14px;
  }

  /* Available balance mobile */
  .p2p-available-balance {
    font-size: 12px;
    margin-top: 8px;
    display: block;
  }
}

/* Mobile portrait (576px and below) */
@media (max-width: 576px) {
  .p2p-dashboard-container {
    padding: 0 4px;
  }

  .p2p-toggle-btn {
    padding: 12px 16px;
    font-size: 14px;
  }

  .p2p-filter-label {
    font-size: 11px;
  }

  .p2p-filter-select {
    padding: 12px 14px;
    font-size: 14px;
  }

  .p2p-find-orders-btn {
    padding: 12px;
    font-size: 14px;
  }

  .p2p-mobile-order-card {
    padding: 14px;
    border-radius: 12px;
  }

  .p2p-mobile-card-header {
    margin-bottom: 14px;
    flex-wrap: wrap;
    gap: 10px;
  }

  .p2p-mobile-card-user {
    gap: 10px;
  }

  .p2p-mobile-card-avatar {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .p2p-mobile-card-user-info h4 {
    font-size: 14px;
  }

  .p2p-mobile-card-user-info p {
    font-size: 12px;
  }

  .p2p-mobile-card-price .p2p-value {
    font-size: 18px;
  }

  .p2p-mobile-card-details {
    gap: 10px;
    margin-bottom: 14px;
    padding-bottom: 14px;
  }

  .p2p-mobile-detail-label {
    font-size: 11px;
  }

  .p2p-mobile-detail-value {
    font-size: 13px;
  }

  .p2p-mobile-card-payments {
    gap: 6px;
    margin-bottom: 14px;
  }

  .p2p-mobile-payment-badge {
    padding: 6px 10px;
    font-size: 11px;
  }

  .p2p-mobile-buy-btn,
  .p2p-mobile-sell-btn {
    padding: 12px;
    font-size: 14px;
    border-radius: 8px;
  }

  /* Expanded section small mobile */
  .p2p-mobile-expanded-section {
    padding-top: 16px;
    margin-top: 16px;
  }

  .p2p-mobile-expanded-section .p2p-input-header {
    padding: 12px 14px 6px;
  }

  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper {
    padding: 0 14px 12px;
  }

  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {
    font-size: 22px;
  }

  .p2p-mobile-expanded-section .p2p-payment-selector-full {
    padding: 12px 14px;
  }

  .p2p-mobile-expanded-section .p2p-expanded-form-actions {
    flex-direction: column;
    gap: 10px;
  }

  .p2p-mobile-expanded-section .p2p-cancel-btn,
  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,
  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {
    flex: none;
    width: 100%;
  }

  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,
  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {
    order: -1;
  }

  .p2p-mobile-expanded-section .p2p-expanded-input-error {
    font-size: 11px;
    margin-top: 6px;
    padding-left: 14px;
  }

  /* Verification button mobile */
  .p2p-mobile-verification-btn {
    padding: 12px;
    font-size: 13px;
  }

  .p2p-mobile-verification-btn i {
    font-size: 16px;
  }

  /* Trade restricted mobile */
  .p2p-mobile-condition-info {
    font-size: 11px;
    padding: 10px;
    flex-direction: column;
    text-align: center;
    gap: 4px;
  }

  /* Pagination small mobile */
  .p2p-pagination-wrapper.p2p-mobile {
    padding: 12px 0;
  }

  .p2p-page-btn {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }

  /* Modal small mobile */
  .p2p-modal-content {
    margin: 8px;
    border-radius: 12px;
  }

  .p2p-payment-option {
    padding: 12px 14px;
  }

  /* No payment methods state */
  .p2p-no-payment-methods {
    padding: 24px 16px;
    text-align: center;
  }

  .p2p-no-payment-methods i {
    font-size: 40px;
  }

  .p2p-no-payment-methods p {
    font-size: 14px;
  }

  .p2p-add-payment-btn {
    padding: 12px 20px;
    font-size: 13px;
  }
}

/* Extra small mobile (400px and below) */
@media (max-width: 400px) {
  .p2p-toggle-wrapper {
    padding: 4px;
  }

  .p2p-toggle-btn {
    padding: 10px 12px;
    font-size: 13px;
  }

  .p2p-filter-select {
    padding: 10px 12px;
    font-size: 13px;
  }

  .p2p-find-orders-btn {
    padding: 10px;
    font-size: 13px;
  }

  .p2p-mobile-order-card {
    padding: 12px;
  }

  .p2p-mobile-card-header {
    margin-bottom: 12px;
  }

  .p2p-mobile-card-avatar {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }

  .p2p-mobile-card-user-info h4 {
    font-size: 13px;
  }

  .p2p-mobile-card-user-info p {
    font-size: 11px;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .p2p-mobile-card-price .p2p-value {
    font-size: 16px;
  }

  .p2p-mobile-card-price .p2p-currency {
    font-size: 11px;
  }

  .p2p-mobile-card-details {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .p2p-mobile-detail-item {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .p2p-mobile-payment-badge {
    padding: 5px 8px;
    font-size: 10px;
  }

  .p2p-mobile-buy-btn,
  .p2p-mobile-sell-btn {
    padding: 8px 10px;
    font-size: 12px;
  }

  .p2p-mobile-expanded-section .p2p-input-header {
    padding: 7px 12px 5px;
  }

  .p2p-mobile-expanded-section .p2p-input-header label {
    font-size: 12px;
  }

  .p2p-mobile-expanded-section .p2p-input-range {
    font-size: 10px;
  }

  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper {
    padding: 0 12px 10px;
    gap: 5px;
  }

  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {
    font-size: 18px;
  }

  .p2p-mobile-expanded-section .p2p-input-currency {
    font-size: 13px;
  }

  .p2p-mobile-expanded-section .p2p-payment-selector-full {
    padding: 10px 12px;
    font-size: 12px;
    margin-top: 14px;

  }

  .p2p-mobile-expanded-section .p2p-cancel-btn,
  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,
  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {
    padding: 10px;
    font-size: 12px;
  }

  /* Rating on mobile */
  .p2p-mobile-card-user-info .p2p-rating {
    font-size: 11px;
  }

  .p2p-mobile-card-user-info .p2p-rating span:first-child {
    font-size: 10px;
    letter-spacing: -1px;
  }
}

/* ====================================
     P2P My Ads Page Styles
     ==================================== */

.p2p-myads-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.p2p-myads-title {
  font-size: 22px;
  font-weight: 600;
  color: #d1d5db;
  margin: 0 0 4px 0;
}

.p2p-myads-subtitle {
  font-size: 13px;
  color: #52525b;
  margin: 0;
}

.p2p-create-ad-btn {
  padding: 10px 20px;
  /* background: rgba(30, 58, 138, 0.4); */
  border: 1px solid rgba(255, 220, 136, 0.3);
  border-radius: 8px;
  /* color: #93c5fd; */
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-create-ad-btn:hover {
  background-color: #e7b641;
}

.p2p-payment-method-header {
  gap: 12px;
}

/* Stats Cards Grid */
.p2p-myads-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
  background-color: #373F4D;
  border-radius: 8px;
  overflow: hidden;
  padding: 12px 0px;
}

.p2p-myads-stat-card {
  background: #373F4D;
  border-radius: 0px;
  border: none;
  padding: 3px 20px;
  transition: border-color 0.2s ease;
  border-right: 1px solid #454C59;
}

.p2p-myads-stat-card:hover {
  border-right: 1px solid #454C59;
}

.p2p-filter-section.myadsfillter {
  padding: 0px;
}

.p2p-myads-stats-grid .p2p-myads-stat-card:last-child {
  border-right: none;
}

.p2p-dashboard-container.p2p-profile-container {
  background-color: #2B313C;
  border-radius: 10px;
}

.p2p-profile-container .p2p-profile-header {
  background: none;
  border-radius: 12px;
  border: none;
  padding: 36px;
  margin-bottom: 0px;
}

.p2p-profile-container .p2p-myads-stats-grid {
  grid-template-columns: repeat(2, 1fr);
  background-color: transparent;
  border-radius: 0px;
  gap: 20px;
  padding: 20px 36px;
  overflow: inherit;
  border-bottom: 1px solid #454C59;
  border-top: 1px solid #454C59;
}

.p2p-profile-container .p2p-myads-stat-card {
  display: flex;
  align-items: center;
  gap: 18px;
  justify-content: space-between;
  background: none;
  border-radius: 0px;
  border-right: none;
  padding: 6px 0px;
  border-bottom: 1px solid #454C59;
}

.p2p-profile-container .p2p-myads-stat-card-label {
  color: #fff;
  font-size: 13px;
  border-bottom: none;
}

.p2p-profile-container .p2p-myads-stat-card:nth-child(5) {
  border-bottom: none;
}

.p2p-profile-container .p2p-myads-stat-card:last-child {
  border-bottom: none;
}

.p2p-profile-tabs.paymentprofiletabs {
  padding: 0px 36px 36px;
}

.p2p-profile-container .p2p-empty-state-card {
  background: none;
  border-radius: 0px;
}

.p2p-profile-container .p2p-empty-state-card i {
  font-size: 30px;
  color: #fff;
  margin-bottom: 0px;
}

.myadsfillter .p2p-filter-select {
  background: #373F4D;
  border: 1px solid #373F4D;
}

.myadsfillter .p2p-find-orders-btn {
  background: #373F4D;
  border: 1px solid #373F4D;
}

.p2p-myads-container {
  background-color: #2B313C;
  padding: 24px;
  border-radius: 12px;
}

.p2p-myads-stat-card-label {
  color: #A2A9B6;
  font-size: 13px;
  padding-bottom: 3px;
  margin-bottom: 4px;
  border-bottom: 1px solid #454C59;
  letter-spacing: 0.3px;
}

.p2p-myads-stat-card-value {
  font-size: 16px;
  font-weight: 400;
  color: #e5e5e5;
}

/* Legacy stats (keep for backwards compatibility) */
.p2p-myads-stats {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
  padding: 16px 20px;
  background: #0d0d14;
  border-radius: 10px;
  border: 1px solid #1e1e2d;
}

.p2p-myads-stat-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-myads-stat-value {
  font-size: 18px;
  font-weight: 600;
  color: #a1a1aa;
}

.p2p-myads-stat-label {
  font-size: 11px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.p2p-loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  min-height: 200px;
}

.p2p-loading-container .spinner-border {
  width: 32px;
  height: 32px;
}

@media (max-width: 768px) {
  .p2p-loading-container {
    padding: 40px 16px;
    min-height: 150px;
  }

  .p2p-loading-container .spinner-border {
    width: 28px;
    height: 28px;
  }
}

/* My Ads Table Specific Styles */
.p2p-myads-asset-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.p2p-myads-side-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.p2p-myads-side-badge.buy {
  background: #5EBA89;
  color: #fff;
}

.p2p-myads-side-badge.sell {
  background: rgba(239, 68, 68, 0.08);
  color: #fca5a5;
}

.p2p-myads-asset-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-empty-state-card .p2p-myads-action-btn {
  padding: 10px 12px;
}

.p2p-myads-asset-name {
  font-size: 14px;
  font-weight: 500;
  color: #d1d5db;
}

.p2p-myads-asset-fiat {
  font-size: 11px;
  color: #6b7280;
}

.p2p-myads-price {
  font-size: 14px;
  font-weight: 500;
  color: #a1a1aa;
}

.p2p-myads-price-currency {
  font-size: 11px;
  color: #6b7280;
  margin-left: 4px;
}

.p2p-myads-volume {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-myads-volume-remaining {
  font-size: 14px;
  font-weight: 500;
  color: #a1a1aa;
}

.p2p-myads-volume-total {
  font-size: 11px;
  color: #6b7280;
}

.p2p-myads-limits {
  font-size: 13px;
  color: #9ca3af;
}

.p2p-myads-status {
  font-size: 13px;
  font-weight: 500;
}

.p2p-myads-date {
  font-size: 12px;
  color: #6b7280;
}

.p2p-payment-badge-more {
  padding: 4px 8px;
  background: rgba(107, 114, 128, 0.2);
  border-radius: 4px;
  font-size: 11px;
  color: #9ca3af;
}

/* Empty State */
.p2p-empty-state {
  text-align: center;
  padding: 60px 20px;
}

.p2p-empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.p2p-empty-state p {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 20px;
}

.p2p-create-ad-btn-small {
  padding: 10px 20px;
  background: rgba(30, 41, 59, 0.4);
  border: 1px solid rgba(51, 65, 85, 0.5);
  border-radius: 8px;
  color: #9ca3af;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.payment_method_pop.modal.fade .modal-dialog {
  min-width: 540px;
}

.p2p-create-ad-btn-small:hover {
  border-color: rgba(71, 85, 105, 0.8);
  color: #d1d5db;
  background: rgba(30, 41, 59, 0.6);
}

.p2p-empty-state-mobile {
  text-align: center;
  padding: 40px 20px;
  background: #373F4D;
  border-radius: 12px;
  border: 1px solid #373F4D;
}

/* Pagination */
.p2p-pagination-buttons,
.p2p-pagination-controls {
  display: flex;
  gap: 6px;
  align-items: center;
}

@media (max-width: 768px) {
  .p2p-myads-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .p2p-myads-stats {
    flex-wrap: wrap;
    gap: 16px;
  }

  .p2p-myads-stat-item {
    min-width: calc(33% - 12px);
  }

  .p2p-pagination-wrapper {
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }
}

@media (max-width: 576px) {
  .p2p-myads-title {
    font-size: 18px;
  }

  .p2p-myads-stats {
    padding: 12px 16px;
  }

  .p2p-myads-stat-value {
    font-size: 16px;
  }
}

/* My Ads Actions */
.p2p-myads-actions {
  display: flex;
  gap: 8px;
}

.p2p-myads-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  color: #a1a1aa;
}

.p2p-myads-action-btn i {
  font-size: 14px;
}

.p2p-myads-action-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.15);
  color: #e5e5e5;
}

.p2p-myads-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Online/Offline Status */
.p2p-myads-status-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.p2p-myads-online-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  width: -moz-fit-content;
  width: fit-content;
}

.p2p-myads-online-badge.online {
  background: rgba(255, 255, 255, 0.08);
  color: #d1d5db;
}

.p2p-myads-online-badge.offline {
  background: rgba(255, 255, 255, 0.04);
  color: #6b7280;
}

.p2p-myads-online-badge.small {
  padding: 2px 6px;
  font-size: 10px;
}

.p2p-myads-online-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6b7280;
}

.p2p-myads-online-badge.online .p2p-myads-online-dot {
  background: #4ade80;
  animation: p2p-pulse 2s ease-in-out infinite;
}

.p2p-myads-online-badge.offline .p2p-myads-online-dot {
  background: #6b7280;
  animation: none;
}

@keyframes p2p-pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

.p2p-mobile-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* .p2p-row-expanded {
    background: rgba(255, 220, 136, 0.03) !important;
  } */

/* Expanded Content */
/* .p2p-myads-expanded-content {
    padding: 20px 24px;
    background: #0a0a0f;
    border-top: 1px solid #1e1e2d;
  } */

.p2p-myads-expanded-section {
  margin-bottom: 24px;
}

.p2p-myads-expanded-section:last-child {
  margin-bottom: 0;
}

.p2p-myads-expanded-title {
  font-size: 13px;
  font-weight: 600;
  color: #9ca3af;
  margin: 0 0 12px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.p2p-myads-expanded-count {
  font-size: 11px;
  color: #6b7280;
  font-weight: 400;
}

.p2p-myads-expanded-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.p2p-myads-expanded-grid.mobile {
  grid-template-columns: repeat(3, 1fr);
}

.p2p-myads-expanded-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.p2p-myads-expanded-label {
  font-size: 11px;
  color: #6b7280;
}

.p2p-myads-expanded-value {
  font-size: 13px;
  color: #a1a1aa;
  font-weight: 500;
}

.p2p-myads-expanded-value.small {
  font-size: 11px;
  word-break: break-all;
}

.p2p-myads-expanded-payments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Payment Details Cards */
.p2p-myads-payment-details {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.p2p-myads-payment-card {
  background: #2f3641;
  border: 1px solid #454C59;
  border-radius: 10px;
  padding: 16px;
}

.p2p-myads-payment-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #454C59;
}

.p2p-myads-payment-type {
  font-size: 14px;
  font-weight: 600;
  color: #bd83cb;
}

.p2p-myads-payment-type-badge {
  font-size: 10px;
  padding: 2px 6px;
  background: rgba(107, 114, 128, 0.2);
  color: #9ca3af;
  border-radius: 4px;
}

.p2p-myads-payment-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.p2p-myads-payment-field {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.p2p-myads-payment-label {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}

.p2p-myads-payment-value {
  font-size: 12px;
  color: #a1a1aa;
  text-align: right;
  word-break: break-all;
}

.p2p-myads-payment-qr {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #454C59;
}

.p2p-myads-payment-qr img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  background: #fff;
  border-radius: 8px;
  padding: 4px;
}

.p2p-myads-no-details {
  font-size: 13px;
  color: #6b7280;
}

/* Closure Information */
.p2p-myads-closure-info {
  background: rgba(107, 114, 128, 0.1);
  border: 1px solid rgba(107, 114, 128, 0.2);
  border-radius: 10px;
  padding: 16px;
}

.p2p-myads-closure-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.p2p-myads-closure-icon {
  font-size: 16px;
}

.p2p-myads-closure-text {
  font-size: 14px;
  font-weight: 500;
  color: #9ca3af;
}

.p2p-myads-closure-date {
  font-size: 12px;
  color: #6b7280;
}

.p2p-myads-closure-reason {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(107, 114, 128, 0.2);
}

.p2p-myads-closure-reason-label {
  font-size: 12px;
  color: #6b7280;
  margin-right: 8px;
}

.p2p-myads-closure-reason-text {
  font-size: 13px;
  color: #a1a1aa;
  line-height: 1.5;
}

/* Mobile Card Actions */
.p2p-mobile-card-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #1e1e2d;
}

.p2p-mobile-card-actions .p2p-myads-action-btn {
  flex: 1 1;
  padding: 10px 16px;
  font-size: 13px;
}

/* Mobile Expanded Details */
.p2p-mobile-expanded-details {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #1e1e2d;
}

.p2p-mobile-expanded-details .p2p-myads-expanded-grid {
  grid-template-columns: repeat(2, 1fr);
}

.p2p-mobile-expanded-details .p2p-myads-payment-details {
  grid-template-columns: 1fr;
}

@media (max-width: 1024px) {
  .p2p-myads-expanded-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .p2p-myads-expanded-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .p2p-myads-payment-details {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .p2p-myads-actions {
    flex-direction: column;
  }

  .p2p-myads-action-btn {
    width: 100%;
    text-align: center;
  }

  .p2p-myads-expanded-content {
    padding: 16px;
  }

  .p2p-myads-expanded-grid {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
}

/* Close Ad Modal */
.p2p-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 20px;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.p2p-close-ad-modal {
  background: #12121a;
  border: 1px solid #1e1e2d;
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: p2p-modal-slide-in 0.2s ease-out;
}

@keyframes p2p-modal-slide-in {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.p2p-close-ad-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
}

.p2p-close-ad-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #d1d5db;
  margin: 0;
}

.p2p-close-ad-modal-close {
  background: transparent;
  border: none;
  font-size: 28px;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  transition: color 0.2s;
}

.p2p-close-ad-modal-close:hover {
  color: #e5e5e5;
}

.p2p-close-ad-modal-body {
  padding: 24px;
  overflow-y: auto;
}

/* Warning Banner */
.p2p-close-ad-warning {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: rgba(120, 113, 108, 0.1);
  border: 1px solid rgba(120, 113, 108, 0.2);
  border-radius: 10px;
  margin-bottom: 20px;
}

.p2p-close-ad-warning-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.p2p-close-ad-warning-content strong {
  display: block;
  font-size: 14px;
  color: #d6d3d1;
  margin-bottom: 4px;
}

.p2p-close-ad-warning-content p {
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
  line-height: 1.5;
}

/* Ad Summary */
.p2p-close-ad-summary {
  background: #0a0a0f;
  border: 1px solid #1e1e2d;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 20px;
}

.p2p-close-ad-summary-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #1e1e2d;
}

.p2p-close-ad-summary-pair {
  font-size: 16px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-close-ad-summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.p2p-close-ad-summary-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.p2p-close-ad-summary-label {
  font-size: 11px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.p2p-close-ad-summary-value {
  font-size: 14px;
  color: #d1d5db;
  font-weight: 500;
}

/* Reason Input Group */
.p2p-close-ad-reason-group {
  margin-bottom: 0;
}

.p2p-close-ad-reason-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #9ca3af;
  margin-bottom: 10px;
}

.p2p-optional-badge {
  font-size: 10px;
  padding: 2px 6px;
  background: rgba(107, 114, 128, 0.2);
  color: #6b7280;
  border-radius: 4px;
}

.p2p-close-ad-reason-input {
  width: 100%;
  background: #0a0a0f;
  border: 1px solid #2a2a3a;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  color: #e5e5e5;
  resize: vertical;
  min-height: 80px;
  transition: border-color 0.2s;
}

.p2p-close-ad-reason-input:focus {
  outline: none;
  border-color: #ffdc88;
}

.p2p-close-ad-reason-input.error {
  border-color: #ef4444;
}

.p2p-close-ad-reason-input::placeholder {
  color: #4b5563;
}

.p2p-close-ad-reason-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.p2p-close-ad-error {
  font-size: 12px;
  color: #ef4444;
}

.p2p-close-ad-char-count {
  font-size: 11px;
  color: #6b7280;
  margin-left: auto;
}

/* Modal Footer */
.p2p-close-ad-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #1e1e2d;
}

.p2p-close-ad-btn-cancel,
.p2p-close-ad-btn-confirm {
  flex: 1 1;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p2p-close-ad-btn-cancel {
  background: transparent;
  border: 1px solid #2a2a3a;
  color: #9ca3af;
}

.p2p-close-ad-btn-cancel:hover:not(:disabled) {
  background: rgba(107, 114, 128, 0.1);
  border-color: #4b5563;
  color: #d1d5db;
}

.p2p-close-ad-btn-confirm {
  background: rgba(153, 27, 27, 0.8);
  border: 1px solid rgba(185, 28, 28, 0.5);
  color: #fecaca;
}

.p2p-close-ad-btn-confirm:hover:not(:disabled) {
  background: rgba(153, 27, 27, 1);
  color: #fff;
}

.p2p-close-ad-btn-cancel:disabled,
.p2p-close-ad-btn-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 576px) {
  .p2p-modal-overlay {
    padding: 16px;
  }

  .p2p-close-ad-modal {
    max-width: 100%;
  }

  .p2p-close-ad-modal-header {
    padding: 16px 20px;
  }

  .p2p-close-ad-modal-body {
    padding: 20px;
  }

  .p2p-close-ad-modal-footer {
    padding: 16px 20px;
    flex-direction: column;
  }

  .p2p-close-ad-summary-grid {
    grid-template-columns: 1fr;
  }
}

/* ====================================
     P2P My Ads - ENHANCED Mobile Responsive
     ==================================== */

/* MyAds Header - Mobile Premium Design */
@media (max-width: 768px) {
  .p2p-myads-header {
    padding: 0 4px;
    margin-bottom: 20px;
  }

  .p2p-myads-header>div {
    margin-bottom: 4px;
  }

  .p2p-myads-title {
    font-size: 22px;
    font-weight: 700;
    color: #f5f5f5;
    margin-bottom: 6px;
  }

  .p2p-myads-subtitle {
    font-size: 13px;
    color: #6b7280;
  }

  .p2p-create-ad-btn {
    width: 100%;
    padding: 14px 24px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 10px;
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.2) 0%, rgba(34, 197, 94, 0.1) 100%);
    border: 1px solid rgba(34, 197, 94, 0.3);
    color: #4ade80;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .p2p-create-ad-btn:hover {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.3) 0%, rgba(34, 197, 94, 0.2) 100%);
    border-color: rgba(34, 197, 94, 0.5);
  }
}

/* Stats Grid - Mobile Premium */
@media (max-width: 768px) {
  .p2p-myads-stats-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 20px;
    padding: 20px;
  }

  .p2p-myads-stat-card {
    padding: 14px 12px;
    border-radius: 0px;
    /* background: linear-gradient(145deg, #12121a00 0%, #0d0d1400 100%); */
    /* border: 1px solid #2c2c2c; */
    text-align: left;
  }

  .p2p-profile-container .p2p-myads-stat-card {
    border: none;
    border-bottom: 1px solid #454C59;
  }

  .p2p-myads-stat-card-label {
    font-size: 10px;
    margin-bottom: 6px;
    color: #6b7280;
    letter-spacing: 0.3px;
  }

  .p2p-myads-stat-card-value {
    font-size: 18px;
    font-weight: 700;
    color: #f5f5f5;
  }

  .selectpaymetpop.modal.fade .modal-dialog {
    width: 100%;
    min-width: 100%;
  }

}

@media (max-width: 480px) {

  .modal.fade .modal-dialog {
    min-width: 100%;
    width: 100%;
    margin: 0 auto;
  }




  .selectpaymetpop.modal.fade .modal-dialog {
    width: 100%;
    min-width: 100%;
  }

  .myadsheading .p2p-mobile-card-user-info h4 {
    font-size: 12px;
    margin: 0px 0px 1px;
  }

  .p2p-myads-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .p2p-myads-stat-card {
    padding: 12px 10px;
  }

  .p2p-myads-stat-card-label {
    font-size: 9px;
  }

  .p2p-myads-stat-card-value {
    font-size: 16px;
  }
}

/* Mobile Order Cards - Premium Design */
@media (max-width: 768px) {
  .p2p-orders-table-wrapper {
    display: none;
  }

  .p2p-mobile-orders-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0 4px;
  }

  .p2p-mobile-order-card {
    border: 1px solid rgb(54 54 54);
    border-radius: 16px;
    padding: 18px;
    transition: all 0.2s ease;
  }

  .p2p-mobile-order-card:hover {
    border-color: rgb(54 54 54);
  }

  /* Card Header */
  .p2p-mobile-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
  }

  .p2p-mobile-card-user {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .p2p-myads-side-badge {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .p2p-myads-side-badge.buy {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.08) 100%);
    color: #4ade80;
    border: 1px solid rgba(34, 197, 94, 0.2);
  }

  .p2p-myads-side-badge.sell {
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.08) 100%);
    color: #f87171;
    border: 1px solid rgba(239, 68, 68, 0.2);
  }

  .p2p-mobile-card-user-info h4 {
    font-size: 16px;
    font-weight: 600;
    color: #f5f5f5;
    margin: 0 0 4px 0;
  }

  .p2p-mobile-status-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  /* Price Display */
  .p2p-mobile-card-price {
    text-align: right;
  }

  .p2p-mobile-card-price .p2p-value {
    font-size: 20px;
    font-weight: 700;
    color: #f5f5f5;
    line-height: 1.2;
  }

  .p2p-mobile-card-price .p2p-currency {
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;
  }

  /* Card Details Grid */
  .p2p-mobile-card-details {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    margin-bottom: 16px;
    padding: 16px;
    background: rgba(0, 0, 0, 0);
    border-radius: 12px;
  }

  .p2p-mobile-detail-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .p2p-mobile-detail-label {
    font-size: 11px;
    color: #6b7280;
    letter-spacing: 0.5px;
    font-weight: 500;
  }

  .p2p-mobile-detail-value {
    font-size: 13px;
    color: #e5e5e5;
    font-weight: 500;
  }

  /* Payment Badges */
  .p2p-mobile-card-payments {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
  }

  .p2p-mobile-payment-badge {
    padding: 6px 12px;
    background: rgba(255, 220, 136, 0.1);
    border: 1px solid rgba(255, 220, 136, 0.2);
    border-radius: 6px;
    font-size: 12px;
    color: #bd83cb;
    font-weight: 500;
  }

  /* Action Buttons */
  .p2p-mobile-card-actions {
    display: flex;
    gap: 10px;
    margin-top: 0;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn {
    flex: 1 1;
    padding: 12px 14px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: #a1a1aa;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
    color: #e5e5e5;
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn i {
    font-size: 16px;
  }

  /* Online/Offline Badge */
  .p2p-myads-online-badge {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
  }

  .p2p-myads-online-badge.online {
    background: rgb(34 197 94 / 0%);
    border: 1px solid rgb(34 197 94 / 0%);
    color: #4ade80;
  }

  .p2p-myads-online-badge.offline {
    background: rgba(107, 114, 128, 0.1);
    border: 1px solid rgba(107, 114, 128, 0.2);
    color: #9ca3af;
  }

  .p2p-myads-online-badge.small {
    padding: 3px 8px;
    font-size: 10px;
  }

  .p2p-myads-online-dot {
    width: 6px;
    height: 6px;
  }

  /* Expanded Details */
  .p2p-mobile-expanded-details {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-section {
    margin-bottom: 20px;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-title {
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    background: rgba(0, 0, 0, 0);
    padding: 0px;
    border-radius: 10px;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-item {
    text-align: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 12px;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-label {
    font-size: 11px;
    color: #828289;
    margin-bottom: 0px;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-value {
    font-size: 12px;
    color: #eaecef;
    font-weight: 500;
  }

  /* Payment Details Cards */
  .p2p-mobile-expanded-details .p2p-myads-payment-details {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .p2p-mobile-expanded-details .p2p-myads-payment-card {
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    padding: 14px;
  }

  .p2p-mobile-expanded-details .p2p-myads-payment-header {
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .p2p-mobile-expanded-details .p2p-myads-payment-type {
    font-size: 14px;
    color: #bd83cb;
  }

  .p2p-mobile-expanded-details .p2p-myads-payment-qr img {
    width: 70px;
    height: 70px;
  }

  /* Closure Info */
  .p2p-mobile-expanded-details .p2p-myads-closure-info {
    background: rgba(107, 114, 128, 0.08);
    border: 1px solid rgba(107, 114, 128, 0.15);
    border-radius: 10px;
    padding: 14px;
  }

  /* Empty State Mobile */
  .p2p-empty-state-mobile {
    text-align: center;
    padding: 48px 24px;
    background: #373F4D;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    margin: 0 4px;
  }

  .p2p-empty-state-mobile .p2p-empty-icon {
    font-size: 56px;
    margin-bottom: 16px;
    opacity: 0.6;
  }

  .p2p-empty-state-mobile p {
    font-size: 16px;
    color: #6b7280;
    margin-bottom: 20px;
  }

  .p2p-empty-state-mobile .p2p-create-ad-btn-small {
    padding: 14px 28px;
    font-size: 14px;
    border-radius: 10px;
  }

  /* Pagination Mobile */
  .p2p-pagination-wrapper.p2p-mobile {
    padding: 16px 4px;
    margin-top: 16px;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    background: transparent;
    border: none;
  }

  .p2p-pagination-wrapper .p2p-pagination-info {
    font-size: 13px;
    color: #6b7280;
    order: 2;
  }

  .p2p-pagination-wrapper .p2p-pagination-buttons {
    order: 1;
  }

  .p2p-page-btn {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .p2p-mobile-order-card {
    padding: 14px;
    border-radius: 14px;
  }

  .p2p-mobile-card-header {
    margin-bottom: 14px;
  }

  .p2p-mobile-card-user {
    gap: 10px;
  }

  .p2p-myads-side-badge {
    padding: 5px 10px;
    font-size: 10px;
  }

  .p2p-mobile-card-user-info h4 {
    font-size: 15px;
  }

  .p2p-mobile-card-price .p2p-value {
    font-size: 18px;
  }

  .p2p-mobile-card-details {
    gap: 12px;
    padding: 14px 0px 0px;
  }

  .p2p-mobile-detail-label {
    font-size: 10px;
  }

  .p2p-mobile-detail-value {
    font-size: 12px;
  }

  .p2p-mobile-payment-badge {
    padding: 5px 10px;
    font-size: 11px;
  }

  .p2p-mobile-card-actions {
    flex-wrap: wrap;
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn {
    padding: 10px 12px;
    font-size: 12px;
    min-width: calc(50% - 5px);
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 380px) {
  .p2p-mobile-card-header {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 12px;
  }


  .p2p-mobile-card-user {
    width: 100%;
  }

  .p2p-mobile-card-price {
    width: 100%;
    text-align: left;
    display: flex;
    align-items: baseline;
    gap: 8px;
  }

  .p2p-mobile-card-details {
    grid-template-columns: 1fr;
  }

  .p2p-mobile-detail-item {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn {
    flex: 1 1;
    min-width: auto;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {
    grid-template-columns: 1fr;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-item {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
}

/* Close Ad Modal - Mobile Enhanced */
@media (max-width: 576px) {
  .p2p-close-ad-modal {
    border-radius: 20px 20px 0 0;
    max-height: 90vh;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 100%;
    animation: slideUp 0.3s ease-out;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }

    to {
      transform: translateY(0);
    }
  }

  .p2p-modal-overlay {
    padding: 0;
    align-items: center;
  }

  .p2p-close-ad-modal-header {
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }

  .p2p-close-ad-modal-title {
    font-size: 18px;
  }

  .p2p-close-ad-modal-body {
    padding: 20px;
    max-height: calc(90vh - 180px);
    overflow-y: auto;
  }

  .p2p-close-ad-warning {
    padding: 14px;
    border-radius: 12px;
  }

  .p2p-close-ad-warning-content strong {
    font-size: 14px;
  }

  .p2p-close-ad-warning-content p {
    font-size: 12px;
  }

  .p2p-close-ad-summary {
    border-radius: 12px;
    padding: 14px;
  }

  .p2p-close-ad-summary-header {
    margin-bottom: 14px;
    padding-bottom: 10px;
  }

  .p2p-close-ad-summary-pair {
    font-size: 15px;
  }

  .p2p-myads-container {
    padding: 15px;
  }

  .p2p-myads-title {
    font-size: 17px;
  }

  .p2p-close-ad-summary-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .p2p-close-ad-summary-label {
    font-size: 10px;
  }

  .p2p-close-ad-summary-value {
    font-size: 13px;
  }

  .p2p-close-ad-reason-input {
    min-height: 70px;
    font-size: 14px;
  }

  .p2p-close-ad-modal-footer {
    padding: 16px 20px 24px;
    flex-direction: row;
    gap: 12px;
  }

  .p2p-close-ad-btn-cancel,
  .p2p-close-ad-btn-confirm {
    padding: 8px 15px;
    font-size: 12px;
    border-radius: 7px;
  }

  .p2p-close-ad-modal {
    max-width: 90%;
    margin: 0 auto;
  }

}

/* ====================================
     P2P My Ads - Mobile Responsive
     ==================================== */

/* Mobile Header */
@media (max-width: 768px) {
  .p2p-myads-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .p2p-myads-title {
    font-size: 20px;
  }

  .p2p-myads-header .p2p-create-ad-btn {
    width: 100%;
    text-align: center;
    padding: 12px 20px;
    display: flex;
    justify-content: center;
  }
}

/* Mobile Filter Header - Hidden on desktop */
.p2p-mobile-filter-header {
  display: none;
}

/* Mobile Filter Toggle Button */
.p2p-mobile-filter-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #373f4d;
  border: 1px solid #373f4d;
  border-radius: 10px;
  color: #e5e5e5;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-mobile-filter-toggle:hover {
  background: #373f4d;
  border: 1px solid #373f4d;
}

.p2p-mobile-filter-toggle.active {
  background: #373f4d;
  border-color: #22c55e;
  color: #22c55e;
}

.p2p-mobile-filter-toggle i {
  font-size: 18px;
}

.p2p-mobile-filter-toggle span {
  flex: 1 1;
  text-align: left;
}

.p2p-mobile-active-filters {
  display: flex;
  align-items: center;
  gap: 6px;
}

.p2p-active-filter-tag {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
}

.p2p-filter-badge {
  background: rgba(255, 255, 255, 0.15);
  color: #e5e5e5;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  margin-left: 4px;
}

/* Mobile Filter Section */
@media (max-width: 768px) {

  /* Show mobile filter header */
  .p2p-mobile-filter-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    padding: 0 4px;
  }

  .p2p-mobile-filter-toggle {
    flex: 1 1;
  }

  /* Hide filter section by default on mobile */
  .p2p-filter-section {
    display: none;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    padding: 16px;
    background: #12121a;
    border: 1px solid #2a2a3a;
    border-radius: 12px;
    margin-bottom: 16px;
    animation: slideDown 0.2s ease-out;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .p2p-filter-section.show {
    display: grid;
  }

  .p2p-filter-group {
    min-width: unset;
  }

  .p2p-filter-section .p2p-find-orders-btn {
    grid-column: 1 / -1;
    width: 100%;
    background: #f3bb2b;
    color: #181a20;
    border: none;
  }

  .p2p-filter-section .p2p-find-orders-btn:hover {
    background: #16a34a;
  }
}

@media (max-width: 480px) {
  .p2p-filter-section.show {
    grid-template-columns: 1fr;
  }

  button.p2p-myads-action-btn {
    padding: 5px 10px !important;
  }

  .p2p-profile-section-desc {
    font-size: 12px !important;
  }

  .p2p-mobile-filter-header {
    flex-wrap: wrap;
  }

  .p2p-mobile-filter-toggle {
    width: 100%;
    flex: none;
    justify-content: flex-start;
  }

  .p2p-mobile-active-filters {
    width: 100%;
    margin-top: 8px;
  }
}

@media (max-width: 400px) {
  .p2p-mobile-filter-toggle {
    padding: 10px 14px;
    font-size: 13px;
  }

  .p2p-active-filter-tag {
    font-size: 11px;
    padding: 3px 8px;
  }
}

/* Hide mobile filter header on desktop */
@media (min-width: 769px) {
  .p2p-mobile-filter-header {
    display: none !important;
  }

  .p2p-filter-section {
    display: flex !important;
  }
}

/* Mobile Stats Cards */
@media (max-width: 768px) {
  .p2p-myads-stats-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }

  .p2p-myads-stat-card {
    padding: 12px 14px;
  }

  .p2p-myads-stat-card-label {
    font-size: 10px;
    margin-bottom: 6px;
  }

  .p2p-myads-stat-card-value {
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .p2p-myads-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .p2p-mobile-detail-item {
    flex-direction: row;
    gap: 12px;
  }

  .p2p-myads-stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }

}

@media (max-width: 400px) {
  .p2p-myads-stats-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .p2p-myads-stat-card {
    padding: 10px 12px;
  }

  .p2p-myads-stat-card-value {
    font-size: 14px;
  }
}

/* Legacy Mobile Stats Bar */
@media (max-width: 768px) {
  .p2p-myads-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    padding: 14px 16px;
    text-align: center;
  }

  .p2p-myads-stat-item {
    align-items: center;
  }

  .p2p-myads-stat-value {
    font-size: 16px;
  }

  .p2p-myads-stat-label {
    font-size: 10px;
  }
}

/* Mobile Card Improvements */
@media (max-width: 991px) {
  .p2p-orders-table-wrapper {
    display: none;
  }

  .p2p-mobile-orders-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

}

@media (min-width: 992px) {
  .p2p-mobile-orders-list {
    display: none;
  }
}

.p2p-mobile-order-card {
  background: #12121a00;
  border: 1px solid #2c2c2c;
  border-radius: 12px;
  padding: 16px;
  transition: border-color 0.2s;
}

.p2p-mobile-order-card:hover {
  border-color: rgba(55, 65, 81, 0.5);
}

.p2p-mobile-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0px;
  padding-bottom: 14px;
  border-bottom: 1px solid #1e1e2d;
}

.p2p-mobile-card-user {
  display: flex;
  align-items: center;
  gap: 10px;
}

button.p2p-mobile-view-btn i {
  color: #535c6b;
}

.p2p-mobile-card-user-info h4 {
  font-size: 13px;
  font-weight: 500;
  color: #d1d5db;
  margin: 0px 0px 2px;
}

.p2p-mobile-card-user-info p {
  margin: 0;
}

.p2p-mobile-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.p2p-mobile-card-price {
  text-align: right;
}

.p2p-mobile-card-price .p2p-value {
  font-size: 16px;
  font-weight: 600;
  color: #a1a1aa;
}

.p2p-mobile-card-price .p2p-currency {
  font-size: 11px;
  color: #6b7280;
}

.p2p-mobile-card-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 0px;
  border: none;
}

.p2p-mobile-detail-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-mobile-detail-label {
  font-size: 11px;
  color: #52525b;
  letter-spacing: 0.3px;
}

.p2p-mobile-detail-value {
  font-size: 13px;
  color: #9ca3af;
  font-weight: 500;
}

.p2p-mobile-card-payments {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
}

.p2p-mobile-payment-badge {
  padding: 4px 8px;
  background: rgba(55, 65, 81, 0.3);
  border-radius: 4px;
  font-size: 11px;
  color: #9ca3af;
}

.p2p-mobile-card-actions {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding-top: 14px;
  border-top: 1px solid #1e1e2d;
}

.p2p-mobile-card-actions .p2p-myads-action-btn {
  flex: unset;
  padding: 10px 8px;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
}

@media (max-width: 400px) {
  .p2p-mobile-card-actions {
    grid-template-columns: 1fr 1fr 1fr;
  }

  /* .p2p-mobile-card-actions .p2p-myads-action-btn:first-child {
      grid-column: 1 / -1;
    } */
}

.p2p-myads-action-btn {
  min-height: 32px;
}

/* Mobile Expanded Details */
.p2p-mobile-expanded-details {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #1e1e2d;
}

.p2p-mobile-expanded-details .p2p-myads-expanded-grid {
  grid-template-columns: repeat(1, 1fr);
  gap: 12px;
}

@media (max-width: 480px) {
  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}

.p2p-mobile-expanded-details .p2p-myads-payment-details {
  grid-template-columns: 1fr;
}

.p2p-mobile-expanded-details .p2p-myads-payment-card {
  padding: 12px;
}

.p2p-mobile-expanded-details .p2p-myads-payment-qr img {
  width: 60px;
  height: 60px;
}

/* Mobile Pagination */
/* Mobile Pagination */
.p2p-pagination-wrapper.p2p-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 16px;
  margin-top: 8px;
  background: rgba(18, 18, 26, 0.6);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-info {
  font-size: 11px;
  color: #6b7280;
  text-align: center;
}

.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-buttons,
.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-controls {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.p2p-pagination-wrapper.p2p-mobile .p2p-page-current {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
  background: rgba(255, 220, 136, 0.2);
  border-radius: 6px;
}

.p2p-pagination-wrapper.p2p-mobile .p2p-page-btn {
  min-width: 36px;
  height: 36px;
  font-size: 13px;
}

@media (max-width: 991px) {
  .p2p-pagination-wrapper:not(.p2p-mobile) {
    display: none;
  }

  .p2p-payment-method-qr {
    flex-direction: row-reverse;
    justify-content: space-between;
  }


}

@media (min-width: 992px) {
  .p2p-pagination-wrapper.p2p-mobile {
    display: none;
  }
}

@media (max-width: 400px) {
  .p2p-pagination-wrapper.p2p-mobile .p2p-page-btn {
    min-width: 32px;
    height: 32px;
    font-size: 12px;
  }
}

/* Mobile Empty State */
.p2p-empty-state-mobile {
  text-align: center;
  padding: 48px 20px;
  background: #373F4D;
  border-radius: 12px;
  border: 1px solid #373F4D;
}

.p2p-empty-state-mobile .p2p-empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.p2p-empty-state-mobile p {
  color: #6b7280;
  font-size: 14px;
  margin: 0 0 20px 0;
}

/* Touch-friendly improvements */
@media (max-width: 768px) {
  .p2p-myads-action-btn {
    min-height: 32px;
    min-width: 44px;
  }

  .p2p-filter-select {
    min-height: 44px;
    font-size: 14px;
  }

  .p2p-page-btn {
    min-width: 36px;
    min-height: 36px;
  }

  .p2p-close-ad-reason-input {
    font-size: 16px;
    /* Prevents zoom on iOS */
  }


  .p2p-close-ad-reason-input {
    font-size: 13px;
  }
}

/* ====================================
     P2P Profile Page Styles
     ==================================== */

.p2p-profile-header {
  background: rgba(18, 18, 26, 0.6);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  padding: 24px;
  margin-bottom: 24px;
}

.p2p-profile-header-inner {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
}

.p2p-profile-user {
  display: flex;
  align-items: center;
  gap: 16px;
}

.p2p-profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
  color: #e5e5e5;
  position: relative;
}

.p2p-profile-online-dot {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 14px;
  height: 14px;
  background: #4ade80;
  border-radius: 50%;
  border: 2px solid #12121a;
}

.p2p-profile-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.p2p-profile-name {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #e5e5e5;
  display: flex;
  align-items: center;
  gap: 6px;
}

.p2p-profile-verified-badge {
  display: inline-flex;
  align-items: center;
  color: #bd83cb;
  font-size: 18px;
}

.p2p-profile-verified-badge i {
  font-size: inherit;
}

.p2p-profile-edit-btn {
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  font-size: 16px;
  padding: 4px;
  transition: color 0.2s;
}

.p2p-profile-edit-btn:hover {
  color: #e5e5e5;
}

.p2p-profile-badges {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.p2p-profile-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #6b7280;
}

.p2p-profile-badge.verified {
  color: #4ade80;
}

.p2p-profile-funding {
  display: flex;
  align-items: center;
  gap: 24px;
}

.p2p-profile-funding-label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-size: 13px;
  margin-bottom: 4px;
}

.p2p-profile-eye-btn {
  background: transparent;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 2px;
}

.p2p-profile-funding-value {
  color: #9ca3af;
  font-size: 16px;
}

/* Profile Tabs */
.p2p-profile-tabs {
  margin-bottom: 24px;
  overflow-x: auto;
}

.p2p-profile-tabs-inner {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
}

.p2p-profile-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  color: #9ca3af;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.p2p-profile-tab:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #d1d5db;
}

.p2p-profile-tab.active {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

.p2p-profile-tab i {
  font-size: 15px;
}

/* Section Header */
.p2p-profile-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.p2p-profile-section-desc {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
}

/* Payment Methods Grid */
.p2p-payment-methods-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

.p2p-payment-method-card {
  background: rgba(18, 18, 26, 0.6);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  overflow: hidden;
}

.p2p-payment-method-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: none;
  background: rgb(13 13 20 / 14%);
}

.p2p-payment-method-title {
  margin: 0;
  color: #d1d5db;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.p2p-payment-method-type-badge {
  font-size: 10px;
  padding: 2px 6px;
  background: rgba(255, 255, 255, 0.08);
  color: #9ca3af;
  border-radius: 4px;
  font-weight: 500;
}

.closebtn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #888;
  font-size: 16px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  padding: 2px 4px;
}

.p2p-payment-method-actions {
  display: flex;
  gap: 8px;
}

.p2p-payment-method-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid;
}

.p2p-payment-method-btn.edit {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.1);
  color: #9ca3af;
}

.p2p-payment-method-btn.edit:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #e5e5e5;
}

.p2p-payment-method-btn.delete {
  background: rgba(127, 29, 29, 0.15);
  border-color: rgba(153, 27, 27, 0.25);
  color: #fca5a5;
}

.p2p-payment-method-btn.delete:hover {
  background: rgba(127, 29, 29, 0.25);
}

.p2p-payment-method-body {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.p2p-payment-method-field {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.p2p-payment-method-label {
  color: #6b7280;
  font-size: 13px;
}

.p2p-payment-method-value {
  color: #d1d5db;
  font-size: 13px;
  text-align: right;
  word-break: break-all;
}

.p2p-payment-method-qr {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.p2p-payment-method-qr img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  background: #fff;
  border-radius: 6px;
  padding: 4px;
}

.p2p-payment-method-qr span {
  font-size: 12px;
  color: #6b7280;
}

/* Empty State Card */
.p2p-empty-state-card {
  background: none;
  border-radius: 12px;
  /* border: 1px solid rgba(255, 255, 255, 0.06); */
  padding: 48px 24px;
  text-align: center;
}

.p2p-empty-state-card i {
  font-size: 48px;
  color: #52525b;
  margin-bottom: 16px;
  display: block;
}

.p2p-empty-state-card p {
  color: #6b7280;
  font-size: 14px;
  margin: 0 0 20px 0;
}


@media (max-width: 991px) {

  .p2p-order-status-badge {
    background-color: #333b47 !important;
    color: #878787 !important;
    border-color: #333b47 !important;
  }

  .p2p-order-status-badge.status_complete {
    color: #dddada !important;
  }



  .p2p-profile-avatar {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }

  .p2p-profile-name-row {
    margin-bottom: 0px;
  }

  .p2p-payment-method-card {
    background: rgb(18 18 26 / 0%);
    border: 1px solid #413f3f;
  }

  .p2p-payment-method-body {
    padding: 12px 15px;
  }

  button.p2p-myads-action-btn {
    width: -moz-fit-content;
    width: fit-content;
    align-items: end;
  }

  .rightalien {
    text-align: right;
  }

  .p2p-mobile-card-details {
    grid-template-columns: 1fr;
  }


  .p2p-mobile-detail-item {
    flex-direction: row;
    gap: 12px;
    justify-content: space-between;
  }

  .p2p-mobile-card-details {
    padding: 14px 0px 0px;
  }

  .p2p-mobile-payment-badge {
    padding: 3px 7px;
    margin-left: 4px;
  }

}


@media (max-width: 768px) {
  .p2p-empty-state-card {
    padding: 32px 16px;
    border-radius: 10px;
  }

  .p2p-empty-state-card i {
    font-size: 40px;
    margin-bottom: 12px;
  }

  .p2p-empty-state-card p {
    font-size: 13px;
    margin-bottom: 16px;
  }

  .p2p-mobile-card-price {
    justify-content: end;
  }

}





@media (max-width: 991px) {


  .p2p-layout-wrapper {
    background-color: #181a20;
  }


  .p2p-mobile-detail-label {
    color: #828289;
  }

  .p2p-mobile-view-btn {
    color: #eaecef;
  }

  .p2p-mobile-detail-value {
    color: #eaecef;
  }

  .p2p-mobile-view-btn {
    color: #eaecef !important;
  }

  .p2p-mobile-detail-value {
    font-size: 12px;
    letter-spacing: 0.3px;
  }

  span.p2p-mobile-detail-value.valueprice {
    font-size: 14px;
  }

  .p2p-mobile-card-avatar {
    width: 36px;
    height: 36px;
  }



}


@media (max-width: 400px) {
  .p2p-empty-state-card {
    padding: 24px 12px;
  }

  .p2p-empty-state-card i {
    font-size: 36px;
  }

  .p2p-empty-state-card p {
    font-size: 12px;
  }
}

/* Add Payment Modal */
.p2p-add-payment-modal {
  background: #12121a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: p2p-modal-slide-in 0.2s ease-out;
}

.p2p-add-payment-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.p2p-add-payment-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0;
}

.p2p-modal-close-btn {
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  transition: color 0.2s;
}

.p2p-modal-close-btn:hover {
  color: #e5e5e5;
}

.p2p-add-payment-modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1 1;
}

.p2p-add-payment-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  justify-content: flex-end;
}

/* Payment Type List */
.p2p-payment-type-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.p2p-payment-type-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-payment-type-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.12);
}

.p2p-payment-type-name {
  font-size: 14px;
  color: #d1d5db;
  font-weight: 500;
}

.p2p-payment-type-item i {
  color: #6b7280;
  font-size: 18px;
}

/* Payment Form */
.p2p-payment-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.p2p-payment-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.p2p-payment-form-label {
  font-size: 13px;
  color: #9ca3af;
}

.p2p-required {
  color: #ef4444;
  margin-left: 4px;
}

.p2p-payment-form-input {
  padding: 12px 14px;
  background: rgba(10, 10, 15, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #e5e5e5;
  font-size: 14px;
  transition: border-color 0.2s;
}

.p2p-payment-form-input:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.2);
}

.p2p-payment-form-input::placeholder {
  color: #52525b;
}

.p2p-payment-file-input {
  position: relative;
}

.p2p-payment-file-input input[type="file"] {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.p2p-payment-file-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  background: rgba(10, 10, 15, 0.8);
  border: 1px dashed rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.p2p-payment-file-label:hover {
  border-color: rgba(255, 255, 255, 0.25);
  color: #9ca3af;
}

.p2p-payment-file-label i {
  font-size: 20px;
}

/* Modal Buttons */
.p2p-modal-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.p2p-modal-btn.primary {
  background: rgba(255, 255, 255, 0.1);
  color: #e5e5e5;
}

.p2p-modal-btn.primary:hover {
  background: rgba(255, 255, 255, 0.15);
}

.p2p-modal-btn.secondary {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #9ca3af;
}

.p2p-modal-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.04);
  color: #d1d5db;
}

.p2p-modal-btn.danger {
  background: rgba(153, 27, 27, 0.8);
  color: #fecaca !important;
}

.p2p-modal-btn.danger:hover {
  background: rgba(153, 27, 27, 1);
}

/* Delete Modal */
.p2p-delete-modal {
  background: #12121a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  width: 100%;
  max-width: 400px;
  padding: 32px 24px;
  text-align: center;
  animation: p2p-modal-slide-in 0.2s ease-out;
}

.p2p-delete-modal-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  background: rgba(127, 29, 29, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p2p-delete-modal-icon i {
  font-size: 28px;
  color: #fca5a5;
}

.p2p-delete-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0 0 12px 0;
}

.p2p-delete-modal-desc {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.p2p-delete-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

/* Profile Mobile Responsive */
@media (max-width: 768px) {
  .p2p-profile-header-inner {
    flex-direction: column;
  }

  .p2p-profile-funding {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .p2p-profile-tabs-inner {
    gap: 8px;
  }

  .p2p-profile-tab {
    padding: 8px 14px;
    font-size: 12px;
  }

  .p2p-profile-section-header {
    flex-direction: column;
    align-items: stretch;
  }

  .p2p-payment-methods-grid {
    grid-template-columns: 1fr;
  }

  .p2p-payment-method-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .p2p-payment-method-actions {
    width: 100%;
  }

  .p2p-payment-method-btn {
    flex: 1 1;
    justify-content: center;
  }

  .p2p-add-payment-modal,
  .p2p-delete-modal {
    margin: 16px;
    max-height: calc(100vh - 32px);
  }
}

/* ============================================
     P2P ORDER DETAILS STYLES
     ============================================ */

.p2p-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: #a8b4c4;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 0;
  margin-bottom: 20px;
  transition: color 0.2s;
}

.p2p-back-btn:hover {
  color: #bd83cb;
}

.p2p-back-btn i {
  font-size: 20px;
}

.p2p-order-header {
  background: linear-gradient(135deg, #12121a 0%, #0d0d14 100%);
  border-radius: 16px;
  border: 1px solid #1e1e2d;
  padding: 24px;
  margin-bottom: 24px;
}

.p2p-order-header-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 24px;
}

.p2p-order-title-section {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.p2p-order-title {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #22c55e;
}

.p2p-order-status-badge {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

/* Timer Styles */
.p2p-order-timer {
  text-align: center;
}

.p2p-order-timer.expired {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 12px;
  padding: 12px 20px;
}

.p2p-timer-label {
  display: block;
  color: #6b7280;
  font-size: 12px;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.p2p-timer-expired {
  color: #ef4444;
  font-size: 16px;
  font-weight: 600;
}

.p2p-timer-display {
  display: flex;
  align-items: center;
  gap: 8px;
}

.p2p-timer-unit {
  text-align: center;
}

.p2p-timer-digits {
  display: flex;
  gap: 4px;
}

.p2p-timer-digit {
  background: linear-gradient(180deg, #1a1a24 0%, #0d0d14 100%);
  border: 1px solid #2a2a3a;
  border-radius: 8px;
  padding: 10px 14px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  font-family: 'SF Mono', 'Monaco', monospace;
  min-width: 42px;
  text-align: center;
}

.p2p-timer-unit-label {
  display: block;
  color: #6b7280;
  font-size: 11px;
  margin-top: 4px;
  text-transform: uppercase;
}

.p2p-timer-separator {
  color: #6b7280;
  font-size: 28px;
  font-weight: 700;
  margin-top: -20px;
}

/* Order Info Row */
.p2p-order-info-row {
  display: flex;
  gap: 32px;
  padding-top: 20px;
  border-top: 1px solid #1e1e2d;
  flex-wrap: wrap;
}

.p2p-order-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.p2p-order-info-label {
  color: #6b7280;
  font-size: 12px;
}

.p2p-order-info-value {
  color: #e5e5e5;
  font-size: 14px;
}

.p2p-order-info-value.clickable {
  color: #a8b4c4;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.p2p-order-info-value.clickable:hover {
  color: #bd83cb;
}

.p2p-order-info-value i {
  font-size: 14px;
}

/* Order Content Layout */
.p2p-order-content {
  display: grid;
  grid-template-columns: minmax(300px, 1fr) minmax(400px, 480px);
  gap: 24px;
}

.p2p-order-main {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 520px;
}

.p2p-order-sidebar {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Order Cards */
.p2p-order-card {
  background: #12121a;
  border-radius: 12px;
  border: 1px solid #1e1e2d;
  padding: 20px;
}

.p2p-order-card-title {
  margin: 0 0 16px 0;
  color: #e5e5e5;
  font-size: 16px;
  font-weight: 600;
}

/* Order Summary Grid */
.p2p-order-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
}

.p2p-order-summary-item {
  background: #0d0d14;
  border-radius: 10px;
  padding: 16px;
  text-align: center;
}

.p2p-order-summary-item.highlight {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(34, 197, 94, 0.05) 100%);
  border: 1px solid rgba(34, 197, 94, 0.2);
}

.p2p-summary-value {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #e5e5e5;
  margin-bottom: 4px;
}

.p2p-summary-value.green {
  color: #22c55e;
}

.p2p-summary-label {
  color: #6b7280;
  font-size: 12px;
}

/* Payment Warning */
.p2p-payment-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: rgba(251, 191, 36, 0.1);
  border: 1px solid rgba(251, 191, 36, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
}

.p2p-payment-warning i {
  color: #fbbf24;
  font-size: 18px;
  flex-shrink: 0;
}

.p2p-payment-warning span {
  color: #fbbf24;
  font-size: 13px;
  line-height: 1.5;
}

/* Payment Method Badges */
.p2p-payment-method-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

/* Payment Detail Card */
.p2p-payment-detail-card {
  background: #0d0d14;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 12px;
}

.p2p-payment-detail-card:last-child {
  margin-bottom: 0;
}

.p2p-payment-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.p2p-payment-type-badge {
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  color: #fff;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
}

.p2p-payment-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.p2p-payment-qr img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  border: 2px solid #2a2a3a;
  cursor: pointer;
  transition: transform 0.2s;
}

.p2p-payment-qr img:hover {
  transform: scale(1.05);
}

.p2p-payment-qr span {
  color: #6b7280;
  font-size: 11px;
}

.p2p-payment-detail-list {
  display: flex;
  flex-direction: column;
}

.p2p-payment-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #1e1e2d;
}

.p2p-payment-detail-row:last-child {
  border-bottom: none;
}

.p2p-payment-detail-label {
  color: #6b7280;
  font-size: 13px;
}

.p2p-payment-detail-value {
  color: #a8b4c4;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s;
}

.p2p-payment-detail-value:hover {
  color: #bd83cb;
}

.p2p-payment-detail-value i {
  font-size: 14px;
  opacity: 0.7;
}

/* Order Actions */
.p2p-order-action-text {
  color: #9ca3af;
  font-size: 14px;
  margin: 0 0 16px 0;
  line-height: 1.6;
}

.p2p-order-action-text .highlight {
  color: #22c55e;
  font-weight: 500;
}

.p2p-order-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.p2p-order-actions .p2p-confirm-buy-btn {
  flex: 1 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.p2p-order-actions .p2p-cancel-btn {
  min-width: 140px;
}

/* Order Remarks */
.p2p-order-remarks {
  color: #9ca3af;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  white-space: pre-wrap;
}

/* User Card */
.p2p-order-user-card {
  display: flex;
  flex-direction: column;
}

.p2p-order-user-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-order-user-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.p2p-order-user-avatar.buyer {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
}

.p2p-order-user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.p2p-order-user-avatar span {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}

.p2p-user-online-dot {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid #12121a;
}

.p2p-order-user-info h4 {
  margin: 0 0 2px 0;
  color: #e5e5e5;
  font-size: 15px;
  font-weight: 600;
}

.p2p-user-role {
  color: #6b7280;
  font-size: 12px;
}

.p2p-user-role.buyer {
  color: #22c55e;
}

/* Chat Card */
.p2p-chat-card {
  display: flex;
  flex-direction: column;
  min-height: 300px;
}

.p2p-chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.p2p-chat-header h4 {
  margin: 0;
  color: #e5e5e5;
  font-size: 14px;
  font-weight: 600;
}

.p2p-chat-expand-btn {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  color: #888;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.p2p-chat-expand-btn:hover {
  background: #1a1a24;
  color: #e5e5e5;
}

.p2p-chat-preview {
  flex: 1 1;
  overflow-y: auto;
  margin-bottom: 12px;
}

.p2p-chat-message {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.p2p-chat-preview .p2p-chat-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3d4a5c, #2d3748);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c9d1d9;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.p2p-chat-bubble {
  background: #1a1a24;
  border-radius: 12px;
  padding: 10px 14px;
  max-width: 85%;
}

.p2p-chat-bubble p {
  margin: 0;
  color: #d1d5db;
  font-size: 13px;
  line-height: 1.5;
}

.p2p-chat-time {
  display: block;
  color: #6b7280;
  font-size: 10px;
  margin-top: 4px;
}

.p2p-chat-input-wrapper {
  display: flex;
  gap: 8px;
  background: #0d0d14;
  border-radius: 8px;
  padding: 8px 12px;
}

.p2p-chat-input {
  flex: 1 1;
  background: transparent;
  border: none;
  color: #e5e5e5;
  font-size: 14px;
  outline: none;
}

.p2p-chat-input::placeholder {
  color: #6b7280;
}

.p2p-chat-preview .p2p-chat-send-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: linear-gradient(135deg, #4a9d6e, #3d8a5f);
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.p2p-chat-preview .p2p-chat-send-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(74, 157, 110, 0.3);
}

/* Order Details Responsive */
@media (max-width: 1200px) {
  .p2p-order-content {
    grid-template-columns: minmax(280px, 1fr) minmax(350px, 420px);
  }

  .p2p-order-main {
    max-width: 100%;
  }


}

@media (max-width: 1024px) {
  .p2p-order-content {
    display: block;
  }

  .p2p-order-main {
    max-width: 100%;
  }

  .p2p-order-sidebar {
    display: flex;
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .p2p-order-header {
    padding: 16px;
  }

  .p2p-order-header-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .p2p-order-title {
    font-size: 22px;
  }

  .p2p-order-timer {
    width: 100%;
  }

  .p2p-timer-display {
    justify-content: center;
  }

  .p2p-timer-digit {
    padding: 8px 10px;
    font-size: 20px;
    min-width: 36px;
  }

  .p2p-order-info-row {
    gap: 16px;
  }

  .p2p-order-info-item {
    min-width: calc(50% - 8px);
  }

  .p2p-order-card {
    padding: 16px;
  }

  .p2p-order-summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .p2p-summary-value {
    font-size: 16px;
  }

  .p2p-order-actions {
    flex-direction: column;
  }

  .p2p-order-actions .p2p-confirm-buy-btn,
  .p2p-order-actions .p2p-cancel-btn {
    width: 100%;
    min-width: unset;
  }

  .p2p-order-sidebar {
    grid-template-columns: 1fr;
  }

  .p2p-payment-detail-header {
    flex-direction: column;
    gap: 12px;
  }

  .p2p-payment-qr {
    align-self: flex-start;
  }

  .p2p-main-content.p2p-mobile .p2p-mobile-card-actions .p2p-myads-action-btn {
    min-width: 100%;
  }

}


@media (max-width: 480px) {
  .p2p-order-title-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn {
    padding: 5px 8px;
    font-size: 11px;
  }

  .p2p-profile-header {
    padding: 16px;
    margin-bottom: 15px;
  }

  .p2p-profile-header-inner.mobileview {
    gap: 15px;
  }


  .p2p-payment-method-title {
    margin: 0;
    font-size: 13px;
    gap: 4px;
  }

  .p2p-payment-method-header.mobileview {
    padding: 12px 15px;
  }

  .p2p-order-summary-grid {
    grid-template-columns: 1fr;
  }

  .p2p-timer-digit {
    padding: 6px 8px;
    font-size: 18px;
    min-width: 32px;
  }

  .p2p-timer-separator {
    font-size: 22px;
  }

  .p2p-payment-detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}

/* ============================================
     P2P ORDERS LIST STYLES
     ============================================ */

.p2p-orders-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.p2p-orders-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #e5e5e5;
}

.p2p-orders-count {
  background: rgba(255, 220, 136, 0.1);
  color: #a8b4c4;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

/* Order Type Cell */
.p2p-order-type-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-order-type {
  font-weight: 600;
  font-size: 14px;
}

.p2p-order-type.buy {
  color: #22c55e;
}

.p2p-order-type.sell {
  color: #ef4444;
}

.p2p-order-crypto {
  color: #e5e5e5;
  font-size: 14px;
  font-weight: 500;
}

.p2p-order-date {
  color: #6b7280;
  font-size: 12px;
}

/* Order ID */
.p2p-order-id {
  color: #a8b4c4;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s;
}

.p2p-order-id:hover {
  color: #bd83cb;
}

.p2p-order-id i {
  font-size: 14px;
  opacity: 0.7;
}

/* Amount Cell */
.p2p-amount-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-fiat-amount {
  color: #eaecef;
  font-weight: 600;
  font-size: 14px;
}

.p2p-crypto-amount {
  color: #9ca3af;
  font-size: 13px;
}

/* Counterparty Cell */
.p2p-counterparty-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.p2p-counterparty-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.p2p-counterparty-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.p2p-counterparty-avatar span {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.p2p-counterparty-name {
  color: #eaecef;
  font-size: 14px;
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Order Status Badge */
.p2p-order-status-badge {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  background-color: #333b47 !important;
  color: #878787 !important;
  border-color: #333b47 !important;
}

/* Order Action Button */
.p2p-order-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: rgb(255 220 136 / 0%);
  border: 1px solid rgba(255, 220, 136, 0.2);
  border-radius: 6px;
  color: #eaecef;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.p2p-order-status-badge.status_complete {
  color: #dddada !important;
}

.p2p-order-action-btn:hover {
  background: rgba(255, 220, 136, 0.2);
  border-color: rgba(255, 220, 136, 0.4);
}

.p2p-order-action-btn i {
  font-size: 15px;
}

.p2p-unread-badge {
  color: #f59e0b;
  font-weight: 600;
  font-size: 12px;
}

/* Table Row Hover */
.p2p-orders-table tbody tr {
  cursor: pointer;
  transition: background 0.2s;
  background: none !important;
  border: none;
}

.volumedatails {
  width: 100%;
  background-color: #2F3641;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #454C59;
}

.volumedatails .p2p-myads-expanded-item {
  flex-direction: row;
  gap: 12px;
}

.p2p-orders-table tbody tr:hover {
  background: #2B313C;
}

/* Mobile Order Card Footer */
.p2p-mobile-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  margin-top: 12px;
  border-top: 1px solid #1e1e2d;
}

.p2p-order-id-mobile {
  color: #eaecef;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.p2p-order-id-mobile:hover {
  color: #a8b4c4;
}

.p2p-order-id-mobile i {
  font-size: 13px;
}

.p2p-mobile-view-btn {
  background: transparent;
  border: none;
  color: #a8b4c4;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
}

.p2p-mobile-view-btn i {
  font-size: 16px;
}

/* Mobile Card Click Effect */
.p2p-mobile-order-card {
  cursor: pointer;
  transition: all 0.2s;
}

.p2p-mobile-order-card:hover {
  border-color: rgba(255, 220, 136, 0.3);
  background: rgba(255, 220, 136, 0.02);
}

/* Orders Page Responsive */
@media (max-width: 1200px) {
  .p2p-counterparty-name {
    max-width: 100px;
  }
}

@media (max-width: 992px) {

  .p2p-orders-table th:nth-child(2),
  .p2p-orders-table td:nth-child(2) {
    display: none;
  }

  .p2p-counterparty-name {
    max-width: 80px;
  }
}

@media (max-width: 768px) {
  .p2p-orders-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .p2p-orders-title {
    font-size: 20px;
  }
}

/* Order Details - Value Colors */
.p2p-summary-value.red {
  color: #ef4444 !important;
}

.p2p-summary-value.green {
  color: #22c55e !important;
}

/* Order Expired Notice */
.p2p-order-expired-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 8px;
  color: #ef4444;
  font-size: 14px;
  font-weight: 500;
}

.p2p-order-expired-notice i {
  font-size: 20px;
}

/* Cancel Button Icon */
.p2p-cancel-btn i {
  font-size: 16px;
  margin-right: 4px;
}

/* User Payment Method Styles for Sell Orders */
.p2p-user-payment-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.p2p-payment-type-badge {
  background: linear-gradient(135deg, #ffdc88, #f4b609);
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.p2p-payment-name {
  font-size: 14px;
  font-weight: 500;
  color: #e2e8f0;
}

.p2p-payment-detail {
  font-size: 12px;
  color: #94a3b8;
}

.p2p-no-payment-methods {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  text-align: center;
  gap: 8px;
}

.p2p-no-payment-methods i {
  font-size: 48px;
  color: #64748b;
  margin-bottom: 8px;
}

.p2p-no-payment-methods p {
  font-size: 16px;
  font-weight: 500;
  color: #e2e8f0;
  margin: 0;
}

.p2p-no-payment-methods span {
  font-size: 13px;
  color: #94a3b8;
}

.p2p-add-payment-btn {
  margin-top: 16px;
  padding: 10px 24px;
  background: linear-gradient(135deg, #ffdc88, #f4b609);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-add-payment-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 220, 136, 0.3);
}

/* Full Payment Option Card (for Sell Orders) */
.p2p-payment-option-full {
  display: block;
  background: rgba(30, 41, 59, 0.5);
  border: 1px solid rgba(148, 163, 184, 0.15);
  border-radius: 12px;
  padding: 0;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
}

.p2p-payment-option-full:hover {
  border-color: rgba(255, 220, 136, 0.4);
  background: rgba(30, 41, 59, 0.7);
}

.p2p-payment-option-full.p2p-selected {
  border-color: #bd83cb;
  background: rgba(255, 220, 136, 0.1);
}

.p2p-user-payment-card {
  padding: 16px;
}

.p2p-user-payment-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
}

.p2p-user-payment-header .p2p-payment-name {
  flex: 1 1;
  font-size: 15px;
  font-weight: 600;
  color: #e2e8f0;
}

.p2p-user-payment-header input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: #bd83cb;
  cursor: pointer;
}

.p2p-user-payment-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.p2p-payment-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-payment-field-label {
  font-size: 11px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.p2p-payment-field-value {
  font-size: 14px;
  color: #e2e8f0;
  font-weight: 500;
  word-break: break-all;
}

.p2p-payment-qr-preview {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  display: flex;
  justify-content: center;
}

.p2p-payment-qr-preview img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: contain;
  background: #fff;
  padding: 4px;
}

@media (max-width: 768px) {
  .p2p-payment-option-full {
    border-radius: 10px;
    margin-bottom: 10px;
  }

  .p2p-user-payment-card {
    padding: 14px;
  }

  .p2p-user-payment-header {
    margin-bottom: 10px;
    padding-bottom: 10px;
  }

  .p2p-user-payment-header .p2p-payment-name {
    font-size: 14px;
  }

  .p2p-payment-field-label {
    font-size: 10px;
  }

  .p2p-payment-field-value {
    font-size: 13px;
  }

  .p2p-payment-qr-preview img {
    width: 70px;
    height: 70px;
  }
}

@media (max-width: 480px) {
  .p2p-user-payment-details {
    grid-template-columns: 1fr;
  }

  .p2p-user-payment-card {
    padding: 12px;
  }

  .p2p-payment-qr-preview img {
    width: 60px;
    height: 60px;
  }
}

/* No Payment Methods State Mobile */
@media (max-width: 768px) {
  .p2p-no-payment-methods {
    padding: 24px 16px;
  }

  .p2p-no-payment-methods i {
    font-size: 36px;
    margin-bottom: 12px;
  }

  .p2p-no-payment-methods p {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .p2p-no-payment-methods span {
    font-size: 12px;
  }

  .p2p-add-payment-btn {
    padding: 12px 20px;
    font-size: 13px;
    margin-top: 14px;
  }
}

@media (max-width: 400px) {
  .p2p-no-payment-methods i {
    font-size: 32px;
  }

  .p2p-no-payment-methods p {
    font-size: 13px;
  }

  .p2p-add-payment-btn {
    padding: 10px 16px;
    font-size: 12px;
    width: 100%;
  }
}

/* ============================================
     P2P ORDER PROGRESS BAR STYLES
     ============================================ */

.p2p-order-progress-container {
  background: rgba(20, 22, 30, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
}

.p2p-order-progress {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.p2p-progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: 1;
}

.p2p-progress-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(40, 45, 55, 0.8);
  border: 2px solid rgba(100, 110, 130, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-size: 18px;
  transition: all 0.3s ease;
}

.p2p-progress-step.active .p2p-progress-icon {
  background: rgba(212, 168, 83, 0.15);
  border-color: #d4a853;
  color: #d4a853;
  box-shadow: 0 0 20px rgba(212, 168, 83, 0.2);
}

.p2p-progress-step.completed .p2p-progress-icon {
  background: rgba(74, 157, 110, 0.15);
  border-color: #4a9d6e;
  color: #4a9d6e;
}

.p2p-progress-label {
  font-size: 12px;
  color: #6b7280;
  text-align: center;
  max-width: 80px;
  line-height: 1.3;
}

.p2p-progress-step.active .p2p-progress-label {
  color: #d4a853;
  font-weight: 500;
}

.p2p-progress-step.completed .p2p-progress-label {
  color: #4a9d6e;
}

.p2p-progress-line {
  flex: 1 1;
  height: 2px;
  background: rgba(100, 110, 130, 0.2);
  margin: 0 -10px;
  margin-bottom: 30px;
  transition: background 0.3s ease;
}

.p2p-progress-line.completed {
  background: linear-gradient(90deg, #4a9d6e, #4a9d6e);
}

/* Quick Order Info */
.p2p-order-quick-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.p2p-quick-info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.p2p-quick-label {
  font-size: 12px;
  color: #6b7280;
}

.p2p-quick-value {
  font-size: 16px;
  font-weight: 600;
  color: #e2e8f0;
}

.p2p-quick-value.highlight-green {
  color: #4a9d6e;
}

.p2p-quick-value.highlight-red {
  color: #c75b5b;
}

.p2p-quick-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.08);
}

/* Progress Responsive */
@media (max-width: 768px) {
  .p2p-order-progress-container {
    padding: 20px 16px;
  }

  .p2p-progress-icon {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .p2p-progress-label {
    font-size: 10px;
    max-width: 60px;
  }

  .p2p-order-quick-info {
    gap: 16px;
  }

  .p2p-quick-value {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .p2p-order-progress {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }

  .p2p-progress-line {
    display: none;
  }

  .p2p-payment-type-item {
    padding: 7px 12px;
  }

  .p2p-payment-type-name {
    font-size: 12px;
  }



  .p2p-progress-step {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 8px);
    padding: 12px;
    background: rgba(30, 35, 45, 0.5);
    border-radius: 12px;
  }

  .p2p-progress-label {
    max-width: 100%;
  }

  .p2p-order-quick-info {
    flex-direction: column;
    gap: 12px;
  }

  .p2p-quick-divider {
    width: 100%;
    height: 1px;
  }

  .p2p-quick-info-item {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  .p2p-payment-form-input {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 12px;
  }

  .p2p-add-payment-modal-header {
    padding: 10px 18px;
  }

  .p2p-add-payment-modal-title {
    font-size: 15px;
  }

  .p2p-modal-btn {
    gap: 6px;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 12px;
  }



}

/* ============================================
     P2P MOBILE TABS FOR ORDER DETAILS
     ============================================ */

.p2p-mobile-tabs {
  display: none;
  margin-bottom: 20px;
  background: rgba(20, 22, 30, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 6px;
  gap: 6px;
}

.p2p-mobile-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #8b8b9a;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-mobile-tab i {
  font-size: 18px;
}

.p2p-mobile-tab:hover {
  background: rgba(255, 255, 255, 0.03);
  color: #c9d1d9;
}

.p2p-mobile-tab.active {
  background: rgba(74, 157, 110, 0.15);
  color: #4a9d6e;
}

/* Show tabs on tablet and mobile */
@media (max-width: 1024px) {
  .p2p-mobile-tabs {
    display: flex;
  }

  .p2p-order-content {
    display: block;
  }

  .p2p-order-main.mobile-hidden,
  .p2p-order-sidebar.mobile-hidden {
    display: none;
  }

  .p2p-order-main,
  .p2p-order-sidebar {
    max-width: 100%;
  }

  .p2p-chat-card {
    height: calc(100vh - 380px);
    min-height: 400px;
    max-height: none;
  }

  .p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {
    height: calc(100vh - 320px);
  }
}

@media (max-width: 768px) {
  .p2p-mobile-tab {
    padding: 10px 12px;
    font-size: 13px;
  }

  .p2p-mobile-tab i {
    font-size: 16px;
  }

  .p2p-chat-card {
    height: calc(100vh - 350px);
    min-height: 350px;
    max-height: none;
  }

  .p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {
    height: calc(100vh - 280px);
  }
}

@media (max-width: 480px) {
  .p2p-mobile-tabs {
    padding: 4px;
    gap: 4px;
  }

  .p2p-mobile-tab {
    padding: 10px 8px;
    font-size: 12px;
    gap: 6px;
  }

  .p2p-mobile-tab i {
    font-size: 15px;
  }

  .p2p-chat-card {
    height: calc(100vh - 300px);
    min-height: 300px;
    max-height: none;
  }

  .p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {
    height: calc(100vh - 250px);
  }

  .p2p-chat-messages {
    padding: 12px;
    gap: 10px;
  }
}

/* ============================================
     P2P CHAT USER HEADER STYLES
     ============================================ */

.p2p-chat-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-chat-user-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3d4a5c, #2d3748);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.p2p-chat-user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.p2p-chat-user-avatar span {
  color: #c9d1d9;
  font-size: 16px;
  font-weight: 600;
}

.p2p-user-status-dot {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #4a9d6e;
  border: 2px solid rgba(20, 22, 30, 1);
}

.p2p-chat-user-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-chat-user-details h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #e2e8f0;
}

.p2p-chat-user-role {
  font-size: 12px;
  color: #6b7280;
}

/* ============================================
     P2P ORDER DETAILS - PREMIUM CHAT STYLES
     ============================================ */

.p2p-chat-card {
  display: flex;
  flex-direction: column;
  height: 550px;
  min-height: 500px;
  max-height: 700px;
  padding: 0 !important;
  overflow: hidden;
  flex: 1 1;
}

/* Ensure chat card children have proper flex behavior */
.p2p-chat-card>* {
  flex-shrink: 0;
}

.p2p-chat-card .p2p-chat-messages {
  flex: 1 1;
  flex-shrink: 1;
  min-height: 200px;
}

.p2p-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: rgba(20, 20, 30, 0.8);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.p2p-chat-header h4 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #e2e8f0;
}

.p2p-chat-header h4 i {
  font-size: 18px;
  color: #8b8b9a;
}

.p2p-chat-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-chat-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
}

.p2p-chat-status.online {
  color: #4a9d6e;
}

.p2p-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4a9d6e;
  animation: pulse 2s infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

.p2p-chat-messages {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: rgba(10, 10, 15, 0.5);
  min-height: 0;
  /* Important for flex child scrolling */
  scroll-behavior: smooth;
}

.p2p-chat-messages::-webkit-scrollbar {
  width: 4px;
}

.p2p-chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

.p2p-chat-messages::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.p2p-chat-messages::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

.p2p-chat-message {
  display: flex;
  gap: 10px;
  max-width: 85%;
}

.p2p-chat-message.sent {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.p2p-chat-message.received {
  align-self: flex-start;
}

.p2p-chat-message.system {
  align-self: center;
  max-width: 90%;
}

.p2p-chat-avatar {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3d4a5c, #2d3748);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c9d1d9;
  font-size: 13px;
  font-weight: 600;
}

.p2p-chat-bubble {
  background: rgba(30, 35, 45, 0.9);
  border-radius: 16px;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.p2p-chat-message.sent .p2p-chat-bubble {
  background: linear-gradient(135deg, rgba(74, 157, 110, 0.2), rgba(74, 157, 110, 0.1));
  border-color: rgba(74, 157, 110, 0.2);
  border-radius: 16px 16px 4px 16px;
}

.p2p-chat-message.received .p2p-chat-bubble {
  border-radius: 16px 16px 16px 4px;
}

.p2p-chat-bubble.system {
  background: rgba(139, 139, 154, 0.1);
  border: 1px dashed rgba(139, 139, 154, 0.3);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.p2p-chat-bubble.system i {
  font-size: 18px;
  color: #8b8b9a;
}

.p2p-chat-bubble p {
  margin: 0;
  color: #c9d1d9;
  font-size: 14px;
  line-height: 1.5;
  word-break: break-word;
}

.p2p-chat-bubble.system p {
  color: #8b8b9a;
  font-size: 13px;
}

.p2p-chat-time {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #6b7280;
  font-size: 11px;
  margin-top: 6px;
}

.p2p-chat-time i {
  font-size: 12px;
  color: #4a9d6e;
}

.p2p-chat-image {
  margin-bottom: 8px;
  border-radius: 8px;
  overflow: hidden;
}

.p2p-chat-image img {
  max-width: 200px;
  max-height: 200px;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s;
}

.p2p-chat-image img:hover {
  transform: scale(1.02);
}

.p2p-chat-image-preview {
  position: relative;
  padding: 12px 16px;
  background: rgba(20, 20, 30, 0.9);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.p2p-chat-image-preview img {
  max-width: 120px;
  max-height: 80px;
  border-radius: 8px;
  object-fit: cover;
}

.p2p-chat-remove-image {
  position: absolute;
  top: 8px;
  left: 120px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(199, 91, 91, 0.9);
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.p2p-chat-input-container {
  padding: 12px 16px;
  background: rgba(20, 20, 30, 0.9);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.p2p-chat-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(30, 35, 45, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 24px;
  padding: 6px 8px 6px 12px;
}

.p2p-chat-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.p2p-chat-action-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: transparent;
  border: none;
  color: #8b8b9a;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s;
}

.p2p-chat-action-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #c9d1d9;
}

.p2p-chat-input {
  flex: 1 1;
  background: transparent;
  border: none;
  color: #e5e5e5;
  font-size: 14px;
  outline: none;
  padding: 8px 0;
}

.p2p-chat-input::placeholder {
  color: #6b7280;
}

.p2p-chat-send-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(74, 157, 110, 0.2);
  border: none;
  color: #6b7280;
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s;
}

.p2p-chat-send-btn.active {
  background: linear-gradient(135deg, #4a9d6e, #3d8a5f);
  color: #fff;
  cursor: pointer;
}

.p2p-chat-send-btn.active:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(74, 157, 110, 0.3);
}

/* Spin animation for loading */
.p2p-spin {
  animation: p2p-spin 1s linear infinite;
}

@keyframes p2p-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Chat Load More Button */
.p2p-chat-load-more {
  display: block;
  width: 100%;
  padding: 10px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px dashed rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #8b8b9a;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.p2p-chat-load-more:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #c9d1d9;
}

.p2p-chat-load-more:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Chat Empty State */
.p2p-chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  color: #6b7280;
  text-align: center;
  padding: 24px;
}

.p2p-chat-empty i {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.p2p-chat-empty p {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #8b8b9a;
}

.p2p-chat-empty span {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
}

/* Chat Typing Indicator */
.p2p-chat-typing {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 4px 0;
}

.p2p-typing-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  background: rgba(30, 35, 45, 0.9);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.p2p-typing-indicator span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #6b7280;
  animation: typing-bounce 1.4s infinite ease-in-out;
}

.p2p-typing-indicator span:nth-child(1) {
  animation-delay: 0s;
}

.p2p-typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.p2p-typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing-bounce {

  0%,
  60%,
  100% {
    transform: translateY(0);
  }

  30% {
    transform: translateY(-6px);
  }
}

/* Chat Error */
.p2p-chat-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(199, 91, 91, 0.1);
  border-top: 1px solid rgba(199, 91, 91, 0.2);
  color: #c75b5b;
  font-size: 13px;
}

.p2p-chat-error i {
  font-size: 16px;
}

/* Chat Connecting Status */
.p2p-chat-connecting {
  display: flex;
  align-items: center;
  color: #d4a853;
}

.p2p-chat-connecting i {
  animation: p2p-spin 1s linear infinite;
}

/* Message Status Icons */
.p2p-msg-status {
  font-size: 14px;
  margin-left: 4px;
}

.p2p-msg-status.sending {
  color: #6b7280;
}

.p2p-msg-status.sent {
  color: #8b8b9a;
}

.p2p-msg-status.delivered {
  color: #8b8b9a;
}

.p2p-msg-status.read {
  color: #4a9d6e;
}

/* Chat Image Uploading Overlay */
.p2p-chat-image-uploading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.p2p-chat-image-uploading i {
  font-size: 24px;
  color: #fff;
  animation: p2p-spin 1s linear infinite;
}

.p2p-chat-image {
  position: relative;
}

/* User Status Dot Variants */
.p2p-user-status-dot.online {
  background: #4a9d6e;
}

.p2p-user-status-dot.offline {
  background: #6b7280;
}

/* Chat Status Variants */
.p2p-chat-status.offline {
  color: #6b7280;
}

.p2p-chat-status.offline .p2p-status-dot {
  background: #6b7280;
  animation: none;
}

/* Chat Avatar with image */
.p2p-chat-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

/* Emoji Picker */
.p2p-emoji-container {
  position: relative;
}

.p2p-emoji-picker {
  position: absolute;
  bottom: 45px;
  left: 0;
  width: 280px;
  max-height: 220px;
  background: rgba(25, 28, 38, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  z-index: 100;
}

.p2p-emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 2px;
  padding: 12px;
  max-height: 200px;
  overflow-y: auto;
}

.p2p-emoji-grid::-webkit-scrollbar {
  width: 4px;
}

.p2p-emoji-grid::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.p2p-emoji-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.15s;
}

.p2p-emoji-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: scale(1.15);
}

/* Premium Order Card Styling */
.p2p-order-card {
  background: rgba(20, 22, 30, 0.7);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
}

.p2p-order-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #c9d1d9;
  margin: 0 0 16px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Chat Responsive */
@media (max-width: 1024px) {
  .p2p-chat-card {
    height: 480px;
    min-height: 450px;
  }
}

@media (max-width: 768px) {
  .p2p-chat-card {
    height: 420px;
    min-height: 400px;
  }

  .p2p-emoji-picker {
    width: 260px;
    left: -50px;
  }

  .p2p-emoji-grid {
    grid-template-columns: repeat(7, 1fr);
  }
}

@media (max-width: 480px) {
  .p2p-chat-card {
    height: 380px;
    min-height: 350px;
  }

  .p2p-chat-header {
    padding: 12px 16px;
  }

  .p2p-chat-header h4 {
    font-size: 14px;
  }

  .p2p-emoji-picker {
    width: 240px;
    left: -20px;
  }

  .p2p-emoji-grid {
    grid-template-columns: repeat(6, 1fr);
  }

  .p2p-chat-image img {
    max-width: 150px;
    max-height: 150px;
  }
}

/* ====================================
     BINANCE STYLE ORDER DETAILS
     ==================================== */

.binance-order-container {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.binance-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 16px;
}

.binance-loading p {
  color: #848e9c;
  font-size: 14px;
}

.binance-loading .spinner-border {
  color: #fcd535;
}

/* Order Status Banners */
.order-status-banner {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 24px;
  border-radius: 12px;
  margin-bottom: 24px;
  animation: bannerSlideIn 0.3s ease-out;
}

@keyframes bannerSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.order-status-banner.success {
  background: linear-gradient(135deg, rgba(14, 203, 129, 0.15) 0%, rgba(14, 203, 129, 0.05) 100%);
  border: 1px solid rgba(14, 203, 129, 0.3);
}

.order-status-banner.cancelled {
  background: linear-gradient(135deg, rgba(246, 70, 93, 0.15) 0%, rgba(246, 70, 93, 0.05) 100%);
  border: 1px solid rgba(246, 70, 93, 0.3);
}

.order-status-banner.disputed {
  background: linear-gradient(135deg, rgba(252, 213, 53, 0.15) 0%, rgba(252, 213, 53, 0.05) 100%);
  border: 1px solid rgba(252, 213, 53, 0.3);
}

.banner-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.order-status-banner.success .banner-icon {
  background: rgba(14, 203, 129, 0.2);
}

.order-status-banner.cancelled .banner-icon {
  background: rgba(246, 70, 93, 0.2);
}

.order-status-banner.disputed .banner-icon {
  background: rgba(252, 213, 53, 0.2);
}

.banner-icon i {
  font-size: 28px;
}

.order-status-banner.success .banner-icon i {
  color: #0ecb81;
}

.order-status-banner.cancelled .banner-icon i {
  color: #f6465d;
}

.order-status-banner.disputed .banner-icon i {
  color: #fcd535;
}

.banner-content {
  flex: 1 1;
}

.banner-content h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
}

.order-status-banner.success .banner-content h3 {
  color: #0ecb81;
}

.order-status-banner.cancelled .banner-content h3 {
  color: #f6465d;
}

.order-status-banner.disputed .banner-content h3 {
  color: #fcd535;
}

.banner-content p {
  margin: 0;
  font-size: 14px;
  color: #848e9c;
  line-height: 1.5;
}

/* Mobile responsive */
@media (max-width: 480px) {
  .order-status-banner {
    padding: 16px;
    gap: 12px;
  }

  .banner-icon {
    width: 40px;
    height: 40px;
  }

  .banner-icon i {
    font-size: 22px;
  }

  .banner-content h3 {
    font-size: 16px;
  }

  .banner-content p {
    font-size: 13px;
  }
}

/* Mobile Tabs */
.binance-mobile-tabs {
  display: none;
  background: #1e2329;
  border-radius: 8px;
  padding: 4px;
  margin-bottom: 20px;
  gap: 4px;
}

.binance-tab {
  flex: 1 1;
  padding: 12px 16px;
  background: transparent;
  border: none;
  color: #848e9c;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
}

.binance-tab:hover {
  color: #eaecef;
}

.binance-tab.active {
  background: #2b3139;
  color: #ffffff;
}

.binance-tab i {
  font-size: 18px;
}

/* Main Layout */
.binance-order-layout {
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 24px;
  align-items: start;
}

/* Left Side - Order Details */
.binance-order-details {
  background: #181a20;
  border-radius: 12px;
  padding: 32px;
}

.binance-order-header {
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.header-left {
  flex: 1 1;
}

.binance-order-title {
  font-size: 24px;
  font-weight: 600;
  color: #eaecef;
  margin: 0 0 12px 0;
}

.binance-order-number {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.binance-order-number>span:first-child {
  color: #848e9c;
}

.binance-order-number .order-id {
  color: #eaecef;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.binance-order-number .order-id i {
  color: #848e9c;
  font-size: 16px;
}

.binance-order-number .order-id:hover i {
  color: #fcd535;
}

/* Timer in Header */
.binance-timer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  padding: 12px 16px;
  /* background: rgba(252, 213, 53, 0.1); */
  border: 1px solid rgb(43 49 57);
  border-radius: 8px;
  min-width: 120px;
}

.binance-timer .timer-label {
  font-size: 12px;
  color: #848e9c;
}

.binance-timer .timer-value {
  font-size: 24px;
  font-weight: 700;
  /* color: #fcd535; */
  font-family: 'Roboto Mono', monospace;
  letter-spacing: 1px;
}

.binance-timer.expired {
  background: rgba(246, 70, 93, 0.1);
  border-color: rgba(246, 70, 93, 0.3);
}

.binance-timer .timer-expired {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f6465d;
  font-size: 14px;
  font-weight: 600;
}

.binance-timer .timer-expired i {
  font-size: 18px;
}

/* Progress Steps */
.binance-progress-steps {
  display: flex;
  flex-direction: column;
}

.binance-step {
  display: flex;
  gap: 16px;
}

.step-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 32px;
  flex-shrink: 0;
}

.step-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  background: #2b3139;
  color: #848e9c;
  border: 2px solid #2b3139;
}

.binance-step.completed .step-icon {
  background: #0ecb81;
  border-color: #0ecb81;
  color: #181a20;
}

.binance-step.active .step-icon {
  background: #fcd535;
  border-color: #fcd535;
  color: #181a20;
}

.step-line {
  width: 2px;
  flex: 1 1;
  min-height: 24px;
  background: #2b3139;
  margin: 8px 0;
}

.binance-step.completed .step-line {
  background: #0ecb81;
}

.step-content {
  flex: 1 1;
  padding-bottom: 24px;
}

.step-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: #eaecef;
  margin: 4px 0 8px 0;
}

.binance-step.pending .step-content h4 {
  color: #848e9c;
}

/* Collapsible Step Header */
.step-header-clickable {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 4px 0;
  margin: -4px 0;
}

.step-header-clickable h4 {
  margin: 0;
}

.step-header-clickable i {
  font-size: 20px;
  color: #848e9c;
  transition: transform 0.2s;
}

.step-header-clickable:hover i {
  color: #eaecef;
}

/* Step Dropdown Content */
.step-dropdown-content {
  margin-top: 16px;
  padding: 16px;
  background: #1e2329;
  border-radius: 8px;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Order Info Grid */
.order-info-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.order-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order-info-row .info-label {
  font-size: 14px;
  color: #848e9c;
}

.order-info-row .info-value {
  font-size: 14px;
  color: #eaecef;
  display: flex;
  align-items: center;
  gap: 6px;
}

.order-info-row .info-value.highlight {
  color: #fcd535;
  font-weight: 600;
  font-size: 16px;
}

.order-info-row .info-value.copyable {
  cursor: pointer;
}

.order-info-row .info-value.copyable i {
  color: #848e9c;
  font-size: 14px;
  transition: color 0.2s;
}

.order-info-row .info-value.copyable:hover i {
  color: #fcd535;
}

.step-desc {
  font-size: 14px;
  color: #848e9c;
  margin: 0 0 16px 0;
  line-height: 1.5;
}

/* Payment Card */
.binance-payment-card {
  background: #1e2329;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
}

.payment-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #2b3139;
}

.payment-type {
  background: rgba(252, 213, 53, 0.15);
  color: #fcd535;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}

.payment-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.payment-qr img {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  object-fit: cover;
}

.payment-qr span {
  font-size: 11px;
  color: #848e9c;
}

.payment-qr:hover span {
  color: #fcd535;
}

.payment-details-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.payment-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.payment-row .label {
  font-size: 14px;
  color: #848e9c;
}

.payment-row .value {
  font-size: 14px;
  color: #eaecef;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.payment-row .value i {
  color: #848e9c;
  font-size: 16px;
  opacity: 0;
  transition: opacity 0.2s;
}

.payment-row .value i {
  opacity: 1;
  /* color: #fcd535; */
}

.payment-row.highlight .value.amount {
  font-size: 18px;
  font-weight: 600;
}

.payment-row .value.amount.green {
  color: #0ecb81;
}

.payment-row .value.amount.red {
  color: #f6465d;
}

.payment-row .value.amount i {
  opacity: 1;
}

.payment-row.buyer-info {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #2b3139;
}

.payment-row .value.name {
  background: #2b3139;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: default;
}

/* Action Buttons */
.binance-action-buttons {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.binance-btn {
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}

.binance-btn.primary {
  background: #fcd535;
  color: #181a20;
}

.binance-btn.primary:hover {
  background: #e5c32e;
}

.binance-btn.primary:disabled {
  background: #5c5424;
  color: #848e9c;
  cursor: not-allowed;
}

.binance-btn i {
  margin-right: 6px;
}

/* Appeal Button */
.binance-btn.appeal {
  background: transparent;
  border: 1px solid #f0b90b;
  color: #f0b90b;
}

.binance-btn.appeal:hover:not(:disabled) {
  background: rgba(240, 185, 11, 0.1);
}

.binance-btn.appeal.disabled,
.binance-btn.appeal:disabled {
  border-color: #848e9c;
  color: #848e9c;
  cursor: not-allowed;
  opacity: 0.7;
}

.binance-btn.appeal-submit {
  background: #f0b90b;
  color: #181a20;
}

.binance-btn.appeal-submit:hover:not(:disabled) {
  background: #d9a80a;
}

.binance-btn.appeal-submit:disabled {
  background: #5c5424;
  color: #848e9c;
  cursor: not-allowed;
}

/* Appeal Modal */
.appeal-modal {
  max-width: 500px;
}

.appeal-modal .binance-modal-header h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f0b90b;
}

.appeal-info {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(240, 185, 11, 0.1);
  border: 1px solid rgba(240, 185, 11, 0.2);
  border-radius: 8px;
  margin-bottom: 16px;
}

.appeal-info i {
  color: #f0b90b;
  font-size: 20px;
  flex-shrink: 0;
}

.appeal-info p {
  color: #eaecef;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
}

.appeal-form {
  margin-bottom: 16px;
}

.appeal-form label {
  display: block;
  color: #eaecef;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}

.appeal-textarea {
  width: 100%;
  padding: 12px;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 8px;
  color: #eaecef;
  font-size: 14px;
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
}

.appeal-textarea:focus {
  outline: none;
  border-color: #f0b90b;
}

.appeal-textarea::placeholder {
  color: #5e6673;
}

.char-count {
  text-align: right;
  color: #848e9c;
  font-size: 12px;
  margin-top: 6px;
}

.appeal-warning {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 8px;
}

.appeal-warning i {
  color: #ef4444;
  font-size: 20px;
  flex-shrink: 0;
}

.appeal-warning p {
  color: #eaecef;
  font-size: 13px;
  font-weight: 500;
  margin: 0 0 6px 0;
}

.appeal-warning ul {
  margin: 0;
  padding-left: 16px;
  color: #848e9c;
  font-size: 12px;
}

.appeal-warning li {
  margin-bottom: 4px;
}

.appeal-modal .binance-modal-footer {
  display: flex;
  gap: 12px;
}

.appeal-modal .binance-modal-footer .binance-btn {
  flex: 1 1;
}

/* ====================================
     WELCOME P2P POPUP
     ==================================== */
.welcome-modal {
  max-width: 480px;
}

.welcome-modal .binance-modal-header h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fcd535;
}

.welcome-modal .binance-modal-header h3 i {
  font-size: 24px;
}

/* Welcome Tabs */
.welcome-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  background: #181a20;
  padding: 4px;
  border-radius: 8px;
}

.welcome-tab {
  flex: 1 1;
  padding: 10px 16px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: #848e9c;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.welcome-tab:hover {
  color: #eaecef;
}

.welcome-tab.active {
  background: #2b3139;
  color: #fcd535;
}

/* Welcome Content */
.welcome-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* How to Pay Steps */
.welcome-step {
  display: flex;
  gap: 16px;
  padding: 16px;
  background: #181a20;
  border-radius: 12px;
}

.welcome-step .step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  background: linear-gradient(135deg, #fcd535 0%, #f0b90b 100%);
  color: #181a20;
  font-size: 16px;
  font-weight: 700;
  border-radius: 50%;
}

.welcome-step .step-info h6 {
  color: #eaecef;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px 0;
}

.welcome-step .step-info p {
  color: #848e9c;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
}

/* Things to Note */
.welcome-note {
  display: flex;
  gap: 16px;
  padding: 16px;
  background: #181a20;
  border-radius: 12px;
}

.welcome-note .note-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  background: rgba(252, 213, 53, 0.1);
  border-radius: 10px;
}

.welcome-note .note-icon i {
  font-size: 20px;
  color: #fcd535;
}

.welcome-note .note-info h6 {
  color: #eaecef;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px 0;
}

.welcome-note .note-info p {
  color: #848e9c;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
}

/* Welcome Modal Footer */
.welcome-modal .binance-modal-footer {
  padding-top: 16px;
}

.welcome-modal .binance-modal-footer .binance-btn.full-width {
  width: 100%;
}

/* ====================================
     TIME WARNING & PAYMENT RECEIVED POPUPS
     ==================================== */

/* Time Warning Popup */
.time-warning-content {
  text-align: center;
  padding: 20px 0;
}

.warning-icon-large {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: rgba(245, 158, 11, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-icon-large i {
  font-size: 40px;
  color: #f59e0b;
}

.time-warning-content h4 {
  font-size: 24px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0 0 12px 0;
}

.time-warning-content p {
  font-size: 14px;
  color: #9ca3af;
  line-height: 1.6;
  margin: 0 0 24px 0;
}

.time-warning-actions {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: 10px;
  padding: 16px;
  margin-top: 20px;
  text-align: left;
}

.warning-action-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #d1d5db;
}

.warning-action-item:last-child {
  margin-bottom: 0;
}

.warning-action-item i {
  font-size: 16px;
  color: #f59e0b;
  flex-shrink: 0;
}

/* Payment Received Popup */
.payment-received-content {
  text-align: center;
  padding: 20px 0;
}

.success-icon-large {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: rgba(34, 197, 94, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-icon-large i {
  font-size: 40px;
  color: #22c55e;
}

.payment-received-content h4 {
  font-size: 22px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0 0 12px 0;
}

.payment-received-content p {
  font-size: 14px;
  color: #9ca3af;
  line-height: 1.6;
  margin: 0 0 24px 0;
}

.payment-received-content p strong {
  color: #e5e5e5;
  font-weight: 600;
}

.payment-received-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 24px 0;
}

.info-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-label {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 16px;
  font-weight: 600;
  color: #e5e5e5;
}

.payment-received-warning {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 10px;
  padding: 16px;
  margin-top: 24px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  text-align: left;
}

.payment-received-warning i {
  font-size: 20px;
  color: #ef4444;
  flex-shrink: 0;
  margin-top: 2px;
}

.payment-received-warning p {
  margin: 0;
  font-size: 13px;
  color: #fca5a5;
  line-height: 1.6;
}

.payment-received-warning p strong {
  color: #fee2e2;
  font-weight: 600;
}

/* ====================================
     P2P TRADE RESTRICTIONS & BALANCE
     ==================================== */

/* Verification Required Button */
.p2p-verification-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: rgba(252, 213, 53, 0.15);
  border: 1px solid rgba(252, 213, 53, 0.3);
  border-radius: 6px;
  color: #fcd535;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.p2p-verification-btn:hover {
  background: rgba(252, 213, 53, 0.25);
  border-color: #fcd535;
}

.p2p-verification-btn i {
  font-size: 16px;
}

/* Trade Restricted Container */
.p2p-trade-restricted {
  display: flex;
  align-items: center;
  gap: 8px;
}

.p2p-trade-restricted .p2p-buy-btn.disabled,
.p2p-trade-restricted .p2p-sell-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

/* Condition Tooltip */
.p2p-condition-tooltip {
  position: relative;
  display: flex;
  align-items: center;
  cursor: help;
}

.p2p-condition-tooltip i {
  font-size: 18px;
  color: #848e9c;
  transition: color 0.2s;
}

.p2p-condition-tooltip:hover i {
  color: #fcd535;
}

.p2p-tooltip-content {
  position: absolute;
  bottom: calc(100% + 8px);
  right: 0;
  min-width: 240px;
  padding: 12px;
  background: #1e2329;
  border: 1px solid #2b3139;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  opacity: 0;
  visibility: hidden;
  transform: translateY(8px);
  transition: all 0.2s;
  z-index: 100;
}

.p2p-condition-tooltip:hover .p2p-tooltip-content {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.p2p-tooltip-content span {
  display: block;
  font-size: 13px;
  color: #eaecef;
  line-height: 1.4;
}

.p2p-tooltip-content .p2p-tooltip-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #f6465d;
}

/* Sell with Balance */
.p2p-sell-with-balance {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.p2p-balance-info {
  font-size: 11px;
  color: #848e9c;
  pointer-events: none;
}

.p2p-available-balance {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
  display: block;
}

.p2p-sell-fee-display {
  display: block;
  font-size: 11px;
  color: #F3BB2B;
  margin-top: 4px;
}

/* Mobile Styles */
.p2p-mobile-verification-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background: rgba(252, 213, 53, 0.15);
  border: 1px solid rgba(252, 213, 53, 0.3);
  border-radius: 8px;
  color: #fcd535;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.p2p-mobile-verification-btn i {
  font-size: 18px;
}

.p2p-mobile-trade-restricted {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.p2p-mobile-trade-restricted .p2p-mobile-buy-btn.disabled,
.p2p-mobile-trade-restricted .p2p-mobile-sell-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.p2p-mobile-condition-info {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(248, 113, 113, 0.1);
  border-radius: 6px;
}

.p2p-mobile-condition-info i {
  font-size: 16px;
  color: #f6465d;
}

.p2p-mobile-condition-info span {
  font-size: 12px;
  color: #f6465d;
}

.p2p-mobile-sell-with-balance {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.p2p-mobile-balance-info {
  font-size: 12px;
  color: #848e9c;
  text-align: center;
  pointer-events: none;
}


.binance-btn.secondary {
  background: transparent;
  color: #848e9c;
  border: 1px solid #2b3139;
}

.binance-btn.secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.binance-expired-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: rgba(246, 70, 93, 0.1);
  border: 1px solid rgba(246, 70, 93, 0.3);
  border-radius: 8px;
  margin-top: 16px;
}

.binance-expired-notice i {
  color: #f6465d;
  font-size: 18px;
}

.binance-expired-notice span {
  color: #f6465d;
  font-size: 14px;
}

/* Chat Section */
.binance-chat-section {
  position: sticky;
  top: 24px;
}

.binance-chat-card {
  background: #181a20;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 650px;
}

.binance-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #2b3139;
}

.chat-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.chat-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #2b3139;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #eaecef;
  font-size: 18px;
  position: relative;
  overflow: hidden;
}

.chat-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.chat-avatar .status-dot {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #848e9c;
  border: 2px solid #181a20;
}

.chat-avatar .status-dot.online {
  background: #0ecb81;
}

.chat-user-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.chat-username {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  color: #eaecef;
}

.chat-username .verified {
  color: #11cb81;
  font-size: 16px;
}

.chat-user-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #848e9c;
}

.chat-user-meta .online-status {
  display: flex;
  align-items: center;
  gap: 4px;
}

.chat-user-meta .online-status i {
  font-size: 8px;
}

.chat-user-meta .online-status.online {
  color: #0ecb81;
}

.chat-user-meta .divider {
  color: #2b3139;
}

.chat-user-meta .user-role {
  background: rgba(132, 142, 156, 0.15);
  color: #848e9c;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 500;
}

.chat-user-meta .trades-link {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.chat-user-meta .trades-link:hover {
  color: #eaecef;
}

.chat-menu-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: transparent;
  border: none;
  color: #848e9c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.chat-menu-btn:hover {
  background: #2b3139;
  color: #eaecef;
}

/* Chat Notice */
.binance-chat-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  background: #2b3139;
  border-bottom: 1px solid #3a3f47;
  position: relative;
}

.binance-chat-notice i {
  color: #ffdc88;
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.binance-chat-notice p {
  font-size: 12px;
  color: #848e9c;
  line-height: 1.5;
  margin: 0;
  flex: 1 1;
}

.notice-close {
  background: transparent;
  border: none;
  color: #848e9c;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
}

.notice-close:hover {
  color: #eaecef;
}

/* Chat Messages */
.binance-chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #0b0e11;
  min-height: 0;
}

.binance-chat-messages::-webkit-scrollbar {
  width: 4px;
}

.binance-chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

.binance-chat-messages::-webkit-scrollbar-thumb {
  background: #2b3139;
  border-radius: 4px;
}

.load-more-btn {
  background: #2b3139;
  border: none;
  color: #848e9c;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin: 0 auto 8px;
}

.load-more-btn:hover {
  background: #3a3f47;
  color: #eaecef;
}

.chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  color: #848e9c;
  gap: 8px;
}

.chat-empty i {
  font-size: 48px;
  opacity: 0.3;
}

.chat-empty p {
  margin: 0;
  font-size: 14px;
}

/* Chat Messages */
.chat-message {
  display: flex;
  max-width: 85%;
}

.chat-message.sent {
  margin-left: auto;
  justify-content: flex-end;
}

.chat-message.received {
  margin-right: auto;
}

.chat-message.system {
  max-width: 100%;
  justify-content: center;
  margin: 12px 0;
}

.system-bubble {
  background: rgba(30, 35, 41, 0.8);
  padding: 8px 20px;
  border-radius: 20px;
  text-align: center;
  border: 1px dashed rgba(132, 142, 156, 0.3);
}

.system-bubble p {
  margin: 0;
  font-size: 12px;
  color: #848e9c;
  font-style: italic;
}

.message-bubble {
  padding: 10px 14px;
  border-radius: 12px;
  max-width: 100%;
}

.chat-message.sent .message-bubble {
  background: #0ecb81;
  border-bottom-right-radius: 4px;
}

.chat-message.received .message-bubble {
  background: #2b3139;
  border-bottom-left-radius: 4px;
}

.message-bubble p {
  margin: 0;
  font-size: 14px;
  color: #eaecef;
  word-wrap: break-word;
  line-height: 1.4;
}

.chat-message.sent .message-bubble p {
  color: #181a20;
}

.message-image {
  margin-bottom: 8px;
  position: relative;
}

.message-image img {
  max-width: 200px;
  max-height: 200px;
  border-radius: 8px;
  cursor: pointer;
  object-fit: cover;
}

.image-uploading {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.image-uploading i {
  color: #fff;
  font-size: 24px;
}

.message-meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 4px;
}

.message-time {
  font-size: 11px;
  color: rgba(234, 236, 239, 0.5);
}

.chat-message.sent .message-time {
  color: rgba(24, 26, 32, 0.6);
}

.msg-status {
  font-size: 14px;
}

.msg-status.sending {
  color: rgba(24, 26, 32, 0.4);
}

.msg-status.sent {
  color: rgba(24, 26, 32, 0.6);
}

.msg-status.delivered {
  color: rgba(24, 26, 32, 0.6);
}

.msg-status.read {
  color: #1890ff;
}

/* Typing Indicator */
.typing-bubble {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  background: #2b3139;
  border-radius: 12px;
  border-bottom-left-radius: 4px;
}

.typing-bubble span {
  width: 8px;
  height: 8px;
  background: #848e9c;
  border-radius: 50%;
  animation: typingBounce 1.4s infinite ease-in-out;
}

.typing-bubble span:nth-child(1) {
  animation-delay: 0s;
}

.typing-bubble span:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-bubble span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typingBounce {

  0%,
  60%,
  100% {
    transform: translateY(0);
  }

  30% {
    transform: translateY(-6px);
  }
}

/* Chat Error */
.chat-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(246, 70, 93, 0.1);
  color: #f6465d;
  font-size: 12px;
}

.chat-error i {
  font-size: 16px;
}

/* Image Preview */
.image-preview {
  padding: 12px 16px;
  background: #1e2329;
  border-top: 1px solid #2b3139;
  position: relative;
  display: flex;
  align-items: center;
}

.image-preview img {
  max-height: 80px;
  border-radius: 8px;
}

.image-preview button {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 6px;
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  background: rgb(252 212 53 / 62%);
  border: none;
  color: #000000;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Chat Input */
.binance-chat-input {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #1e2329;
  border-top: 1px solid #2b3139;
}

.binance-chat-input input[type="text"] {
  flex: 1 1;
  background: transparent;
  border: none;
  outline: none;
  color: #eaecef;
  font-size: 14px;
  padding: 8px 0;
}

.binance-chat-input input[type="text"]::placeholder {
  color: #5e6673;
}

.input-action {
  width: 36px;
  height: 36px;
  padding: 0px;
  border-radius: 50%;
  background: transparent;
  border: none;
  color: #848e9c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  transition: all 0.2s;
}

.input-action:hover {
  color: #eaecef;
}

.input-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.input-actions-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

.emoji-container {
  position: relative;
}

.emoji-picker {
  position: absolute;
  bottom: 48px;
  right: 0;
  width: 280px;
  background: #1e2329;
  border: 1px solid #2b3139;
  border-radius: 12px;
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 100;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.emoji-picker::-webkit-scrollbar {
  width: 4px;
}

.emoji-picker::-webkit-scrollbar-thumb {
  background: #2b3139;
  border-radius: 4px;
}

.emoji-picker button {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s;
}

.emoji-picker button:hover {
  background: #2b3139;
  transform: scale(1.1);
}

.send-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #2b3139;
  border: none;
  color: #5e6673;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s;
}

.send-btn.active {
  background: #0ecb81;
  color: #181a20;
}

.send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Spinning animation */
.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* ====================================
     BINANCE MODAL STYLES
     ==================================== */

.binance-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.binance-modal {
  background: #1e2329;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: modalSlideIn 0.2s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.binance-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #2b3139;
}

.binance-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #eaecef;
}

.modal-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  padding: 0px;
  background: transparent;
  border: none;
  color: #848e9c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  transition: all 0.2s;
}

.modal-close-btn:hover {
  background: #2b3139;
  color: #eaecef;
}

.binance-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

/* Cancel Warning */
.cancel-warning {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: rgba(246, 70, 93, 0.1);
  border: 1px solid rgba(246, 70, 93, 0.2);
  border-radius: 8px;
  margin-bottom: 24px;
}

.cancel-warning>i {
  color: #f6465d;
  font-size: 24px;
  flex-shrink: 0;
}

.cancel-warning p {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 500;
  color: #eaecef;
}

.cancel-warning span {
  font-size: 12px;
  color: #848e9c;
  line-height: 1.4;
}

/* Cancel Reasons */
.cancel-reasons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reason-label {
  font-size: 14px;
  font-weight: 500;
  color: #eaecef;
  margin-bottom: 8px;
}

.reason-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.reason-option:hover {
  border-color: #3a3f47;
}

.reason-option.selected {
  border-color: #fcd535;
  background: rgba(252, 213, 53, 0.05);
}

.reason-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #3a3f47;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}

.reason-option.selected .reason-radio {
  background: #fcd535;
  border-color: #fcd535;
}

.reason-radio i {
  color: #181a20;
  font-size: 12px;
  font-weight: bold;
}

.reason-option span {
  font-size: 14px;
  color: #eaecef;
}

/* Custom Reason Input */
.custom-reason-input {
  margin-top: 12px;
  position: relative;
}

.custom-reason-input textarea {
  width: 100%;
  padding: 12px 16px;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 8px;
  color: #eaecef;
  font-size: 14px;
  resize: none;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s;
}

.custom-reason-input textarea:focus {
  border-color: #fcd535;
}

.custom-reason-input textarea::placeholder {
  color: #5e6673;
}

.custom-reason-input .char-count {
  position: absolute;
  bottom: 8px;
  right: 12px;
  font-size: 11px;
  color: #5e6673;
}

/* Modal Footer */
.binance-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #2b3139;
}

.binance-modal-footer .binance-btn {
  flex: 1 1;
}

.binance-btn.danger {
  background: #f6465d;
  color: #fff;
}

.binance-btn.danger:hover {
  background: #d83a4f;
}

.binance-btn.danger:disabled {
  background: #5e3a40;
  color: #848e9c;
  cursor: not-allowed;
}

.binance-btn.full-width {
  width: 100%;
}

/* Confirm Checklist */
.confirm-checklist {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.checklist-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.checklist-item i.success {
  color: #0ecb81;
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}

.checklist-item span {
  font-size: 14px;
  color: #eaecef;
  line-height: 1.5;
}

.checklist-item strong {
  color: #fcd535;
}

/* Payment Proof Section */
.payment-proof-section {
  margin-bottom: 20px;
}

.payment-proof-section label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #eaecef;
  margin-bottom: 4px;
}

.payment-proof-section label .required {
  color: #f6465d;
  margin-left: 2px;
}

.proof-desc {
  font-size: 12px;
  color: #848e9c;
  margin: 0 0 12px 0;
}

.proof-upload-area {
  border: 2px dashed #2b3139;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.proof-upload-area:hover {
  border-color: #fcd535;
  background: rgba(252, 213, 53, 0.05);
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #848e9c;
}

.upload-placeholder i {
  font-size: 36px;
}

.upload-placeholder span {
  font-size: 13px;
}

.proof-preview {
  position: relative;
  display: inline-block;
}

.proof-preview img {
  max-width: 200px;
  max-height: 150px;
  border-radius: 8px;
  object-fit: cover;
}

.remove-proof {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  padding: 0px;
  height: 24px;
  border-radius: 50%;
  background: #f6465d;
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

/* Modal Warning */
.modal-warning {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(252, 213, 53, 0.1);
  border: 1px solid rgba(252, 213, 53, 0.2);
  border-radius: 8px;
}

.modal-warning i {
  color: #fcd535;
  font-size: 20px;
  flex-shrink: 0;
}

.modal-warning p {
  margin: 0;
  font-size: 12px;
  color: #848e9c;
  line-height: 1.5;
}

/* Release Warning */
.release-warning {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #2b3139;
  border-radius: 8px;
  margin-bottom: 20px;
}

.release-warning>i {
  color: #848e9c;
  font-size: 20px;
  flex-shrink: 0;
}

.release-warning p {
  margin: 0 0 4px 0;
  font-size: 14px;
  color: #eaecef;
}

.release-warning span {
  font-size: 12px;
  color: #848e9c;
  line-height: 1.4;
}

/* Release Confirm Checkbox */
.release-confirm-checkbox {
  margin-top: 20px;
}

.checkbox-container {
  display: flex;
  gap: 12px;
  cursor: pointer;
  padding: 12px 16px;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 8px;
  transition: all 0.2s;
}

.checkbox-container:hover {
  border-color: #3a3f47;
}

.checkbox-container.checked {
  border-color: #fcd535;
  background: rgba(252, 213, 53, 0.05);
}

.checkbox-box {
  width: 20px;
  height: 20px;
  border: 2px solid #3a3f47;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}

.checkbox-container.checked .checkbox-box {
  background: #fcd535;
  border-color: #fcd535;
}

.checkbox-box i {
  color: #181a20;
  font-size: 12px;
  font-weight: bold;
}

.checkbox-container span {
  font-size: 14px;
  color: #eaecef;
  line-height: 1.4;
}

.checkbox-container span strong {
  color: #fcd535;
}

/* Mobile Modal */
@media (max-width: 480px) {
  .binance-modal-overlay {
    padding: 0;
    /* align-items: flex-end; */
  }

  .p2p-mobile-card-user-info .p2p-mobile-status-row {
    flex-wrap: nowrap;
  }

  .binance-modal {
    max-width: 100%;
    max-height: 85vh;
    border-radius: 16px 16px 0 0;
  }

  .binance-modal-header {
    padding: 16px 20px;
  }

  .binance-modal-body {
    padding: 20px;
  }

  .binance-modal-footer {
    padding: 16px 20px;
  }

  .reason-option {
    padding: 10px 14px;
  }
}

/* Mobile Hidden */
.mobile-hidden {
  display: block;
}

/* Responsive */
@media (max-width: 1200px) {
  .binance-order-layout {
    grid-template-columns: 1fr 380px;
    gap: 20px;
  }

  .p2p-buy-btn {
    padding: 6px 12px;
    white-space: nowrap;
    font-size: 12px;
  }
}

@media (max-width: 1024px) {
  .binance-mobile-tabs {
    display: flex;
  }

  .binance-order-layout {
    display: block;
  }

  .mobile-hidden {
    display: none !important;
  }

  .binance-chat-card {
    height: calc(100vh - 200px);
    min-height: 500px;
  }
}

@media (max-width: 768px) {
  .binance-order-container {
    padding: 16px;
  }

  .binance-order-details {
    padding: 20px;
  }

  .binance-order-header {
    flex-direction: column;
    gap: 16px;
  }

  .binance-timer {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .binance-timer .timer-value {
    font-size: 20px;
  }

  .binance-order-title {
    font-size: 20px;
  }

  .binance-action-buttons {
    flex-direction: column;
  }

  .binance-btn {
    width: 100%;
    text-align: center;
  }

  .binance-chat-card {
    height: calc(100vh - 180px);
  }

  .chat-username span {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .order-info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}

@media (max-width: 480px) {
  .binance-order-container {
    padding: 12px;
  }

  .binance-order-details {
    padding: 16px;
  }

  .binance-order-title {
    font-size: 18px;
  }

  .step-content h4 {
    font-size: 14px;
  }

  .binance-payment-card {
    padding: 16px;
  }

  .payment-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .payment-row .value {
    width: 100%;
    justify-content: space-between;
  }

  .payment-row .value i {
    opacity: 1;
  }

  .binance-chat-card {
    height: calc(100vh - 160px);
    min-height: 400px;
  }

  .emoji-picker {
    width: 240px;
    grid-template-columns: repeat(6, 1fr);
    right: -40px;
  }

  .message-image img {
    max-width: 150px;
    max-height: 150px;
  }

  .binance-timer {
    padding: 8px 12px;
  }

  .binance-tab {
    padding: 8px 12px;
    font-size: 13px;
  }

  .p2p-page-content {
    padding: 18px;
  }

  .order-info-row .info-label {
    font-size: 12px;
  }

  .order-info-row .info-value {
    font-size: 12px;
  }

  .payment-row.highlight .value.amount {
    font-size: 14px;
  }

  .binance-expired-notice {
    padding: 8px 12px;
    margin-top: 10px;
  }

  .step-desc {
    font-size: 12px;
  }

  .binance-chat-input {
    gap: 2px;
    padding: 8px 5px;
  }

  .p2p-mobile-header {
    padding: 10px 15px;
    margin-bottom: 10px;
  }
}

/* ====================================
     LIGHT THEME OVERRIDES
     ==================================== */

body.light_theme .p2p-layout-wrapper {
  background-color: #fff;
}

body.light_theme .p2p-main-content {
  color: #000;
}

body.light_theme .p2p-page-content {
  color: #000;
}

body.light_theme .p2p-mobile-header {
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-hamburger {
  background-color: #f5f5f5;
}

body.light_theme .p2p-hamburger:hover {
  background-color: rgba(244, 182, 9, 0.1);
}

body.light_theme .p2p-hamburger-line {
  background-color: #000;
}

body.light_theme .p2p-mobile-logo-text {
  color: #000;
}

body.light_theme .p2p-page-title {
  color: #333;
}

body.light_theme .p2p-dashboard-container h2,
body.light_theme .p2p-dashboard-container h3,
body.light_theme .p2p-dashboard-container h4,
body.light_theme .p2p-dashboard-container .p2p-section-header,
body.light_theme .p2p-dashboard-container .p2p-orders-title {
  color: #333;
}

body.light_theme .p2p-profile-funding,
body.light_theme .p2p-profile-funding-label,
body.light_theme .p2p-profile-funding-value {
  color: #333;
}

body.light_theme .p2p-sidebar {
  background: #fff;
  border-right: 1px solid #e5e5e5;
}

body.light_theme .p2p-sidebar-logo {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-logo-text {
  color: #000;
}

body.light_theme .p2p-logo-icon {
  background: #f5f5f5;
}

body.light_theme .p2p-nav-item {
  color: #4E4E4E;
}

body.light_theme .p2p-nav-item:hover {
  background-color: #f5f5f5;
  color: #000;
}

body.light_theme .p2p-nav-item.active {
  background: #f5f5f5;
  color: #F4B609;
  border-left: 2px solid #F4B609;
}

body.light_theme .p2p-nav-item.active .p2p-nav-icon {
  color: #F4B609;
}

body.light_theme .p2p-sidebar-close {
  background: #f5f5f5;
  color: #000;
}

body.light_theme .p2p-sidebar-close:hover {
  background: rgba(244, 182, 9, 0.1);
}

body.light_theme .p2p-sidebar-footer {
  border-top: 1px solid #e5e5e5;
}

body.light_theme .p2p-back-link {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  color: #4E4E4E;
}

body.light_theme .p2p-back-link:hover {
  background: #e5e5e5;
  border-color: #F4B609;
  color: #000;
}

body.light_theme .p2p-sidebar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}

body.light_theme .p2p-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

body.light_theme h4.p2p-profile-tab {
  color: #000;
}

body.light_theme .p2p-toggle-wrapper {
  background: #f5f5f5;
}

/* body.light_theme .p2p-toggle-btn {
    color: #555;
  } */

body.light_theme .p2p-filter-label {
  color: #555;
}

/* body.light_theme .p2p-dashboard-container button:not(.p2p-find-orders-btn):not(.p2p-buy-btn):not(.p2p-sell-btn):not(.p2p-myads-action-btn):not(.p2p-modal-btn):not(.p2p-page-btn.p2p-active) {
    color: #333;
    border: 1px solid #d0d0d0;
    background-color: #f5f5f5;
  }
  
  body.light_theme .p2p-dashboard-container button:not(.p2p-find-orders-btn):not(.p2p-buy-btn):not(.p2p-sell-btn):not(.p2p-myads-action-btn):not(.p2p-modal-btn):not(.p2p-page-btn.p2p-active):hover {
    background-color: #e8e8e8;
    border-color: #c0c0c0;
    color: #000;
  } */

body.light_theme .p2p-filter-select {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #000;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right;
}

body.light_theme .p2p-filter-section.myadsfillter .p2p-filter-select {
  background: #e2e2e2;
  border: 1px solid #d5d5d5;
}

body.light_theme .p2p-filter-select:focus {
  border-color: #F4B609;
}

body.light_theme .p2p-find-orders-btn {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-find-orders-btn:hover {
  background: rgba(244, 182, 9, 0.1);
  border-color: #F4B609;
}

body.light_theme .p2p-orders-table-wrapper {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-orders-table thead {
  background: #f5f5f5;
}

body.light_theme .p2p-orders-table th {
  color: #333;
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-orders-table tbody tr {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-orders-table tbody tr:hover {
  background: rgba(244, 182, 9, 0.05);
}

body.light_theme .p2p-advertiser-info h4 {
  color: #000;
}

body.light_theme .p2p-advertiser-stats {
  color: #555;
}

body.light_theme .p2p-rating-value {
  color: #4E4E4E;
}

body.light_theme .p2p-price-value {
  color: #000;
}

body.light_theme .p2p-limit-label {
  color: #555;
}

body.light_theme .p2p-limit-value {
  color: #000;
}

body.light_theme .p2p-payment-badge {
  background: rgba(244, 182, 9, 0.1);
  border: 1px solid rgba(244, 182, 9, 0.2);
  color: #000;
}

body.light_theme .p2p-pagination-wrapper {
  background: #f5f5f5;
  border-top: 1px solid #e5e5e5;
}

body.light_theme .p2p-pagination-info {
  color: #555;
}

body.light_theme .p2p-page-current {
  color: #000;
  background: rgba(244, 182, 9, 0.2);
}

body.light_theme .p2p-page-btn {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #333;
}

body.light_theme .p2p-page-btn:hover {
  border-color: #F4B609;
  color: #000;
}

body.light_theme .p2p-page-btn.p2p-active {
  background: #F4B609;
  border-color: #F4B609;
  color: #000;
}

body.light_theme .p2p-page-dots {
  color: #555;
}

body.light_theme .p2p-order-action-btn {
  color: #b8860b;
  border-color: rgba(184, 134, 11, 0.4);
}

body.light_theme .p2p-order-action-btn:hover {
  color: #9a7209;
  background: rgba(244, 182, 9, 0.1);
}

body.light_theme .p2p-order-action-text {
  color: #555;
}

body.light_theme .p2p-dashboard-container a:not(.p2p-nav-item) {
  color: #b8860b;
}

body.light_theme .p2p-dashboard-container a:not(.p2p-nav-item):hover {
  color: #9a7209;
}

body.light_theme .p2p-empty-state-card {
  color: #555;
}

body.light_theme .p2p-expanded-content {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-expanded-user-details h5 {
  color: #000;
}

body.light_theme .p2p-expanded-user-details p {
  color: #aaa;
}

body.light_theme .p2p-stat-value {
  color: #000;
}

body.light_theme .p2p-stat-label {
  color: #aaa;
}

body.light_theme .p2p-expanded-payments h6 {
  color: #000;
}

body.light_theme .p2p-expanded-payment-badge {
  background: rgba(244, 182, 9, 0.1);
  border: 1px solid rgba(244, 182, 9, 0.2);
  color: #000;
}

body.light_theme .p2p-expanded-remarks h6 {
  color: #000;
}

body.light_theme .p2p-expanded-remarks p {
  color: #aaa;
}

body.light_theme .p2p-input-header {
  border: 1px solid #e5e5e5;
  background: #ececec;
}

body.light_theme .p2p-input-header label {
  color: #000;
}

body.light_theme .p2p-payment-selector-left {
  color: #666;
}

body.light_theme .p2p-create-post-fee-breakdown-box {
  background: rgb(236 236 236);
  border: 1px solid #2a2a3a1a;
}

body.light_theme .p2p-create-post-fee-breakdown-row span:last-child {
  color: #6f6f6f;
}

body.light_theme .p2p-payment-option-full {
  background: rgb(213 213 213 / 50%);
}

body.light_theme .p2p-payment-option-full:hover {
  background-color: rgb(213 213 213 / 50%);
}

body.light_theme .p2p-user-payment-header .p2p-payment-name {
  color: #6e6e6e;
}

body.light_theme .p2p-payment-field-label {
  color: #646464;
}

body.light_theme .p2p-payment-field-value {
  color: #848484;
}

body.light_theme .p2p-expanded-input-wrapper {
  border: 1px solid #e5e5e5;
  background: #fff;
}

body.light_theme .p2p-expanded-input-wrapper:focus-within {
  border-color: #F4B609;
}

body.light_theme .p2p-expanded-input-wrapper input {
  color: #000;
  background: transparent;
}

body.light_theme .p2p-expanded-input-wrapper input::placeholder {
  color: #999;
}

body.light_theme .p2p-expanded-input-error {
  color: #dc3545;
}

body.light_theme .p2p-price-info {
  color: #aaa;
}

body.light_theme .p2p-payment-selector-full {
  border: 1px solid #e5e5e5;
  background: #fff;
}

body.light_theme .p2p-payment-selector-full:hover {
  border-color: #F4B609;
}

body.light_theme .p2p-cancel-btn {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-cancel-btn:hover {
  border-color: #F4B609;
}

body.light_theme .p2p-mobile-order-card {
  border: 1px solid #e5e5e5;
  background: #fff;
}

body.light_theme .p2p-mobile-card-user-info h4 {
  color: #000;
}

body.light_theme .p2p-mobile-card-user-info p {
  color: #aaa;
}

body.light_theme .p2p-mobile-card-price .p2p-value {
  color: #000;
}

body.light_theme .p2p-mobile-card-price .p2p-currency {
  color: #aaa;
}

body.light_theme .p2p-mobile-card-details {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-mobile-detail-label {
  color: #aaa;
}

body.light_theme .p2p-mobile-detail-value {
  color: #000;
}

body.light_theme .p2p-mobile-payment-badge {
  background: rgba(244, 182, 9, 0.1);
  color: #000;
}

body.light_theme .p2p-mobile-expanded-section {
  border-top: 1px solid #e5e5e5;
}

body.light_theme .p2p-modal-content {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-modal-header {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-modal-title {
  color: #000;
}

body.light_theme .p2p-payment-option {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-payment-option:hover {
  border-color: #F4B609;
}

body.light_theme .p2p-payment-option.p2p-selected {
  background: rgba(244, 182, 9, 0.1);
  border-color: #F4B609;
}

body.light_theme .p2p-payment-option span {
  color: #000;
}

body.light_theme .p2p-dashboard-container {
  color: #000;
}

body.light_theme .p2p-profile-header {
  background: #ececec;
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-profile-name {
  color: #000;
}

body.light_theme .p2p-dashboard-container.p2p-profile-container {
  background-color: #f0f0f0;
}

body.light_theme .p2p-myads-stat-card {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-myads-stat-card-label {
  color: #555;
}

body.light_theme .p2p-myads-stat-card-value {
  color: #000;
}

body.light_theme .p2p-profile-section-desc {
  color: #555;
}

body.light_theme .p2p-payment-methods-grid {
  gap: 16px;
}

body.light_theme .p2p-payment-method-card {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-payment-method-title {
  color: #000;
}

body.light_theme .p2p-payment-method-label {
  color: #555;
}

body.light_theme .p2p-payment-method-value {
  color: #000;
}

body.light_theme .p2p-empty-state-card {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #555;
}

body.light_theme .p2p-add-payment-modal {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-add-payment-modal-header {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-add-payment-modal-title {
  color: #000;
}

body.light_theme .p2p-modal-close-btn {
  color: #aaa;
}

body.light_theme .p2p-modal-close-btn:hover {
  background: #f5f5f5;
  color: #000;
}

body.light_theme .p2p-payment-type-item {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-payment-type-item:hover {
  border-color: #F4B609;
  background: rgba(244, 182, 9, 0.05);
}

body.light_theme .p2p-payment-type-name {
  color: #000;
}

body.light_theme .p2p-payment-form-label {
  color: #000;
}

body.light_theme .p2p-payment-form-input {
  background: #f5f5f5 !important;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-payment-form-input:focus {
  border-color: #F4B609;
  outline: none;
}

body.light_theme .p2p-payment-file-label {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-payment-file-label:hover {
  border-color: #F4B609;
  background: rgba(244, 182, 9, 0.05);
}

body.light_theme .p2p-modal-btn.primary {
  background: #F4B609;
  color: #000;
}

body.light_theme .p2p-modal-btn.primary:hover {
  background: #e5a608;
}

body.light_theme .p2p-modal-btn.secondary {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-modal-btn.secondary:hover {
  border-color: #F4B609;
  background: #f5f5f5;
}

body.light_theme .p2p-delete-modal {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-delete-modal-title {
  color: #000;
}

body.light_theme .p2p-delete-modal-desc {
  color: #aaa;
}

body.light_theme .p2p-modal-btn.danger {
  background: #dc3545;
  color: #fff;
}

body.light_theme .p2p-myads-action-btn {
  background: #F4B609;
  color: #000;
}

body.light_theme .p2p-myads-action-btn:hover {
  background: #e5a608;
}

body.light_theme .p2p-order-card {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-order-card-title {
  color: #000;
}

body.light_theme .p2p-order-summary-item {
  background: #f5f5f5;
}

body.light_theme .p2p-summary-value {
  color: #000;
}

body.light_theme .p2p-summary-label {
  color: #aaa;
}

body.light_theme .p2p-payment-detail-card {
  background: #f5f5f5;
}

body.light_theme .p2p-payment-detail-header {
  color: #000;
}

body.light_theme .p2p-payment-detail-value {
  color: #000;
}

body.light_theme .binance-modal {
  background: #fff;
}

body.light_theme .binance-modal-header {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .binance-modal-header h3 {
  color: #000;
}

body.light_theme .modal-close-btn {
  color: #aaa;
}

body.light_theme .modal-close-btn:hover {
  background: #f5f5f5;
  color: #000;
}

body.light_theme .binance-order-info {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
}

body.light_theme .info-label {
  color: #aaa;
}

body.light_theme .info-value {
  color: #000;
}

body.light_theme .payment-row {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .payment-row .label {
  color: #aaa;
}

body.light_theme .payment-row .value {
  color: #000;
}

body.light_theme .binance-chat-container {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .binance-chat-header {
  background: #f5f5f5;
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .binance-chat-header h4 {
  color: #000;
}

body.light_theme .binance-message {
  background: #f5f5f5;
  color: #000;
}

body.light_theme .binance-message.own {
  background: rgba(244, 182, 9, 0.1);
}

body.light_theme .binance-chat-input {
  background: #ececec;
  border-top: 1px solid #e5e5e5;
}

body.light_theme .binance-chat-section.mobile-hidden .binance-chat-input input {
  background: #f5f5f500;
  border: 1px solid #e5e5e500;
}

body.light_theme .binance-chat-input input {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .binance-chat-input input::placeholder {
  color: #999;
}

body.light_theme .binance-btn.primary {
  background: #F4B609;
  color: #000;
}

body.light_theme .binance-btn.primary:hover {
  background: #e5a608;
}

body.light_theme .chat-username {
  color: #636363;
}

body.light_theme .system-bubble {
  background: rgb(222 222 222);
}

body.light_theme .cancel-warning {
  background: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.2);
}

body.light_theme .cancel-warning p {
  color: #000;
}

body.light_theme .cancel-warning span {
  color: #aaa;
}

body.light_theme .appeal-info {
  background: rgba(244, 182, 9, 0.1);
  border: 1px solid rgba(244, 182, 9, 0.2);
}

body.light_theme .appeal-info p {
  color: #000;
}

body.light_theme .appeal-form label {
  color: #000;
}

body.light_theme .appeal-textarea {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .appeal-textarea::placeholder {
  color: #999;
}

body.light_theme .binance-tab {
  color: #aaa;
}

body.light_theme .binance-tab.active {
  color: #F4B609;
  border-bottom-color: #F4B609;
}

body.light_theme .step-desc {
  color: #aaa;
}

body.light_theme .p2p-loading-container {
  color: #aaa;
}

/* P2P Create Post Styles */
.p2p-create-post-container {
  display: grid;
  grid-template-columns: 1fr 200px;
  gap: 24px;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 1023px) {
  .p2p-create-post-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .p2p-create-post-container {
    gap: 16px;
  }
}

.p2p-create-post-form-card {
  background: #2B313C;
  border-radius: 12px;
  border: 1px solid #2B313C;
  padding: 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  position: relative;
  border-radius: 12px;
  padding: 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  position: relative;
}

@media (max-width: 1023px) {
  .p2p-create-post-form-card {
    padding: 24px;
  }
}

@media (max-width: 767px) {
  .p2p-create-post-form-card {
    border-radius: 12px;
    padding: 16px;
  }
}

.p2p-create-post-header {
  margin-bottom: 32px;
}

@media (max-width: 767px) {
  .p2p-create-post-header {
    margin-bottom: 20px;
  }
}

.p2p-create-post-title {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 8px 0;
}



.p2p-create-post-subtitle {
  color: #949AA4;
  font-size: 14px;
  margin: 0;
}

@media (max-width: 767px) {
  .p2p-create-post-subtitle {
    font-size: 12px;
  }
}

.p2p-create-post-stepper {
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 32px;
  gap: 0;
  width: 100%;
}

@media (max-width: 767px) {
  .p2p-create-post-stepper {
    margin-bottom: 20px;
  }
}

.p2p-create-post-step-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 400;
  background: transparent;
  border: 1px solid #ffffff60;
  color: #ffffff60;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

@media (max-width: 767px) {
  .p2p-create-post-step-circle {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
}

.p2p-create-post-step-circle.active {
  background: #F3BB2B;
  border-color: #F3BB2B;
  color: #000;
}

.p2p-create-post-step-circle.completed {
  background: #F3BB2B;
  border-color: #F3BB2B;
  color: #000;
}

.p2p-create-post-step-line {
  width: 310px;
  height: 1px;
  background: #ffffff60;
  transition: all 0.3s ease;
}

@media (max-width: 1023px) {
  .p2p-create-post-step-line {
    width: 80px;
  }
}

@media (max-width: 480px) {
  .p2p-create-post-step-line {
    width: 60px;
  }
}

.p2p-create-post-step-line.completed {
  background: #F3BB2B;
}

.p2p-create-post-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 20px;
}

@media (max-width: 767px) {
  .p2p-create-post-section-title {
    font-size: 14px;
    margin-bottom: 16px;
  }

  .p2p-nav-item {
    gap: 10px;
    padding: 10px 12px 10px 20px;
    font-size: 13px;
  }



  .pricehigh_box_item_title {
    font-size: 18px;
  }

  .pricehigh_box_item_title span {
    font-size: 10px;
  }

}

.p2p-create-post-section-icon {
  color: #ffdc88;
}

/* Buy/Sell tabs - Create Post */
.p2p-create-post-tabs-container {
  display: flex;
  gap: 0;
  margin-bottom: 32px;
  border-bottom: 1px solid #2a2a3a;
}

.p2p-create-post-tab-btn {
  background: transparent;
  border: none;
  color: #888;
  font-size: 16px;
  font-weight: 400;
  padding: 14px 20px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}

.p2p-create-post-tab-btn.active {
  color: #fff;
  font-weight: 500;
  border-bottom: 2px solid #fff;
}

@media (max-width: 767px) {
  .p2p-create-post-tabs-container {
    margin-bottom: 24px;
  }

  .p2p-create-post-tab-btn {
    font-size: 14px;
    padding: 12px 16px;
  }
}

/* Market price info box (USDT/INR block) - Create Post */
.p2p-create-post-info-box {
  background: #373f4d;
  border-radius: 10px;
  padding: 16px;
  margin-top: 16px;
}

.p2p-create-post-market-loading {
  text-align: center;
  padding: 10px;
}

.p2p-create-post-market-loading span {
  color: #666;
}

.p2p-create-post-market-pair {
  color: #9ca3af;
  font-size: 14px;
  margin-bottom: 10px;
}

.p2p-create-post-market-row {
  color: #6b7280;
  font-size: 13px;
  margin-bottom: 6px;
}

.p2p-create-post-market-row:last-child {
  margin-bottom: 0;
}

.p2p-create-post-market-bullet {
  margin-right: 6px;
}

.p2p-create-post-market-error {
  color: #d97706;
  font-size: 13px;
}

@media (max-width: 767px) {
  .p2p-create-post-info-box {
    padding: 12px;
  }

  .p2p-create-post-market-pair {
    font-size: 13px;
  }

  .p2p-create-post-market-row {
    font-size: 12px;
  }
}

/* Section spacing (steps) */
.p2p-create-post-section-spacing {
  margin-top: 32px;
}

@media (max-width: 767px) {
  .p2p-create-post-section-spacing {
    margin-top: 24px;
  }
}

.p2p-create-post-field-error-with-margin {
  margin-top: -12px;
  margin-bottom: 12px;
}

.p2p-create-post-select-with-icon {
  padding-left: 36px;
}

.p2p-create-post-section-title-inline {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 20px;
}

.p2p-create-post-section-icon-inline {
  color: #F3BB2B;
}

@media (max-width: 767px) {
  .p2p-create-post-section-title-inline {
    font-size: 14px;
    margin-bottom: 16px;
  }
}

.p2p-create-post-payment-required-error {
  color: #ef4444;
  font-size: 12px;
  font-weight: 400;
  margin-left: 8px;
}

.p2p-create-post-checkbox {
  width: 20px;
  height: 20px;
  accent-color: #ffdc88;
  flex-shrink: 0;
}

@media (max-width: 767px) {
  .p2p-create-post-checkbox {
    width: 18px;
    height: 18px;
  }
}

/* Preview Card */
.p2p-preview-card {
  background: #12121a;
  border-radius: 16px;
  border: 1px solid #1e1e2d;
  position: sticky;
  top: 20px;
}

@media (max-width: 991px) {
  .p2p-preview-card {
    position: relative;
    top: 0;
  }
}

@media (max-width: 767px) {
  .p2p-preview-card {
    border-radius: 12px;
  }
}

.p2p-preview-card-header {
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
}

.p2p-preview-card-header-buy {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.05) 100%);
}

.p2p-preview-card-header-sell {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.05) 100%);
}

@media (max-width: 767px) {
  .p2p-preview-card-header {
    padding: 16px;
  }
}

.p2p-preview-card-header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.p2p-preview-card-ad-label {
  color: #888;
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
}

.p2p-preview-card-title {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 767px) {
  .p2p-preview-card-title {
    font-size: 18px;
  }
}

.p2p-preview-card-badge {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 14px;
}

.p2p-preview-card-badge-buy {
  color: #22c55e;
  background: rgba(34, 197, 94, 0.2);
}

.p2p-preview-card-badge-sell {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.2);
}

.p2p-preview-card-price-block {
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
  text-align: center;
}

@media (max-width: 767px) {
  .p2p-preview-card-price-block {
    padding: 16px;
  }
}

.p2p-preview-card-price-label {
  color: #666;
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
}

.p2p-preview-card-price-value {
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -1px;
}

.p2p-preview-card-price-value-buy {
  color: #22c55e;
}

.p2p-preview-card-price-value-sell {
  color: #ef4444;
}

@media (max-width: 767px) {
  .p2p-preview-card-price-value {
    font-size: 28px;
  }
}

.p2p-preview-card-price-fiat {
  font-size: 16px;
  color: #888;
}

.p2p-preview-card-market {
  color: #666;
  font-size: 11px;
  margin-top: 4px;
  display: block;
}

.p2p-preview-card-details {
  padding: 20px 24px;
}

@media (max-width: 767px) {
  .p2p-preview-card-details {
    padding: 16px;
  }
}

.p2p-preview-card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.p2p-preview-card-grid-item {
  background: #0d0d14;
  padding: 12px;
  border-radius: 10px;
}

.p2p-preview-card-grid-label {
  color: #666;
  font-size: 11px;
  display: block;
  margin-bottom: 4px;
}

.p2p-preview-card-grid-value {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}

.p2p-preview-card-grid-value-muted {
  color: #888;
  font-size: 12px;
}

.p2p-preview-card-payment-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #0d0d14;
  border-radius: 10px;
  margin-bottom: 16px;
}

.p2p-preview-card-payment-time-label {
  color: #666;
  font-size: 13px;
}

.p2p-preview-card-payment-time-value {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.p2p-preview-card-block {
  margin-bottom: 16px;
}

.p2p-preview-card-section-label {
  color: #666;
  font-size: 12px;
  display: block;
  margin-bottom: 8px;
}

.p2p-preview-card-badges-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.p2p-preview-card-badge-pm {
  padding: 6px 12px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.3);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
}

.p2p-preview-card-empty-pm {
  color: #666;
  font-size: 12px;
  padding: 6px 12px;
  background: #0d0d14;
  border-radius: 6px;
  border: 1px dashed #2a2a3a;
}

.p2p-preview-card-badge-kyc {
  padding: 6px 12px;
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.3);
  border-radius: 6px;
  color: #4ade80;
  font-size: 12px;
}

.p2p-preview-card-badge-days {
  padding: 6px 12px;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 6px;
  color: #fbbf24;
  font-size: 12px;
}

.p2p-preview-card-remarks {
  padding: 12px;
  background: #0d0d14;
  border-radius: 10px;
  border-left: 3px solid #ffdc88;
}

.p2p-preview-card-remarks-title {
  color: #666;
  font-size: 11px;
  display: block;
  margin-bottom: 6px;
}

.p2p-preview-card-remarks-text {
  color: #aaa;
  font-size: 13px;
  line-height: 1.5;
}

.p2p-preview-card-footer {
  padding: 16px 24px;
  border-top: 1px solid #1e1e2d;
  background: #0a0a0f;
}

@media (max-width: 767px) {
  .p2p-preview-card-footer {
    padding: 16px;
  }
}

.p2p-preview-card-footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.p2p-preview-card-footer-fee {
  color: #666;
  font-size: 11px;
}

.p2p-preview-card-footer-note {
  color: #888;
  font-size: 11px;
}

.p2p-mobile-preview-toggle {
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #0d0d14;
  border-radius: 10px;
  margin-bottom: 16px;
  cursor: pointer;
  border: 1px solid #2a2a3a;
}

@media (max-width: 991px) {
  .p2p-mobile-preview-toggle {
    display: flex;
  }
}

.p2p-mobile-preview-toggle-text {
  color: #888;
  font-size: 14px;
}

.p2p-preview-highlight-buy {
  color: #22c55e;
  font-weight: 600;
}

.p2p-preview-highlight-sell {
  color: #ef4444;
  font-weight: 600;
}

.p2p-mobile-preview-view {
  color: #ffdc88;
  font-size: 14px;
}

.p2p-create-post-mobile-preview-wrap {
  margin-bottom: 16px;
}

/* Sell modal (Add Payment Method) */
.p2p-sell-modal .modal-content {
  background: #12121a;
  border: 1px solid #2a2a3a;
  border-radius: 16px;
}

.p2p-sell-modal .modal-header {
  border-bottom: 1px solid #2a2a3a;
  padding: 20px 24px;
}

.p2p-sell-modal .modal-header .modal-title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.p2p-sell-modal .modal-body {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}

.p2p-sell-modal-tips {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.p2p-sell-modal-tips-icon {
  color: #f59e0b;
}

.p2p-sell-modal-tips-text {
  color: #d4a574;
  font-size: 13px;
  line-height: 1.5;
}

.p2p-sell-modal-label {
  color: #888;
  font-size: 13px;
  margin-bottom: 8px;
  display: block;
}

.p2p-sell-modal-spinner-wrap {
  text-align: center;
  padding: 20px;
}

.p2p-sell-modal-methods-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

@media (max-width: 767px) {
  .p2p-sell-modal-methods-grid {
    grid-template-columns: 1fr;
  }
}

.p2p-sell-modal-method-card {
  padding: 14px 16px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.p2p-sell-modal-method-card:hover {
  border-color: #ffdc88;
}

.p2p-sell-modal-method-card.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.p2p-sell-modal-method-name {
  color: #fff;
  font-size: 14px;
}

.p2p-sell-modal-method-badge {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 4px;
}

.p2p-sell-modal-back-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #2a2a3a;
}

.p2p-sell-modal-back-btn {
  background: transparent;
  border: none;
  color: #888;
  cursor: pointer;
  padding: 4px;
}

.p2p-sell-modal-back-title {
  color: #ffdc88;
  font-weight: 600;
}

.p2p-sell-modal-kyc-warning {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 20px;
  color: #d4a574;
  font-size: 13px;
}

.p2p-sell-modal-input-wrap {
  margin-bottom: 16px;
}

.p2p-sell-modal-input {
  width: 100%;
  padding: 12px 16px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  outline: none;
}

.p2p-sell-modal-input.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.p2p-sell-modal-input-bg {
  width: 100%;
  padding: 12px 16px;
  background: #1a1a2e;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  cursor: not-allowed;
  opacity: 0.6;
}

.p2p-sell-modal-small {
  color: #666;
  font-size: 11px;
  margin-top: 4px;
  display: block;
}

.p2p-sell-modal-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.p2p-sell-modal-file-zone {
  border: 2px dashed #2a2a3a;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  position: relative;
}

.p2p-sell-modal-file-zone.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.p2p-sell-modal-file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.p2p-sell-modal-file-zone.disabled .p2p-sell-modal-file-input {
  cursor: not-allowed;
}

.p2p-sell-modal-file-preview {
  max-width: 100px;
  max-height: 100px;
  border-radius: 8px;
}

.p2p-sell-modal-file-placeholder-icon {
  color: #666;
  font-size: 24px;
  margin-bottom: 8px;
}

.p2p-sell-modal-file-placeholder-text {
  color: #888;
  font-size: 13px;
}

.p2p-sell-modal-warning-box {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 10px;
  padding: 12px 16px;
  margin-top: 8px;
}

.p2p-sell-modal-warning-text {
  color: #f87171;
  font-size: 12px;
  line-height: 1.5;
}

.p2p-sell-modal-label-optional {
  color: #666;
}

.p2p-sell-modal-label-required {
  color: #ef4444;
}

.p2p-sell-modal-buttons {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.p2p-sell-modal-btn-cancel {
  flex: 1 1;
  padding: 12px 20px;
  background: transparent;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.p2p-sell-modal-btn-confirm {
  flex: 1 1;
  padding: 12px 20px;
  background: #ffdc88;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.p2p-sell-modal-btn-confirm:disabled,
.p2p-sell-modal-btn-confirm.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.p2p-sell-modal-spinner-lg {
  text-align: center;
  padding: 40px;
}

.p2p-buyer-modal-desc {
  color: #888;
  margin-bottom: 20px;
}

.p2p-buyer-modal-spinner-wrap {
  text-align: center;
  padding: 20px;
}

.p2p-confirm-post-fee {
  color: #F3BB2B;
}

.p2p-create-post-input-group {
  margin-bottom: 10px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
}

@media (max-width: 767px) {
  .p2p-create-post-input-group {
    margin-bottom: 10px;
  }
}

.p2p-create-post-label {
  display: block;
  color: #A2A9B6;
  font-size: 13px;
  margin-bottom: 5px;
}

@media (max-width: 767px) {
  .p2p-create-post-label {
    font-size: 12px;
  }
}

.p2p-create-post-select-wrap {
  position: relative;
  width: 100%;
}

.p2p-create-post-select-wrap .p2p-create-post-select-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
}

.p2p-create-post-select-wrap .p2p-create-post-select-icon img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
}

.p2p-create-post-select-wrap .p2p-create-post-select-icon-fiat {
  font-size: 16px;
  font-weight: 600;
  color: #F3BB2B;
}

.p2p-create-post-select {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 12px 44px 12px 36px;
  background: #373F4D;
  border: 1px solid #373F4D;
  border-radius: 10px;
  color: #A2A9B6;
  font-size: 13px;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 12px 12px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

@media (max-width: 767px) {
  .p2p-create-post-select {
    padding: 12px 40px 12px 14px;
    font-size: 13px;
    background-position: right 12px center;
  }
}

.p2p-create-post-select.error {
  border: 1px solid #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.p2p-create-post-input {
  width: 100%;
  padding: 14px 16px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

@media (max-width: 767px) {
  .p2p-create-post-input {
    padding: 12px 14px;
    font-size: 13px;
  }
}

.p2p-create-post-input.error {
  border: 1px solid #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.p2p-create-post-input-with-suffix {
  display: flex;
  align-items: center;
  background: #373F4D;
  border: 1px solid #373F4D;
  border-radius: 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.p2p-create-post-input-with-suffix.error {
  border: 1px solid #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.p2p-create-post-input-inner {
  flex: 1 1;
  padding: 14px 16px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 14px;
  outline: none;
  min-width: 0;
}

@media (max-width: 767px) {
  .p2p-create-post-input-inner {
    padding: 12px 14px;
    font-size: 13px;
  }
}

.pricehigh_box {
  width: 100%;
  background-color: #373D4B;
  padding: 24px;
  border-radius: 12px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
}

.pricehigh_box_item_title {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 24px;
  font-weight: 600;
}

.pricehigh_box_item_container {
  gap: 90px;
}

.helpguide {
  font-size: 12px;
}

.helpguide i {
  font-size: 16px;
}

.btnnextback {
  margin-top: 24px;
  gap: 24px;
}

.btnnextback button {
  font-size: 16px;
  color: #fff;
  padding: 16px 20px;
  width: 100%;
  border-radius: 4px;
  border: none;
  background-color: #3C424C;
  font-weight: 500;
}

.btnnextback button.nextbtn {
  background-color: #5EBA89;
}

.btnnextback button.backbtn {
  width: 40%;
}

.pricehigh_box_item_title span {
  font-size: 12px;
  font-weight: 300;
}

.p2p-create-post-input-suffix {
  padding: 14px 16px;
  color: #b9b9b9;
  font-size: 14px;
  border-left: 1px solid #585858;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .p2p-create-post-input-suffix {
    padding: 12px 10px;
    font-size: 12px;
  }
}

.p2p-create-post-available-text {
  color: #22c55e;
  font-size: 12px;
  margin-left: 8px;
  margin-right: 8px;
  display: inline;
}

.p2p-create-post-tab-btn:hover {
  background-color: transparent;
}

body.light_theme .p2p-create-post-tab-btn.active {
  color: #5a5a5a;
  border-bottom: 2px solid #676464;
}

@media (max-width: 767px) {
  .p2p-create-post-available-text {
    font-size: 10px;
    display: none;
  }
}

.p2p-create-post-fee-box {
  background: linear-gradient(90deg, rgba(34, 197, 94, 0.1) 0%, transparent 100%);
  border: 1px solid rgba(34, 197, 94, 0.2);
  border-radius: 10px;
  padding: 12px 16px;
  color: #22c55e;
  font-size: 14px;
  margin-top: 20px;
}

@media (max-width: 767px) {
  .p2p-create-post-fee-box {
    padding: 10px 14px;
    font-size: 13px;
    margin-top: 16px;
  }
}

.p2p-create-post-info-box {
  background: #0d0d14;
  border-radius: 10px;
  padding: 16px;
  margin-top: 16px;
}

@media (max-width: 767px) {
  .p2p-create-post-info-box {
    padding: 12px;
  }
}

.p2p-create-post-pair-text {
  color: #f59e0b;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 8px;
}

@media (max-width: 767px) {
  .p2p-create-post-pair-text {
    font-size: 14px;
  }
}

.p2p-create-post-info-text {
  color: #a8b4c4;
  font-size: 13px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-bottom: 4px;
}

@media (max-width: 767px) {
  .p2p-create-post-info-text {
    font-size: 12px;
  }
}

.p2p-create-post-payment-method {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

@media (max-width: 767px) {
  .p2p-create-post-payment-method {
    padding: 12px 14px;
  }
}

.p2p-create-post-payment-method.active {
  border-color: #ffdc88;
  background: rgba(255, 220, 136, 0.1);
}

.p2p-create-post-payment-method.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.p2p-create-post-checkbox {
  width: 20px;
  height: 20px;
  accent-color: #ffdc88;
  flex-shrink: 0;
}

@media (max-width: 767px) {
  .p2p-create-post-checkbox {
    width: 18px;
    height: 18px;
  }
}

.p2p-create-post-add-method-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #ffdc88;
  background: transparent;
  border: none;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 0;
}

@media (max-width: 767px) {
  .p2p-create-post-add-method-btn {
    font-size: 13px;
  }
}

.p2p-create-post-textarea {
  width: 100%;
  padding: 14px 16px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  outline: none;
  min-height: 100px;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

@media (max-width: 767px) {
  .p2p-create-post-textarea {
    padding: 12px 14px;
    font-size: 13px;
    min-height: 80px;
  }
}

.p2p-create-post-checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #ccc;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 16px;
}

@media (max-width: 767px) {
  .p2p-create-post-checkbox-label {
    font-size: 13px;
  }
}

.p2p-create-post-button-group {
  display: flex;
  gap: 12px;
  margin-top: 32px;
  flex-direction: row;
}

@media (max-width: 767px) {
  .p2p-create-post-button-group {
    margin-top: 24px;
    flex-direction: column-reverse;
  }
}

.p2p-create-post-btn-primary {
  flex: 1 1;
  padding: 14px 24px;
  background: #22c55e;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: auto;
}

@media (max-width: 767px) {
  .p2p-create-post-btn-primary {
    flex: unset;
    padding: 14px 20px;
    font-size: 14px;
    width: 100%;
  }
}

.p2p-create-post-btn-secondary {
  padding: 14px 24px;
  background: transparent;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  width: auto;
}

@media (max-width: 767px) {
  .p2p-create-post-btn-secondary {
    padding: 14px 20px;
    font-size: 14px;
    width: 100%;
  }
}

.p2p-create-post-preview-card {
  background: #12121a;
  border-radius: 16px;
  border: 1px solid #1e1e2d;
  position: sticky;
  top: 20px;
}

@media (max-width: 1023px) {
  .p2p-create-post-preview-card {
    position: relative;
    top: 0;
  }
}

@media (max-width: 767px) {
  .p2p-create-post-preview-card {
    border-radius: 12px;
  }
}

.p2p-create-post-preview-header {
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-header {
    padding: 16px;
  }
}

.p2p-create-post-preview-title {
  font-size: 16px;
  color: #888;
  margin: 0;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-title {
    font-size: 14px;
  }
}

.p2p-create-post-preview-highlight {
  font-weight: 600;
}

.p2p-create-post-preview-highlight.buy {
  color: #22c55e;
}

.p2p-create-post-preview-highlight.sell {
  color: #ef4444;
}

.p2p-create-post-preview-body {
  padding: 24px;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-body {
    padding: 16px;
  }
}

.p2p-create-post-preview-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-row {
    margin-bottom: 12px;
  }
}

.p2p-create-post-preview-label {
  color: #aaa;
  font-size: 14px;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-label {
    font-size: 13px;
  }
}

.p2p-create-post-preview-value {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-align: right;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-value {
    font-size: 13px;
  }
}

.p2p-create-post-preview-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.p2p-create-post-preview-badge {
  padding: 6px 12px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.3);
  border-radius: 6px;
  color: #a8b4c4;
  font-size: 12px;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-badge {
    padding: 4px 10px;
    font-size: 11px;
  }
}

.p2p-create-post-preview-remarks {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #1e1e2d;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-remarks {
    margin-top: 16px;
    padding-top: 16px;
  }
}

.p2p-create-post-preview-remarks-title {
  color: #888;
  font-size: 13px;
  margin-bottom: 8px;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-remarks-title {
    font-size: 12px;
  }

  .pricehigh_box_item_container {
    gap: 24px;
  }

}

.p2p-create-post-preview-remarks-text {
  color: #ccc;
  font-size: 13px;
  line-height: 1.5;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-remarks-text {
    font-size: 12px;
  }
}

.p2p-create-post-agreement-box {
  background: #0d0d14;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

@media (max-width: 767px) {
  .p2p-create-post-agreement-box {
    padding: 12px;
  }
}

.p2p-create-post-agreement-box.error {
  background: rgba(239, 68, 68, 0.05);
  border: 1px solid #ef4444;
}

.p2p-create-post-helper-text {
  color: #949AA4;
  font-size: 12px;
  margin-top: 6px;
}

.p2p-create-post-fee-total-box {
  margin-top: 6px;
}

.p2p-create-post-fee-total-box .p2p-create-post-helper-text {
  margin-top: 4px;
}

.p2p-create-post-fee-breakdown-box {
  margin-top: 12px;
  background: rgba(42, 42, 58, 0.5);
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  padding: 12px 14px;
  max-width: 320px;
}

.p2p-create-post-fee-breakdown-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #949AA4;
  padding: 4px 0;
}

.p2p-create-post-fee-breakdown-row span:last-child {
  color: #fff;
  font-weight: 500;
}

.p2p-create-post-fee-breakdown-total {
  margin-top: 6px;
  padding-top: 8px;
  border-top: 1px solid #2a2a3a;
  color: #F3BB2B;
  font-weight: 500;
}

.p2p-create-post-fee-breakdown-total span:last-child {
  color: #F3BB2B;
}

.p2p-create-post-fee-breakdown-box .p2p-create-post-insufficient-funds {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid rgba(239, 68, 68, 0.3);
}

.p2p-create-post-total-required {
  color: #F3BB2B;
  font-weight: 500;
}

.p2p-create-post-insufficient-funds {
  color: #ef4444;
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
}

@media (max-width: 767px) {
  .p2p-create-post-fee-breakdown-box {
    padding: 10px 12px;
    margin-top: 10px;
  }

  .p2p-create-post-fee-breakdown-row {
    font-size: 11px;
  }
}

@media (max-width: 767px) {
  .p2p-create-post-helper-text {
    font-size: 11px;
  }
}

.p2p-create-post-mobile-preview-toggle {
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #0d0d14;
  border-radius: 10px;
  margin-bottom: 16px;
  cursor: pointer;
  border: 1px solid #2a2a3a;
}

@media (max-width: 1023px) {
  .p2p-create-post-mobile-preview-toggle {
    display: flex;
  }
}

.p2p-create-post-grid-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
}

@media (max-width: 767px) {
  .p2p-create-post-grid-two-col {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

.p2p-create-post-payment-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 767px) {
  .p2p-create-post-payment-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}

.p2p-create-post-field-error {
  color: #ef4444;
  font-size: 12px;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 767px) {
  .p2p-create-post-field-error {
    font-size: 11px;
  }
}

.p2p-create-post-preview-header-gradient {
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-header-gradient {
    padding: 16px;
  }
}

.p2p-create-post-preview-header-gradient.buy {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.05) 100%);
}

.p2p-create-post-preview-header-gradient.sell {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.05) 100%);
}

.p2p-create-post-preview-price-section {
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
  text-align: center;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-price-section {
    padding: 16px;
  }
}

.p2p-create-post-preview-price-label {
  color: #aaa;
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
}

.p2p-create-post-preview-price-value {
  font-size: 32px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-price-value {
    font-size: 28px;
  }
}

.p2p-create-post-preview-price-value.buy {
  color: #22c55e;
}

.p2p-create-post-preview-price-value.sell {
  color: #ef4444;
}

.p2p-create-post-preview-price-currency {
  font-size: 16px;
  color: #888;
}

.p2p-create-post-preview-market-price {
  color: #aaa;
  font-size: 11px;
  margin-top: 4px;
  display: block;
}

.p2p-create-post-preview-stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 20px 24px;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-stats-grid {
    padding: 16px;
  }
}

.p2p-create-post-preview-stat-box {
  background: #0d0d14;
  padding: 12px;
  border-radius: 10px;
}

.p2p-create-post-preview-stat-label {
  color: #aaa;
  font-size: 11px;
  display: block;
  margin-bottom: 4px;
}

.p2p-create-post-preview-stat-value {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-stat-value {
    font-size: 15px;
  }
}

.p2p-create-post-preview-stat-currency {
  color: #888;
  font-size: 12px;
}

.p2p-create-post-preview-payment-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-payment-time {
    padding: 16px;
  }
}

.p2p-create-post-preview-payment-time-label {
  color: #aaa;
  font-size: 13px;
}

.p2p-create-post-preview-payment-time-value {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.p2p-create-post-preview-payment-methods {
  margin-bottom: 16px;
}

.p2p-create-post-preview-payment-methods-label {
  color: #aaa;
  font-size: 12px;
  display: block;
  margin-bottom: 8px;
}

.p2p-create-post-preview-payment-methods-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.p2p-create-post-preview-payment-method-badge {
  padding: 6px 12px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.3);
  border-radius: 6px;
  color: #a8b4c4;
  font-size: 12px;
}

.p2p-create-post-preview-payment-methods-empty {
  color: #aaa;
  font-size: 12px;
  padding: 6px 12px;
}

.p2p-create-post-preview-counterparty-label {
  color: #aaa;
  font-size: 12px;
  display: block;
  margin-bottom: 8px;
}

.p2p-create-post-preview-counterparty-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.p2p-create-post-preview-counterparty-badge {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
}

.p2p-create-post-preview-counterparty-badge.kyc {
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: #22c55e;
}

.p2p-create-post-preview-counterparty-badge.registered {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  color: #f59e0b;
}

.p2p-create-post-preview-remarks-box {
  padding: 12px;
  background: #0d0d14;
  border-radius: 10px;
}

.p2p-create-post-preview-remarks-label {
  color: #aaa;
  font-size: 11px;
  display: block;
  margin-bottom: 6px;
}

.p2p-create-post-preview-remarks-content {
  color: #aaa;
  font-size: 13px;
  line-height: 1.5;
}

.p2p-create-post-preview-footer {
  padding: 16px 24px;
  border-top: 1px solid #1e1e2d;
  background: #0a0a0f;
}

@media (max-width: 767px) {
  .p2p-create-post-preview-footer {
    padding: 16px;
  }
}

.p2p-create-post-preview-footer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.p2p-create-post-preview-footer-fee {
  color: #aaa;
  font-size: 11px;
}

.p2p-create-post-preview-footer-available {
  color: #888;
  font-size: 11px;
}

/* Radio Button Styles */
.p2p-radio-group {
  margin-top: 8px;
}

.p2p-radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.p2p-radio-input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border: 5px solid #aaa;
  border-radius: 50%;
  margin: 0;
  margin-right: 12px;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.2s ease;
}

.p2p-radio-input:checked {
  border-color: #D9D9D9;
  background-color: transparent;
}

.p2p-radio-input:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #222;
}

.p2p-radio-input:hover {
  border-color: #999;
}

.p2p-radio-input:checked:hover {
  border-color: #fff;
}

.p2p-radio-text {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}

/* Light Theme Radio Button */
body.light_theme .p2p-radio-input {
  border-color: #ccc;
}

body.light_theme .p2p-radio-input:checked {
  border-color: #333;
}

body.light_theme .p2p-radio-input:checked::after {
  background-color: #f5f5f5;
}

body.light_theme .p2p-radio-input:hover {
  border-color: #999;
}

body.light_theme .p2p-radio-input:checked:hover {
  border-color: #333;
}

body.light_theme .p2p-radio-text {
  color: #333;
}

/* Payment Method Styles */
.p2p-payment-methods-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.p2p-payment-method-card {
  background: #373f4d;
  border: 1px solid #373f4d;
  border-radius: 10px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

@media (min-width: 768px) {
  .p2p-payment-method-card {
    padding: 16px;
  }
}

.p2p-payment-method-card.selected {
  border-color: #ffdc88;
  background: rgba(255, 220, 136, 0.1);
}

.p2p-payment-method-card.error {
  border-color: rgba(239, 68, 68, 0.5);
}

.p2p-payment-method-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.p2p-payment-method-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.p2p-payment-method-name {
  color: #ffdc88;
  font-size: 14px;
  font-weight: 600;
}

@media (min-width: 768px) {
  .p2p-payment-method-name {
    font-size: 15px;
  }
}

.p2p-payment-method-type-badge {
  color: #aaa;
  font-size: 11px;
  background: #373f4d;
  padding: 2px 8px;
  border-radius: 4px;
}

.p2p-payment-method-fields-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

@media (min-width: 768px) {
  .p2p-payment-method-fields-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.p2p-payment-method-field {
  font-size: 12px;
}

.p2p-payment-method-field-label {
  color: #aaa;
}

.p2p-payment-method-field-value {
  color: #aaa;
}

.p2p-payment-method-qr-section {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #2a2a3a40;
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-payment-method-qr-image {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
  padding: 4px;
}

@media (min-width: 768px) {
  .p2p-payment-method-qr-image {
    width: 80px;
    height: 80px;
  }
}

.p2p-payment-method-qr-label {
  color: #aaa;
  font-size: 11px;
}

.p2p-payment-methods-empty {
  color: #888;
  font-size: 13px;
  padding: 20px;
  text-align: center;
  background: #373f4d;
  border-radius: 10px;
  border: 1px solid #373f4d;
}

.p2p-payment-methods-empty.error {
  border-color: #ef4444;
}

.p2p-payment-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.p2p-payment-method-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background: #373F4D;
  border: 1px solid #373F4D;
  border-radius: 10px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

@media (min-width: 768px) {
  .p2p-payment-method-item {
    padding: 14px 16px;
  }
}

.p2p-payment-method-item.selected {
  border-color: #FFFFFF60;
}

.p2p-payment-method-item.error {
  border-color: rgba(239, 68, 68, 0.5);
}

.p2p-payment-method-item-text {
  color: #fff;
  font-size: 13px;
}

.p2p-payment-method-item input[type="checkbox"] {
  display: none;
  accent-color: #303234 !important;
}

.p2p-payment-method-item.selected input[type="checkbox"] {
  display: block;
}

.p2p-add-method-button {
  color: #fff;
}

.p2p-add-method-button:hover {
  background-color: transparent;
}

@media (min-width: 768px) {
  .p2p-payment-method-item-text {
    font-size: 14px;
    color: #A2A9B6;
  }
}

.p2p-payment-method-error {
  color: #ef4444;
  font-size: 11px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (min-width: 768px) {
  .p2p-payment-method-error {
    font-size: 12px;
  }
}

.p2p-add-method-button {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 300;
  color: #fff;
  background: transparent;
  border: none;
  font-size: 13px;
  cursor: pointer;
  padding: 8px 0;
}

@media (min-width: 768px) {
  .p2p-add-method-button {
    font-size: 14px;
  }
}

.p2p-add-method-button-icon {
  font-size: 18px;
}

/* Light Theme Payment Method Styles */
body.light_theme .p2p-payment-method-card {
  background: #ececec;
  border-color: #E0E0E0;
}

body.light_theme .p2p-payment-method-btn.delete {
  color: #ae4e4e;
}

body.light_theme button.p2p-profile-edit-btn:hover {
  background-color: transparent;
  color: #9b9b9b;
  ;
}

body.light_theme .p2p-payment-method-card.selected {
  border-color: #F4B609;
  background: rgba(244, 182, 9, 0.1);
}

body.light_theme .p2p-payment-method-name {
  color: #F4B609;
}

body.light_theme .p2p-payment-method-type-badge {
  color: #aaa;
  background: #E8E8E8;
}

body.light_theme .p2p-payment-method-field-label {
  color: #aaa;
}

body.light_theme .p2p-payment-method-field-value {
  color: #333;
}

body.light_theme .p2p-payment-method-qr-label {
  color: #aaa;
}

body.light_theme .p2p-payment-methods-empty {
  background: #f5f5f5;
  border-color: #E0E0E0;
  color: #aaa;
}

body.light_theme .p2p-payment-method-item {
  background: #f5f5f5;
  border-color: #E0E0E0;
}

body.light_theme .p2p-payment-method-item.selected {
  border-color: #F4B609;
  background: rgba(244, 182, 9, 0.1);
}

body.light_theme .p2p-payment-method-item-text {
  color: #333;
}

/* Step 3 Styles */
.p2p-create-post-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 16px;
}

@media (min-width: 768px) {
  .p2p-create-post-section-title {
    font-size: 16px;
    margin-bottom: 20px;
  }
}

.p2p-create-post-section-icon {
  color: #F3BB2B;
}

.p2p-create-post-textarea {
  width: 100%;
  padding: 12px 14px;
  background: #373F4D;
  border: 1px solid #ffffff40;
  border-radius: 10px;
  color: #fff;
  font-size: 13px;
  outline: none;
  min-height: 80px;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  font-family: inherit;
}

@media (min-width: 768px) {
  .p2p-create-post-textarea {
    padding: 14px 16px;
    font-size: 14px;
    min-height: 130px;
  }
}

.p2p-create-post-step3-section {
  margin-top: 24px;
}

@media (min-width: 768px) {
  .p2p-create-post-step3-section {
    margin-top: 32px;
  }
}

.p2p-create-post-checkbox-label {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #ccc;
  font-size: 13px;
  cursor: pointer;
  margin-bottom: 16px;
}

@media (min-width: 768px) {
  .p2p-create-post-checkbox-label {
    font-size: 14px;
  }
}

.p2p-create-post-checkbox-label-wrap {
  flex-wrap: wrap;
}

.p2p-create-post-checkbox-label-no-margin {
  margin-bottom: 0;
}

.p2p-create-post-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #f3bb2b;
  flex-shrink: 0;
  margin-top: 2px;
}

@media (min-width: 768px) {
  .p2p-create-post-checkbox {
    width: 20px;
    height: 20px;
  }
}

.p2p-create-post-registered-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 0;
  margin-top: 8px;
  width: 100%;
}

@media (min-width: 768px) {
  .p2p-create-post-registered-input-wrapper {
    margin-left: 8px;
    margin-top: 0;
    width: auto;
  }
}

.p2p-create-post-registered-input {
  width: 80px;
  padding: 8px 12px;
  background: #373F4D;
  border: 1px solid #373F4D;
  border-radius: 10px;
  color: #a1a1a1;
  text-align: center;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.p2p-create-post-registered-input.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.p2p-create-post-registered-label {
  color: #D0D0D0;
  font-size: 13px;
}

.p2p-create-post-radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.p2p-create-post-radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.p2p-create-post-radio-input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #D9D9D9;
  background-color: #000 !important;
  border-radius: 50%;
  margin: 0;
  margin-right: 12px;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.2s ease;
}

.p2p-create-post-radio-input:checked {
  border-color: #fff;
  background-color: transparent !important;
}

.p2p-create-post-step3-section .p2p-create-post-radio-group {
  flex-direction: row;
  gap: 48px;
}

.p2p-layout-wrapper .p2p-create-post-radio-input:focus {
  border: 5px solid #ffffff !important;
}

.userprofile_pop .modal-content {
  background-color: #373E4B;
}

.userprofile_pop ul.list_upi {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.userprofile_pop ul.list_upi li {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  position: relative;
  font-weight: 300;
  font-size: 13px;
  color: #ffffff9e;
}

.userprofile_pop ul.list_upi li span {
  color: #fff;
}

.userprofile_pop ul.list_upi li span.text-danger {
  color: #ef4444;
}

.userprofile_pop ul.list_upi li span.text-success {
  color: #22c55e;
}

.userprofile_pop.btnnextback button {
  background-color: #474D59;
}

.userprofile_pop ul.list_upi li::before {
  position: absolute;
  left: -15px;
  top: 0px;
  content: "";
  width: 10px;
}

.p2p-create-post-radio-input:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #222;
}

.p2p-create-post-radio-input:hover {
  border-color: #999;
}

.p2p-create-post-radio-input:checked:hover {
  border-color: #fff;
}

.p2p-create-post-radio-text {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}

.p2p-create-post-agreement-box {
  background: #0d0d14;
  border-radius: 10px;
  padding: 12px;
  margin-top: 16px;
}

@media (min-width: 768px) {
  .p2p-create-post-agreement-box {
    padding: 16px;
  }
}

.p2p-create-post-agreement-text {
  font-size: 12px;
}

@media (min-width: 768px) {
  .p2p-create-post-agreement-text {
    font-size: 14px;
  }
}

.p2p-create-post-field-error {
  color: #ef4444;
  font-size: 11px;
  margin-top: 4px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (min-width: 768px) {
  .p2p-create-post-field-error {
    font-size: 12px;
  }
}

.p2p-create-post-field-error-agreement {
  margin-top: -12px;
}

.p2p-create-post-button-group {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

@media (min-width: 768px) {
  .p2p-create-post-button-group {
    margin-top: 32px;
  }
}

.p2p-create-post-btn-secondary {
  flex: 1 1;
  padding: 12px 20px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-create-post-btn-secondary:hover {
  background: #1a1a2a;
  border-color: #3a3a4a;
}

.p2p-create-post-btn-primary {
  flex: 1 1;
  padding: 12px 20px;
  background: #22c55e;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-create-post-btn-primary:hover {
  background: #20b855;
}

.p2p-create-post-btn-primary-sell {
  background: #ef4444;
}

.p2p-create-post-btn-primary-sell:hover {
  background: #dc2626;
}

.p2p-create-post-btn-primary-buy {
  background: #22c55e;
}

.p2p-create-post-btn-primary-buy:hover {
  background: #20b855;
}

/* Light Theme Step 3 Styles */
body.light_theme .p2p-create-post-section-title {
  color: #333;
}

body.light_theme .p2p-create-post-section-icon {
  color: #F4B609;
}

body.light_theme .p2p-create-post-textarea {
  background: #f5f5f5;
  border-color: #E0E0E0;
  color: #333;
}

body.light_theme .p2p-create-post-checkbox-label {
  color: #333;
}

body.light_theme .p2p-create-post-registered-input {
  background: #f5f5f5;
  border-color: #E0E0E0;
  color: #333;
}

body.light_theme .p2p-create-post-registered-label {
  color: #aaa;
}

body.light_theme .p2p-create-post-radio-input {
  border-color: #ccc;
}

body.light_theme .p2p-create-post-radio-input:checked {
  border-color: #333;
}

body.light_theme .p2p-create-post-radio-input:checked::after {
  background-color: #f5f5f5;
}

body.light_theme .p2p-create-post-radio-text {
  color: #333;
}

body.light_theme .p2p-create-post-agreement-box {
  background: #f5f5f5;
}

body.light_theme .p2p-create-post-btn-secondary {
  background: #f5f5f5;
  border-color: #E0E0E0;
  color: #333;
}

body.light_theme .p2p-create-post-btn-secondary:hover {
  background: #E8E8E8;
}

/* P2P My Ads Table Styles */
.p2p-orders-table td {
  padding: 12px 10px;
}

.p2p-orders-table td.p2p-myads-actions-cell {
  text-align: right;
}

.p2p-row-expanded {
  background: rgba(255, 220, 136, 0.03) !important;
}

.p2p-myads-asset-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-myads-side-badge {
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.p2p-myads-asset-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-myads-asset-name {
  font-size: 15px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-myads-table-cell-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-myads-table-cell-content-gap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.p2p-myads-price-text {
  font-size: 14px;
  font-weight: 500;
  color: #e5e5e5;
}

.p2p-myads-volume-text {
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-myads-limits-text {
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-payment-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.p2p-payment-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.2);
}

.p2p-payment-badge-count {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  background: #5EBA8920;
  color: #9ca3af;
  border: 1px solid rgba(107, 114, 128, 0.2);
}

.p2p-myads-status-cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.p2p-myads-status {
  font-size: 13px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  display: inline-block;
}

.p2p-myads-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.p2p-myads-action-btn {
  padding: 3px 12px;
  min-height: 24px;
  border-radius: 6px;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  color: #a1a1aa;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.p2p-myads-action-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.15);
  color: #e5e5e5;
}

.p2p-myads-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.p2p-myads-action-btn-view {
  background: rgba(255, 255, 255, 0.04);
}

.p2p-myads-action-btn-view.active {
  background: rgba(255, 220, 136, 0.2);
}

.p2p-myads-action-btn-view:hover {
  background: rgba(255, 220, 136, 0.15);
  border-color: rgba(255, 220, 136, 0.3);
  color: #e5e5e5;
}

.p2p-myads-action-btn-view.active:hover {
  background: rgba(255, 220, 136, 0.2);
  border-color: rgba(255, 255, 255, 0.1);
}

.p2p-myads-action-btn-close {
  background: rgba(239, 68, 68, 0.1);
  border-color: rgba(239, 68, 68, 0.2);
}

.p2p-myads-action-btn-close:hover {
  background: rgba(239, 68, 68, 0.15);
  border-color: rgba(239, 68, 68, 0.3);
}

.p2p-myads-action-btn-icon {
  font-size: 14px;
}

.p2p-myads-action-btn-icon-online {
  color: #4ade80;
}

/* Expanded Row Styles */
.p2p-myads-expanded-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.p2p-myads-expanded-section {
  margin-bottom: 20px;
}

.p2p-myads-expanded-title {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-myads-expanded-title-count {
  font-size: 12px;
  color: #6b7280;
  margin-left: 6px;
  font-weight: 400;
}

.p2p-myads-expanded-content-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.p2p-myads-expanded-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
}

.p2p-myads-expanded-item-label {
  font-size: 12px;
  color: #9ca3af;
}

.p2p-myads-expanded-item-value {
  font-size: 14px;
  color: #e5e5e5;
  font-weight: 500;
}

.p2p-myads-expanded-item-value-small {
  font-size: 12px;
  color: #e5e5e5;
  font-family: monospace;
}

.p2p-myads-fee-value {
  color: #F3BB2B;
  font-weight: 500;
  font-size: 12px;
}

.p2p-orders-fee-value {
  color: #F3BB2B;
  font-weight: 500;
  font-size: 12px;
}

.p2p-myads-expanded-payments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.p2p-payment-badge-expanded {
  font-size: 12px;
  padding: 6px 10px;
}

.p2p-myads-expanded-section-border {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.p2p-myads-expanded-title-large {
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-myads-online-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
}

.p2p-myads-online-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.p2p-myads-online-badge.online .p2p-myads-online-dot {
  background: #4ade80;
}

.p2p-myads-online-badge.offline .p2p-myads-online-dot {
  background: #6b7280;
}

/* Light Theme Table Styles */
body.light_theme .p2p-myads-asset-name {
  color: #333;
}

body.light_theme .p2p-myads-price-text,
body.light_theme .p2p-myads-volume-text,
body.light_theme .p2p-myads-limits-text {
  color: #333;
}

body.light_theme .p2p-myads-status {
  background: rgba(0, 0, 0, 0.05);
}

body.light_theme .p2p-myads-action-btn {
  background: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.1);
  color: #aaa;
}

body.light_theme .p2p-myads-action-btn:hover {
  background: rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 0, 0, 0.15);
  color: #333;
}

body.light_theme .p2p-myads-action-btn-view.active {
  background: rgba(244, 182, 9, 0.2);
}

body.light_theme .p2p-myads-action-btn-view:hover {
  background: rgba(244, 182, 9, 0.15);
  border-color: rgba(244, 182, 9, 0.3);
}

body.light_theme .p2p-myads-expanded-title {
  color: #333;
}

body.light_theme .p2p-myads-expanded-item {
  background: rgba(0, 0, 0, 0.03);
}

body.light_theme .p2p-myads-expanded-item-label {
  color: #aaa;
}

body.light_theme .p2p-myads-expanded-item-value {
  color: #333;
}

body.light_theme .p2p-myads-expanded-item-value-small {
  color: #333;
}

body.light_theme .p2p-myads-expanded-section-border {
  border-top-color: rgba(0, 0, 0, 0.1);
}

body.light_theme .p2p-row-expanded {
  background: rgba(244, 182, 9, 0.03) !important;
}

@media (max-width: 1200px) {

  .p2p-create-post-container {
    grid-template-columns: 1fr 80px;
  }

  .p2p-myads-stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }


}


@media (max-width:767px) {

  .payment_method_pop.modal.fade .modal-dialog {
    min-width: 100%;
  }

  .userprofile_pop ul.list_upi li {
    font-size: 12px;
  }

  .userprofile_pop ul.list_upi {
    gap: 10px;
  }

  .p2p-create-post-container {
    grid-template-columns: 1fr 0px;
    gap: 0px;
  }

  .p2p-payment-method-item {
    margin-bottom: 5px;
    padding: 8px 12px;
  }

  .pricehigh_box_item_title {
    font-size: 18px;
  }

  .pricehigh_box_item_title span {
    font-size: 10px;
  }


  .btnnextback button {
    font-size: 13px;
    padding: 10px 15px;
  }

  .p2p-profile-container .p2p-profile-header {
    padding: 20px;
  }

  .p2p-profile-tabs.paymentprofiletabs {
    padding: 0px 15px 20px;
  }

  .rightalien {
    text-align: center;
  }

  .p2p-profile-container .p2p-empty-state-card i {
    font-size: 26px;
  }

  .p2p-profile-name {
    font-size: 18px;
  }

  .p2p-myads-stat-card {
    border-right: none;
    padding: 10px 5px;
  }

  .p2p-empty-state-mobile {
    margin: 0px;
  }

  .p2p-empty-state-mobile .p2p-create-ad-btn-small {
    padding: 10px 24px;
    font-size: 12px;
    margin: 0 auto;
  }

  .p2p-filter-section.myadsfillter {
    background: #3f4856;
    padding: 20px;
  }

}

@media (max-width: 767px) {
  .p2p-create-post-title {
    font-size: 18px;
  }

  .p2p-create-post-radio-text {
    font-size: 12px;
  }

  .p2p-create-post-radio-input {
    width: 16px;
    height: 16px;
  }

}


@media (max-width: 660px) {

  .pricehigh_box_item_title {
    font-size: 18px;
  }

  .pricehigh_box_item_title span {
    font-size: 10px;
  }

  .p2p-myads-stat-card-value {
    font-size: 13px;
  }

  .p2p-profile-container .p2p-myads-stats-grid {
    gap: 10px;
    padding: 10px 15px;
  }

  .p2p-profile-container .p2p-myads-stat-card-label {
    font-size: 11px;
    text-align: left;
    padding-bottom: 0px;
    margin-bottom: 0px;
  }

  .p2p-myads-stat-card-value {
    font-size: 11px;
  }


  .pricehigh_box {
    padding: 15px;
    margin-top: 15px;
    align-items: start;
    gap: 12px;
    flex-direction: column;
  }


}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/P2P/p2p.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;yCAWyC;;AAEzC;;yCAEyC;;AAEzC;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,wCAAwC;EACxC,kDAAkD;EAClD,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,gCAAgC;EAChC,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;2CAE2C;;AAE3C;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;;AAEhB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yDAA6L;EAC7L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;KAEK;;AAEL;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;;EAEE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,iCAAiC;AACjC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;2CAE2C;;AAE3C;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,gCAAgC;EAChC;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;;;;EAKA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;;EAEA,oCAAoC;EACpC;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;2CAE2C;;AAE3C,sCAAsC;AACtC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,+BAA+B;EACjC;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,cAAc;EAChB;;EAEA,8CAA8C;EAC9C;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,gCAAgC;EAChC;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA,oDAAoD;EACpD;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,SAAS;EACX;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,SAAO;IACP,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;;IAEE,SAAO;IACP,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,eAAe;IACf,eAAe;IACf,cAAc;EAChB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;IAGE,UAAU;IACV,WAAW;EACb;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA,+BAA+B;EAC/B;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;EACV;;EAEA,4BAA4B;EAC5B;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;;EAElB;;EAEA;;;IAGE,aAAa;IACb,eAAe;EACjB;;EAEA,qBAAqB;EACrB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;;EAEE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;KAEK;;AAEL,qBAAqB;AACrB;;;;KAIK;;AAEL;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;2CAE2C;;AAE3C,yCAAyC;AACzC;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,2FAA2F;IAC3F,wCAAwC;IACxC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,2FAA2F;IAC3F,oCAAoC;EACtC;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,uEAAuE;IACvE,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;;;;;EAKA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,6FAA6F;IAC7F,cAAc;IACd,wCAAwC;EAC1C;;EAEA;IACE,6FAA6F;IAC7F,cAAc;IACd,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA,kBAAkB;EAClB;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,+CAA+C;EACjD;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;IACrC,2CAA2C;IAC3C,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,qCAAqC;IACrC,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,qCAAqC;IACrC,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,0CAA0C;IAC1C,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;EACjD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,0BAA0B;EAC1B;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,iBAAiB;EACjB;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;EACf;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;EACX;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;EAClB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE;MACE,2BAA2B;IAC7B;;IAEA;MACE,wBAAwB;IAC1B;EACF;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kDAAkD;EACpD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;AAEF;;AAEA;;2CAE2C;;AAE3C,kBAAkB;AAClB;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA,6CAA6C;AAC7C;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;;EAEE,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,SAAO;EACT;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;;IAEA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;AAEF;;AAEA;EACE;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;AAEF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;;OAEK;AACP;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;;AAGF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;;EAGA;IACE,eAAe;EACjB;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;;AAGA;;EAEE;IACE,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;;;EAIA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,mBAAmB;IACnB,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;AAEF;;;AAGA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;AAEF;;;;;;AAMA;;;EAGE;IACE,yBAAyB;EAC3B;;;EAGA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;;;AAIF;;;AAGA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,4CAA4C;EAC5C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;;IAEE,YAAY;IACZ,8BAA8B;EAChC;AACF;;AAEA;;mDAEmD;;AAEnD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,4FAA4F;EAC5F,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,6BAA6B;AAC7B;EACE;IACE,8DAA8D;EAChE;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;;EAGA;IACE,SAAS;IACT,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;;mDAEmD;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,+CAA+C;AAC/C;EACE,cAAc;EACd,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;AACF;;AAEA;;mDAEmD;;AAEnD;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oDAAoD;AACtD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;;;EAIA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,aAAa;IACb,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;;;AAIF;;AAEA;;mDAEmD;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA;;mDAEmD;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;mDAEmD;;AAEnD;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,SAAO;AACT;;AAEA,wDAAwD;AACxD;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,qFAAqF;EACrF,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,+BAA+B;AAC/B;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,4CAA4C;EAC5C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,iCAAiC;EACjC,mCAA2B;UAA3B,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+FAA+F;EAC/F,yCAAyC;AAC3C;;AAEA;EACE,6FAA6F;EAC7F,wCAAwC;AAC1C;;AAEA;EACE,+FAA+F;EAC/F,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;;2CAE2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;2CAE2C;;AAE3C,uBAAuB;AACvB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;2CAE2C;;AAE3C,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;;AAGA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;KAEK;;AAEL;EACE,WAAW;AACb;;AAEA;;;;;;;;;;KAUK;;AAEL;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,yDAA6L;EAC7L,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;;;AAIA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;EACN,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,4BAA4B;IAC5B,eAAe;EACjB;;;;EAIA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,yDAAyD;AACzD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;EACR;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,6FAA6F;AAC/F;;AAEA;EACE,6FAA6F;AAC/F;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yDAA6L;EAC7L,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE;IACE,4BAA4B;IAC5B,eAAe;IACf,sCAAsC;EACxC;AACF;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,+EAA+E;EAC/E,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,8BAA8B;EAChC;AACF;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;EACR;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;AAEF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,6FAA6F;AAC/F;;AAEA;EACE,6FAA6F;AAC/F;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;;AAEhB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wDAAwD;EACxD,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE;IACE,+BAA+B;EACjC;;EAEA;IACE,2DAA2D;EAC7D;;;AAGF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,sBAAsB;EACxB;;;AAGF","sourcesContent":["/* ====================================\n   P2P Module Styles\n   All styles are scoped with .p2p- prefix\n   to avoid conflicts with other project CSS\n   \n   Theme Color: #ffdc88 (Yellow/Gold - Dark Theme), #F4B609 (Yellow - Light Theme)\n   Color Palette:\n   - Primary (Dark): #ffdc88\n   - Primary (Light): #F4B609\n   - Primary Dark: #f4b609\n   - Primary Light: #bd83cb\n   ==================================== */\n\n/* ====================================\n   P2P Layout Styles\n   ==================================== */\n\n.p2p-layout-wrapper {\n  display: flex;\n  min-height: 100vh;\n  background-color: #0a0a0f;\n  background-size: cover;\n  background-position: center top;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n\n.p2p-main-content {\n  flex: 1;\n  margin-left: 260px;\n  transition: margin-left 0.3s ease;\n  min-height: 100vh;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.p2p-main-content.p2p-mobile {\n  margin-left: 0;\n}\n\n.p2p-mobile-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background-color: rgba(13, 13, 20, 0.95);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.p2p-hamburger {\n  width: 40px;\n  height: 40px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.p2p-hamburger:hover {\n  background-color: rgba(166, 95, 255, 0.2);\n}\n\n.p2p-hamburger-line {\n  width: 20px;\n  height: 2px;\n  background-color: #fff;\n  border-radius: 2px;\n}\n\n.p2p-mobile-logo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-mobile-logo-icon {\n  width: 32px;\n  height: 32px;\n  background-color: #ffdc88;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.p2p-mobile-logo-text {\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.p2p-page-title {\n  font-size: 12px;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.p2p-page-content {\n  padding: 30px 20px 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  color: #fff;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.p2p-spacer {\n  width: 40px;\n}\n\n@media (max-width: 991.98px) {\n  .p2p-main-content {\n    margin-left: 0;\n  }\n}\n\n/* ====================================\n     P2P Sidebar Styles\n     ==================================== */\n\n.p2p-sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 998;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n}\n\n\nh4.p2p-profile-tab {\n  background-color: transparent;\n  border: none;\n  cursor: default;\n  padding: 0px;\n  color: #cfcfcf;\n}\n\nh4.p2p-profile-tab:hover {\n  background-color: transparent;\n}\n\n.p2p-sidebar-overlay.p2p-visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n.p2p-sidebar {\n  position: fixed;\n  left: 0;\n  top: 40px;\n  bottom: 0;\n  width: 260px;\n  background: transparent;\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.3s ease;\n  overflow-y: auto;\n}\n\n.p2p-sidebar.p2p-closed {\n  transform: translateX(-100%);\n}\n\n.p2p-sidebar-logo {\n  padding: 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.p2p-sidebar-logo a {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n}\n\n.p2p-logo-icon {\n  width: 38px;\n  height: 38px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.p2p-logo-text {\n  font-size: 22px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.5px;\n}\n\n.p2p-sidebar-nav {\n  padding: 16px 12px 16px 0px;\n  flex: 1 1;\n}\n\n.p2p-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 16px 16px 16px 54px;\n  border-radius: 0px 16px 16px 0px;\n  color: #9ca3af;\n  text-decoration: none;\n  font-size: 15px;\n  font-weight: 400;\n  transition: all 0.2s ease;\n  margin-bottom: 4px;\n}\n\n.p2p-nav-item:hover {\n  background-color: #2B313C;\n  color: #fff;\n}\n\n.p2p-nav-item.active {\n  background: #2B313C;\n  color: #ffffff;\n  border-left: #2B313C;\n  margin-left: 0px;\n}\n\n.p2p-nav-item.active .p2p-nav-icon {\n  color: #ffffff;\n}\n\n.p2p-nav-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: inherit;\n}\n\n.p2p-sidebar-close {\n  position: absolute;\n  top: 16px;\n  right: 12px;\n  width: 32px;\n  height: 32px;\n  background: rgba(255, 255, 255, 0.08);\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  transition: background 0.2s ease;\n}\n\n.p2p-sidebar-close:hover {\n  background: rgba(255, 220, 136, 0.2);\n}\n\n.p2p-sidebar-footer {\n  padding: 16px;\n  /* border-top: 1px solid rgba(255, 255, 255, 0.04); */\n}\n\n.p2p-back-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  color: #9ca3af;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.p2p-back-link:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n}\n\n/* Sidebar Scrollbar */\n.p2p-sidebar::-webkit-scrollbar {\n  width: 4px;\n}\n\n.p2p-sidebar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.p2p-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n}\n\n.selectpaymetpop.modal.fade .modal-dialog {\n  width: 480px;\n  min-width: 480px;\n}\n\n.p2p-sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* ====================================\n     P2P Dashboard Styles\n     ==================================== */\n\n.p2p-dashboard-container {\n  max-width: 100%;\n  width: 100%;\n  padding: 0;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n/* Buy/Sell Toggle */\n.p2p-buy-sell-toggle {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.p2p-toggle-wrapper {\n  display: flex;\n  background: #2B313C;\n  border-radius: 6px;\n  padding: 4px;\n  gap: 4px;\n}\n\n.p2p-toggle-btn {\n  padding: 7px 48px;\n  border: none;\n  width: 136px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: transparent;\n  color: #87909F;\n\n}\n\n.p2p-dashboard-container input:focus {\n  border: 1px solid #ffffff00 !important;\n}\n\n.p2p-dashboard-container select:focus-visible {\n  outline: none !important;\n}\n\n.binance-chat-input input:focus {\n  border: none !important;\n}\n\n.p2p-layout-wrapper button:disabled {\n  background-color: #181a1f81 !important;\n  color: #fff;\n}\n\n.p2p-toggle-btn.p2p-active-buy {\n  background: #5EBA89;\n  color: #fff;\n}\n\n.p2p-toggle-btn.p2p-active-sell {\n  background: #E45561;\n  color: #fff;\n}\n\n.p2p-toggle-btn.p2p-active-buy:hover {\n  background: #5EBA89;\n}\n\n.p2p-toggle-btn:hover:not(.p2p-active-buy):not(.p2p-active-sell) {\n  color: #fff;\n  background: rgba(34, 197, 94, 0.1);\n}\n\n/* Filter Section */\n.p2p-filter-section {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: flex-end;\n  margin-bottom: 20px;\n  padding: 0 8px;\n}\n\n.p2p-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n  min-width: 150px;\n}\n\n.p2p-filter-label {\n  font-size: 12px;\n  color: #c9c9c9;\n  /* text-transform: uppercase; */\n  letter-spacing: 0.5px;\n}\n\n.p2p-filter-select {\n  padding: 12px 16px;\n  background: #2B313C;\n  border: 1px solid #2B313C;\n  border-radius: 8px;\n  color: #A2A9B6;\n  font-size: 13px;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23888' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 16px center;\n  padding-right: 40px;\n}\n\n.p2p-filter-select:focus {\n  outline: none;\n  border-color: #ffdc88;\n}\n\n.p2p-find-orders-btn {\n  padding: 12px 32px;\n  background: #2b313c;\n  border: 1px solid #2b313c;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.p2p-find-orders-btn:hover {\n  background: rgba(255, 220, 136, 0.1);\n  border-color: #ffdc88;\n}\n\n/* Table Section */\n.p2p-orders-table-wrapper {\n  background: #2B313C;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid #2B313C;\n}\n\n.p2p-orders-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.p2p-orders-table thead {\n  background: #2B313C;\n}\n\n.p2p-orders-table th {\n  padding: 10px 10px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 400;\n  color: #949AA4;\n  border-bottom: 1px solid #454C59;\n}\n\n.p2p-orders-table th:last-child {\n  text-align: right;\n}\n\n.p2p-trade-fee-badge {\n  background: rgba(255, 220, 136, 0.15);\n  color: #F3BB2B;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  margin-left: 8px;\n}\n\n.p2p-orders-table tbody tr {\n  border-bottom: 1px solid #1e1e2d;\n  transition: background 0.2s ease;\n  cursor: pointer;\n}\n\n.p2p-orders-table tbody tr:hover {\n  background: rgba(255, 220, 136, 0.05);\n}\n\n.p2p-orders-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.p2p-orders-table td {\n  padding: 20px;\n  vertical-align: middle;\n}\n\n/* Advertiser Cell */\n.p2p-advertiser-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-advertiser-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: #fff;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.p2p-advertiser-info h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0 0 4px 0;\n}\n\n.p2p-advertiser-stats {\n  font-size: 12px;\n  color: #aaa;\n  margin-bottom: 4px;\n}\n\n.p2p-advertiser-rating {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.p2p-star-icon {\n  color: #fbbf24;\n  font-size: 12px;\n}\n\n.p2p-rating-value {\n  font-size: 12px;\n  color: #a8b4c4;\n  font-weight: 500;\n}\n\n/* Price Cell */\n.p2p-price-value {\n  font-size: 16px;\n  font-weight: 500;\n  color: #eaecef;\n}\n\n/* Limit Cell */\n.p2p-limit-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.p2p-limit-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-limit-label {\n  font-size: 12px;\n  color: #aaa;\n  min-width: 55px;\n}\n\n.p2p-limit-value {\n  font-size: 13px;\n  color: #eaecef;\n}\n\n/* Payment Cell */\n.p2p-payment-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.p2p-payment-badge {\n  padding: 6px 12px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.2);\n  border-radius: 6px;\n  font-size: 12px;\n  color: #eaecef;\n}\n\n/* Trade Cell */\n.p2p-trade-cell {\n  text-align: right;\n}\n\n.p2p-buy-btn {\n  padding: 10px 24px;\n  background: #22c55e;\n  border: none;\n  border-radius: 6px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.p2p-buy-btn:hover {\n  background: #16a34a;\n}\n\n.p2p-sell-btn {\n  padding: 10px 24px;\n  background: #ef4444;\n  border: none;\n  border-radius: 6px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.p2p-sell-btn:hover {\n  background: #dc2626;\n}\n\n/* Pagination */\n.p2p-pagination-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 0px 10px;\n  background: none;\n  border-top: none;\n  flex-wrap: wrap;\n}\n\n.p2p-pagination-info {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.p2p-pagination-buttons,\n.p2p-pagination-controls {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.p2p-page-current {\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #e5e5e5;\n  background: rgba(255, 220, 136, 0.2);\n  border-radius: 6px;\n}\n\n.p2p-page-btn {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #1a1a24;\n  border: 1px solid #2a2a3a;\n  border-radius: 6px;\n  color: #888;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-page-btn:hover {\n  border-color: #ffdc88;\n  color: #fff;\n}\n\n.p2p-page-btn.p2p-active {\n  background: #363c47;\n  border-color: #363c47;\n  color: #fff;\n}\n\n.p2p-page-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.p2p-page-dots {\n  color: #aaa;\n  padding: 0 8px;\n}\n\n/* Expanded Row */\n/* .p2p-expanded-row {\n    background: #0d0d14 !important;\n  } */\n\n.p2p-expanded-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n  padding: 24px;\n}\n\n.p2p-expanded-left {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.p2p-expanded-user-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.p2p-expanded-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: #fff;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.p2p-expanded-user-details h5 {\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0 0 4px 0;\n}\n\n.p2p-expanded-user-details p {\n  font-size: 13px;\n  color: #aaa;\n  margin: 0;\n}\n\n.p2p-expanded-stats {\n  display: flex;\n  gap: 24px;\n}\n\n.p2p-stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.p2p-stat-value {\n  font-size: 15px;\n  font-weight: 600;\n  color: #a8b4c4;\n}\n\n.p2p-stat-label {\n  font-size: 12px;\n  color: #aaa;\n}\n\n.p2p-expanded-payments h6 {\n  font-size: 13px;\n  color: #888;\n  margin: 0 0 12px 0;\n}\n\n.p2p-expanded-payment-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.p2p-expanded-payment-badge {\n  padding: 6px 13px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.2);\n  border-radius: 6px;\n  font-size: 12px;\n  color: #bd83cb;\n}\n\n.p2p-expanded-remarks h6 {\n  font-size: 13px;\n  color: #888;\n  margin: 0 0 8px 0;\n}\n\n.p2p-expanded-remarks p {\n  font-size: 13px;\n  color: #ccc;\n  margin: 0;\n}\n\n.p2p-expanded-right {\n  background: transparent;\n  border-radius: 12px;\n  padding: 0;\n  min-width: 320px;\n}\n\n.p2p-expanded-form-group {\n  margin-bottom: 12px;\n}\n\n.p2p-expanded-form-group.has-error .p2p-input-header {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.08);\n}\n\n.p2p-expanded-form-group.has-error .p2p-expanded-input-wrapper {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.p2p-expanded-form-group.has-error .p2p-payment-selector-full,\n.p2p-expanded-form-group.has-error .p2p-payment-selector {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.p2p-input-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0;\n  padding: 16px 20px 8px;\n  background: #1a1a22;\n  border-radius: 12px 12px 0 0;\n  border: 1px solid #2a2a3a;\n  border-bottom: none;\n}\n\n.p2p-input-header label {\n  font-size: 13px;\n  color: #888;\n  margin: 0;\n}\n\n.p2p-input-range {\n  font-size: 12px;\n  color: #aaa;\n}\n\n.p2p-expanded-input-wrapper {\n  display: flex;\n  align-items: center;\n  background: #1a1a22;\n  border: 1px solid #2a2a3a;\n  border-top: none;\n  border-radius: 0 0 12px 12px;\n  overflow: hidden;\n  padding: 0 20px 16px;\n}\n\n.p2p-expanded-input-wrapper:focus-within {\n  border-color: #ffdc88;\n}\n\n.p2p-expanded-input-wrapper.p2p-input-error {\n  border-color: #ef4444 !important;\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.p2p-expanded-input-wrapper.p2p-input-error:focus-within {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.1);\n}\n\n.p2p-payment-selector-full.p2p-input-error,\n.p2p-payment-selector.p2p-input-error {\n  border-color: #ef4444 !important;\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.p2p-expanded-input-wrapper input {\n  flex: 1;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 32px;\n  font-weight: 500;\n}\n\n.p2p-expanded-input-wrapper input:focus {\n  outline: none;\n}\n\n.p2p-expanded-input-wrapper input::placeholder {\n  color: #444;\n}\n\n/* Remove number input spinners */\n.p2p-expanded-input-wrapper input[type=\"number\"]::-webkit-outer-spin-button,\n.p2p-expanded-input-wrapper input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.p2p-expanded-input-wrapper input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.p2p-input-currency {\n  padding: 0;\n  color: #888;\n  font-size: 14px;\n  font-weight: 500;\n  background: transparent;\n}\n\n.p2p-expanded-input-error {\n  font-size: 12px;\n  color: #ef4444;\n  margin-top: 6px;\n  padding-left: 20px;\n}\n\n.p2p-price-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #888;\n  font-size: 12px;\n}\n\n.p2p-price-info svg {\n  color: #aaa;\n}\n\n.p2p-payment-selector-full {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 16px 20px;\n  background: #f59e0b0d;\n  border: 1px solid #2a2a3a;\n  border-top: none;\n  border-radius: 0 0 12px 12px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-payment-selector-full:hover {\n  border-color: #ffdc88;\n}\n\n.p2p-payment-selector-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.p2p-payment-indicator {\n  width: 4px;\n  height: 16px;\n  background: #f59e0b;\n  border-radius: 2px;\n}\n\n.p2p-payment-selector-full svg {\n  color: #aaa;\n}\n\n.p2p-expanded-form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.p2p-cancel-btn {\n  flex: 1;\n  padding: 14px 24px;\n  background: transparent;\n  border: 1px solid #2a2a3a;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.p2p-cancel-btn:hover {\n  background: rgba(255, 220, 136, 0.1);\n  border-color: #ffdc88;\n}\n\n.p2p-confirm-buy-btn {\n  width: 100%;\n  padding: 16px 24px;\n  background: #22c55e;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.p2p-confirm-buy-btn:hover {\n  background: #16a34a;\n}\n\n.p2p-confirm-sell-btn {\n  width: 100%;\n  padding: 16px 24px;\n  background: #ef4444;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.p2p-confirm-sell-btn:hover {\n  background: #dc2626;\n}\n\n/* Mobile Card View */\n.p2p-mobile-orders-list {\n  display: none;\n}\n\n.p2p-mobile-order-card {\n  background: #12121a;\n  border: 1px solid #1e1e2d;\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.p2p-mobile-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.binance-chat-input .send-btn {\n  padding: 0px;\n}\n\n.p2p-mobile-card-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-mobile-card-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: #fff;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.p2p-mobile-card-user-info h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0 0 4px 0;\n}\n\n.p2p-mobile-card-user-info p {\n  font-size: 12px;\n  color: #aaa;\n  margin: 0 0 2px 0;\n}\n\n.p2p-mobile-card-user-info .p2p-rating {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #a8b4c4;\n}\n\n.p2p-mobile-card-price {\n  text-align: right;\n}\n\n.p2p-mobile-card-price .p2p-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.p2p-mobile-card-price .p2p-currency {\n  font-size: 12px;\n  color: #aaa;\n}\n\n.p2p-mobile-card-details {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.p2p-mobile-detail-label {\n  font-size: 11px;\n  color: #aaa;\n}\n\n.p2p-mobile-detail-value {\n  font-size: 13px;\n  color: #fff;\n}\n\n.p2p-mobile-card-payments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.p2p-mobile-payment-badge {\n  padding: 6px 10px;\n  background: rgba(255, 220, 136, 0.1);\n  border-radius: 4px;\n  font-size: 11px;\n  color: #bd83cb;\n}\n\n.p2p-mobile-card-action {\n  width: 100%;\n}\n\n.p2p-mobile-buy-btn {\n  width: 100%;\n  padding: 12px;\n  background: #22c55e;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.p2p-mobile-buy-btn:hover {\n  background: #16a34a;\n}\n\n.p2p-mobile-sell-btn {\n  width: 100%;\n  padding: 12px;\n  background: #ef4444;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n}\n\n.p2p-mobile-sell-btn:hover {\n  background: #dc2626;\n}\n\n.p2p-mobile-expanded-section {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #1e1e2d;\n}\n\n/* Payment Modal */\n.p2p-modal-content {\n  background: #373E4B;\n  border: 1px solid #373E4B;\n  border-radius: 10px;\n}\n\n.p2p-modal-header {\n  border-bottom: 1px solid #404754;\n  padding: 20px 24px;\n}\n\n.payment_search_box {\n  margin-bottom: 20px;\n}\n\n.payment_search_box input {\n  width: 100%;\n  padding: 14px 16px;\n  background: #4B515D;\n  border: 1px solid #4B515D;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n}\n\n.p2p-modal-title {\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.p2p-modal-body {\n  padding: 24px;\n}\n\n.p2p-modal-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.p2p-payment-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  background: #4B515D;\n  border: 1px solid #4B515D;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-payment-option:hover {\n  border-color: #ffdc88;\n}\n\n.p2p-payment-option.p2p-selected {\n  background: rgba(255, 220, 136, 0.15);\n  border-color: #ffdc88;\n}\n\n.p2p-payment-option span {\n  color: #fff;\n  font-size: 14px;\n}\n\n.p2p-payment-option input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: #ffdc88;\n  display: none;\n}\n\n.p2p-payment-option.p2p-selected input[type=\"checkbox\"] {\n  display: block;\n}\n\n.button.p2p-submit-button {\n  background-color: #fff;\n  border: none;\n  border-radius: 50px;\n  font-size: 15px;\n  margin-top: 12px;\n}\n\n/* ====================================\n     Responsive Styles\n     ==================================== */\n\n@media (max-width: 991.98px) {\n  .p2p-sidebar {\n    transform: translateX(-100%);\n  }\n\n  .p2p-sidebar.p2p-open {\n    transform: translateX(0);\n    background: #000;\n  }\n\n  .p2p-sidebar-close {\n    display: flex;\n  }\n}\n\n@media (min-width: 992px) {\n  .p2p-sidebar-overlay {\n    display: none !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .p2p-filter-section {\n    flex-wrap: wrap;\n  }\n\n  .p2p-filter-group {\n    min-width: calc(50% - 8px);\n  }\n\n  .p2p-find-orders-btn {\n    width: 100%;\n  }\n\n  .p2p-orders-table th:nth-child(2),\n  .p2p-orders-table td:nth-child(2) {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .p2p-toggle-btn {\n    padding: 10px 32px;\n    font-size: 14px;\n  }\n\n  .p2p-filter-group {\n    min-width: 100%;\n  }\n\n\n  .p2p-orders-table-wrapper {\n    overflow-x: auto;\n  }\n\n  .p2p-orders-table {\n    min-width: 600px;\n  }\n\n  .p2p-expanded-content {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .p2p-expanded-right {\n    min-width: 100%;\n    padding: 0;\n  }\n\n  .p2p-expanded-left {\n    padding: 16px;\n  }\n\n  .p2p-input-header {\n    padding: 14px 16px 6px;\n  }\n\n  .p2p-expanded-input-wrapper {\n    padding: 0 16px 14px;\n  }\n\n  .p2p-expanded-input-wrapper input {\n    font-size: 26px;\n  }\n\n  .p2p-payment-selector-full {\n    padding: 14px 16px;\n    font-size: 14px;\n  }\n\n  .p2p-confirm-buy-btn,\n  .p2p-confirm-sell-btn {\n    padding: 14px 20px;\n    font-size: 14px;\n  }\n\n  .p2p-pagination-wrapper {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 640px) {\n  .p2p-orders-table-wrapper {\n    display: none;\n  }\n\n  .p2p-mobile-orders-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  /* Mobile expanded row styling */\n  .p2p-expanded-row {\n    display: block;\n  }\n\n  .p2p-expanded-row td {\n    padding: 0 !important;\n  }\n\n  .p2p-expanded-content {\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n    background: #0d0d14;\n    border-radius: 12px;\n    margin: 8px 0;\n  }\n\n  .p2p-expanded-left {\n    order: 2;\n    border-top: 1px solid #2a2a3a;\n    padding-top: 16px;\n    margin-top: 16px;\n  }\n\n  .p2p-expanded-right {\n    order: 1;\n  }\n}\n\n@media (max-width: 576px) {\n  .p2p-buy-sell-toggle {\n    margin-bottom: 16px;\n  }\n\n\n\n\n  .p2p-toggle-wrapper {\n    width: 100%;\n  }\n\n  .p2p-toggle-btn {\n    flex: 1;\n    padding: 10px 16px;\n  }\n\n  .p2p-filter-section {\n    gap: 12px;\n    padding: 0;\n  }\n\n  .p2p-orders-table th,\n  .p2p-orders-table td {\n    padding: 12px;\n  }\n\n  .p2p-advertiser-avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n  }\n\n  .p2p-advertiser-info h4 {\n    font-size: 13px;\n  }\n\n  .p2p-buy-btn,\n  .p2p-sell-btn {\n    padding: 8px 16px;\n    font-size: 12px;\n  }\n\n  .p2p-expanded-stats {\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n\n  .p2p-expanded-form-actions {\n    flex-direction: column;\n  }\n\n  .p2p-pagination-wrapper.p2p-mobile {\n    background: transparent;\n    border: none;\n    margin-top: 16px;\n  }\n\n  /* P2P Expanded Form Mobile Styles */\n  .p2p-expanded-content {\n    padding: 12px;\n    gap: 16px;\n  }\n\n  .p2p-expanded-right {\n    min-width: 100%;\n  }\n\n  .p2p-expanded-form-group {\n    margin-bottom: 10px;\n  }\n\n  .p2p-input-header {\n    padding: 12px 14px 4px;\n    border-radius: 10px 10px 0 0;\n  }\n\n  .p2p-input-header label {\n    font-size: 12px;\n  }\n\n  .p2p-input-range {\n    font-size: 11px;\n  }\n\n  .p2p-expanded-input-wrapper {\n    padding: 0 14px 12px;\n    border-radius: 0 0 10px 10px;\n  }\n\n  .p2p-expanded-input-wrapper input {\n    font-size: 22px;\n  }\n\n  .p2p-input-currency {\n    font-size: 13px;\n  }\n\n  .p2p-price-info {\n    font-size: 11px;\n  }\n\n  .p2p-payment-selector-full {\n    padding: 12px 14px;\n    font-size: 13px;\n    border-radius: 0 0 10px 10px;\n  }\n\n  .p2p-payment-indicator {\n    width: 3px;\n    height: 14px;\n  }\n\n  .p2p-expanded-form-actions {\n    margin-top: 12px;\n  }\n\n  .p2p-confirm-buy-btn,\n  .p2p-confirm-sell-btn {\n    padding: 12px 16px;\n    font-size: 13px;\n    border-radius: 8px;\n  }\n\n  .p2p-expanded-input-error {\n    font-size: 11px;\n    padding-left: 14px;\n  }\n\n  /* Expanded left section mobile */\n  .p2p-expanded-left {\n    padding: 12px;\n  }\n\n  .p2p-expanded-avatar {\n    width: 36px;\n    height: 36px;\n    font-size: 14px;\n  }\n\n  .p2p-expanded-user-details h5 {\n    font-size: 14px;\n  }\n\n  .p2p-expanded-user-details p {\n    font-size: 11px;\n  }\n\n  .p2p-expanded-stats {\n    gap: 12px;\n  }\n\n  .p2p-stat-item {\n    min-width: calc(50% - 6px);\n  }\n\n  .p2p-stat-value {\n    font-size: 13px;\n  }\n\n  .p2p-stat-label {\n    font-size: 10px;\n  }\n\n  .p2p-expanded-payments h6,\n  .p2p-expanded-remarks h6 {\n    font-size: 12px;\n  }\n\n  .p2p-expanded-payment-badge {\n    font-size: 11px;\n    padding: 4px 8px;\n  }\n\n  .p2p-expanded-remarks p {\n    font-size: 12px;\n  }\n}\n\n/* Extra small devices */\n@media (max-width: 400px) {\n  .p2p-expanded-input-wrapper input {\n    font-size: 20px;\n  }\n\n  .p2p-input-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .p2p-payment-selector-full {\n    font-size: 12px;\n  }\n\n  .p2p-stat-item {\n    min-width: 100%;\n  }\n}\n\n/* ====================================\n     ENHANCED MOBILE RESPONSIVENESS - P2P Dashboard\n     ==================================== */\n\n/* Tablet breakpoint (992px - 768px) */\n@media (max-width: 992px) and (min-width: 769px) {\n  .p2p-dashboard-container {\n    padding: 0 12px;\n  }\n\n  .p2p-toggle-btn {\n    padding: 12px 36px;\n    font-size: 14px;\n  }\n\n  .p2p-filter-section {\n    gap: 12px;\n  }\n\n  .p2p-filter-group {\n    min-width: calc(33.333% - 12px);\n  }\n\n  .p2p-orders-table th,\n  .p2p-orders-table td {\n    padding: 16px 12px;\n    font-size: 13px;\n  }\n\n  .p2p-price-value {\n    font-size: 15px;\n  }\n}\n\n/* Mobile landscape and small tablets (768px) */\n@media (max-width: 768px) {\n  .p2p-dashboard-container {\n    padding: 0 8px;\n  }\n\n  /* Hide desktop table at this breakpoint too */\n  .p2p-orders-table-wrapper {\n    display: none;\n  }\n\n  .p2p-mobile-orders-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .p2p-filter-section {\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 16px;\n    padding: 0 4px;\n  }\n\n  .p2p-filter-group {\n    min-width: 100%;\n    flex: none;\n  }\n\n  .p2p-filter-select {\n    padding: 14px 16px;\n    font-size: 15px;\n    border-radius: 10px;\n  }\n\n  .p2p-find-orders-btn {\n    padding: 14px;\n    width: 100%;\n    font-size: 15px;\n    border-radius: 10px;\n    margin-top: 4px;\n  }\n\n  .p2p-buy-sell-toggle {\n    margin-bottom: 20px;\n    padding: 0 4px;\n  }\n\n  .p2p-toggle-wrapper {\n    width: 100%;\n    border-radius: 10px;\n    padding: 5px;\n  }\n\n  .p2p-toggle-btn {\n    flex: 1;\n    padding: 14px 20px;\n    font-size: 15px;\n    font-weight: 600;\n    border-radius: 8px;\n  }\n\n  /* Mobile order cards improved */\n  .p2p-mobile-order-card {\n    padding: 16px;\n    border-radius: 14px;\n    margin-bottom: 0;\n  }\n\n  .p2p-mobile-card-avatar {\n    width: 44px;\n    height: 44px;\n    font-size: 18px;\n  }\n\n  .p2p-mobile-card-user-info h4 {\n    font-size: 15px;\n    font-weight: 600;\n  }\n\n  .p2p-mobile-card-user-info p {\n    font-size: 13px;\n    color: #7d8087;\n  }\n\n  .p2p-mobile-card-price .p2p-value {\n    font-size: 20px;\n    font-weight: 700;\n  }\n\n  .p2p-mobile-card-price .p2p-currency {\n    font-size: 13px;\n  }\n\n  .p2p-mobile-card-details {\n    gap: 16px;\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n  }\n\n  .p2p-mobile-detail-label {\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .p2p-mobile-detail-value {\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 8px 12px;\n    font-size: 12px;\n    border-radius: 6px;\n  }\n\n  .p2p-mobile-buy-btn,\n  .p2p-mobile-sell-btn {\n    padding: 9px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 10px;\n    margin-top: 12px;\n  }\n\n  /* Expanded section mobile */\n  .p2p-mobile-expanded-section {\n    padding-top: 20px;\n    margin-top: 20px;\n  }\n\n  .p2p-payment-method-header.mobileview {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .mobileview .p2p-payment-method-actions {\n    width: auto;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-right {\n    padding: 0;\n  }\n\n  /* Keep same design as desktop - card style inputs */\n  .p2p-mobile-expanded-section .p2p-expanded-form-group {\n    margin-bottom: 14px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-input-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 16px 8px;\n    background: #1a1a2200;\n    border-radius: 10px 10px 0 0;\n    border: 1px solid #424251;\n    border-bottom: none;\n  }\n\n  .p2p-mobile-expanded-section .p2p-input-header label {\n    font-size: 13px;\n    color: #ffffff;\n    margin: 0;\n  }\n\n  .p2p-mobile-expanded-section .p2p-input-range {\n    font-size: 11px;\n    color: #adabab;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper {\n    display: flex;\n    align-items: center;\n    background: #1a1a2200;\n    border: 1px solid #424251;\n    border-top: none;\n    border-radius: 0 0 10px 10px;\n    padding: 0 16px 14px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {\n    flex: 1;\n    background: transparent;\n    border: none;\n    color: #fff;\n    font-size: 26px;\n    font-weight: 500;\n    padding: 0;\n    width: 100%;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper input:focus {\n    outline: none;\n  }\n\n  .p2p-mobile-expanded-section .p2p-input-currency {\n    color: #888;\n    font-size: 14px;\n    font-weight: 500;\n    background: transparent;\n    padding: 0;\n  }\n\n  .p2p-mobile-expanded-section .p2p-price-info {\n    font-size: 11px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-payment-selector-full,\n  .p2p-mobile-expanded-section .p2p-payment-selector {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 16px;\n    background: #1a1a2200;\n    border: 1px solid #424251;\n    border-radius: 10px;\n    color: #888;\n    font-size: 14px;\n    text-align: left;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n\n  .p2p-mobile-expanded-section .p2p-payment-selector-full:hover,\n  .p2p-mobile-expanded-section .p2p-payment-selector:hover {\n    border-color: #3a3a4a;\n  }\n\n  .p2p-mobile-expanded-section .p2p-payment-indicator {\n    width: 3px;\n    height: 16px;\n    background: #22c55e;\n    border-radius: 2px;\n    margin-right: 10px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-form-actions {\n    display: flex;\n    gap: 12px;\n    margin-top: 20px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-cancel-btn {\n    flex: 1;\n    padding: 14px;\n    background: transparent;\n    border: 1px solid #2a2a3a;\n    border-radius: 10px;\n    color: #8b8b8b;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n  }\n\n  .p2p-mobile-expanded-section .p2p-cancel-btn:hover {\n    background: rgba(255, 255, 255, 0.05);\n  }\n\n  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {\n    flex: 2;\n    padding: 14px;\n    font-size: 15px;\n    font-weight: 600;\n    border-radius: 10px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-input-error {\n    font-size: 11px;\n    color: #ef4444;\n    margin-top: 6px;\n    padding-left: 16px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-available-balance {\n    display: block;\n    font-size: 12px;\n    color: #aaa;\n    margin-top: 6px;\n    padding-left: 2px;\n  }\n\n  .payment_method_pop {\n    padding-right: 0px !important;\n  }\n\n  .modal.fade {\n    padding-right: 0px !important;\n  }\n\n  /* Pagination mobile */\n  .p2p-pagination-wrapper {\n    padding: 16px;\n    margin-top: 16px;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n  }\n\n  .p2p-pagination-info {\n    font-size: 13px;\n    order: 2;\n  }\n\n  .p2p-pagination-controls {\n    order: 1;\n  }\n\n  .p2p-page-btn {\n    width: 36px;\n    height: 36px;\n    font-size: 13px;\n  }\n\n  /* Modal mobile */\n  .p2p-modal-content {\n    margin: 16px;\n    max-height: calc(100vh - 32px);\n  }\n\n  .p2p-modal-header {\n    padding: 16px;\n  }\n\n  .p2p-modal-title {\n    font-size: 16px;\n  }\n\n  .p2p-modal-body {\n    padding: 16px;\n    max-height: calc(100vh - 150px);\n    overflow-y: auto;\n  }\n\n  .p2p-payment-option {\n    padding: 14px 16px;\n  }\n\n  .p2p-payment-option span {\n    font-size: 14px;\n  }\n\n  /* Available balance mobile */\n  .p2p-available-balance {\n    font-size: 12px;\n    margin-top: 8px;\n    display: block;\n  }\n}\n\n/* Mobile portrait (576px and below) */\n@media (max-width: 576px) {\n  .p2p-dashboard-container {\n    padding: 0 4px;\n  }\n\n  .p2p-toggle-btn {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n\n  .p2p-filter-label {\n    font-size: 11px;\n  }\n\n  .p2p-filter-select {\n    padding: 12px 14px;\n    font-size: 14px;\n  }\n\n  .p2p-find-orders-btn {\n    padding: 12px;\n    font-size: 14px;\n  }\n\n  .p2p-mobile-order-card {\n    padding: 14px;\n    border-radius: 12px;\n  }\n\n  .p2p-mobile-card-header {\n    margin-bottom: 14px;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .p2p-mobile-card-user {\n    gap: 10px;\n  }\n\n  .p2p-mobile-card-avatar {\n    width: 40px;\n    height: 40px;\n    font-size: 16px;\n  }\n\n  .p2p-mobile-card-user-info h4 {\n    font-size: 14px;\n  }\n\n  .p2p-mobile-card-user-info p {\n    font-size: 12px;\n  }\n\n  .p2p-mobile-card-price .p2p-value {\n    font-size: 18px;\n  }\n\n  .p2p-mobile-card-details {\n    gap: 10px;\n    margin-bottom: 14px;\n    padding-bottom: 14px;\n  }\n\n  .p2p-mobile-detail-label {\n    font-size: 11px;\n  }\n\n  .p2p-mobile-detail-value {\n    font-size: 13px;\n  }\n\n  .p2p-mobile-card-payments {\n    gap: 6px;\n    margin-bottom: 14px;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n\n  .p2p-mobile-buy-btn,\n  .p2p-mobile-sell-btn {\n    padding: 12px;\n    font-size: 14px;\n    border-radius: 8px;\n  }\n\n  /* Expanded section small mobile */\n  .p2p-mobile-expanded-section {\n    padding-top: 16px;\n    margin-top: 16px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-input-header {\n    padding: 12px 14px 6px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper {\n    padding: 0 14px 12px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {\n    font-size: 22px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-payment-selector-full {\n    padding: 12px 14px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-form-actions {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-cancel-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {\n    flex: none;\n    width: 100%;\n  }\n\n  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {\n    order: -1;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-input-error {\n    font-size: 11px;\n    margin-top: 6px;\n    padding-left: 14px;\n  }\n\n  /* Verification button mobile */\n  .p2p-mobile-verification-btn {\n    padding: 12px;\n    font-size: 13px;\n  }\n\n  .p2p-mobile-verification-btn i {\n    font-size: 16px;\n  }\n\n  /* Trade restricted mobile */\n  .p2p-mobile-condition-info {\n    font-size: 11px;\n    padding: 10px;\n    flex-direction: column;\n    text-align: center;\n    gap: 4px;\n  }\n\n  /* Pagination small mobile */\n  .p2p-pagination-wrapper.p2p-mobile {\n    padding: 12px 0;\n  }\n\n  .p2p-page-btn {\n    width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n\n  /* Modal small mobile */\n  .p2p-modal-content {\n    margin: 8px;\n    border-radius: 12px;\n  }\n\n  .p2p-payment-option {\n    padding: 12px 14px;\n  }\n\n  /* No payment methods state */\n  .p2p-no-payment-methods {\n    padding: 24px 16px;\n    text-align: center;\n  }\n\n  .p2p-no-payment-methods i {\n    font-size: 40px;\n  }\n\n  .p2p-no-payment-methods p {\n    font-size: 14px;\n  }\n\n  .p2p-add-payment-btn {\n    padding: 12px 20px;\n    font-size: 13px;\n  }\n}\n\n/* Extra small mobile (400px and below) */\n@media (max-width: 400px) {\n  .p2p-toggle-wrapper {\n    padding: 4px;\n  }\n\n  .p2p-toggle-btn {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .p2p-filter-select {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .p2p-find-orders-btn {\n    padding: 10px;\n    font-size: 13px;\n  }\n\n  .p2p-mobile-order-card {\n    padding: 12px;\n  }\n\n  .p2p-mobile-card-header {\n    margin-bottom: 12px;\n  }\n\n  .p2p-mobile-card-avatar {\n    width: 28px;\n    height: 28px;\n    font-size: 14px;\n  }\n\n  .p2p-mobile-card-user-info h4 {\n    font-size: 13px;\n  }\n\n  .p2p-mobile-card-user-info p {\n    font-size: 11px;\n    max-width: 120px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .p2p-mobile-card-price .p2p-value {\n    font-size: 16px;\n  }\n\n  .p2p-mobile-card-price .p2p-currency {\n    font-size: 11px;\n  }\n\n  .p2p-mobile-card-details {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .p2p-mobile-detail-item {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 5px 8px;\n    font-size: 10px;\n  }\n\n  .p2p-mobile-buy-btn,\n  .p2p-mobile-sell-btn {\n    padding: 8px 10px;\n    font-size: 12px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-input-header {\n    padding: 7px 12px 5px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-input-header label {\n    font-size: 12px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-input-range {\n    font-size: 10px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper {\n    padding: 0 12px 10px;\n    gap: 5px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {\n    font-size: 18px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-input-currency {\n    font-size: 13px;\n  }\n\n  .p2p-mobile-expanded-section .p2p-payment-selector-full {\n    padding: 10px 12px;\n    font-size: 12px;\n    margin-top: 14px;\n\n  }\n\n  .p2p-mobile-expanded-section .p2p-cancel-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {\n    padding: 10px;\n    font-size: 12px;\n  }\n\n  /* Rating on mobile */\n  .p2p-mobile-card-user-info .p2p-rating {\n    font-size: 11px;\n  }\n\n  .p2p-mobile-card-user-info .p2p-rating span:first-child {\n    font-size: 10px;\n    letter-spacing: -1px;\n  }\n}\n\n/* ====================================\n     P2P My Ads Page Styles\n     ==================================== */\n\n.p2p-myads-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.p2p-myads-title {\n  font-size: 22px;\n  font-weight: 600;\n  color: #d1d5db;\n  margin: 0 0 4px 0;\n}\n\n.p2p-myads-subtitle {\n  font-size: 13px;\n  color: #52525b;\n  margin: 0;\n}\n\n.p2p-create-ad-btn {\n  padding: 10px 20px;\n  /* background: rgba(30, 58, 138, 0.4); */\n  border: 1px solid rgba(255, 220, 136, 0.3);\n  border-radius: 8px;\n  /* color: #93c5fd; */\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-create-ad-btn:hover {\n  background-color: #e7b641;\n}\n\n.p2p-payment-method-header {\n  gap: 12px;\n}\n\n/* Stats Cards Grid */\n.p2p-myads-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n  margin-bottom: 24px;\n  background-color: #373F4D;\n  border-radius: 8px;\n  overflow: hidden;\n  padding: 12px 0px;\n}\n\n.p2p-myads-stat-card {\n  background: #373F4D;\n  border-radius: 0px;\n  border: none;\n  padding: 3px 20px;\n  transition: border-color 0.2s ease;\n  border-right: 1px solid #454C59;\n}\n\n.p2p-myads-stat-card:hover {\n  border-right: 1px solid #454C59;\n}\n\n.p2p-filter-section.myadsfillter {\n  padding: 0px;\n}\n\n.p2p-myads-stats-grid .p2p-myads-stat-card:last-child {\n  border-right: none;\n}\n\n.p2p-dashboard-container.p2p-profile-container {\n  background-color: #2B313C;\n  border-radius: 10px;\n}\n\n.p2p-profile-container .p2p-profile-header {\n  background: none;\n  border-radius: 12px;\n  border: none;\n  padding: 36px;\n  margin-bottom: 0px;\n}\n\n.p2p-profile-container .p2p-myads-stats-grid {\n  grid-template-columns: repeat(2, 1fr);\n  background-color: transparent;\n  border-radius: 0px;\n  gap: 20px;\n  padding: 20px 36px;\n  overflow: inherit;\n  border-bottom: 1px solid #454C59;\n  border-top: 1px solid #454C59;\n}\n\n.p2p-profile-container .p2p-myads-stat-card {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  justify-content: space-between;\n  background: none;\n  border-radius: 0px;\n  border-right: none;\n  padding: 6px 0px;\n  border-bottom: 1px solid #454C59;\n}\n\n.p2p-profile-container .p2p-myads-stat-card-label {\n  color: #fff;\n  font-size: 13px;\n  border-bottom: none;\n}\n\n.p2p-profile-container .p2p-myads-stat-card:nth-child(5) {\n  border-bottom: none;\n}\n\n.p2p-profile-container .p2p-myads-stat-card:last-child {\n  border-bottom: none;\n}\n\n.p2p-profile-tabs.paymentprofiletabs {\n  padding: 0px 36px 36px;\n}\n\n.p2p-profile-container .p2p-empty-state-card {\n  background: none;\n  border-radius: 0px;\n}\n\n.p2p-profile-container .p2p-empty-state-card i {\n  font-size: 30px;\n  color: #fff;\n  margin-bottom: 0px;\n}\n\n.myadsfillter .p2p-filter-select {\n  background: #373F4D;\n  border: 1px solid #373F4D;\n}\n\n.myadsfillter .p2p-find-orders-btn {\n  background: #373F4D;\n  border: 1px solid #373F4D;\n}\n\n.p2p-myads-container {\n  background-color: #2B313C;\n  padding: 24px;\n  border-radius: 12px;\n}\n\n.p2p-myads-stat-card-label {\n  color: #A2A9B6;\n  font-size: 13px;\n  padding-bottom: 3px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid #454C59;\n  letter-spacing: 0.3px;\n}\n\n.p2p-myads-stat-card-value {\n  font-size: 16px;\n  font-weight: 400;\n  color: #e5e5e5;\n}\n\n/* Legacy stats (keep for backwards compatibility) */\n.p2p-myads-stats {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 20px;\n  padding: 16px 20px;\n  background: #0d0d14;\n  border-radius: 10px;\n  border: 1px solid #1e1e2d;\n}\n\n.p2p-myads-stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-myads-stat-value {\n  font-size: 18px;\n  font-weight: 600;\n  color: #a1a1aa;\n}\n\n.p2p-myads-stat-label {\n  font-size: 11px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.p2p-loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 60px 20px;\n  min-height: 200px;\n}\n\n.p2p-loading-container .spinner-border {\n  width: 32px;\n  height: 32px;\n}\n\n@media (max-width: 768px) {\n  .p2p-loading-container {\n    padding: 40px 16px;\n    min-height: 150px;\n  }\n\n  .p2p-loading-container .spinner-border {\n    width: 28px;\n    height: 28px;\n  }\n}\n\n/* My Ads Table Specific Styles */\n.p2p-myads-asset-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.p2p-myads-side-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.p2p-myads-side-badge.buy {\n  background: #5EBA89;\n  color: #fff;\n}\n\n.p2p-myads-side-badge.sell {\n  background: rgba(239, 68, 68, 0.08);\n  color: #fca5a5;\n}\n\n.p2p-myads-asset-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-empty-state-card .p2p-myads-action-btn {\n  padding: 10px 12px;\n}\n\n.p2p-myads-asset-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #d1d5db;\n}\n\n.p2p-myads-asset-fiat {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.p2p-myads-price {\n  font-size: 14px;\n  font-weight: 500;\n  color: #a1a1aa;\n}\n\n.p2p-myads-price-currency {\n  font-size: 11px;\n  color: #6b7280;\n  margin-left: 4px;\n}\n\n.p2p-myads-volume {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-myads-volume-remaining {\n  font-size: 14px;\n  font-weight: 500;\n  color: #a1a1aa;\n}\n\n.p2p-myads-volume-total {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.p2p-myads-limits {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.p2p-myads-status {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.p2p-myads-date {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.p2p-payment-badge-more {\n  padding: 4px 8px;\n  background: rgba(107, 114, 128, 0.2);\n  border-radius: 4px;\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* Empty State */\n.p2p-empty-state {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.p2p-empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.p2p-empty-state p {\n  color: #6b7280;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.p2p-create-ad-btn-small {\n  padding: 10px 20px;\n  background: rgba(30, 41, 59, 0.4);\n  border: 1px solid rgba(51, 65, 85, 0.5);\n  border-radius: 8px;\n  color: #9ca3af;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.payment_method_pop.modal.fade .modal-dialog {\n  min-width: 540px;\n}\n\n.p2p-create-ad-btn-small:hover {\n  border-color: rgba(71, 85, 105, 0.8);\n  color: #d1d5db;\n  background: rgba(30, 41, 59, 0.6);\n}\n\n.p2p-empty-state-mobile {\n  text-align: center;\n  padding: 40px 20px;\n  background: #373F4D;\n  border-radius: 12px;\n  border: 1px solid #373F4D;\n}\n\n/* Pagination */\n.p2p-pagination-buttons,\n.p2p-pagination-controls {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .p2p-myads-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .p2p-myads-stats {\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n\n  .p2p-myads-stat-item {\n    min-width: calc(33% - 12px);\n  }\n\n  .p2p-pagination-wrapper {\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n  }\n}\n\n@media (max-width: 576px) {\n  .p2p-myads-title {\n    font-size: 18px;\n  }\n\n  .p2p-myads-stats {\n    padding: 12px 16px;\n  }\n\n  .p2p-myads-stat-value {\n    font-size: 16px;\n  }\n}\n\n/* My Ads Actions */\n.p2p-myads-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.p2p-myads-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  color: #a1a1aa;\n}\n\n.p2p-myads-action-btn i {\n  font-size: 14px;\n}\n\n.p2p-myads-action-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.15);\n  color: #e5e5e5;\n}\n\n.p2p-myads-action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Online/Offline Status */\n.p2p-myads-status-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.p2p-myads-online-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  width: fit-content;\n}\n\n.p2p-myads-online-badge.online {\n  background: rgba(255, 255, 255, 0.08);\n  color: #d1d5db;\n}\n\n.p2p-myads-online-badge.offline {\n  background: rgba(255, 255, 255, 0.04);\n  color: #6b7280;\n}\n\n.p2p-myads-online-badge.small {\n  padding: 2px 6px;\n  font-size: 10px;\n}\n\n.p2p-myads-online-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #6b7280;\n}\n\n.p2p-myads-online-badge.online .p2p-myads-online-dot {\n  background: #4ade80;\n  animation: p2p-pulse 2s ease-in-out infinite;\n}\n\n.p2p-myads-online-badge.offline .p2p-myads-online-dot {\n  background: #6b7280;\n  animation: none;\n}\n\n@keyframes p2p-pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.p2p-mobile-status-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* .p2p-row-expanded {\n    background: rgba(255, 220, 136, 0.03) !important;\n  } */\n\n/* Expanded Content */\n/* .p2p-myads-expanded-content {\n    padding: 20px 24px;\n    background: #0a0a0f;\n    border-top: 1px solid #1e1e2d;\n  } */\n\n.p2p-myads-expanded-section {\n  margin-bottom: 24px;\n}\n\n.p2p-myads-expanded-section:last-child {\n  margin-bottom: 0;\n}\n\n.p2p-myads-expanded-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #9ca3af;\n  margin: 0 0 12px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-myads-expanded-count {\n  font-size: 11px;\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.p2p-myads-expanded-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.p2p-myads-expanded-grid.mobile {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.p2p-myads-expanded-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.p2p-myads-expanded-label {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.p2p-myads-expanded-value {\n  font-size: 13px;\n  color: #a1a1aa;\n  font-weight: 500;\n}\n\n.p2p-myads-expanded-value.small {\n  font-size: 11px;\n  word-break: break-all;\n}\n\n.p2p-myads-expanded-payments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n/* Payment Details Cards */\n.p2p-myads-payment-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.p2p-myads-payment-card {\n  background: #2f3641;\n  border: 1px solid #454C59;\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.p2p-myads-payment-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #454C59;\n}\n\n.p2p-myads-payment-type {\n  font-size: 14px;\n  font-weight: 600;\n  color: #bd83cb;\n}\n\n.p2p-myads-payment-type-badge {\n  font-size: 10px;\n  padding: 2px 6px;\n  background: rgba(107, 114, 128, 0.2);\n  color: #9ca3af;\n  border-radius: 4px;\n}\n\n.p2p-myads-payment-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.p2p-myads-payment-field {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.p2p-myads-payment-label {\n  font-size: 12px;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.p2p-myads-payment-value {\n  font-size: 12px;\n  color: #a1a1aa;\n  text-align: right;\n  word-break: break-all;\n}\n\n.p2p-myads-payment-qr {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #454C59;\n}\n\n.p2p-myads-payment-qr img {\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n  background: #fff;\n  border-radius: 8px;\n  padding: 4px;\n}\n\n.p2p-myads-no-details {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n/* Closure Information */\n.p2p-myads-closure-info {\n  background: rgba(107, 114, 128, 0.1);\n  border: 1px solid rgba(107, 114, 128, 0.2);\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.p2p-myads-closure-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.p2p-myads-closure-icon {\n  font-size: 16px;\n}\n\n.p2p-myads-closure-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #9ca3af;\n}\n\n.p2p-myads-closure-date {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.p2p-myads-closure-reason {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(107, 114, 128, 0.2);\n}\n\n.p2p-myads-closure-reason-label {\n  font-size: 12px;\n  color: #6b7280;\n  margin-right: 8px;\n}\n\n.p2p-myads-closure-reason-text {\n  font-size: 13px;\n  color: #a1a1aa;\n  line-height: 1.5;\n}\n\n/* Mobile Card Actions */\n.p2p-mobile-card-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-card-actions .p2p-myads-action-btn {\n  flex: 1;\n  padding: 10px 16px;\n  font-size: 13px;\n}\n\n/* Mobile Expanded Details */\n.p2p-mobile-expanded-details {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.p2p-mobile-expanded-details .p2p-myads-payment-details {\n  grid-template-columns: 1fr;\n}\n\n@media (max-width: 1024px) {\n  .p2p-myads-expanded-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .p2p-myads-expanded-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .p2p-myads-payment-details {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 576px) {\n  .p2p-myads-actions {\n    flex-direction: column;\n  }\n\n  .p2p-myads-action-btn {\n    width: 100%;\n    text-align: center;\n  }\n\n  .p2p-myads-expanded-content {\n    padding: 16px;\n  }\n\n  .p2p-myads-expanded-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n  }\n}\n\n/* Close Ad Modal */\n.p2p-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n  padding: 20px;\n  backdrop-filter: blur(4px);\n}\n\n.p2p-close-ad-modal {\n  background: #12121a;\n  border: 1px solid #1e1e2d;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 480px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: p2p-modal-slide-in 0.2s ease-out;\n}\n\n@keyframes p2p-modal-slide-in {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.p2p-close-ad-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n.p2p-close-ad-modal-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #d1d5db;\n  margin: 0;\n}\n\n.p2p-close-ad-modal-close {\n  background: transparent;\n  border: none;\n  font-size: 28px;\n  color: #6b7280;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  transition: color 0.2s;\n}\n\n.p2p-close-ad-modal-close:hover {\n  color: #e5e5e5;\n}\n\n.p2p-close-ad-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n}\n\n/* Warning Banner */\n.p2p-close-ad-warning {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: rgba(120, 113, 108, 0.1);\n  border: 1px solid rgba(120, 113, 108, 0.2);\n  border-radius: 10px;\n  margin-bottom: 20px;\n}\n\n.p2p-close-ad-warning-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.p2p-close-ad-warning-content strong {\n  display: block;\n  font-size: 14px;\n  color: #d6d3d1;\n  margin-bottom: 4px;\n}\n\n.p2p-close-ad-warning-content p {\n  font-size: 13px;\n  color: #9ca3af;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Ad Summary */\n.p2p-close-ad-summary {\n  background: #0a0a0f;\n  border: 1px solid #1e1e2d;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 20px;\n}\n\n.p2p-close-ad-summary-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n.p2p-close-ad-summary-pair {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-close-ad-summary-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.p2p-close-ad-summary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.p2p-close-ad-summary-label {\n  font-size: 11px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.p2p-close-ad-summary-value {\n  font-size: 14px;\n  color: #d1d5db;\n  font-weight: 500;\n}\n\n/* Reason Input Group */\n.p2p-close-ad-reason-group {\n  margin-bottom: 0;\n}\n\n.p2p-close-ad-reason-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #9ca3af;\n  margin-bottom: 10px;\n}\n\n.p2p-optional-badge {\n  font-size: 10px;\n  padding: 2px 6px;\n  background: rgba(107, 114, 128, 0.2);\n  color: #6b7280;\n  border-radius: 4px;\n}\n\n.p2p-close-ad-reason-input {\n  width: 100%;\n  background: #0a0a0f;\n  border: 1px solid #2a2a3a;\n  border-radius: 8px;\n  padding: 12px;\n  font-size: 14px;\n  color: #e5e5e5;\n  resize: vertical;\n  min-height: 80px;\n  transition: border-color 0.2s;\n}\n\n.p2p-close-ad-reason-input:focus {\n  outline: none;\n  border-color: #ffdc88;\n}\n\n.p2p-close-ad-reason-input.error {\n  border-color: #ef4444;\n}\n\n.p2p-close-ad-reason-input::placeholder {\n  color: #4b5563;\n}\n\n.p2p-close-ad-reason-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 8px;\n}\n\n.p2p-close-ad-error {\n  font-size: 12px;\n  color: #ef4444;\n}\n\n.p2p-close-ad-char-count {\n  font-size: 11px;\n  color: #6b7280;\n  margin-left: auto;\n}\n\n/* Modal Footer */\n.p2p-close-ad-modal-footer {\n  display: flex;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-close-ad-btn-cancel,\n.p2p-close-ad-btn-confirm {\n  flex: 1;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.p2p-close-ad-btn-cancel {\n  background: transparent;\n  border: 1px solid #2a2a3a;\n  color: #9ca3af;\n}\n\n.p2p-close-ad-btn-cancel:hover:not(:disabled) {\n  background: rgba(107, 114, 128, 0.1);\n  border-color: #4b5563;\n  color: #d1d5db;\n}\n\n.p2p-close-ad-btn-confirm {\n  background: rgba(153, 27, 27, 0.8);\n  border: 1px solid rgba(185, 28, 28, 0.5);\n  color: #fecaca;\n}\n\n.p2p-close-ad-btn-confirm:hover:not(:disabled) {\n  background: rgba(153, 27, 27, 1);\n  color: #fff;\n}\n\n.p2p-close-ad-btn-cancel:disabled,\n.p2p-close-ad-btn-confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 576px) {\n  .p2p-modal-overlay {\n    padding: 16px;\n  }\n\n  .p2p-close-ad-modal {\n    max-width: 100%;\n  }\n\n  .p2p-close-ad-modal-header {\n    padding: 16px 20px;\n  }\n\n  .p2p-close-ad-modal-body {\n    padding: 20px;\n  }\n\n  .p2p-close-ad-modal-footer {\n    padding: 16px 20px;\n    flex-direction: column;\n  }\n\n  .p2p-close-ad-summary-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ====================================\n     P2P My Ads - ENHANCED Mobile Responsive\n     ==================================== */\n\n/* MyAds Header - Mobile Premium Design */\n@media (max-width: 768px) {\n  .p2p-myads-header {\n    padding: 0 4px;\n    margin-bottom: 20px;\n  }\n\n  .p2p-myads-header>div {\n    margin-bottom: 4px;\n  }\n\n  .p2p-myads-title {\n    font-size: 22px;\n    font-weight: 700;\n    color: #f5f5f5;\n    margin-bottom: 6px;\n  }\n\n  .p2p-myads-subtitle {\n    font-size: 13px;\n    color: #6b7280;\n  }\n\n  .p2p-create-ad-btn {\n    width: 100%;\n    padding: 14px 24px;\n    font-size: 14px;\n    font-weight: 600;\n    border-radius: 10px;\n    background: linear-gradient(135deg, rgba(34, 197, 94, 0.2) 0%, rgba(34, 197, 94, 0.1) 100%);\n    border: 1px solid rgba(34, 197, 94, 0.3);\n    color: #4ade80;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n  }\n\n  .p2p-create-ad-btn:hover {\n    background: linear-gradient(135deg, rgba(34, 197, 94, 0.3) 0%, rgba(34, 197, 94, 0.2) 100%);\n    border-color: rgba(34, 197, 94, 0.5);\n  }\n}\n\n/* Stats Grid - Mobile Premium */\n@media (max-width: 768px) {\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    margin-bottom: 20px;\n    padding: 20px;\n  }\n\n  .p2p-myads-stat-card {\n    padding: 14px 12px;\n    border-radius: 0px;\n    /* background: linear-gradient(145deg, #12121a00 0%, #0d0d1400 100%); */\n    /* border: 1px solid #2c2c2c; */\n    text-align: left;\n  }\n\n  .p2p-profile-container .p2p-myads-stat-card {\n    border: none;\n    border-bottom: 1px solid #454C59;\n  }\n\n  .p2p-myads-stat-card-label {\n    font-size: 10px;\n    margin-bottom: 6px;\n    color: #6b7280;\n    letter-spacing: 0.3px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 18px;\n    font-weight: 700;\n    color: #f5f5f5;\n  }\n\n  .selectpaymetpop.modal.fade .modal-dialog {\n    width: 100%;\n    min-width: 100%;\n  }\n\n}\n\n@media (max-width: 480px) {\n\n  .modal.fade .modal-dialog {\n    min-width: 100%;\n    width: 100%;\n    margin: 0 auto;\n  }\n\n\n\n\n  .selectpaymetpop.modal.fade .modal-dialog {\n    width: 100%;\n    min-width: 100%;\n  }\n\n  .myadsheading .p2p-mobile-card-user-info h4 {\n    font-size: 12px;\n    margin: 0px 0px 1px;\n  }\n\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .p2p-myads-stat-card {\n    padding: 12px 10px;\n  }\n\n  .p2p-myads-stat-card-label {\n    font-size: 9px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 16px;\n  }\n}\n\n/* Mobile Order Cards - Premium Design */\n@media (max-width: 768px) {\n  .p2p-orders-table-wrapper {\n    display: none;\n  }\n\n  .p2p-mobile-orders-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 0 4px;\n  }\n\n  .p2p-mobile-order-card {\n    border: 1px solid rgb(54 54 54);\n    border-radius: 16px;\n    padding: 18px;\n    transition: all 0.2s ease;\n  }\n\n  .p2p-mobile-order-card:hover {\n    border-color: rgb(54 54 54);\n  }\n\n  /* Card Header */\n  .p2p-mobile-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 16px;\n  }\n\n  .p2p-mobile-card-user {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .p2p-myads-side-badge {\n    padding: 6px 12px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n  }\n\n  .p2p-myads-side-badge.buy {\n    background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.08) 100%);\n    color: #4ade80;\n    border: 1px solid rgba(34, 197, 94, 0.2);\n  }\n\n  .p2p-myads-side-badge.sell {\n    background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.08) 100%);\n    color: #f87171;\n    border: 1px solid rgba(239, 68, 68, 0.2);\n  }\n\n  .p2p-mobile-card-user-info h4 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #f5f5f5;\n    margin: 0 0 4px 0;\n  }\n\n  .p2p-mobile-status-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n  }\n\n  /* Price Display */\n  .p2p-mobile-card-price {\n    text-align: right;\n  }\n\n  .p2p-mobile-card-price .p2p-value {\n    font-size: 20px;\n    font-weight: 700;\n    color: #f5f5f5;\n    line-height: 1.2;\n  }\n\n  .p2p-mobile-card-price .p2p-currency {\n    font-size: 12px;\n    color: #6b7280;\n    font-weight: 500;\n  }\n\n  /* Card Details Grid */\n  .p2p-mobile-card-details {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 14px;\n    margin-bottom: 16px;\n    padding: 16px;\n    background: rgba(0, 0, 0, 0);\n    border-radius: 12px;\n  }\n\n  .p2p-mobile-detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .p2p-mobile-detail-label {\n    font-size: 11px;\n    color: #6b7280;\n    letter-spacing: 0.5px;\n    font-weight: 500;\n  }\n\n  .p2p-mobile-detail-value {\n    font-size: 13px;\n    color: #e5e5e5;\n    font-weight: 500;\n  }\n\n  /* Payment Badges */\n  .p2p-mobile-card-payments {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 6px 12px;\n    background: rgba(255, 220, 136, 0.1);\n    border: 1px solid rgba(255, 220, 136, 0.2);\n    border-radius: 6px;\n    font-size: 12px;\n    color: #bd83cb;\n    font-weight: 500;\n  }\n\n  /* Action Buttons */\n  .p2p-mobile-card-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 0;\n    padding-top: 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn {\n    flex: 1;\n    padding: 12px 14px;\n    font-size: 13px;\n    font-weight: 500;\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    color: #a1a1aa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.08);\n    color: #e5e5e5;\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn i {\n    font-size: 16px;\n  }\n\n  /* Online/Offline Badge */\n  .p2p-myads-online-badge {\n    padding: 4px 10px;\n    border-radius: 20px;\n    font-size: 11px;\n    font-weight: 600;\n  }\n\n  .p2p-myads-online-badge.online {\n    background: rgb(34 197 94 / 0%);\n    border: 1px solid rgb(34 197 94 / 0%);\n    color: #4ade80;\n  }\n\n  .p2p-myads-online-badge.offline {\n    background: rgba(107, 114, 128, 0.1);\n    border: 1px solid rgba(107, 114, 128, 0.2);\n    color: #9ca3af;\n  }\n\n  .p2p-myads-online-badge.small {\n    padding: 3px 8px;\n    font-size: 10px;\n  }\n\n  .p2p-myads-online-dot {\n    width: 6px;\n    height: 6px;\n  }\n\n  /* Expanded Details */\n  .p2p-mobile-expanded-details {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-section {\n    margin-bottom: 20px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-title {\n    font-size: 12px;\n    color: #6b7280;\n    margin-bottom: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n    background: rgba(0, 0, 0, 0);\n    padding: 0px;\n    border-radius: 10px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-item {\n    text-align: center;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-label {\n    font-size: 11px;\n    color: #828289;\n    margin-bottom: 0px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-value {\n    font-size: 12px;\n    color: #eaecef;\n    font-weight: 500;\n  }\n\n  /* Payment Details Cards */\n  .p2p-mobile-expanded-details .p2p-myads-payment-details {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-payment-card {\n    background: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 12px;\n    padding: 14px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-payment-header {\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-payment-type {\n    font-size: 14px;\n    color: #bd83cb;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-payment-qr img {\n    width: 70px;\n    height: 70px;\n  }\n\n  /* Closure Info */\n  .p2p-mobile-expanded-details .p2p-myads-closure-info {\n    background: rgba(107, 114, 128, 0.08);\n    border: 1px solid rgba(107, 114, 128, 0.15);\n    border-radius: 10px;\n    padding: 14px;\n  }\n\n  /* Empty State Mobile */\n  .p2p-empty-state-mobile {\n    text-align: center;\n    padding: 48px 24px;\n    background: #373F4D;\n    border-radius: 16px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    margin: 0 4px;\n  }\n\n  .p2p-empty-state-mobile .p2p-empty-icon {\n    font-size: 56px;\n    margin-bottom: 16px;\n    opacity: 0.6;\n  }\n\n  .p2p-empty-state-mobile p {\n    font-size: 16px;\n    color: #6b7280;\n    margin-bottom: 20px;\n  }\n\n  .p2p-empty-state-mobile .p2p-create-ad-btn-small {\n    padding: 14px 28px;\n    font-size: 14px;\n    border-radius: 10px;\n  }\n\n  /* Pagination Mobile */\n  .p2p-pagination-wrapper.p2p-mobile {\n    padding: 16px 4px;\n    margin-top: 16px;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    background: transparent;\n    border: none;\n  }\n\n  .p2p-pagination-wrapper .p2p-pagination-info {\n    font-size: 13px;\n    color: #6b7280;\n    order: 2;\n  }\n\n  .p2p-pagination-wrapper .p2p-pagination-buttons {\n    order: 1;\n  }\n\n  .p2p-page-btn {\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .p2p-mobile-order-card {\n    padding: 14px;\n    border-radius: 14px;\n  }\n\n  .p2p-mobile-card-header {\n    margin-bottom: 14px;\n  }\n\n  .p2p-mobile-card-user {\n    gap: 10px;\n  }\n\n  .p2p-myads-side-badge {\n    padding: 5px 10px;\n    font-size: 10px;\n  }\n\n  .p2p-mobile-card-user-info h4 {\n    font-size: 15px;\n  }\n\n  .p2p-mobile-card-price .p2p-value {\n    font-size: 18px;\n  }\n\n  .p2p-mobile-card-details {\n    gap: 12px;\n    padding: 14px 0px 0px;\n  }\n\n  .p2p-mobile-detail-label {\n    font-size: 10px;\n  }\n\n  .p2p-mobile-detail-value {\n    font-size: 12px;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 5px 10px;\n    font-size: 11px;\n  }\n\n  .p2p-mobile-card-actions {\n    flex-wrap: wrap;\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn {\n    padding: 10px 12px;\n    font-size: 12px;\n    min-width: calc(50% - 5px);\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 380px) {\n  .p2p-mobile-card-header {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: 12px;\n  }\n\n\n  .p2p-mobile-card-user {\n    width: 100%;\n  }\n\n  .p2p-mobile-card-price {\n    width: 100%;\n    text-align: left;\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n  }\n\n  .p2p-mobile-card-details {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-mobile-detail-item {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn {\n    flex: 1;\n    min-width: auto;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-item {\n    flex-direction: row;\n    justify-content: space-between;\n    text-align: left;\n  }\n}\n\n/* Close Ad Modal - Mobile Enhanced */\n@media (max-width: 576px) {\n  .p2p-close-ad-modal {\n    border-radius: 20px 20px 0 0;\n    max-height: 90vh;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    max-width: 100%;\n    animation: slideUp 0.3s ease-out;\n  }\n\n  @keyframes slideUp {\n    from {\n      transform: translateY(100%);\n    }\n\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  .p2p-modal-overlay {\n    padding: 0;\n    align-items: center;\n  }\n\n  .p2p-close-ad-modal-header {\n    padding: 20px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  }\n\n  .p2p-close-ad-modal-title {\n    font-size: 18px;\n  }\n\n  .p2p-close-ad-modal-body {\n    padding: 20px;\n    max-height: calc(90vh - 180px);\n    overflow-y: auto;\n  }\n\n  .p2p-close-ad-warning {\n    padding: 14px;\n    border-radius: 12px;\n  }\n\n  .p2p-close-ad-warning-content strong {\n    font-size: 14px;\n  }\n\n  .p2p-close-ad-warning-content p {\n    font-size: 12px;\n  }\n\n  .p2p-close-ad-summary {\n    border-radius: 12px;\n    padding: 14px;\n  }\n\n  .p2p-close-ad-summary-header {\n    margin-bottom: 14px;\n    padding-bottom: 10px;\n  }\n\n  .p2p-close-ad-summary-pair {\n    font-size: 15px;\n  }\n\n  .p2p-myads-container {\n    padding: 15px;\n  }\n\n  .p2p-myads-title {\n    font-size: 17px;\n  }\n\n  .p2p-close-ad-summary-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n\n  .p2p-close-ad-summary-label {\n    font-size: 10px;\n  }\n\n  .p2p-close-ad-summary-value {\n    font-size: 13px;\n  }\n\n  .p2p-close-ad-reason-input {\n    min-height: 70px;\n    font-size: 14px;\n  }\n\n  .p2p-close-ad-modal-footer {\n    padding: 16px 20px 24px;\n    flex-direction: row;\n    gap: 12px;\n  }\n\n  .p2p-close-ad-btn-cancel,\n  .p2p-close-ad-btn-confirm {\n    padding: 8px 15px;\n    font-size: 12px;\n    border-radius: 7px;\n  }\n\n  .p2p-close-ad-modal {\n    max-width: 90%;\n    margin: 0 auto;\n  }\n\n}\n\n/* ====================================\n     P2P My Ads - Mobile Responsive\n     ==================================== */\n\n/* Mobile Header */\n@media (max-width: 768px) {\n  .p2p-myads-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .p2p-myads-title {\n    font-size: 20px;\n  }\n\n  .p2p-myads-header .p2p-create-ad-btn {\n    width: 100%;\n    text-align: center;\n    padding: 12px 20px;\n    display: flex;\n    justify-content: center;\n  }\n}\n\n/* Mobile Filter Header - Hidden on desktop */\n.p2p-mobile-filter-header {\n  display: none;\n}\n\n/* Mobile Filter Toggle Button */\n.p2p-mobile-filter-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: #373f4d;\n  border: 1px solid #373f4d;\n  border-radius: 10px;\n  color: #e5e5e5;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-mobile-filter-toggle:hover {\n  background: #373f4d;\n  border: 1px solid #373f4d;\n}\n\n.p2p-mobile-filter-toggle.active {\n  background: #373f4d;\n  border-color: #22c55e;\n  color: #22c55e;\n}\n\n.p2p-mobile-filter-toggle i {\n  font-size: 18px;\n}\n\n.p2p-mobile-filter-toggle span {\n  flex: 1;\n  text-align: left;\n}\n\n.p2p-mobile-active-filters {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.p2p-active-filter-tag {\n  background: rgba(34, 197, 94, 0.15);\n  color: #22c55e;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 6px;\n}\n\n.p2p-filter-badge {\n  background: rgba(255, 255, 255, 0.15);\n  color: #e5e5e5;\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  margin-left: 4px;\n}\n\n/* Mobile Filter Section */\n@media (max-width: 768px) {\n\n  /* Show mobile filter header */\n  .p2p-mobile-filter-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 16px;\n    padding: 0 4px;\n  }\n\n  .p2p-mobile-filter-toggle {\n    flex: 1;\n  }\n\n  /* Hide filter section by default on mobile */\n  .p2p-filter-section {\n    display: none;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    padding: 16px;\n    background: #12121a;\n    border: 1px solid #2a2a3a;\n    border-radius: 12px;\n    margin-bottom: 16px;\n    animation: slideDown 0.2s ease-out;\n  }\n\n  @keyframes slideDown {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  .p2p-filter-section.show {\n    display: grid;\n  }\n\n  .p2p-filter-group {\n    min-width: unset;\n  }\n\n  .p2p-filter-section .p2p-find-orders-btn {\n    grid-column: 1 / -1;\n    width: 100%;\n    background: #f3bb2b;\n    color: #181a20;\n    border: none;\n  }\n\n  .p2p-filter-section .p2p-find-orders-btn:hover {\n    background: #16a34a;\n  }\n}\n\n@media (max-width: 480px) {\n  .p2p-filter-section.show {\n    grid-template-columns: 1fr;\n  }\n\n  button.p2p-myads-action-btn {\n    padding: 5px 10px !important;\n  }\n\n  .p2p-profile-section-desc {\n    font-size: 12px !important;\n  }\n\n  .p2p-mobile-filter-header {\n    flex-wrap: wrap;\n  }\n\n  .p2p-mobile-filter-toggle {\n    width: 100%;\n    flex: none;\n    justify-content: flex-start;\n  }\n\n  .p2p-mobile-active-filters {\n    width: 100%;\n    margin-top: 8px;\n  }\n}\n\n@media (max-width: 400px) {\n  .p2p-mobile-filter-toggle {\n    padding: 10px 14px;\n    font-size: 13px;\n  }\n\n  .p2p-active-filter-tag {\n    font-size: 11px;\n    padding: 3px 8px;\n  }\n}\n\n/* Hide mobile filter header on desktop */\n@media (min-width: 769px) {\n  .p2p-mobile-filter-header {\n    display: none !important;\n  }\n\n  .p2p-filter-section {\n    display: flex !important;\n  }\n}\n\n/* Mobile Stats Cards */\n@media (max-width: 768px) {\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n  }\n\n  .p2p-myads-stat-card {\n    padding: 12px 14px;\n  }\n\n  .p2p-myads-stat-card-label {\n    font-size: 10px;\n    margin-bottom: 6px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 576px) {\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .p2p-mobile-detail-item {\n    flex-direction: row;\n    gap: 12px;\n  }\n\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n}\n\n@media (max-width: 400px) {\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n  }\n\n  .p2p-myads-stat-card {\n    padding: 10px 12px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 14px;\n  }\n}\n\n/* Legacy Mobile Stats Bar */\n@media (max-width: 768px) {\n  .p2p-myads-stats {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n    padding: 14px 16px;\n    text-align: center;\n  }\n\n  .p2p-myads-stat-item {\n    align-items: center;\n  }\n\n  .p2p-myads-stat-value {\n    font-size: 16px;\n  }\n\n  .p2p-myads-stat-label {\n    font-size: 10px;\n  }\n}\n\n/* Mobile Card Improvements */\n@media (max-width: 991px) {\n  .p2p-orders-table-wrapper {\n    display: none;\n  }\n\n  .p2p-mobile-orders-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n}\n\n@media (min-width: 992px) {\n  .p2p-mobile-orders-list {\n    display: none;\n  }\n}\n\n.p2p-mobile-order-card {\n  background: #12121a00;\n  border: 1px solid #2c2c2c;\n  border-radius: 12px;\n  padding: 16px;\n  transition: border-color 0.2s;\n}\n\n.p2p-mobile-order-card:hover {\n  border-color: rgba(55, 65, 81, 0.5);\n}\n\n.p2p-mobile-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-card-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\nbutton.p2p-mobile-view-btn i {\n  color: #535c6b;\n}\n\n.p2p-mobile-card-user-info h4 {\n  font-size: 13px;\n  font-weight: 500;\n  color: #d1d5db;\n  margin: 0px 0px 2px;\n}\n\n.p2p-mobile-card-user-info p {\n  margin: 0;\n}\n\n.p2p-mobile-status-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.p2p-mobile-card-price {\n  text-align: right;\n}\n\n.p2p-mobile-card-price .p2p-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #a1a1aa;\n}\n\n.p2p-mobile-card-price .p2p-currency {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.p2p-mobile-card-details {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 0px;\n  border: none;\n}\n\n.p2p-mobile-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-mobile-detail-label {\n  font-size: 11px;\n  color: #52525b;\n  letter-spacing: 0.3px;\n}\n\n.p2p-mobile-detail-value {\n  font-size: 13px;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n.p2p-mobile-card-payments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 14px;\n}\n\n.p2p-mobile-payment-badge {\n  padding: 4px 8px;\n  background: rgba(55, 65, 81, 0.3);\n  border-radius: 4px;\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.p2p-mobile-card-actions {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  padding-top: 14px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-card-actions .p2p-myads-action-btn {\n  flex: unset;\n  padding: 10px 8px;\n  font-size: 12px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n@media (max-width: 400px) {\n  .p2p-mobile-card-actions {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n\n  /* .p2p-mobile-card-actions .p2p-myads-action-btn:first-child {\n      grid-column: 1 / -1;\n    } */\n}\n\n.p2p-myads-action-btn {\n  min-height: 32px;\n}\n\n/* Mobile Expanded Details */\n.p2p-mobile-expanded-details {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n  grid-template-columns: repeat(1, 1fr);\n  gap: 12px;\n}\n\n@media (max-width: 480px) {\n  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n.p2p-mobile-expanded-details .p2p-myads-payment-details {\n  grid-template-columns: 1fr;\n}\n\n.p2p-mobile-expanded-details .p2p-myads-payment-card {\n  padding: 12px;\n}\n\n.p2p-mobile-expanded-details .p2p-myads-payment-qr img {\n  width: 60px;\n  height: 60px;\n}\n\n/* Mobile Pagination */\n/* Mobile Pagination */\n.p2p-pagination-wrapper.p2p-mobile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  margin-top: 8px;\n  background: rgba(18, 18, 26, 0.6);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-info {\n  font-size: 11px;\n  color: #6b7280;\n  text-align: center;\n}\n\n.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-buttons,\n.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-controls {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.p2p-pagination-wrapper.p2p-mobile .p2p-page-current {\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n  background: rgba(255, 220, 136, 0.2);\n  border-radius: 6px;\n}\n\n.p2p-pagination-wrapper.p2p-mobile .p2p-page-btn {\n  min-width: 36px;\n  height: 36px;\n  font-size: 13px;\n}\n\n@media (max-width: 991px) {\n  .p2p-pagination-wrapper:not(.p2p-mobile) {\n    display: none;\n  }\n\n  .p2p-payment-method-qr {\n    flex-direction: row-reverse;\n    justify-content: space-between;\n  }\n\n\n}\n\n@media (min-width: 992px) {\n  .p2p-pagination-wrapper.p2p-mobile {\n    display: none;\n  }\n}\n\n@media (max-width: 400px) {\n  .p2p-pagination-wrapper.p2p-mobile .p2p-page-btn {\n    min-width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n}\n\n/* Mobile Empty State */\n.p2p-empty-state-mobile {\n  text-align: center;\n  padding: 48px 20px;\n  background: #373F4D;\n  border-radius: 12px;\n  border: 1px solid #373F4D;\n}\n\n.p2p-empty-state-mobile .p2p-empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.p2p-empty-state-mobile p {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0 0 20px 0;\n}\n\n/* Touch-friendly improvements */\n@media (max-width: 768px) {\n  .p2p-myads-action-btn {\n    min-height: 32px;\n    min-width: 44px;\n  }\n\n  .p2p-filter-select {\n    min-height: 44px;\n    font-size: 14px;\n  }\n\n  .p2p-page-btn {\n    min-width: 36px;\n    min-height: 36px;\n  }\n\n  .p2p-close-ad-reason-input {\n    font-size: 16px;\n    /* Prevents zoom on iOS */\n  }\n\n\n  .p2p-close-ad-reason-input {\n    font-size: 13px;\n  }\n}\n\n/* ====================================\n     P2P Profile Page Styles\n     ==================================== */\n\n.p2p-profile-header {\n  background: rgba(18, 18, 26, 0.6);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.p2p-profile-header-inner {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 24px;\n}\n\n.p2p-profile-user {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.p2p-profile-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 600;\n  color: #e5e5e5;\n  position: relative;\n}\n\n.p2p-profile-online-dot {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 14px;\n  height: 14px;\n  background: #4ade80;\n  border-radius: 50%;\n  border: 2px solid #12121a;\n}\n\n.p2p-profile-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.p2p-profile-name {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #e5e5e5;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.p2p-profile-verified-badge {\n  display: inline-flex;\n  align-items: center;\n  color: #bd83cb;\n  font-size: 18px;\n}\n\n.p2p-profile-verified-badge i {\n  font-size: inherit;\n}\n\n.p2p-profile-edit-btn {\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 4px;\n  transition: color 0.2s;\n}\n\n.p2p-profile-edit-btn:hover {\n  color: #e5e5e5;\n}\n\n.p2p-profile-badges {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.p2p-profile-badge {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.p2p-profile-badge.verified {\n  color: #4ade80;\n}\n\n.p2p-profile-funding {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.p2p-profile-funding-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #6b7280;\n  font-size: 13px;\n  margin-bottom: 4px;\n}\n\n.p2p-profile-eye-btn {\n  background: transparent;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 2px;\n}\n\n.p2p-profile-funding-value {\n  color: #9ca3af;\n  font-size: 16px;\n}\n\n/* Profile Tabs */\n.p2p-profile-tabs {\n  margin-bottom: 24px;\n  overflow-x: auto;\n}\n\n.p2p-profile-tabs-inner {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.p2p-profile-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  color: #9ca3af;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.p2p-profile-tab:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #d1d5db;\n}\n\n.p2p-profile-tab.active {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n}\n\n.p2p-profile-tab i {\n  font-size: 15px;\n}\n\n/* Section Header */\n.p2p-profile-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.p2p-profile-section-desc {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0;\n}\n\n/* Payment Methods Grid */\n.p2p-payment-methods-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 16px;\n}\n\n.p2p-payment-method-card {\n  background: rgba(18, 18, 26, 0.6);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  overflow: hidden;\n}\n\n.p2p-payment-method-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: none;\n  background: rgb(13 13 20 / 14%);\n}\n\n.p2p-payment-method-title {\n  margin: 0;\n  color: #d1d5db;\n  font-size: 15px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-payment-method-type-badge {\n  font-size: 10px;\n  padding: 2px 6px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #9ca3af;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.closebtn {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: #888;\n  font-size: 16px;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  padding: 2px 4px;\n}\n\n.p2p-payment-method-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.p2p-payment-method-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid;\n}\n\n.p2p-payment-method-btn.edit {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #9ca3af;\n}\n\n.p2p-payment-method-btn.edit:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e5e5e5;\n}\n\n.p2p-payment-method-btn.delete {\n  background: rgba(127, 29, 29, 0.15);\n  border-color: rgba(153, 27, 27, 0.25);\n  color: #fca5a5;\n}\n\n.p2p-payment-method-btn.delete:hover {\n  background: rgba(127, 29, 29, 0.25);\n}\n\n.p2p-payment-method-body {\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.p2p-payment-method-field {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.p2p-payment-method-label {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.p2p-payment-method-value {\n  color: #d1d5db;\n  font-size: 13px;\n  text-align: right;\n  word-break: break-all;\n}\n\n.p2p-payment-method-qr {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 8px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.p2p-payment-method-qr img {\n  width: 60px;\n  height: 60px;\n  object-fit: contain;\n  background: #fff;\n  border-radius: 6px;\n  padding: 4px;\n}\n\n.p2p-payment-method-qr span {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* Empty State Card */\n.p2p-empty-state-card {\n  background: none;\n  border-radius: 12px;\n  /* border: 1px solid rgba(255, 255, 255, 0.06); */\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.p2p-empty-state-card i {\n  font-size: 48px;\n  color: #52525b;\n  margin-bottom: 16px;\n  display: block;\n}\n\n.p2p-empty-state-card p {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0 0 20px 0;\n}\n\n\n@media (max-width: 991px) {\n\n  .p2p-order-status-badge {\n    background-color: #333b47 !important;\n    color: #878787 !important;\n    border-color: #333b47 !important;\n  }\n\n  .p2p-order-status-badge.status_complete {\n    color: #dddada !important;\n  }\n\n\n\n  .p2p-profile-avatar {\n    width: 40px;\n    height: 40px;\n    font-size: 14px;\n  }\n\n  .p2p-profile-name-row {\n    margin-bottom: 0px;\n  }\n\n  .p2p-payment-method-card {\n    background: rgb(18 18 26 / 0%);\n    border: 1px solid #413f3f;\n  }\n\n  .p2p-payment-method-body {\n    padding: 12px 15px;\n  }\n\n  button.p2p-myads-action-btn {\n    width: fit-content;\n    align-items: end;\n  }\n\n  .rightalien {\n    text-align: right;\n  }\n\n  .p2p-mobile-card-details {\n    grid-template-columns: 1fr;\n  }\n\n\n  .p2p-mobile-detail-item {\n    flex-direction: row;\n    gap: 12px;\n    justify-content: space-between;\n  }\n\n  .p2p-mobile-card-details {\n    padding: 14px 0px 0px;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 3px 7px;\n    margin-left: 4px;\n  }\n\n}\n\n\n@media (max-width: 768px) {\n  .p2p-empty-state-card {\n    padding: 32px 16px;\n    border-radius: 10px;\n  }\n\n  .p2p-empty-state-card i {\n    font-size: 40px;\n    margin-bottom: 12px;\n  }\n\n  .p2p-empty-state-card p {\n    font-size: 13px;\n    margin-bottom: 16px;\n  }\n\n  .p2p-mobile-card-price {\n    justify-content: end;\n  }\n\n}\n\n\n\n\n\n@media (max-width: 991px) {\n\n\n  .p2p-layout-wrapper {\n    background-color: #181a20;\n  }\n\n\n  .p2p-mobile-detail-label {\n    color: #828289;\n  }\n\n  .p2p-mobile-view-btn {\n    color: #eaecef;\n  }\n\n  .p2p-mobile-detail-value {\n    color: #eaecef;\n  }\n\n  .p2p-mobile-view-btn {\n    color: #eaecef !important;\n  }\n\n  .p2p-mobile-detail-value {\n    font-size: 12px;\n    letter-spacing: 0.3px;\n  }\n\n  span.p2p-mobile-detail-value.valueprice {\n    font-size: 14px;\n  }\n\n  .p2p-mobile-card-avatar {\n    width: 36px;\n    height: 36px;\n  }\n\n\n\n}\n\n\n@media (max-width: 400px) {\n  .p2p-empty-state-card {\n    padding: 24px 12px;\n  }\n\n  .p2p-empty-state-card i {\n    font-size: 36px;\n  }\n\n  .p2p-empty-state-card p {\n    font-size: 12px;\n  }\n}\n\n/* Add Payment Modal */\n.p2p-add-payment-modal {\n  background: #12121a;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 480px;\n  max-height: 85vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: p2p-modal-slide-in 0.2s ease-out;\n}\n\n.p2p-add-payment-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.p2p-add-payment-modal-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0;\n}\n\n.p2p-modal-close-btn {\n  background: transparent;\n  border: none;\n  color: #6b7280;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 4px;\n  line-height: 1;\n  transition: color 0.2s;\n}\n\n.p2p-modal-close-btn:hover {\n  color: #e5e5e5;\n}\n\n.p2p-add-payment-modal-body {\n  padding: 20px 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.p2p-add-payment-modal-footer {\n  display: flex;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  justify-content: flex-end;\n}\n\n/* Payment Type List */\n.p2p-payment-type-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.p2p-payment-type-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 16px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-payment-type-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\n.p2p-payment-type-name {\n  font-size: 14px;\n  color: #d1d5db;\n  font-weight: 500;\n}\n\n.p2p-payment-type-item i {\n  color: #6b7280;\n  font-size: 18px;\n}\n\n/* Payment Form */\n.p2p-payment-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.p2p-payment-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.p2p-payment-form-label {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.p2p-required {\n  color: #ef4444;\n  margin-left: 4px;\n}\n\n.p2p-payment-form-input {\n  padding: 12px 14px;\n  background: rgba(10, 10, 15, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #e5e5e5;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.p2p-payment-form-input:focus {\n  outline: none;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.p2p-payment-form-input::placeholder {\n  color: #52525b;\n}\n\n.p2p-payment-file-input {\n  position: relative;\n}\n\n.p2p-payment-file-input input[type=\"file\"] {\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.p2p-payment-file-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px;\n  background: rgba(10, 10, 15, 0.8);\n  border: 1px dashed rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  color: #6b7280;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.p2p-payment-file-label:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n  color: #9ca3af;\n}\n\n.p2p-payment-file-label i {\n  font-size: 20px;\n}\n\n/* Modal Buttons */\n.p2p-modal-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.p2p-modal-btn.primary {\n  background: rgba(255, 255, 255, 0.1);\n  color: #e5e5e5;\n}\n\n.p2p-modal-btn.primary:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.p2p-modal-btn.secondary {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #9ca3af;\n}\n\n.p2p-modal-btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.04);\n  color: #d1d5db;\n}\n\n.p2p-modal-btn.danger {\n  background: rgba(153, 27, 27, 0.8);\n  color: #fecaca !important;\n}\n\n.p2p-modal-btn.danger:hover {\n  background: rgba(153, 27, 27, 1);\n}\n\n/* Delete Modal */\n.p2p-delete-modal {\n  background: #12121a;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 400px;\n  padding: 32px 24px;\n  text-align: center;\n  animation: p2p-modal-slide-in 0.2s ease-out;\n}\n\n.p2p-delete-modal-icon {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 20px;\n  background: rgba(127, 29, 29, 0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.p2p-delete-modal-icon i {\n  font-size: 28px;\n  color: #fca5a5;\n}\n\n.p2p-delete-modal-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0 0 12px 0;\n}\n\n.p2p-delete-modal-desc {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0 0 24px 0;\n  line-height: 1.5;\n}\n\n.p2p-delete-modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n/* Profile Mobile Responsive */\n@media (max-width: 768px) {\n  .p2p-profile-header-inner {\n    flex-direction: column;\n  }\n\n  .p2p-profile-funding {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .p2p-profile-tabs-inner {\n    gap: 8px;\n  }\n\n  .p2p-profile-tab {\n    padding: 8px 14px;\n    font-size: 12px;\n  }\n\n  .p2p-profile-section-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .p2p-payment-methods-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-payment-method-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .p2p-payment-method-actions {\n    width: 100%;\n  }\n\n  .p2p-payment-method-btn {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .p2p-add-payment-modal,\n  .p2p-delete-modal {\n    margin: 16px;\n    max-height: calc(100vh - 32px);\n  }\n}\n\n/* ============================================\n     P2P ORDER DETAILS STYLES\n     ============================================ */\n\n.p2p-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: none;\n  color: #a8b4c4;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 8px 0;\n  margin-bottom: 20px;\n  transition: color 0.2s;\n}\n\n.p2p-back-btn:hover {\n  color: #bd83cb;\n}\n\n.p2p-back-btn i {\n  font-size: 20px;\n}\n\n.p2p-order-header {\n  background: linear-gradient(135deg, #12121a 0%, #0d0d14 100%);\n  border-radius: 16px;\n  border: 1px solid #1e1e2d;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.p2p-order-header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.p2p-order-title-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.p2p-order-title {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 700;\n  color: #22c55e;\n}\n\n.p2p-order-status-badge {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* Timer Styles */\n.p2p-order-timer {\n  text-align: center;\n}\n\n.p2p-order-timer.expired {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 12px;\n  padding: 12px 20px;\n}\n\n.p2p-timer-label {\n  display: block;\n  color: #6b7280;\n  font-size: 12px;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.p2p-timer-expired {\n  color: #ef4444;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.p2p-timer-display {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-timer-unit {\n  text-align: center;\n}\n\n.p2p-timer-digits {\n  display: flex;\n  gap: 4px;\n}\n\n.p2p-timer-digit {\n  background: linear-gradient(180deg, #1a1a24 0%, #0d0d14 100%);\n  border: 1px solid #2a2a3a;\n  border-radius: 8px;\n  padding: 10px 14px;\n  color: #fff;\n  font-size: 24px;\n  font-weight: 700;\n  font-family: 'SF Mono', 'Monaco', monospace;\n  min-width: 42px;\n  text-align: center;\n}\n\n.p2p-timer-unit-label {\n  display: block;\n  color: #6b7280;\n  font-size: 11px;\n  margin-top: 4px;\n  text-transform: uppercase;\n}\n\n.p2p-timer-separator {\n  color: #6b7280;\n  font-size: 28px;\n  font-weight: 700;\n  margin-top: -20px;\n}\n\n/* Order Info Row */\n.p2p-order-info-row {\n  display: flex;\n  gap: 32px;\n  padding-top: 20px;\n  border-top: 1px solid #1e1e2d;\n  flex-wrap: wrap;\n}\n\n.p2p-order-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.p2p-order-info-label {\n  color: #6b7280;\n  font-size: 12px;\n}\n\n.p2p-order-info-value {\n  color: #e5e5e5;\n  font-size: 14px;\n}\n\n.p2p-order-info-value.clickable {\n  color: #a8b4c4;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.p2p-order-info-value.clickable:hover {\n  color: #bd83cb;\n}\n\n.p2p-order-info-value i {\n  font-size: 14px;\n}\n\n/* Order Content Layout */\n.p2p-order-content {\n  display: grid;\n  grid-template-columns: minmax(300px, 1fr) minmax(400px, 480px);\n  gap: 24px;\n}\n\n.p2p-order-main {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  max-width: 520px;\n}\n\n.p2p-order-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Order Cards */\n.p2p-order-card {\n  background: #12121a;\n  border-radius: 12px;\n  border: 1px solid #1e1e2d;\n  padding: 20px;\n}\n\n.p2p-order-card-title {\n  margin: 0 0 16px 0;\n  color: #e5e5e5;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n/* Order Summary Grid */\n.p2p-order-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n}\n\n.p2p-order-summary-item {\n  background: #0d0d14;\n  border-radius: 10px;\n  padding: 16px;\n  text-align: center;\n}\n\n.p2p-order-summary-item.highlight {\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(34, 197, 94, 0.05) 100%);\n  border: 1px solid rgba(34, 197, 94, 0.2);\n}\n\n.p2p-summary-value {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  color: #e5e5e5;\n  margin-bottom: 4px;\n}\n\n.p2p-summary-value.green {\n  color: #22c55e;\n}\n\n.p2p-summary-label {\n  color: #6b7280;\n  font-size: 12px;\n}\n\n/* Payment Warning */\n.p2p-payment-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  background: rgba(251, 191, 36, 0.1);\n  border: 1px solid rgba(251, 191, 36, 0.2);\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n}\n\n.p2p-payment-warning i {\n  color: #fbbf24;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.p2p-payment-warning span {\n  color: #fbbf24;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n/* Payment Method Badges */\n.p2p-payment-method-badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n/* Payment Detail Card */\n.p2p-payment-detail-card {\n  background: #0d0d14;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.p2p-payment-detail-card:last-child {\n  margin-bottom: 0;\n}\n\n.p2p-payment-detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.p2p-payment-type-badge {\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  color: #fff;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.p2p-payment-qr {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.p2p-payment-qr img {\n  width: 80px;\n  height: 80px;\n  border-radius: 8px;\n  border: 2px solid #2a2a3a;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.p2p-payment-qr img:hover {\n  transform: scale(1.05);\n}\n\n.p2p-payment-qr span {\n  color: #6b7280;\n  font-size: 11px;\n}\n\n.p2p-payment-detail-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.p2p-payment-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n.p2p-payment-detail-row:last-child {\n  border-bottom: none;\n}\n\n.p2p-payment-detail-label {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.p2p-payment-detail-value {\n  color: #a8b4c4;\n  font-size: 13px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: color 0.2s;\n}\n\n.p2p-payment-detail-value:hover {\n  color: #bd83cb;\n}\n\n.p2p-payment-detail-value i {\n  font-size: 14px;\n  opacity: 0.7;\n}\n\n/* Order Actions */\n.p2p-order-action-text {\n  color: #9ca3af;\n  font-size: 14px;\n  margin: 0 0 16px 0;\n  line-height: 1.6;\n}\n\n.p2p-order-action-text .highlight {\n  color: #22c55e;\n  font-weight: 500;\n}\n\n.p2p-order-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.p2p-order-actions .p2p-confirm-buy-btn {\n  flex: 1;\n  min-width: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.p2p-order-actions .p2p-cancel-btn {\n  min-width: 140px;\n}\n\n/* Order Remarks */\n.p2p-order-remarks {\n  color: #9ca3af;\n  font-size: 14px;\n  line-height: 1.6;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n/* User Card */\n.p2p-order-user-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.p2p-order-user-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-order-user-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.p2p-order-user-avatar.buyer {\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n}\n\n.p2p-order-user-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.p2p-order-user-avatar span {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.p2p-user-online-dot {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #22c55e;\n  border: 2px solid #12121a;\n}\n\n.p2p-order-user-info h4 {\n  margin: 0 0 2px 0;\n  color: #e5e5e5;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.p2p-user-role {\n  color: #6b7280;\n  font-size: 12px;\n}\n\n.p2p-user-role.buyer {\n  color: #22c55e;\n}\n\n/* Chat Card */\n.p2p-chat-card {\n  display: flex;\n  flex-direction: column;\n  min-height: 300px;\n}\n\n.p2p-chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.p2p-chat-header h4 {\n  margin: 0;\n  color: #e5e5e5;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.p2p-chat-expand-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  color: #888;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.p2p-chat-expand-btn:hover {\n  background: #1a1a24;\n  color: #e5e5e5;\n}\n\n.p2p-chat-preview {\n  flex: 1;\n  overflow-y: auto;\n  margin-bottom: 12px;\n}\n\n.p2p-chat-message {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.p2p-chat-preview .p2p-chat-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3d4a5c, #2d3748);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #c9d1d9;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.p2p-chat-bubble {\n  background: #1a1a24;\n  border-radius: 12px;\n  padding: 10px 14px;\n  max-width: 85%;\n}\n\n.p2p-chat-bubble p {\n  margin: 0;\n  color: #d1d5db;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.p2p-chat-time {\n  display: block;\n  color: #6b7280;\n  font-size: 10px;\n  margin-top: 4px;\n}\n\n.p2p-chat-input-wrapper {\n  display: flex;\n  gap: 8px;\n  background: #0d0d14;\n  border-radius: 8px;\n  padding: 8px 12px;\n}\n\n.p2p-chat-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: #e5e5e5;\n  font-size: 14px;\n  outline: none;\n}\n\n.p2p-chat-input::placeholder {\n  color: #6b7280;\n}\n\n.p2p-chat-preview .p2p-chat-send-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #4a9d6e, #3d8a5f);\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.p2p-chat-preview .p2p-chat-send-btn:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(74, 157, 110, 0.3);\n}\n\n/* Order Details Responsive */\n@media (max-width: 1200px) {\n  .p2p-order-content {\n    grid-template-columns: minmax(280px, 1fr) minmax(350px, 420px);\n  }\n\n  .p2p-order-main {\n    max-width: 100%;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .p2p-order-content {\n    display: block;\n  }\n\n  .p2p-order-main {\n    max-width: 100%;\n  }\n\n  .p2p-order-sidebar {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 768px) {\n  .p2p-order-header {\n    padding: 16px;\n  }\n\n  .p2p-order-header-top {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .p2p-order-title {\n    font-size: 22px;\n  }\n\n  .p2p-order-timer {\n    width: 100%;\n  }\n\n  .p2p-timer-display {\n    justify-content: center;\n  }\n\n  .p2p-timer-digit {\n    padding: 8px 10px;\n    font-size: 20px;\n    min-width: 36px;\n  }\n\n  .p2p-order-info-row {\n    gap: 16px;\n  }\n\n  .p2p-order-info-item {\n    min-width: calc(50% - 8px);\n  }\n\n  .p2p-order-card {\n    padding: 16px;\n  }\n\n  .p2p-order-summary-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .p2p-summary-value {\n    font-size: 16px;\n  }\n\n  .p2p-order-actions {\n    flex-direction: column;\n  }\n\n  .p2p-order-actions .p2p-confirm-buy-btn,\n  .p2p-order-actions .p2p-cancel-btn {\n    width: 100%;\n    min-width: unset;\n  }\n\n  .p2p-order-sidebar {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-payment-detail-header {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .p2p-payment-qr {\n    align-self: flex-start;\n  }\n\n  .p2p-main-content.p2p-mobile .p2p-mobile-card-actions .p2p-myads-action-btn {\n    min-width: 100%;\n  }\n\n}\n\n\n@media (max-width: 480px) {\n  .p2p-order-title-section {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn {\n    padding: 5px 8px;\n    font-size: 11px;\n  }\n\n  .p2p-profile-header {\n    padding: 16px;\n    margin-bottom: 15px;\n  }\n\n  .p2p-profile-header-inner.mobileview {\n    gap: 15px;\n  }\n\n\n  .p2p-payment-method-title {\n    margin: 0;\n    font-size: 13px;\n    gap: 4px;\n  }\n\n  .p2p-payment-method-header.mobileview {\n    padding: 12px 15px;\n  }\n\n  .p2p-order-summary-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-timer-digit {\n    padding: 6px 8px;\n    font-size: 18px;\n    min-width: 32px;\n  }\n\n  .p2p-timer-separator {\n    font-size: 22px;\n  }\n\n  .p2p-payment-detail-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n}\n\n/* ============================================\n     P2P ORDERS LIST STYLES\n     ============================================ */\n\n.p2p-orders-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.p2p-orders-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #e5e5e5;\n}\n\n.p2p-orders-count {\n  background: rgba(255, 220, 136, 0.1);\n  color: #a8b4c4;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* Order Type Cell */\n.p2p-order-type-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-order-type {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.p2p-order-type.buy {\n  color: #22c55e;\n}\n\n.p2p-order-type.sell {\n  color: #ef4444;\n}\n\n.p2p-order-crypto {\n  color: #e5e5e5;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.p2p-order-date {\n  color: #6b7280;\n  font-size: 12px;\n}\n\n/* Order ID */\n.p2p-order-id {\n  color: #a8b4c4;\n  font-size: 13px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: color 0.2s;\n}\n\n.p2p-order-id:hover {\n  color: #bd83cb;\n}\n\n.p2p-order-id i {\n  font-size: 14px;\n  opacity: 0.7;\n}\n\n/* Amount Cell */\n.p2p-amount-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-fiat-amount {\n  color: #eaecef;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.p2p-crypto-amount {\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n/* Counterparty Cell */\n.p2p-counterparty-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.p2p-counterparty-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.p2p-counterparty-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.p2p-counterparty-avatar span {\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.p2p-counterparty-name {\n  color: #eaecef;\n  font-size: 14px;\n  font-weight: 500;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Order Status Badge */\n.p2p-order-status-badge {\n  display: inline-block;\n  padding: 5px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  background-color: #333b47 !important;\n  color: #878787 !important;\n  border-color: #333b47 !important;\n}\n\n/* Order Action Button */\n.p2p-order-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  background: rgb(255 220 136 / 0%);\n  border: 1px solid rgba(255, 220, 136, 0.2);\n  border-radius: 6px;\n  color: #eaecef;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.p2p-order-status-badge.status_complete {\n  color: #dddada !important;\n}\n\n.p2p-order-action-btn:hover {\n  background: rgba(255, 220, 136, 0.2);\n  border-color: rgba(255, 220, 136, 0.4);\n}\n\n.p2p-order-action-btn i {\n  font-size: 15px;\n}\n\n.p2p-unread-badge {\n  color: #f59e0b;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n/* Table Row Hover */\n.p2p-orders-table tbody tr {\n  cursor: pointer;\n  transition: background 0.2s;\n  background: none !important;\n  border: none;\n}\n\n.volumedatails {\n  width: 100%;\n  background-color: #2F3641;\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid #454C59;\n}\n\n.volumedatails .p2p-myads-expanded-item {\n  flex-direction: row;\n  gap: 12px;\n}\n\n.p2p-orders-table tbody tr:hover {\n  background: #2B313C;\n}\n\n/* Mobile Order Card Footer */\n.p2p-mobile-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 12px;\n  margin-top: 12px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-order-id-mobile {\n  color: #eaecef;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.p2p-order-id-mobile:hover {\n  color: #a8b4c4;\n}\n\n.p2p-order-id-mobile i {\n  font-size: 13px;\n}\n\n.p2p-mobile-view-btn {\n  background: transparent;\n  border: none;\n  color: #a8b4c4;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n}\n\n.p2p-mobile-view-btn i {\n  font-size: 16px;\n}\n\n/* Mobile Card Click Effect */\n.p2p-mobile-order-card {\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.p2p-mobile-order-card:hover {\n  border-color: rgba(255, 220, 136, 0.3);\n  background: rgba(255, 220, 136, 0.02);\n}\n\n/* Orders Page Responsive */\n@media (max-width: 1200px) {\n  .p2p-counterparty-name {\n    max-width: 100px;\n  }\n}\n\n@media (max-width: 992px) {\n\n  .p2p-orders-table th:nth-child(2),\n  .p2p-orders-table td:nth-child(2) {\n    display: none;\n  }\n\n  .p2p-counterparty-name {\n    max-width: 80px;\n  }\n}\n\n@media (max-width: 768px) {\n  .p2p-orders-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .p2p-orders-title {\n    font-size: 20px;\n  }\n}\n\n/* Order Details - Value Colors */\n.p2p-summary-value.red {\n  color: #ef4444 !important;\n}\n\n.p2p-summary-value.green {\n  color: #22c55e !important;\n}\n\n/* Order Expired Notice */\n.p2p-order-expired-notice {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 8px;\n  color: #ef4444;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.p2p-order-expired-notice i {\n  font-size: 20px;\n}\n\n/* Cancel Button Icon */\n.p2p-cancel-btn i {\n  font-size: 16px;\n  margin-right: 4px;\n}\n\n/* User Payment Method Styles for Sell Orders */\n.p2p-user-payment-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.p2p-payment-type-badge {\n  background: linear-gradient(135deg, #ffdc88, #f4b609);\n  color: #fff;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.p2p-payment-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e2e8f0;\n}\n\n.p2p-payment-detail {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.p2p-no-payment-methods {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n  text-align: center;\n  gap: 8px;\n}\n\n.p2p-no-payment-methods i {\n  font-size: 48px;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.p2p-no-payment-methods p {\n  font-size: 16px;\n  font-weight: 500;\n  color: #e2e8f0;\n  margin: 0;\n}\n\n.p2p-no-payment-methods span {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.p2p-add-payment-btn {\n  margin-top: 16px;\n  padding: 10px 24px;\n  background: linear-gradient(135deg, #ffdc88, #f4b609);\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-add-payment-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(255, 220, 136, 0.3);\n}\n\n/* Full Payment Option Card (for Sell Orders) */\n.p2p-payment-option-full {\n  display: block;\n  background: rgba(30, 41, 59, 0.5);\n  border: 1px solid rgba(148, 163, 184, 0.15);\n  border-radius: 12px;\n  padding: 0;\n  margin-bottom: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  overflow: hidden;\n}\n\n.p2p-payment-option-full:hover {\n  border-color: rgba(255, 220, 136, 0.4);\n  background: rgba(30, 41, 59, 0.7);\n}\n\n.p2p-payment-option-full.p2p-selected {\n  border-color: #bd83cb;\n  background: rgba(255, 220, 136, 0.1);\n}\n\n.p2p-user-payment-card {\n  padding: 16px;\n}\n\n.p2p-user-payment-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.1);\n}\n\n.p2p-user-payment-header .p2p-payment-name {\n  flex: 1;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n\n.p2p-user-payment-header input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: #bd83cb;\n  cursor: pointer;\n}\n\n.p2p-user-payment-details {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n}\n\n.p2p-payment-field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-payment-field-label {\n  font-size: 11px;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.p2p-payment-field-value {\n  font-size: 14px;\n  color: #e2e8f0;\n  font-weight: 500;\n  word-break: break-all;\n}\n\n.p2p-payment-qr-preview {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(148, 163, 184, 0.1);\n  display: flex;\n  justify-content: center;\n}\n\n.p2p-payment-qr-preview img {\n  width: 80px;\n  height: 80px;\n  border-radius: 8px;\n  object-fit: contain;\n  background: #fff;\n  padding: 4px;\n}\n\n@media (max-width: 768px) {\n  .p2p-payment-option-full {\n    border-radius: 10px;\n    margin-bottom: 10px;\n  }\n\n  .p2p-user-payment-card {\n    padding: 14px;\n  }\n\n  .p2p-user-payment-header {\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n  }\n\n  .p2p-user-payment-header .p2p-payment-name {\n    font-size: 14px;\n  }\n\n  .p2p-payment-field-label {\n    font-size: 10px;\n  }\n\n  .p2p-payment-field-value {\n    font-size: 13px;\n  }\n\n  .p2p-payment-qr-preview img {\n    width: 70px;\n    height: 70px;\n  }\n}\n\n@media (max-width: 480px) {\n  .p2p-user-payment-details {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-user-payment-card {\n    padding: 12px;\n  }\n\n  .p2p-payment-qr-preview img {\n    width: 60px;\n    height: 60px;\n  }\n}\n\n/* No Payment Methods State Mobile */\n@media (max-width: 768px) {\n  .p2p-no-payment-methods {\n    padding: 24px 16px;\n  }\n\n  .p2p-no-payment-methods i {\n    font-size: 36px;\n    margin-bottom: 12px;\n  }\n\n  .p2p-no-payment-methods p {\n    font-size: 14px;\n    margin-bottom: 6px;\n  }\n\n  .p2p-no-payment-methods span {\n    font-size: 12px;\n  }\n\n  .p2p-add-payment-btn {\n    padding: 12px 20px;\n    font-size: 13px;\n    margin-top: 14px;\n  }\n}\n\n@media (max-width: 400px) {\n  .p2p-no-payment-methods i {\n    font-size: 32px;\n  }\n\n  .p2p-no-payment-methods p {\n    font-size: 13px;\n  }\n\n  .p2p-add-payment-btn {\n    padding: 10px 16px;\n    font-size: 12px;\n    width: 100%;\n  }\n}\n\n/* ============================================\n     P2P ORDER PROGRESS BAR STYLES\n     ============================================ */\n\n.p2p-order-progress-container {\n  background: rgba(20, 22, 30, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.p2p-order-progress {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.p2p-progress-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n  z-index: 1;\n}\n\n.p2p-progress-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: rgba(40, 45, 55, 0.8);\n  border: 2px solid rgba(100, 110, 130, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  font-size: 18px;\n  transition: all 0.3s ease;\n}\n\n.p2p-progress-step.active .p2p-progress-icon {\n  background: rgba(212, 168, 83, 0.15);\n  border-color: #d4a853;\n  color: #d4a853;\n  box-shadow: 0 0 20px rgba(212, 168, 83, 0.2);\n}\n\n.p2p-progress-step.completed .p2p-progress-icon {\n  background: rgba(74, 157, 110, 0.15);\n  border-color: #4a9d6e;\n  color: #4a9d6e;\n}\n\n.p2p-progress-label {\n  font-size: 12px;\n  color: #6b7280;\n  text-align: center;\n  max-width: 80px;\n  line-height: 1.3;\n}\n\n.p2p-progress-step.active .p2p-progress-label {\n  color: #d4a853;\n  font-weight: 500;\n}\n\n.p2p-progress-step.completed .p2p-progress-label {\n  color: #4a9d6e;\n}\n\n.p2p-progress-line {\n  flex: 1;\n  height: 2px;\n  background: rgba(100, 110, 130, 0.2);\n  margin: 0 -10px;\n  margin-bottom: 30px;\n  transition: background 0.3s ease;\n}\n\n.p2p-progress-line.completed {\n  background: linear-gradient(90deg, #4a9d6e, #4a9d6e);\n}\n\n/* Quick Order Info */\n.p2p-order-quick-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.p2p-quick-info-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.p2p-quick-label {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.p2p-quick-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n\n.p2p-quick-value.highlight-green {\n  color: #4a9d6e;\n}\n\n.p2p-quick-value.highlight-red {\n  color: #c75b5b;\n}\n\n.p2p-quick-divider {\n  width: 1px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n/* Progress Responsive */\n@media (max-width: 768px) {\n  .p2p-order-progress-container {\n    padding: 20px 16px;\n  }\n\n  .p2p-progress-icon {\n    width: 36px;\n    height: 36px;\n    font-size: 16px;\n  }\n\n  .p2p-progress-label {\n    font-size: 10px;\n    max-width: 60px;\n  }\n\n  .p2p-order-quick-info {\n    gap: 16px;\n  }\n\n  .p2p-quick-value {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .p2p-order-progress {\n    flex-wrap: wrap;\n    gap: 8px;\n    justify-content: center;\n  }\n\n  .p2p-progress-line {\n    display: none;\n  }\n\n  .p2p-payment-type-item {\n    padding: 7px 12px;\n  }\n\n  .p2p-payment-type-name {\n    font-size: 12px;\n  }\n\n\n\n  .p2p-progress-step {\n    flex: 0 0 calc(50% - 8px);\n    padding: 12px;\n    background: rgba(30, 35, 45, 0.5);\n    border-radius: 12px;\n  }\n\n  .p2p-progress-label {\n    max-width: 100%;\n  }\n\n  .p2p-order-quick-info {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .p2p-quick-divider {\n    width: 100%;\n    height: 1px;\n  }\n\n  .p2p-quick-info-item {\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .p2p-payment-form-input {\n    padding: 8px 12px;\n    border-radius: 6px;\n    font-size: 12px;\n  }\n\n  .p2p-add-payment-modal-header {\n    padding: 10px 18px;\n  }\n\n  .p2p-add-payment-modal-title {\n    font-size: 15px;\n  }\n\n  .p2p-modal-btn {\n    gap: 6px;\n    padding: 8px 16px;\n    border-radius: 6px;\n    font-size: 12px;\n  }\n\n\n\n}\n\n/* ============================================\n     P2P MOBILE TABS FOR ORDER DETAILS\n     ============================================ */\n\n.p2p-mobile-tabs {\n  display: none;\n  margin-bottom: 20px;\n  background: rgba(20, 22, 30, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 6px;\n  gap: 6px;\n}\n\n.p2p-mobile-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: #8b8b9a;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-mobile-tab i {\n  font-size: 18px;\n}\n\n.p2p-mobile-tab:hover {\n  background: rgba(255, 255, 255, 0.03);\n  color: #c9d1d9;\n}\n\n.p2p-mobile-tab.active {\n  background: rgba(74, 157, 110, 0.15);\n  color: #4a9d6e;\n}\n\n/* Show tabs on tablet and mobile */\n@media (max-width: 1024px) {\n  .p2p-mobile-tabs {\n    display: flex;\n  }\n\n  .p2p-order-content {\n    display: block;\n  }\n\n  .p2p-order-main.mobile-hidden,\n  .p2p-order-sidebar.mobile-hidden {\n    display: none;\n  }\n\n  .p2p-order-main,\n  .p2p-order-sidebar {\n    max-width: 100%;\n  }\n\n  .p2p-chat-card {\n    height: calc(100vh - 380px);\n    min-height: 400px;\n    max-height: none;\n  }\n\n  .p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {\n    height: calc(100vh - 320px);\n  }\n}\n\n@media (max-width: 768px) {\n  .p2p-mobile-tab {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .p2p-mobile-tab i {\n    font-size: 16px;\n  }\n\n  .p2p-chat-card {\n    height: calc(100vh - 350px);\n    min-height: 350px;\n    max-height: none;\n  }\n\n  .p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {\n    height: calc(100vh - 280px);\n  }\n}\n\n@media (max-width: 480px) {\n  .p2p-mobile-tabs {\n    padding: 4px;\n    gap: 4px;\n  }\n\n  .p2p-mobile-tab {\n    padding: 10px 8px;\n    font-size: 12px;\n    gap: 6px;\n  }\n\n  .p2p-mobile-tab i {\n    font-size: 15px;\n  }\n\n  .p2p-chat-card {\n    height: calc(100vh - 300px);\n    min-height: 300px;\n    max-height: none;\n  }\n\n  .p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {\n    height: calc(100vh - 250px);\n  }\n\n  .p2p-chat-messages {\n    padding: 12px;\n    gap: 10px;\n  }\n}\n\n/* ============================================\n     P2P CHAT USER HEADER STYLES\n     ============================================ */\n\n.p2p-chat-user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-chat-user-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3d4a5c, #2d3748);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.p2p-chat-user-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.p2p-chat-user-avatar span {\n  color: #c9d1d9;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.p2p-user-status-dot {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #4a9d6e;\n  border: 2px solid rgba(20, 22, 30, 1);\n}\n\n.p2p-chat-user-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-chat-user-details h4 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n\n.p2p-chat-user-role {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* ============================================\n     P2P ORDER DETAILS - PREMIUM CHAT STYLES\n     ============================================ */\n\n.p2p-chat-card {\n  display: flex;\n  flex-direction: column;\n  height: 550px;\n  min-height: 500px;\n  max-height: 700px;\n  padding: 0 !important;\n  overflow: hidden;\n  flex: 1;\n}\n\n/* Ensure chat card children have proper flex behavior */\n.p2p-chat-card>* {\n  flex-shrink: 0;\n}\n\n.p2p-chat-card .p2p-chat-messages {\n  flex: 1;\n  flex-shrink: 1;\n  min-height: 200px;\n}\n\n.p2p-chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: rgba(20, 20, 30, 0.8);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.p2p-chat-header h4 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n\n.p2p-chat-header h4 i {\n  font-size: 18px;\n  color: #8b8b9a;\n}\n\n.p2p-chat-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-chat-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.p2p-chat-status.online {\n  color: #4a9d6e;\n}\n\n.p2p-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #4a9d6e;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.p2p-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: rgba(10, 10, 15, 0.5);\n  min-height: 0;\n  /* Important for flex child scrolling */\n  scroll-behavior: smooth;\n}\n\n.p2p-chat-messages::-webkit-scrollbar {\n  width: 4px;\n}\n\n.p2p-chat-messages::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.p2p-chat-messages::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n.p2p-chat-messages::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.p2p-chat-message {\n  display: flex;\n  gap: 10px;\n  max-width: 85%;\n}\n\n.p2p-chat-message.sent {\n  align-self: flex-end;\n  flex-direction: row-reverse;\n}\n\n.p2p-chat-message.received {\n  align-self: flex-start;\n}\n\n.p2p-chat-message.system {\n  align-self: center;\n  max-width: 90%;\n}\n\n.p2p-chat-avatar {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3d4a5c, #2d3748);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #c9d1d9;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.p2p-chat-bubble {\n  background: rgba(30, 35, 45, 0.9);\n  border-radius: 16px;\n  padding: 12px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.p2p-chat-message.sent .p2p-chat-bubble {\n  background: linear-gradient(135deg, rgba(74, 157, 110, 0.2), rgba(74, 157, 110, 0.1));\n  border-color: rgba(74, 157, 110, 0.2);\n  border-radius: 16px 16px 4px 16px;\n}\n\n.p2p-chat-message.received .p2p-chat-bubble {\n  border-radius: 16px 16px 16px 4px;\n}\n\n.p2p-chat-bubble.system {\n  background: rgba(139, 139, 154, 0.1);\n  border: 1px dashed rgba(139, 139, 154, 0.3);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.p2p-chat-bubble.system i {\n  font-size: 18px;\n  color: #8b8b9a;\n}\n\n.p2p-chat-bubble p {\n  margin: 0;\n  color: #c9d1d9;\n  font-size: 14px;\n  line-height: 1.5;\n  word-break: break-word;\n}\n\n.p2p-chat-bubble.system p {\n  color: #8b8b9a;\n  font-size: 13px;\n}\n\n.p2p-chat-time {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #6b7280;\n  font-size: 11px;\n  margin-top: 6px;\n}\n\n.p2p-chat-time i {\n  font-size: 12px;\n  color: #4a9d6e;\n}\n\n.p2p-chat-image {\n  margin-bottom: 8px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.p2p-chat-image img {\n  max-width: 200px;\n  max-height: 200px;\n  object-fit: cover;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.p2p-chat-image img:hover {\n  transform: scale(1.02);\n}\n\n.p2p-chat-image-preview {\n  position: relative;\n  padding: 12px 16px;\n  background: rgba(20, 20, 30, 0.9);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.p2p-chat-image-preview img {\n  max-width: 120px;\n  max-height: 80px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.p2p-chat-remove-image {\n  position: absolute;\n  top: 8px;\n  left: 120px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: rgba(199, 91, 91, 0.9);\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n\n.p2p-chat-input-container {\n  padding: 12px 16px;\n  background: rgba(20, 20, 30, 0.9);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.p2p-chat-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(30, 35, 45, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 24px;\n  padding: 6px 8px 6px 12px;\n}\n\n.p2p-chat-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.p2p-chat-action-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: transparent;\n  border: none;\n  color: #8b8b9a;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  transition: all 0.2s;\n}\n\n.p2p-chat-action-btn:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #c9d1d9;\n}\n\n.p2p-chat-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: #e5e5e5;\n  font-size: 14px;\n  outline: none;\n  padding: 8px 0;\n}\n\n.p2p-chat-input::placeholder {\n  color: #6b7280;\n}\n\n.p2p-chat-send-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: rgba(74, 157, 110, 0.2);\n  border: none;\n  color: #6b7280;\n  cursor: not-allowed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  transition: all 0.2s;\n}\n\n.p2p-chat-send-btn.active {\n  background: linear-gradient(135deg, #4a9d6e, #3d8a5f);\n  color: #fff;\n  cursor: pointer;\n}\n\n.p2p-chat-send-btn.active:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(74, 157, 110, 0.3);\n}\n\n/* Spin animation for loading */\n.p2p-spin {\n  animation: p2p-spin 1s linear infinite;\n}\n\n@keyframes p2p-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Chat Load More Button */\n.p2p-chat-load-more {\n  display: block;\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px dashed rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #8b8b9a;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.p2p-chat-load-more:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #c9d1d9;\n}\n\n.p2p-chat-load-more:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Chat Empty State */\n.p2p-chat-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 200px;\n  color: #6b7280;\n  text-align: center;\n  padding: 24px;\n}\n\n.p2p-chat-empty i {\n  font-size: 48px;\n  margin-bottom: 12px;\n  opacity: 0.5;\n}\n\n.p2p-chat-empty p {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: #8b8b9a;\n}\n\n.p2p-chat-empty span {\n  font-size: 13px;\n  color: #6b7280;\n  margin-top: 4px;\n}\n\n/* Chat Typing Indicator */\n.p2p-chat-typing {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  padding: 4px 0;\n}\n\n.p2p-typing-indicator {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 16px;\n  background: rgba(30, 35, 45, 0.9);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.p2p-typing-indicator span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #6b7280;\n  animation: typing-bounce 1.4s infinite ease-in-out;\n}\n\n.p2p-typing-indicator span:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.p2p-typing-indicator span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.p2p-typing-indicator span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typing-bounce {\n\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n  }\n\n  30% {\n    transform: translateY(-6px);\n  }\n}\n\n/* Chat Error */\n.p2p-chat-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: rgba(199, 91, 91, 0.1);\n  border-top: 1px solid rgba(199, 91, 91, 0.2);\n  color: #c75b5b;\n  font-size: 13px;\n}\n\n.p2p-chat-error i {\n  font-size: 16px;\n}\n\n/* Chat Connecting Status */\n.p2p-chat-connecting {\n  display: flex;\n  align-items: center;\n  color: #d4a853;\n}\n\n.p2p-chat-connecting i {\n  animation: p2p-spin 1s linear infinite;\n}\n\n/* Message Status Icons */\n.p2p-msg-status {\n  font-size: 14px;\n  margin-left: 4px;\n}\n\n.p2p-msg-status.sending {\n  color: #6b7280;\n}\n\n.p2p-msg-status.sent {\n  color: #8b8b9a;\n}\n\n.p2p-msg-status.delivered {\n  color: #8b8b9a;\n}\n\n.p2p-msg-status.read {\n  color: #4a9d6e;\n}\n\n/* Chat Image Uploading Overlay */\n.p2p-chat-image-uploading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n.p2p-chat-image-uploading i {\n  font-size: 24px;\n  color: #fff;\n  animation: p2p-spin 1s linear infinite;\n}\n\n.p2p-chat-image {\n  position: relative;\n}\n\n/* User Status Dot Variants */\n.p2p-user-status-dot.online {\n  background: #4a9d6e;\n}\n\n.p2p-user-status-dot.offline {\n  background: #6b7280;\n}\n\n/* Chat Status Variants */\n.p2p-chat-status.offline {\n  color: #6b7280;\n}\n\n.p2p-chat-status.offline .p2p-status-dot {\n  background: #6b7280;\n  animation: none;\n}\n\n/* Chat Avatar with image */\n.p2p-chat-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n/* Emoji Picker */\n.p2p-emoji-container {\n  position: relative;\n}\n\n.p2p-emoji-picker {\n  position: absolute;\n  bottom: 45px;\n  left: 0;\n  width: 280px;\n  max-height: 220px;\n  background: rgba(25, 28, 38, 0.98);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  z-index: 100;\n}\n\n.p2p-emoji-grid {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 2px;\n  padding: 12px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.p2p-emoji-grid::-webkit-scrollbar {\n  width: 4px;\n}\n\n.p2p-emoji-grid::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n.p2p-emoji-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  font-size: 18px;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.15s;\n}\n\n.p2p-emoji-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: scale(1.15);\n}\n\n/* Premium Order Card Styling */\n.p2p-order-card {\n  background: rgba(20, 22, 30, 0.7);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 20px;\n  margin-bottom: 16px;\n}\n\n.p2p-order-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #c9d1d9;\n  margin: 0 0 16px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Chat Responsive */\n@media (max-width: 1024px) {\n  .p2p-chat-card {\n    height: 480px;\n    min-height: 450px;\n  }\n}\n\n@media (max-width: 768px) {\n  .p2p-chat-card {\n    height: 420px;\n    min-height: 400px;\n  }\n\n  .p2p-emoji-picker {\n    width: 260px;\n    left: -50px;\n  }\n\n  .p2p-emoji-grid {\n    grid-template-columns: repeat(7, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .p2p-chat-card {\n    height: 380px;\n    min-height: 350px;\n  }\n\n  .p2p-chat-header {\n    padding: 12px 16px;\n  }\n\n  .p2p-chat-header h4 {\n    font-size: 14px;\n  }\n\n  .p2p-emoji-picker {\n    width: 240px;\n    left: -20px;\n  }\n\n  .p2p-emoji-grid {\n    grid-template-columns: repeat(6, 1fr);\n  }\n\n  .p2p-chat-image img {\n    max-width: 150px;\n    max-height: 150px;\n  }\n}\n\n/* ====================================\n     BINANCE STYLE ORDER DETAILS\n     ==================================== */\n\n.binance-order-container {\n  padding: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.binance-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 16px;\n}\n\n.binance-loading p {\n  color: #848e9c;\n  font-size: 14px;\n}\n\n.binance-loading .spinner-border {\n  color: #fcd535;\n}\n\n/* Order Status Banners */\n.order-status-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 20px 24px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  animation: bannerSlideIn 0.3s ease-out;\n}\n\n@keyframes bannerSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.order-status-banner.success {\n  background: linear-gradient(135deg, rgba(14, 203, 129, 0.15) 0%, rgba(14, 203, 129, 0.05) 100%);\n  border: 1px solid rgba(14, 203, 129, 0.3);\n}\n\n.order-status-banner.cancelled {\n  background: linear-gradient(135deg, rgba(246, 70, 93, 0.15) 0%, rgba(246, 70, 93, 0.05) 100%);\n  border: 1px solid rgba(246, 70, 93, 0.3);\n}\n\n.order-status-banner.disputed {\n  background: linear-gradient(135deg, rgba(252, 213, 53, 0.15) 0%, rgba(252, 213, 53, 0.05) 100%);\n  border: 1px solid rgba(252, 213, 53, 0.3);\n}\n\n.banner-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.order-status-banner.success .banner-icon {\n  background: rgba(14, 203, 129, 0.2);\n}\n\n.order-status-banner.cancelled .banner-icon {\n  background: rgba(246, 70, 93, 0.2);\n}\n\n.order-status-banner.disputed .banner-icon {\n  background: rgba(252, 213, 53, 0.2);\n}\n\n.banner-icon i {\n  font-size: 28px;\n}\n\n.order-status-banner.success .banner-icon i {\n  color: #0ecb81;\n}\n\n.order-status-banner.cancelled .banner-icon i {\n  color: #f6465d;\n}\n\n.order-status-banner.disputed .banner-icon i {\n  color: #fcd535;\n}\n\n.banner-content {\n  flex: 1;\n}\n\n.banner-content h3 {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.order-status-banner.success .banner-content h3 {\n  color: #0ecb81;\n}\n\n.order-status-banner.cancelled .banner-content h3 {\n  color: #f6465d;\n}\n\n.order-status-banner.disputed .banner-content h3 {\n  color: #fcd535;\n}\n\n.banner-content p {\n  margin: 0;\n  font-size: 14px;\n  color: #848e9c;\n  line-height: 1.5;\n}\n\n/* Mobile responsive */\n@media (max-width: 480px) {\n  .order-status-banner {\n    padding: 16px;\n    gap: 12px;\n  }\n\n  .banner-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .banner-icon i {\n    font-size: 22px;\n  }\n\n  .banner-content h3 {\n    font-size: 16px;\n  }\n\n  .banner-content p {\n    font-size: 13px;\n  }\n}\n\n/* Mobile Tabs */\n.binance-mobile-tabs {\n  display: none;\n  background: #1e2329;\n  border-radius: 8px;\n  padding: 4px;\n  margin-bottom: 20px;\n  gap: 4px;\n}\n\n.binance-tab {\n  flex: 1;\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.2s;\n}\n\n.binance-tab:hover {\n  color: #eaecef;\n}\n\n.binance-tab.active {\n  background: #2b3139;\n  color: #ffffff;\n}\n\n.binance-tab i {\n  font-size: 18px;\n}\n\n/* Main Layout */\n.binance-order-layout {\n  display: grid;\n  grid-template-columns: 1fr 420px;\n  gap: 24px;\n  align-items: start;\n}\n\n/* Left Side - Order Details */\n.binance-order-details {\n  background: #181a20;\n  border-radius: 12px;\n  padding: 32px;\n}\n\n.binance-order-header {\n  margin-bottom: 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.header-left {\n  flex: 1;\n}\n\n.binance-order-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #eaecef;\n  margin: 0 0 12px 0;\n}\n\n.binance-order-number {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.binance-order-number>span:first-child {\n  color: #848e9c;\n}\n\n.binance-order-number .order-id {\n  color: #eaecef;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.binance-order-number .order-id i {\n  color: #848e9c;\n  font-size: 16px;\n}\n\n.binance-order-number .order-id:hover i {\n  color: #fcd535;\n}\n\n/* Timer in Header */\n.binance-timer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  padding: 12px 16px;\n  /* background: rgba(252, 213, 53, 0.1); */\n  border: 1px solid rgb(43 49 57);\n  border-radius: 8px;\n  min-width: 120px;\n}\n\n.binance-timer .timer-label {\n  font-size: 12px;\n  color: #848e9c;\n}\n\n.binance-timer .timer-value {\n  font-size: 24px;\n  font-weight: 700;\n  /* color: #fcd535; */\n  font-family: 'Roboto Mono', monospace;\n  letter-spacing: 1px;\n}\n\n.binance-timer.expired {\n  background: rgba(246, 70, 93, 0.1);\n  border-color: rgba(246, 70, 93, 0.3);\n}\n\n.binance-timer .timer-expired {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #f6465d;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.binance-timer .timer-expired i {\n  font-size: 18px;\n}\n\n/* Progress Steps */\n.binance-progress-steps {\n  display: flex;\n  flex-direction: column;\n}\n\n.binance-step {\n  display: flex;\n  gap: 16px;\n}\n\n.step-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 32px;\n  flex-shrink: 0;\n}\n\n.step-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  background: #2b3139;\n  color: #848e9c;\n  border: 2px solid #2b3139;\n}\n\n.binance-step.completed .step-icon {\n  background: #0ecb81;\n  border-color: #0ecb81;\n  color: #181a20;\n}\n\n.binance-step.active .step-icon {\n  background: #fcd535;\n  border-color: #fcd535;\n  color: #181a20;\n}\n\n.step-line {\n  width: 2px;\n  flex: 1;\n  min-height: 24px;\n  background: #2b3139;\n  margin: 8px 0;\n}\n\n.binance-step.completed .step-line {\n  background: #0ecb81;\n}\n\n.step-content {\n  flex: 1;\n  padding-bottom: 24px;\n}\n\n.step-content h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #eaecef;\n  margin: 4px 0 8px 0;\n}\n\n.binance-step.pending .step-content h4 {\n  color: #848e9c;\n}\n\n/* Collapsible Step Header */\n.step-header-clickable {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: 4px 0;\n  margin: -4px 0;\n}\n\n.step-header-clickable h4 {\n  margin: 0;\n}\n\n.step-header-clickable i {\n  font-size: 20px;\n  color: #848e9c;\n  transition: transform 0.2s;\n}\n\n.step-header-clickable:hover i {\n  color: #eaecef;\n}\n\n/* Step Dropdown Content */\n.step-dropdown-content {\n  margin-top: 16px;\n  padding: 16px;\n  background: #1e2329;\n  border-radius: 8px;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Order Info Grid */\n.order-info-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.order-info-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.order-info-row .info-label {\n  font-size: 14px;\n  color: #848e9c;\n}\n\n.order-info-row .info-value {\n  font-size: 14px;\n  color: #eaecef;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.order-info-row .info-value.highlight {\n  color: #fcd535;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.order-info-row .info-value.copyable {\n  cursor: pointer;\n}\n\n.order-info-row .info-value.copyable i {\n  color: #848e9c;\n  font-size: 14px;\n  transition: color 0.2s;\n}\n\n.order-info-row .info-value.copyable:hover i {\n  color: #fcd535;\n}\n\n.step-desc {\n  font-size: 14px;\n  color: #848e9c;\n  margin: 0 0 16px 0;\n  line-height: 1.5;\n}\n\n/* Payment Card */\n.binance-payment-card {\n  background: #1e2329;\n  border-radius: 8px;\n  padding: 20px;\n  margin-top: 16px;\n}\n\n.payment-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #2b3139;\n}\n\n.payment-type {\n  background: rgba(252, 213, 53, 0.15);\n  color: #fcd535;\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.payment-qr {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.payment-qr img {\n  width: 50px;\n  height: 50px;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.payment-qr span {\n  font-size: 11px;\n  color: #848e9c;\n}\n\n.payment-qr:hover span {\n  color: #fcd535;\n}\n\n.payment-details-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.payment-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.payment-row .label {\n  font-size: 14px;\n  color: #848e9c;\n}\n\n.payment-row .value {\n  font-size: 14px;\n  color: #eaecef;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.payment-row .value i {\n  color: #848e9c;\n  font-size: 16px;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.payment-row .value i {\n  opacity: 1;\n  /* color: #fcd535; */\n}\n\n.payment-row.highlight .value.amount {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.payment-row .value.amount.green {\n  color: #0ecb81;\n}\n\n.payment-row .value.amount.red {\n  color: #f6465d;\n}\n\n.payment-row .value.amount i {\n  opacity: 1;\n}\n\n.payment-row.buyer-info {\n  margin-top: 8px;\n  padding-top: 12px;\n  border-top: 1px solid #2b3139;\n}\n\n.payment-row .value.name {\n  background: #2b3139;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: default;\n}\n\n/* Action Buttons */\n.binance-action-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.binance-btn {\n  padding: 12px 24px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s;\n}\n\n.binance-btn.primary {\n  background: #fcd535;\n  color: #181a20;\n}\n\n.binance-btn.primary:hover {\n  background: #e5c32e;\n}\n\n.binance-btn.primary:disabled {\n  background: #5c5424;\n  color: #848e9c;\n  cursor: not-allowed;\n}\n\n.binance-btn i {\n  margin-right: 6px;\n}\n\n/* Appeal Button */\n.binance-btn.appeal {\n  background: transparent;\n  border: 1px solid #f0b90b;\n  color: #f0b90b;\n}\n\n.binance-btn.appeal:hover:not(:disabled) {\n  background: rgba(240, 185, 11, 0.1);\n}\n\n.binance-btn.appeal.disabled,\n.binance-btn.appeal:disabled {\n  border-color: #848e9c;\n  color: #848e9c;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.binance-btn.appeal-submit {\n  background: #f0b90b;\n  color: #181a20;\n}\n\n.binance-btn.appeal-submit:hover:not(:disabled) {\n  background: #d9a80a;\n}\n\n.binance-btn.appeal-submit:disabled {\n  background: #5c5424;\n  color: #848e9c;\n  cursor: not-allowed;\n}\n\n/* Appeal Modal */\n.appeal-modal {\n  max-width: 500px;\n}\n\n.appeal-modal .binance-modal-header h3 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #f0b90b;\n}\n\n.appeal-info {\n  display: flex;\n  gap: 12px;\n  padding: 12px 16px;\n  background: rgba(240, 185, 11, 0.1);\n  border: 1px solid rgba(240, 185, 11, 0.2);\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.appeal-info i {\n  color: #f0b90b;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.appeal-info p {\n  color: #eaecef;\n  font-size: 13px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.appeal-form {\n  margin-bottom: 16px;\n}\n\n.appeal-form label {\n  display: block;\n  color: #eaecef;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.appeal-textarea {\n  width: 100%;\n  padding: 12px;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 8px;\n  color: #eaecef;\n  font-size: 14px;\n  resize: vertical;\n  min-height: 120px;\n  font-family: inherit;\n}\n\n.appeal-textarea:focus {\n  outline: none;\n  border-color: #f0b90b;\n}\n\n.appeal-textarea::placeholder {\n  color: #5e6673;\n}\n\n.char-count {\n  text-align: right;\n  color: #848e9c;\n  font-size: 12px;\n  margin-top: 6px;\n}\n\n.appeal-warning {\n  display: flex;\n  gap: 12px;\n  padding: 12px 16px;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: 8px;\n}\n\n.appeal-warning i {\n  color: #ef4444;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.appeal-warning p {\n  color: #eaecef;\n  font-size: 13px;\n  font-weight: 500;\n  margin: 0 0 6px 0;\n}\n\n.appeal-warning ul {\n  margin: 0;\n  padding-left: 16px;\n  color: #848e9c;\n  font-size: 12px;\n}\n\n.appeal-warning li {\n  margin-bottom: 4px;\n}\n\n.appeal-modal .binance-modal-footer {\n  display: flex;\n  gap: 12px;\n}\n\n.appeal-modal .binance-modal-footer .binance-btn {\n  flex: 1;\n}\n\n/* ====================================\n     WELCOME P2P POPUP\n     ==================================== */\n.welcome-modal {\n  max-width: 480px;\n}\n\n.welcome-modal .binance-modal-header h3 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fcd535;\n}\n\n.welcome-modal .binance-modal-header h3 i {\n  font-size: 24px;\n}\n\n/* Welcome Tabs */\n.welcome-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n  background: #181a20;\n  padding: 4px;\n  border-radius: 8px;\n}\n\n.welcome-tab {\n  flex: 1;\n  padding: 10px 16px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: #848e9c;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.welcome-tab:hover {\n  color: #eaecef;\n}\n\n.welcome-tab.active {\n  background: #2b3139;\n  color: #fcd535;\n}\n\n/* Welcome Content */\n.welcome-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* How to Pay Steps */\n.welcome-step {\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  background: #181a20;\n  border-radius: 12px;\n}\n\n.welcome-step .step-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  background: linear-gradient(135deg, #fcd535 0%, #f0b90b 100%);\n  color: #181a20;\n  font-size: 16px;\n  font-weight: 700;\n  border-radius: 50%;\n}\n\n.welcome-step .step-info h6 {\n  color: #eaecef;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 6px 0;\n}\n\n.welcome-step .step-info p {\n  color: #848e9c;\n  font-size: 13px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Things to Note */\n.welcome-note {\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  background: #181a20;\n  border-radius: 12px;\n}\n\n.welcome-note .note-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  background: rgba(252, 213, 53, 0.1);\n  border-radius: 10px;\n}\n\n.welcome-note .note-icon i {\n  font-size: 20px;\n  color: #fcd535;\n}\n\n.welcome-note .note-info h6 {\n  color: #eaecef;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 6px 0;\n}\n\n.welcome-note .note-info p {\n  color: #848e9c;\n  font-size: 13px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Welcome Modal Footer */\n.welcome-modal .binance-modal-footer {\n  padding-top: 16px;\n}\n\n.welcome-modal .binance-modal-footer .binance-btn.full-width {\n  width: 100%;\n}\n\n/* ====================================\n     TIME WARNING & PAYMENT RECEIVED POPUPS\n     ==================================== */\n\n/* Time Warning Popup */\n.time-warning-content {\n  text-align: center;\n  padding: 20px 0;\n}\n\n.warning-icon-large {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 20px;\n  background: rgba(245, 158, 11, 0.15);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.warning-icon-large i {\n  font-size: 40px;\n  color: #f59e0b;\n}\n\n.time-warning-content h4 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0 0 12px 0;\n}\n\n.time-warning-content p {\n  font-size: 14px;\n  color: #9ca3af;\n  line-height: 1.6;\n  margin: 0 0 24px 0;\n}\n\n.time-warning-actions {\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 20px;\n  text-align: left;\n}\n\n.warning-action-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  font-size: 13px;\n  color: #d1d5db;\n}\n\n.warning-action-item:last-child {\n  margin-bottom: 0;\n}\n\n.warning-action-item i {\n  font-size: 16px;\n  color: #f59e0b;\n  flex-shrink: 0;\n}\n\n/* Payment Received Popup */\n.payment-received-content {\n  text-align: center;\n  padding: 20px 0;\n}\n\n.success-icon-large {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 20px;\n  background: rgba(34, 197, 94, 0.15);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.success-icon-large i {\n  font-size: 40px;\n  color: #22c55e;\n}\n\n.payment-received-content h4 {\n  font-size: 22px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0 0 12px 0;\n}\n\n.payment-received-content p {\n  font-size: 14px;\n  color: #9ca3af;\n  line-height: 1.6;\n  margin: 0 0 24px 0;\n}\n\n.payment-received-content p strong {\n  color: #e5e5e5;\n  font-weight: 600;\n}\n\n.payment-received-info {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin: 24px 0;\n}\n\n.info-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.info-label {\n  font-size: 12px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.info-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.payment-received-warning {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 24px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.payment-received-warning i {\n  font-size: 20px;\n  color: #ef4444;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.payment-received-warning p {\n  margin: 0;\n  font-size: 13px;\n  color: #fca5a5;\n  line-height: 1.6;\n}\n\n.payment-received-warning p strong {\n  color: #fee2e2;\n  font-weight: 600;\n}\n\n/* ====================================\n     P2P TRADE RESTRICTIONS & BALANCE\n     ==================================== */\n\n/* Verification Required Button */\n.p2p-verification-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: rgba(252, 213, 53, 0.15);\n  border: 1px solid rgba(252, 213, 53, 0.3);\n  border-radius: 6px;\n  color: #fcd535;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.p2p-verification-btn:hover {\n  background: rgba(252, 213, 53, 0.25);\n  border-color: #fcd535;\n}\n\n.p2p-verification-btn i {\n  font-size: 16px;\n}\n\n/* Trade Restricted Container */\n.p2p-trade-restricted {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-trade-restricted .p2p-buy-btn.disabled,\n.p2p-trade-restricted .p2p-sell-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* Condition Tooltip */\n.p2p-condition-tooltip {\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: help;\n}\n\n.p2p-condition-tooltip i {\n  font-size: 18px;\n  color: #848e9c;\n  transition: color 0.2s;\n}\n\n.p2p-condition-tooltip:hover i {\n  color: #fcd535;\n}\n\n.p2p-tooltip-content {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  right: 0;\n  min-width: 240px;\n  padding: 12px;\n  background: #1e2329;\n  border: 1px solid #2b3139;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(8px);\n  transition: all 0.2s;\n  z-index: 100;\n}\n\n.p2p-condition-tooltip:hover .p2p-tooltip-content {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.p2p-tooltip-content span {\n  display: block;\n  font-size: 13px;\n  color: #eaecef;\n  line-height: 1.4;\n}\n\n.p2p-tooltip-content .p2p-tooltip-sub {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #f6465d;\n}\n\n/* Sell with Balance */\n.p2p-sell-with-balance {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.p2p-balance-info {\n  font-size: 11px;\n  color: #848e9c;\n  pointer-events: none;\n}\n\n.p2p-available-balance {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-top: 4px;\n  display: block;\n}\n\n.p2p-sell-fee-display {\n  display: block;\n  font-size: 11px;\n  color: #F3BB2B;\n  margin-top: 4px;\n}\n\n/* Mobile Styles */\n.p2p-mobile-verification-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 12px 16px;\n  background: rgba(252, 213, 53, 0.15);\n  border: 1px solid rgba(252, 213, 53, 0.3);\n  border-radius: 8px;\n  color: #fcd535;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.p2p-mobile-verification-btn i {\n  font-size: 18px;\n}\n\n.p2p-mobile-trade-restricted {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.p2p-mobile-trade-restricted .p2p-mobile-buy-btn.disabled,\n.p2p-mobile-trade-restricted .p2p-mobile-sell-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.p2p-mobile-condition-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: rgba(248, 113, 113, 0.1);\n  border-radius: 6px;\n}\n\n.p2p-mobile-condition-info i {\n  font-size: 16px;\n  color: #f6465d;\n}\n\n.p2p-mobile-condition-info span {\n  font-size: 12px;\n  color: #f6465d;\n}\n\n.p2p-mobile-sell-with-balance {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.p2p-mobile-balance-info {\n  font-size: 12px;\n  color: #848e9c;\n  text-align: center;\n  pointer-events: none;\n}\n\n\n.binance-btn.secondary {\n  background: transparent;\n  color: #848e9c;\n  border: 1px solid #2b3139;\n}\n\n.binance-btn.secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.binance-expired-notice {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: rgba(246, 70, 93, 0.1);\n  border: 1px solid rgba(246, 70, 93, 0.3);\n  border-radius: 8px;\n  margin-top: 16px;\n}\n\n.binance-expired-notice i {\n  color: #f6465d;\n  font-size: 18px;\n}\n\n.binance-expired-notice span {\n  color: #f6465d;\n  font-size: 14px;\n}\n\n/* Chat Section */\n.binance-chat-section {\n  position: sticky;\n  top: 24px;\n}\n\n.binance-chat-card {\n  background: #181a20;\n  border-radius: 12px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  height: 650px;\n}\n\n.binance-chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #2b3139;\n}\n\n.chat-user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.chat-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: #2b3139;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: #eaecef;\n  font-size: 18px;\n  position: relative;\n  overflow: hidden;\n}\n\n.chat-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.chat-avatar .status-dot {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #848e9c;\n  border: 2px solid #181a20;\n}\n\n.chat-avatar .status-dot.online {\n  background: #0ecb81;\n}\n\n.chat-user-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.chat-username {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\n.chat-username .verified {\n  color: #11cb81;\n  font-size: 16px;\n}\n\n.chat-user-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #848e9c;\n}\n\n.chat-user-meta .online-status {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.chat-user-meta .online-status i {\n  font-size: 8px;\n}\n\n.chat-user-meta .online-status.online {\n  color: #0ecb81;\n}\n\n.chat-user-meta .divider {\n  color: #2b3139;\n}\n\n.chat-user-meta .user-role {\n  background: rgba(132, 142, 156, 0.15);\n  color: #848e9c;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.chat-user-meta .trades-link {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.chat-user-meta .trades-link:hover {\n  color: #eaecef;\n}\n\n.chat-menu-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n\n.chat-menu-btn:hover {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n/* Chat Notice */\n.binance-chat-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #2b3139;\n  border-bottom: 1px solid #3a3f47;\n  position: relative;\n}\n\n.binance-chat-notice i {\n  color: #ffdc88;\n  font-size: 18px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.binance-chat-notice p {\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.5;\n  margin: 0;\n  flex: 1;\n}\n\n.notice-close {\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  cursor: pointer;\n  padding: 4px;\n  line-height: 1;\n}\n\n.notice-close:hover {\n  color: #eaecef;\n}\n\n/* Chat Messages */\n.binance-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: #0b0e11;\n  min-height: 0;\n}\n\n.binance-chat-messages::-webkit-scrollbar {\n  width: 4px;\n}\n\n.binance-chat-messages::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.binance-chat-messages::-webkit-scrollbar-thumb {\n  background: #2b3139;\n  border-radius: 4px;\n}\n\n.load-more-btn {\n  background: #2b3139;\n  border: none;\n  color: #848e9c;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  margin: 0 auto 8px;\n}\n\n.load-more-btn:hover {\n  background: #3a3f47;\n  color: #eaecef;\n}\n\n.chat-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  color: #848e9c;\n  gap: 8px;\n}\n\n.chat-empty i {\n  font-size: 48px;\n  opacity: 0.3;\n}\n\n.chat-empty p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Chat Messages */\n.chat-message {\n  display: flex;\n  max-width: 85%;\n}\n\n.chat-message.sent {\n  margin-left: auto;\n  justify-content: flex-end;\n}\n\n.chat-message.received {\n  margin-right: auto;\n}\n\n.chat-message.system {\n  max-width: 100%;\n  justify-content: center;\n  margin: 12px 0;\n}\n\n.system-bubble {\n  background: rgba(30, 35, 41, 0.8);\n  padding: 8px 20px;\n  border-radius: 20px;\n  text-align: center;\n  border: 1px dashed rgba(132, 142, 156, 0.3);\n}\n\n.system-bubble p {\n  margin: 0;\n  font-size: 12px;\n  color: #848e9c;\n  font-style: italic;\n}\n\n.message-bubble {\n  padding: 10px 14px;\n  border-radius: 12px;\n  max-width: 100%;\n}\n\n.chat-message.sent .message-bubble {\n  background: #0ecb81;\n  border-bottom-right-radius: 4px;\n}\n\n.chat-message.received .message-bubble {\n  background: #2b3139;\n  border-bottom-left-radius: 4px;\n}\n\n.message-bubble p {\n  margin: 0;\n  font-size: 14px;\n  color: #eaecef;\n  word-wrap: break-word;\n  line-height: 1.4;\n}\n\n.chat-message.sent .message-bubble p {\n  color: #181a20;\n}\n\n.message-image {\n  margin-bottom: 8px;\n  position: relative;\n}\n\n.message-image img {\n  max-width: 200px;\n  max-height: 200px;\n  border-radius: 8px;\n  cursor: pointer;\n  object-fit: cover;\n}\n\n.image-uploading {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n.image-uploading i {\n  color: #fff;\n  font-size: 24px;\n}\n\n.message-meta {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.message-time {\n  font-size: 11px;\n  color: rgba(234, 236, 239, 0.5);\n}\n\n.chat-message.sent .message-time {\n  color: rgba(24, 26, 32, 0.6);\n}\n\n.msg-status {\n  font-size: 14px;\n}\n\n.msg-status.sending {\n  color: rgba(24, 26, 32, 0.4);\n}\n\n.msg-status.sent {\n  color: rgba(24, 26, 32, 0.6);\n}\n\n.msg-status.delivered {\n  color: rgba(24, 26, 32, 0.6);\n}\n\n.msg-status.read {\n  color: #1890ff;\n}\n\n/* Typing Indicator */\n.typing-bubble {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 16px;\n  background: #2b3139;\n  border-radius: 12px;\n  border-bottom-left-radius: 4px;\n}\n\n.typing-bubble span {\n  width: 8px;\n  height: 8px;\n  background: #848e9c;\n  border-radius: 50%;\n  animation: typingBounce 1.4s infinite ease-in-out;\n}\n\n.typing-bubble span:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.typing-bubble span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typing-bubble span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typingBounce {\n\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n  }\n\n  30% {\n    transform: translateY(-6px);\n  }\n}\n\n/* Chat Error */\n.chat-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: rgba(246, 70, 93, 0.1);\n  color: #f6465d;\n  font-size: 12px;\n}\n\n.chat-error i {\n  font-size: 16px;\n}\n\n/* Image Preview */\n.image-preview {\n  padding: 12px 16px;\n  background: #1e2329;\n  border-top: 1px solid #2b3139;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.image-preview img {\n  max-height: 80px;\n  border-radius: 8px;\n}\n\n.image-preview button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  padding: 6px;\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  border-radius: 50%;\n  background: rgb(252 212 53 / 62%);\n  border: none;\n  color: #000000;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Chat Input */\n.binance-chat-input {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: #1e2329;\n  border-top: 1px solid #2b3139;\n}\n\n.binance-chat-input input[type=\"text\"] {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #eaecef;\n  font-size: 14px;\n  padding: 8px 0;\n}\n\n.binance-chat-input input[type=\"text\"]::placeholder {\n  color: #5e6673;\n}\n\n.input-action {\n  width: 36px;\n  height: 36px;\n  padding: 0px;\n  border-radius: 50%;\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  transition: all 0.2s;\n}\n\n.input-action:hover {\n  color: #eaecef;\n}\n\n.input-action:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.input-actions-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.emoji-container {\n  position: relative;\n}\n\n.emoji-picker {\n  position: absolute;\n  bottom: 48px;\n  right: 0;\n  width: 280px;\n  background: #1e2329;\n  border: 1px solid #2b3139;\n  border-radius: 12px;\n  padding: 12px;\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 100;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n\n.emoji-picker::-webkit-scrollbar {\n  width: 4px;\n}\n\n.emoji-picker::-webkit-scrollbar-thumb {\n  background: #2b3139;\n  border-radius: 4px;\n}\n\n.emoji-picker button {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.15s;\n}\n\n.emoji-picker button:hover {\n  background: #2b3139;\n  transform: scale(1.1);\n}\n\n.send-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #2b3139;\n  border: none;\n  color: #5e6673;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  transition: all 0.2s;\n}\n\n.send-btn.active {\n  background: #0ecb81;\n  color: #181a20;\n}\n\n.send-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Spinning animation */\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ====================================\n     BINANCE MODAL STYLES\n     ==================================== */\n\n.binance-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  backdrop-filter: blur(4px);\n}\n\n.binance-modal {\n  background: #1e2329;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 480px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: modalSlideIn 0.2s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.binance-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #2b3139;\n}\n\n.binance-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\n.modal-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  padding: 0px;\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  transition: all 0.2s;\n}\n\n.modal-close-btn:hover {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.binance-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Cancel Warning */\n.cancel-warning {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: rgba(246, 70, 93, 0.1);\n  border: 1px solid rgba(246, 70, 93, 0.2);\n  border-radius: 8px;\n  margin-bottom: 24px;\n}\n\n.cancel-warning>i {\n  color: #f6465d;\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.cancel-warning p {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #eaecef;\n}\n\n.cancel-warning span {\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.4;\n}\n\n/* Cancel Reasons */\n.cancel-reasons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.reason-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #eaecef;\n  margin-bottom: 8px;\n}\n\n.reason-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.reason-option:hover {\n  border-color: #3a3f47;\n}\n\n.reason-option.selected {\n  border-color: #fcd535;\n  background: rgba(252, 213, 53, 0.05);\n}\n\n.reason-radio {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid #3a3f47;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n\n.reason-option.selected .reason-radio {\n  background: #fcd535;\n  border-color: #fcd535;\n}\n\n.reason-radio i {\n  color: #181a20;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.reason-option span {\n  font-size: 14px;\n  color: #eaecef;\n}\n\n/* Custom Reason Input */\n.custom-reason-input {\n  margin-top: 12px;\n  position: relative;\n}\n\n.custom-reason-input textarea {\n  width: 100%;\n  padding: 12px 16px;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 8px;\n  color: #eaecef;\n  font-size: 14px;\n  resize: none;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.custom-reason-input textarea:focus {\n  border-color: #fcd535;\n}\n\n.custom-reason-input textarea::placeholder {\n  color: #5e6673;\n}\n\n.custom-reason-input .char-count {\n  position: absolute;\n  bottom: 8px;\n  right: 12px;\n  font-size: 11px;\n  color: #5e6673;\n}\n\n/* Modal Footer */\n.binance-modal-footer {\n  display: flex;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid #2b3139;\n}\n\n.binance-modal-footer .binance-btn {\n  flex: 1;\n}\n\n.binance-btn.danger {\n  background: #f6465d;\n  color: #fff;\n}\n\n.binance-btn.danger:hover {\n  background: #d83a4f;\n}\n\n.binance-btn.danger:disabled {\n  background: #5e3a40;\n  color: #848e9c;\n  cursor: not-allowed;\n}\n\n.binance-btn.full-width {\n  width: 100%;\n}\n\n/* Confirm Checklist */\n.confirm-checklist {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.checklist-item {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.checklist-item i.success {\n  color: #0ecb81;\n  font-size: 20px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.checklist-item span {\n  font-size: 14px;\n  color: #eaecef;\n  line-height: 1.5;\n}\n\n.checklist-item strong {\n  color: #fcd535;\n}\n\n/* Payment Proof Section */\n.payment-proof-section {\n  margin-bottom: 20px;\n}\n\n.payment-proof-section label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #eaecef;\n  margin-bottom: 4px;\n}\n\n.payment-proof-section label .required {\n  color: #f6465d;\n  margin-left: 2px;\n}\n\n.proof-desc {\n  font-size: 12px;\n  color: #848e9c;\n  margin: 0 0 12px 0;\n}\n\n.proof-upload-area {\n  border: 2px dashed #2b3139;\n  border-radius: 8px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: center;\n}\n\n.proof-upload-area:hover {\n  border-color: #fcd535;\n  background: rgba(252, 213, 53, 0.05);\n}\n\n.upload-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: #848e9c;\n}\n\n.upload-placeholder i {\n  font-size: 36px;\n}\n\n.upload-placeholder span {\n  font-size: 13px;\n}\n\n.proof-preview {\n  position: relative;\n  display: inline-block;\n}\n\n.proof-preview img {\n  max-width: 200px;\n  max-height: 150px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.remove-proof {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  width: 24px;\n  padding: 0px;\n  height: 24px;\n  border-radius: 50%;\n  background: #f6465d;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n}\n\n/* Modal Warning */\n.modal-warning {\n  display: flex;\n  gap: 12px;\n  padding: 12px 16px;\n  background: rgba(252, 213, 53, 0.1);\n  border: 1px solid rgba(252, 213, 53, 0.2);\n  border-radius: 8px;\n}\n\n.modal-warning i {\n  color: #fcd535;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.modal-warning p {\n  margin: 0;\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.5;\n}\n\n/* Release Warning */\n.release-warning {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: #2b3139;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.release-warning>i {\n  color: #848e9c;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.release-warning p {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  color: #eaecef;\n}\n\n.release-warning span {\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.4;\n}\n\n/* Release Confirm Checkbox */\n.release-confirm-checkbox {\n  margin-top: 20px;\n}\n\n.checkbox-container {\n  display: flex;\n  gap: 12px;\n  cursor: pointer;\n  padding: 12px 16px;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.checkbox-container:hover {\n  border-color: #3a3f47;\n}\n\n.checkbox-container.checked {\n  border-color: #fcd535;\n  background: rgba(252, 213, 53, 0.05);\n}\n\n.checkbox-box {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #3a3f47;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n\n.checkbox-container.checked .checkbox-box {\n  background: #fcd535;\n  border-color: #fcd535;\n}\n\n.checkbox-box i {\n  color: #181a20;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.checkbox-container span {\n  font-size: 14px;\n  color: #eaecef;\n  line-height: 1.4;\n}\n\n.checkbox-container span strong {\n  color: #fcd535;\n}\n\n/* Mobile Modal */\n@media (max-width: 480px) {\n  .binance-modal-overlay {\n    padding: 0;\n    /* align-items: flex-end; */\n  }\n\n  .p2p-mobile-card-user-info .p2p-mobile-status-row {\n    flex-wrap: nowrap;\n  }\n\n  .binance-modal {\n    max-width: 100%;\n    max-height: 85vh;\n    border-radius: 16px 16px 0 0;\n  }\n\n  .binance-modal-header {\n    padding: 16px 20px;\n  }\n\n  .binance-modal-body {\n    padding: 20px;\n  }\n\n  .binance-modal-footer {\n    padding: 16px 20px;\n  }\n\n  .reason-option {\n    padding: 10px 14px;\n  }\n}\n\n/* Mobile Hidden */\n.mobile-hidden {\n  display: block;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .binance-order-layout {\n    grid-template-columns: 1fr 380px;\n    gap: 20px;\n  }\n\n  .p2p-buy-btn {\n    padding: 6px 12px;\n    white-space: nowrap;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .binance-mobile-tabs {\n    display: flex;\n  }\n\n  .binance-order-layout {\n    display: block;\n  }\n\n  .mobile-hidden {\n    display: none !important;\n  }\n\n  .binance-chat-card {\n    height: calc(100vh - 200px);\n    min-height: 500px;\n  }\n}\n\n@media (max-width: 768px) {\n  .binance-order-container {\n    padding: 16px;\n  }\n\n  .binance-order-details {\n    padding: 20px;\n  }\n\n  .binance-order-header {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .binance-timer {\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .binance-timer .timer-value {\n    font-size: 20px;\n  }\n\n  .binance-order-title {\n    font-size: 20px;\n  }\n\n  .binance-action-buttons {\n    flex-direction: column;\n  }\n\n  .binance-btn {\n    width: 100%;\n    text-align: center;\n  }\n\n  .binance-chat-card {\n    height: calc(100vh - 180px);\n  }\n\n  .chat-username span {\n    max-width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .order-info-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n}\n\n@media (max-width: 480px) {\n  .binance-order-container {\n    padding: 12px;\n  }\n\n  .binance-order-details {\n    padding: 16px;\n  }\n\n  .binance-order-title {\n    font-size: 18px;\n  }\n\n  .step-content h4 {\n    font-size: 14px;\n  }\n\n  .binance-payment-card {\n    padding: 16px;\n  }\n\n  .payment-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .payment-row .value {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .payment-row .value i {\n    opacity: 1;\n  }\n\n  .binance-chat-card {\n    height: calc(100vh - 160px);\n    min-height: 400px;\n  }\n\n  .emoji-picker {\n    width: 240px;\n    grid-template-columns: repeat(6, 1fr);\n    right: -40px;\n  }\n\n  .message-image img {\n    max-width: 150px;\n    max-height: 150px;\n  }\n\n  .binance-timer {\n    padding: 8px 12px;\n  }\n\n  .binance-tab {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n\n  .p2p-page-content {\n    padding: 18px;\n  }\n\n  .order-info-row .info-label {\n    font-size: 12px;\n  }\n\n  .order-info-row .info-value {\n    font-size: 12px;\n  }\n\n  .payment-row.highlight .value.amount {\n    font-size: 14px;\n  }\n\n  .binance-expired-notice {\n    padding: 8px 12px;\n    margin-top: 10px;\n  }\n\n  .step-desc {\n    font-size: 12px;\n  }\n\n  .binance-chat-input {\n    gap: 2px;\n    padding: 8px 5px;\n  }\n\n  .p2p-mobile-header {\n    padding: 10px 15px;\n    margin-bottom: 10px;\n  }\n}\n\n/* ====================================\n     LIGHT THEME OVERRIDES\n     ==================================== */\n\nbody.light_theme .p2p-layout-wrapper {\n  background-color: #fff;\n}\n\nbody.light_theme .p2p-main-content {\n  color: #000;\n}\n\nbody.light_theme .p2p-page-content {\n  color: #000;\n}\n\nbody.light_theme .p2p-mobile-header {\n  background-color: #fff;\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-hamburger {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .p2p-hamburger:hover {\n  background-color: rgba(244, 182, 9, 0.1);\n}\n\nbody.light_theme .p2p-hamburger-line {\n  background-color: #000;\n}\n\nbody.light_theme .p2p-mobile-logo-text {\n  color: #000;\n}\n\nbody.light_theme .p2p-page-title {\n  color: #333;\n}\n\nbody.light_theme .p2p-dashboard-container h2,\nbody.light_theme .p2p-dashboard-container h3,\nbody.light_theme .p2p-dashboard-container h4,\nbody.light_theme .p2p-dashboard-container .p2p-section-header,\nbody.light_theme .p2p-dashboard-container .p2p-orders-title {\n  color: #333;\n}\n\nbody.light_theme .p2p-profile-funding,\nbody.light_theme .p2p-profile-funding-label,\nbody.light_theme .p2p-profile-funding-value {\n  color: #333;\n}\n\nbody.light_theme .p2p-sidebar {\n  background: #fff;\n  border-right: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-sidebar-logo {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-logo-text {\n  color: #000;\n}\n\nbody.light_theme .p2p-logo-icon {\n  background: #f5f5f5;\n}\n\nbody.light_theme .p2p-nav-item {\n  color: #4E4E4E;\n}\n\nbody.light_theme .p2p-nav-item:hover {\n  background-color: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .p2p-nav-item.active {\n  background: #f5f5f5;\n  color: #F4B609;\n  border-left: 2px solid #F4B609;\n}\n\nbody.light_theme .p2p-nav-item.active .p2p-nav-icon {\n  color: #F4B609;\n}\n\nbody.light_theme .p2p-sidebar-close {\n  background: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .p2p-sidebar-close:hover {\n  background: rgba(244, 182, 9, 0.1);\n}\n\nbody.light_theme .p2p-sidebar-footer {\n  border-top: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-back-link {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  color: #4E4E4E;\n}\n\nbody.light_theme .p2p-back-link:hover {\n  background: #e5e5e5;\n  border-color: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .p2p-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n}\n\nbody.light_theme .p2p-sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.3);\n}\n\nbody.light_theme h4.p2p-profile-tab {\n  color: #000;\n}\n\nbody.light_theme .p2p-toggle-wrapper {\n  background: #f5f5f5;\n}\n\n/* body.light_theme .p2p-toggle-btn {\n    color: #555;\n  } */\n\nbody.light_theme .p2p-filter-label {\n  color: #555;\n}\n\n/* body.light_theme .p2p-dashboard-container button:not(.p2p-find-orders-btn):not(.p2p-buy-btn):not(.p2p-sell-btn):not(.p2p-myads-action-btn):not(.p2p-modal-btn):not(.p2p-page-btn.p2p-active) {\n    color: #333;\n    border: 1px solid #d0d0d0;\n    background-color: #f5f5f5;\n  }\n  \n  body.light_theme .p2p-dashboard-container button:not(.p2p-find-orders-btn):not(.p2p-buy-btn):not(.p2p-sell-btn):not(.p2p-myads-action-btn):not(.p2p-modal-btn):not(.p2p-page-btn.p2p-active):hover {\n    background-color: #e8e8e8;\n    border-color: #c0c0c0;\n    color: #000;\n  } */\n\nbody.light_theme .p2p-filter-select {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #000;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23666' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right;\n}\n\nbody.light_theme .p2p-filter-section.myadsfillter .p2p-filter-select {\n  background: #e2e2e2;\n  border: 1px solid #d5d5d5;\n}\n\nbody.light_theme .p2p-filter-select:focus {\n  border-color: #F4B609;\n}\n\nbody.light_theme .p2p-find-orders-btn {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-find-orders-btn:hover {\n  background: rgba(244, 182, 9, 0.1);\n  border-color: #F4B609;\n}\n\nbody.light_theme .p2p-orders-table-wrapper {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-orders-table thead {\n  background: #f5f5f5;\n}\n\nbody.light_theme .p2p-orders-table th {\n  color: #333;\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-orders-table tbody tr {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-orders-table tbody tr:hover {\n  background: rgba(244, 182, 9, 0.05);\n}\n\nbody.light_theme .p2p-advertiser-info h4 {\n  color: #000;\n}\n\nbody.light_theme .p2p-advertiser-stats {\n  color: #555;\n}\n\nbody.light_theme .p2p-rating-value {\n  color: #4E4E4E;\n}\n\nbody.light_theme .p2p-price-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-limit-label {\n  color: #555;\n}\n\nbody.light_theme .p2p-limit-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-badge {\n  background: rgba(244, 182, 9, 0.1);\n  border: 1px solid rgba(244, 182, 9, 0.2);\n  color: #000;\n}\n\nbody.light_theme .p2p-pagination-wrapper {\n  background: #f5f5f5;\n  border-top: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-pagination-info {\n  color: #555;\n}\n\nbody.light_theme .p2p-page-current {\n  color: #000;\n  background: rgba(244, 182, 9, 0.2);\n}\n\nbody.light_theme .p2p-page-btn {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #333;\n}\n\nbody.light_theme .p2p-page-btn:hover {\n  border-color: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .p2p-page-btn.p2p-active {\n  background: #F4B609;\n  border-color: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .p2p-page-dots {\n  color: #555;\n}\n\nbody.light_theme .p2p-order-action-btn {\n  color: #b8860b;\n  border-color: rgba(184, 134, 11, 0.4);\n}\n\nbody.light_theme .p2p-order-action-btn:hover {\n  color: #9a7209;\n  background: rgba(244, 182, 9, 0.1);\n}\n\nbody.light_theme .p2p-order-action-text {\n  color: #555;\n}\n\nbody.light_theme .p2p-dashboard-container a:not(.p2p-nav-item) {\n  color: #b8860b;\n}\n\nbody.light_theme .p2p-dashboard-container a:not(.p2p-nav-item):hover {\n  color: #9a7209;\n}\n\nbody.light_theme .p2p-empty-state-card {\n  color: #555;\n}\n\nbody.light_theme .p2p-expanded-content {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-expanded-user-details h5 {\n  color: #000;\n}\n\nbody.light_theme .p2p-expanded-user-details p {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-stat-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-stat-label {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-expanded-payments h6 {\n  color: #000;\n}\n\nbody.light_theme .p2p-expanded-payment-badge {\n  background: rgba(244, 182, 9, 0.1);\n  border: 1px solid rgba(244, 182, 9, 0.2);\n  color: #000;\n}\n\nbody.light_theme .p2p-expanded-remarks h6 {\n  color: #000;\n}\n\nbody.light_theme .p2p-expanded-remarks p {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-input-header {\n  border: 1px solid #e5e5e5;\n  background: #ececec;\n}\n\nbody.light_theme .p2p-input-header label {\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-selector-left {\n  color: #666;\n}\n\nbody.light_theme .p2p-create-post-fee-breakdown-box {\n  background: rgb(236 236 236);\n  border: 1px solid #2a2a3a1a;\n}\n\nbody.light_theme .p2p-create-post-fee-breakdown-row span:last-child {\n  color: #6f6f6f;\n}\n\nbody.light_theme .p2p-payment-option-full {\n  background: rgb(213 213 213 / 50%);\n}\n\nbody.light_theme .p2p-payment-option-full:hover {\n  background-color: rgb(213 213 213 / 50%);\n}\n\nbody.light_theme .p2p-user-payment-header .p2p-payment-name {\n  color: #6e6e6e;\n}\n\nbody.light_theme .p2p-payment-field-label {\n  color: #646464;\n}\n\nbody.light_theme .p2p-payment-field-value {\n  color: #848484;\n}\n\nbody.light_theme .p2p-expanded-input-wrapper {\n  border: 1px solid #e5e5e5;\n  background: #fff;\n}\n\nbody.light_theme .p2p-expanded-input-wrapper:focus-within {\n  border-color: #F4B609;\n}\n\nbody.light_theme .p2p-expanded-input-wrapper input {\n  color: #000;\n  background: transparent;\n}\n\nbody.light_theme .p2p-expanded-input-wrapper input::placeholder {\n  color: #999;\n}\n\nbody.light_theme .p2p-expanded-input-error {\n  color: #dc3545;\n}\n\nbody.light_theme .p2p-price-info {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-payment-selector-full {\n  border: 1px solid #e5e5e5;\n  background: #fff;\n}\n\nbody.light_theme .p2p-payment-selector-full:hover {\n  border-color: #F4B609;\n}\n\nbody.light_theme .p2p-cancel-btn {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-cancel-btn:hover {\n  border-color: #F4B609;\n}\n\nbody.light_theme .p2p-mobile-order-card {\n  border: 1px solid #e5e5e5;\n  background: #fff;\n}\n\nbody.light_theme .p2p-mobile-card-user-info h4 {\n  color: #000;\n}\n\nbody.light_theme .p2p-mobile-card-user-info p {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-mobile-card-price .p2p-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-mobile-card-price .p2p-currency {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-mobile-card-details {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-mobile-detail-label {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-mobile-detail-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-mobile-payment-badge {\n  background: rgba(244, 182, 9, 0.1);\n  color: #000;\n}\n\nbody.light_theme .p2p-mobile-expanded-section {\n  border-top: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-modal-content {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-modal-header {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-modal-title {\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-option {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-payment-option:hover {\n  border-color: #F4B609;\n}\n\nbody.light_theme .p2p-payment-option.p2p-selected {\n  background: rgba(244, 182, 9, 0.1);\n  border-color: #F4B609;\n}\n\nbody.light_theme .p2p-payment-option span {\n  color: #000;\n}\n\nbody.light_theme .p2p-dashboard-container {\n  color: #000;\n}\n\nbody.light_theme .p2p-profile-header {\n  background: #ececec;\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-profile-name {\n  color: #000;\n}\n\nbody.light_theme .p2p-dashboard-container.p2p-profile-container {\n  background-color: #f0f0f0;\n}\n\nbody.light_theme .p2p-myads-stat-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-myads-stat-card-label {\n  color: #555;\n}\n\nbody.light_theme .p2p-myads-stat-card-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-profile-section-desc {\n  color: #555;\n}\n\nbody.light_theme .p2p-payment-methods-grid {\n  gap: 16px;\n}\n\nbody.light_theme .p2p-payment-method-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-payment-method-title {\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-method-label {\n  color: #555;\n}\n\nbody.light_theme .p2p-payment-method-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-empty-state-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #555;\n}\n\nbody.light_theme .p2p-add-payment-modal {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-add-payment-modal-header {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-add-payment-modal-title {\n  color: #000;\n}\n\nbody.light_theme .p2p-modal-close-btn {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-modal-close-btn:hover {\n  background: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-type-item {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-type-item:hover {\n  border-color: #F4B609;\n  background: rgba(244, 182, 9, 0.05);\n}\n\nbody.light_theme .p2p-payment-type-name {\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-form-label {\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-form-input {\n  background: #f5f5f5 !important;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-form-input:focus {\n  border-color: #F4B609;\n  outline: none;\n}\n\nbody.light_theme .p2p-payment-file-label {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-file-label:hover {\n  border-color: #F4B609;\n  background: rgba(244, 182, 9, 0.05);\n}\n\nbody.light_theme .p2p-modal-btn.primary {\n  background: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .p2p-modal-btn.primary:hover {\n  background: #e5a608;\n}\n\nbody.light_theme .p2p-modal-btn.secondary {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-modal-btn.secondary:hover {\n  border-color: #F4B609;\n  background: #f5f5f5;\n}\n\nbody.light_theme .p2p-delete-modal {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-delete-modal-title {\n  color: #000;\n}\n\nbody.light_theme .p2p-delete-modal-desc {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-modal-btn.danger {\n  background: #dc3545;\n  color: #fff;\n}\n\nbody.light_theme .p2p-myads-action-btn {\n  background: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .p2p-myads-action-btn:hover {\n  background: #e5a608;\n}\n\nbody.light_theme .p2p-order-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-order-card-title {\n  color: #000;\n}\n\nbody.light_theme .p2p-order-summary-item {\n  background: #f5f5f5;\n}\n\nbody.light_theme .p2p-summary-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-summary-label {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-payment-detail-card {\n  background: #f5f5f5;\n}\n\nbody.light_theme .p2p-payment-detail-header {\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-detail-value {\n  color: #000;\n}\n\nbody.light_theme .binance-modal {\n  background: #fff;\n}\n\nbody.light_theme .binance-modal-header {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .binance-modal-header h3 {\n  color: #000;\n}\n\nbody.light_theme .modal-close-btn {\n  color: #aaa;\n}\n\nbody.light_theme .modal-close-btn:hover {\n  background: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .binance-order-info {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .info-label {\n  color: #aaa;\n}\n\nbody.light_theme .info-value {\n  color: #000;\n}\n\nbody.light_theme .payment-row {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .payment-row .label {\n  color: #aaa;\n}\n\nbody.light_theme .payment-row .value {\n  color: #000;\n}\n\nbody.light_theme .binance-chat-container {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .binance-chat-header {\n  background: #f5f5f5;\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .binance-chat-header h4 {\n  color: #000;\n}\n\nbody.light_theme .binance-message {\n  background: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .binance-message.own {\n  background: rgba(244, 182, 9, 0.1);\n}\n\nbody.light_theme .binance-chat-input {\n  background: #ececec;\n  border-top: 1px solid #e5e5e5;\n}\n\nbody.light_theme .binance-chat-section.mobile-hidden .binance-chat-input input {\n  background: #f5f5f500;\n  border: 1px solid #e5e5e500;\n}\n\nbody.light_theme .binance-chat-input input {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .binance-chat-input input::placeholder {\n  color: #999;\n}\n\nbody.light_theme .binance-btn.primary {\n  background: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .binance-btn.primary:hover {\n  background: #e5a608;\n}\n\nbody.light_theme .chat-username {\n  color: #636363;\n}\n\nbody.light_theme .system-bubble {\n  background: rgb(222 222 222);\n}\n\nbody.light_theme .cancel-warning {\n  background: rgba(220, 53, 69, 0.1);\n  border: 1px solid rgba(220, 53, 69, 0.2);\n}\n\nbody.light_theme .cancel-warning p {\n  color: #000;\n}\n\nbody.light_theme .cancel-warning span {\n  color: #aaa;\n}\n\nbody.light_theme .appeal-info {\n  background: rgba(244, 182, 9, 0.1);\n  border: 1px solid rgba(244, 182, 9, 0.2);\n}\n\nbody.light_theme .appeal-info p {\n  color: #000;\n}\n\nbody.light_theme .appeal-form label {\n  color: #000;\n}\n\nbody.light_theme .appeal-textarea {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .appeal-textarea::placeholder {\n  color: #999;\n}\n\nbody.light_theme .binance-tab {\n  color: #aaa;\n}\n\nbody.light_theme .binance-tab.active {\n  color: #F4B609;\n  border-bottom-color: #F4B609;\n}\n\nbody.light_theme .step-desc {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-loading-container {\n  color: #aaa;\n}\n\n/* P2P Create Post Styles */\n.p2p-create-post-container {\n  display: grid;\n  grid-template-columns: 1fr 200px;\n  gap: 24px;\n  max-width: 100%;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 1023px) {\n  .p2p-create-post-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-container {\n    gap: 16px;\n  }\n}\n\n.p2p-create-post-form-card {\n  background: #2B313C;\n  border-radius: 12px;\n  border: 1px solid #2B313C;\n  padding: 32px;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  position: relative;\n  border-radius: 12px;\n  padding: 32px;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  position: relative;\n}\n\n@media (max-width: 1023px) {\n  .p2p-create-post-form-card {\n    padding: 24px;\n  }\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-form-card {\n    border-radius: 12px;\n    padding: 16px;\n  }\n}\n\n.p2p-create-post-header {\n  margin-bottom: 32px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-header {\n    margin-bottom: 20px;\n  }\n}\n\n.p2p-create-post-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0 0 8px 0;\n}\n\n\n\n.p2p-create-post-subtitle {\n  color: #949AA4;\n  font-size: 14px;\n  margin: 0;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-subtitle {\n    font-size: 12px;\n  }\n}\n\n.p2p-create-post-stepper {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  margin-bottom: 32px;\n  gap: 0;\n  width: 100%;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-stepper {\n    margin-bottom: 20px;\n  }\n}\n\n.p2p-create-post-step-circle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  font-weight: 400;\n  background: transparent;\n  border: 1px solid #ffffff60;\n  color: #ffffff60;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-step-circle {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n}\n\n.p2p-create-post-step-circle.active {\n  background: #F3BB2B;\n  border-color: #F3BB2B;\n  color: #000;\n}\n\n.p2p-create-post-step-circle.completed {\n  background: #F3BB2B;\n  border-color: #F3BB2B;\n  color: #000;\n}\n\n.p2p-create-post-step-line {\n  width: 310px;\n  height: 1px;\n  background: #ffffff60;\n  transition: all 0.3s ease;\n}\n\n@media (max-width: 1023px) {\n  .p2p-create-post-step-line {\n    width: 80px;\n  }\n}\n\n@media (max-width: 480px) {\n  .p2p-create-post-step-line {\n    width: 60px;\n  }\n}\n\n.p2p-create-post-step-line.completed {\n  background: #F3BB2B;\n}\n\n.p2p-create-post-section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-section-title {\n    font-size: 14px;\n    margin-bottom: 16px;\n  }\n\n  .p2p-nav-item {\n    gap: 10px;\n    padding: 10px 12px 10px 20px;\n    font-size: 13px;\n  }\n\n\n\n  .pricehigh_box_item_title {\n    font-size: 18px;\n  }\n\n  .pricehigh_box_item_title span {\n    font-size: 10px;\n  }\n\n}\n\n.p2p-create-post-section-icon {\n  color: #ffdc88;\n}\n\n/* Buy/Sell tabs - Create Post */\n.p2p-create-post-tabs-container {\n  display: flex;\n  gap: 0;\n  margin-bottom: 32px;\n  border-bottom: 1px solid #2a2a3a;\n}\n\n.p2p-create-post-tab-btn {\n  background: transparent;\n  border: none;\n  color: #888;\n  font-size: 16px;\n  font-weight: 400;\n  padding: 14px 20px;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s ease;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n}\n\n.p2p-create-post-tab-btn.active {\n  color: #fff;\n  font-weight: 500;\n  border-bottom: 2px solid #fff;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-tabs-container {\n    margin-bottom: 24px;\n  }\n\n  .p2p-create-post-tab-btn {\n    font-size: 14px;\n    padding: 12px 16px;\n  }\n}\n\n/* Market price info box (USDT/INR block) - Create Post */\n.p2p-create-post-info-box {\n  background: #373f4d;\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 16px;\n}\n\n.p2p-create-post-market-loading {\n  text-align: center;\n  padding: 10px;\n}\n\n.p2p-create-post-market-loading span {\n  color: #666;\n}\n\n.p2p-create-post-market-pair {\n  color: #9ca3af;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.p2p-create-post-market-row {\n  color: #6b7280;\n  font-size: 13px;\n  margin-bottom: 6px;\n}\n\n.p2p-create-post-market-row:last-child {\n  margin-bottom: 0;\n}\n\n.p2p-create-post-market-bullet {\n  margin-right: 6px;\n}\n\n.p2p-create-post-market-error {\n  color: #d97706;\n  font-size: 13px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-info-box {\n    padding: 12px;\n  }\n\n  .p2p-create-post-market-pair {\n    font-size: 13px;\n  }\n\n  .p2p-create-post-market-row {\n    font-size: 12px;\n  }\n}\n\n/* Section spacing (steps) */\n.p2p-create-post-section-spacing {\n  margin-top: 32px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-section-spacing {\n    margin-top: 24px;\n  }\n}\n\n.p2p-create-post-field-error-with-margin {\n  margin-top: -12px;\n  margin-bottom: 12px;\n}\n\n.p2p-create-post-select-with-icon {\n  padding-left: 36px;\n}\n\n.p2p-create-post-section-title-inline {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 20px;\n}\n\n.p2p-create-post-section-icon-inline {\n  color: #F3BB2B;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-section-title-inline {\n    font-size: 14px;\n    margin-bottom: 16px;\n  }\n}\n\n.p2p-create-post-payment-required-error {\n  color: #ef4444;\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: 8px;\n}\n\n.p2p-create-post-checkbox {\n  width: 20px;\n  height: 20px;\n  accent-color: #ffdc88;\n  flex-shrink: 0;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-checkbox {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n/* Preview Card */\n.p2p-preview-card {\n  background: #12121a;\n  border-radius: 16px;\n  border: 1px solid #1e1e2d;\n  position: sticky;\n  top: 20px;\n}\n\n@media (max-width: 991px) {\n  .p2p-preview-card {\n    position: relative;\n    top: 0;\n  }\n}\n\n@media (max-width: 767px) {\n  .p2p-preview-card {\n    border-radius: 12px;\n  }\n}\n\n.p2p-preview-card-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n.p2p-preview-card-header-buy {\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.05) 100%);\n}\n\n.p2p-preview-card-header-sell {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.05) 100%);\n}\n\n@media (max-width: 767px) {\n  .p2p-preview-card-header {\n    padding: 16px;\n  }\n}\n\n.p2p-preview-card-header-inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.p2p-preview-card-ad-label {\n  color: #888;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.p2p-preview-card-title {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n@media (max-width: 767px) {\n  .p2p-preview-card-title {\n    font-size: 18px;\n  }\n}\n\n.p2p-preview-card-badge {\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.p2p-preview-card-badge-buy {\n  color: #22c55e;\n  background: rgba(34, 197, 94, 0.2);\n}\n\n.p2p-preview-card-badge-sell {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.2);\n}\n\n.p2p-preview-card-price-block {\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n  text-align: center;\n}\n\n@media (max-width: 767px) {\n  .p2p-preview-card-price-block {\n    padding: 16px;\n  }\n}\n\n.p2p-preview-card-price-label {\n  color: #666;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.p2p-preview-card-price-value {\n  font-size: 32px;\n  font-weight: 700;\n  letter-spacing: -1px;\n}\n\n.p2p-preview-card-price-value-buy {\n  color: #22c55e;\n}\n\n.p2p-preview-card-price-value-sell {\n  color: #ef4444;\n}\n\n@media (max-width: 767px) {\n  .p2p-preview-card-price-value {\n    font-size: 28px;\n  }\n}\n\n.p2p-preview-card-price-fiat {\n  font-size: 16px;\n  color: #888;\n}\n\n.p2p-preview-card-market {\n  color: #666;\n  font-size: 11px;\n  margin-top: 4px;\n  display: block;\n}\n\n.p2p-preview-card-details {\n  padding: 20px 24px;\n}\n\n@media (max-width: 767px) {\n  .p2p-preview-card-details {\n    padding: 16px;\n  }\n}\n\n.p2p-preview-card-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.p2p-preview-card-grid-item {\n  background: #0d0d14;\n  padding: 12px;\n  border-radius: 10px;\n}\n\n.p2p-preview-card-grid-label {\n  color: #666;\n  font-size: 11px;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.p2p-preview-card-grid-value {\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.p2p-preview-card-grid-value-muted {\n  color: #888;\n  font-size: 12px;\n}\n\n.p2p-preview-card-payment-time {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  background: #0d0d14;\n  border-radius: 10px;\n  margin-bottom: 16px;\n}\n\n.p2p-preview-card-payment-time-label {\n  color: #666;\n  font-size: 13px;\n}\n\n.p2p-preview-card-payment-time-value {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.p2p-preview-card-block {\n  margin-bottom: 16px;\n}\n\n.p2p-preview-card-section-label {\n  color: #666;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.p2p-preview-card-badges-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.p2p-preview-card-badge-pm {\n  padding: 6px 12px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.3);\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.p2p-preview-card-empty-pm {\n  color: #666;\n  font-size: 12px;\n  padding: 6px 12px;\n  background: #0d0d14;\n  border-radius: 6px;\n  border: 1px dashed #2a2a3a;\n}\n\n.p2p-preview-card-badge-kyc {\n  padding: 6px 12px;\n  background: rgba(34, 197, 94, 0.1);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  border-radius: 6px;\n  color: #4ade80;\n  font-size: 12px;\n}\n\n.p2p-preview-card-badge-days {\n  padding: 6px 12px;\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 6px;\n  color: #fbbf24;\n  font-size: 12px;\n}\n\n.p2p-preview-card-remarks {\n  padding: 12px;\n  background: #0d0d14;\n  border-radius: 10px;\n  border-left: 3px solid #ffdc88;\n}\n\n.p2p-preview-card-remarks-title {\n  color: #666;\n  font-size: 11px;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.p2p-preview-card-remarks-text {\n  color: #aaa;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.p2p-preview-card-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #1e1e2d;\n  background: #0a0a0f;\n}\n\n@media (max-width: 767px) {\n  .p2p-preview-card-footer {\n    padding: 16px;\n  }\n}\n\n.p2p-preview-card-footer-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.p2p-preview-card-footer-fee {\n  color: #666;\n  font-size: 11px;\n}\n\n.p2p-preview-card-footer-note {\n  color: #888;\n  font-size: 11px;\n}\n\n.p2p-mobile-preview-toggle {\n  display: none;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #0d0d14;\n  border-radius: 10px;\n  margin-bottom: 16px;\n  cursor: pointer;\n  border: 1px solid #2a2a3a;\n}\n\n@media (max-width: 991px) {\n  .p2p-mobile-preview-toggle {\n    display: flex;\n  }\n}\n\n.p2p-mobile-preview-toggle-text {\n  color: #888;\n  font-size: 14px;\n}\n\n.p2p-preview-highlight-buy {\n  color: #22c55e;\n  font-weight: 600;\n}\n\n.p2p-preview-highlight-sell {\n  color: #ef4444;\n  font-weight: 600;\n}\n\n.p2p-mobile-preview-view {\n  color: #ffdc88;\n  font-size: 14px;\n}\n\n.p2p-create-post-mobile-preview-wrap {\n  margin-bottom: 16px;\n}\n\n/* Sell modal (Add Payment Method) */\n.p2p-sell-modal .modal-content {\n  background: #12121a;\n  border: 1px solid #2a2a3a;\n  border-radius: 16px;\n}\n\n.p2p-sell-modal .modal-header {\n  border-bottom: 1px solid #2a2a3a;\n  padding: 20px 24px;\n}\n\n.p2p-sell-modal .modal-header .modal-title {\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.p2p-sell-modal .modal-body {\n  padding: 24px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.p2p-sell-modal-tips {\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 10px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.p2p-sell-modal-tips-icon {\n  color: #f59e0b;\n}\n\n.p2p-sell-modal-tips-text {\n  color: #d4a574;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.p2p-sell-modal-label {\n  color: #888;\n  font-size: 13px;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.p2p-sell-modal-spinner-wrap {\n  text-align: center;\n  padding: 20px;\n}\n\n.p2p-sell-modal-methods-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n@media (max-width: 767px) {\n  .p2p-sell-modal-methods-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.p2p-sell-modal-method-card {\n  padding: 14px 16px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.p2p-sell-modal-method-card:hover {\n  border-color: #ffdc88;\n}\n\n.p2p-sell-modal-method-card.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.p2p-sell-modal-method-name {\n  color: #fff;\n  font-size: 14px;\n}\n\n.p2p-sell-modal-method-badge {\n  background: rgba(34, 197, 94, 0.1);\n  color: #22c55e;\n  font-size: 10px;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.p2p-sell-modal-back-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #2a2a3a;\n}\n\n.p2p-sell-modal-back-btn {\n  background: transparent;\n  border: none;\n  color: #888;\n  cursor: pointer;\n  padding: 4px;\n}\n\n.p2p-sell-modal-back-title {\n  color: #ffdc88;\n  font-weight: 600;\n}\n\n.p2p-sell-modal-kyc-warning {\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 10px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  color: #d4a574;\n  font-size: 13px;\n}\n\n.p2p-sell-modal-input-wrap {\n  margin-bottom: 16px;\n}\n\n.p2p-sell-modal-input {\n  width: 100%;\n  padding: 12px 16px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n}\n\n.p2p-sell-modal-input.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.p2p-sell-modal-input-bg {\n  width: 100%;\n  padding: 12px 16px;\n  background: #1a1a2e;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.p2p-sell-modal-small {\n  color: #666;\n  font-size: 11px;\n  margin-top: 4px;\n  display: block;\n}\n\n.p2p-sell-modal-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.p2p-sell-modal-file-zone {\n  border: 2px dashed #2a2a3a;\n  border-radius: 10px;\n  padding: 20px;\n  text-align: center;\n  cursor: pointer;\n  position: relative;\n}\n\n.p2p-sell-modal-file-zone.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.p2p-sell-modal-file-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.p2p-sell-modal-file-zone.disabled .p2p-sell-modal-file-input {\n  cursor: not-allowed;\n}\n\n.p2p-sell-modal-file-preview {\n  max-width: 100px;\n  max-height: 100px;\n  border-radius: 8px;\n}\n\n.p2p-sell-modal-file-placeholder-icon {\n  color: #666;\n  font-size: 24px;\n  margin-bottom: 8px;\n}\n\n.p2p-sell-modal-file-placeholder-text {\n  color: #888;\n  font-size: 13px;\n}\n\n.p2p-sell-modal-warning-box {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 10px;\n  padding: 12px 16px;\n  margin-top: 8px;\n}\n\n.p2p-sell-modal-warning-text {\n  color: #f87171;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.p2p-sell-modal-label-optional {\n  color: #666;\n}\n\n.p2p-sell-modal-label-required {\n  color: #ef4444;\n}\n\n.p2p-sell-modal-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.p2p-sell-modal-btn-cancel {\n  flex: 1;\n  padding: 12px 20px;\n  background: transparent;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.p2p-sell-modal-btn-confirm {\n  flex: 1;\n  padding: 12px 20px;\n  background: #ffdc88;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.p2p-sell-modal-btn-confirm:disabled,\n.p2p-sell-modal-btn-confirm.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.p2p-sell-modal-spinner-lg {\n  text-align: center;\n  padding: 40px;\n}\n\n.p2p-buyer-modal-desc {\n  color: #888;\n  margin-bottom: 20px;\n}\n\n.p2p-buyer-modal-spinner-wrap {\n  text-align: center;\n  padding: 20px;\n}\n\n.p2p-confirm-post-fee {\n  color: #F3BB2B;\n}\n\n.p2p-create-post-input-group {\n  margin-bottom: 10px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-input-group {\n    margin-bottom: 10px;\n  }\n}\n\n.p2p-create-post-label {\n  display: block;\n  color: #A2A9B6;\n  font-size: 13px;\n  margin-bottom: 5px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-label {\n    font-size: 12px;\n  }\n}\n\n.p2p-create-post-select-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.p2p-create-post-select-wrap .p2p-create-post-select-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.p2p-create-post-select-wrap .p2p-create-post-select-icon img {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.p2p-create-post-select-wrap .p2p-create-post-select-icon-fiat {\n  font-size: 16px;\n  font-weight: 600;\n  color: #F3BB2B;\n}\n\n.p2p-create-post-select {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 12px 44px 12px 36px;\n  background: #373F4D;\n  border: 1px solid #373F4D;\n  border-radius: 10px;\n  color: #A2A9B6;\n  font-size: 13px;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23888' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 16px center;\n  background-size: 12px 12px;\n  box-sizing: border-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-select {\n    padding: 12px 40px 12px 14px;\n    font-size: 13px;\n    background-position: right 12px center;\n  }\n}\n\n.p2p-create-post-select.error {\n  border: 1px solid #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.p2p-create-post-input {\n  width: 100%;\n  padding: 14px 16px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-input {\n    padding: 12px 14px;\n    font-size: 13px;\n  }\n}\n\n.p2p-create-post-input.error {\n  border: 1px solid #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.p2p-create-post-input-with-suffix {\n  display: flex;\n  align-items: center;\n  background: #373F4D;\n  border: 1px solid #373F4D;\n  border-radius: 10px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.p2p-create-post-input-with-suffix.error {\n  border: 1px solid #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.p2p-create-post-input-inner {\n  flex: 1;\n  padding: 14px 16px;\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  min-width: 0;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-input-inner {\n    padding: 12px 14px;\n    font-size: 13px;\n  }\n}\n\n.pricehigh_box {\n  width: 100%;\n  background-color: #373D4B;\n  padding: 24px;\n  border-radius: 12px;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  justify-content: space-between;\n}\n\n.pricehigh_box_item_title {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.pricehigh_box_item_container {\n  gap: 90px;\n}\n\n.helpguide {\n  font-size: 12px;\n}\n\n.helpguide i {\n  font-size: 16px;\n}\n\n.btnnextback {\n  margin-top: 24px;\n  gap: 24px;\n}\n\n.btnnextback button {\n  font-size: 16px;\n  color: #fff;\n  padding: 16px 20px;\n  width: 100%;\n  border-radius: 4px;\n  border: none;\n  background-color: #3C424C;\n  font-weight: 500;\n}\n\n.btnnextback button.nextbtn {\n  background-color: #5EBA89;\n}\n\n.btnnextback button.backbtn {\n  width: 40%;\n}\n\n.pricehigh_box_item_title span {\n  font-size: 12px;\n  font-weight: 300;\n}\n\n.p2p-create-post-input-suffix {\n  padding: 14px 16px;\n  color: #b9b9b9;\n  font-size: 14px;\n  border-left: 1px solid #585858;\n  white-space: nowrap;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-input-suffix {\n    padding: 12px 10px;\n    font-size: 12px;\n  }\n}\n\n.p2p-create-post-available-text {\n  color: #22c55e;\n  font-size: 12px;\n  margin-left: 8px;\n  margin-right: 8px;\n  display: inline;\n}\n\n.p2p-create-post-tab-btn:hover {\n  background-color: transparent;\n}\n\nbody.light_theme .p2p-create-post-tab-btn.active {\n  color: #5a5a5a;\n  border-bottom: 2px solid #676464;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-available-text {\n    font-size: 10px;\n    display: none;\n  }\n}\n\n.p2p-create-post-fee-box {\n  background: linear-gradient(90deg, rgba(34, 197, 94, 0.1) 0%, transparent 100%);\n  border: 1px solid rgba(34, 197, 94, 0.2);\n  border-radius: 10px;\n  padding: 12px 16px;\n  color: #22c55e;\n  font-size: 14px;\n  margin-top: 20px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-fee-box {\n    padding: 10px 14px;\n    font-size: 13px;\n    margin-top: 16px;\n  }\n}\n\n.p2p-create-post-info-box {\n  background: #0d0d14;\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 16px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-info-box {\n    padding: 12px;\n  }\n}\n\n.p2p-create-post-pair-text {\n  color: #f59e0b;\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-pair-text {\n    font-size: 14px;\n  }\n}\n\n.p2p-create-post-info-text {\n  color: #a8b4c4;\n  font-size: 13px;\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-info-text {\n    font-size: 12px;\n  }\n}\n\n.p2p-create-post-payment-method {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-payment-method {\n    padding: 12px 14px;\n  }\n}\n\n.p2p-create-post-payment-method.active {\n  border-color: #ffdc88;\n  background: rgba(255, 220, 136, 0.1);\n}\n\n.p2p-create-post-payment-method.error {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.p2p-create-post-checkbox {\n  width: 20px;\n  height: 20px;\n  accent-color: #ffdc88;\n  flex-shrink: 0;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-checkbox {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.p2p-create-post-add-method-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #ffdc88;\n  background: transparent;\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 8px 0;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-add-method-btn {\n    font-size: 13px;\n  }\n}\n\n.p2p-create-post-textarea {\n  width: 100%;\n  padding: 14px 16px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  min-height: 100px;\n  resize: vertical;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-textarea {\n    padding: 12px 14px;\n    font-size: 13px;\n    min-height: 80px;\n  }\n}\n\n.p2p-create-post-checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  color: #ccc;\n  font-size: 14px;\n  cursor: pointer;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-checkbox-label {\n    font-size: 13px;\n  }\n}\n\n.p2p-create-post-button-group {\n  display: flex;\n  gap: 12px;\n  margin-top: 32px;\n  flex-direction: row;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-button-group {\n    margin-top: 24px;\n    flex-direction: column-reverse;\n  }\n}\n\n.p2p-create-post-btn-primary {\n  flex: 1;\n  padding: 14px 24px;\n  background: #22c55e;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: auto;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-btn-primary {\n    flex: unset;\n    padding: 14px 20px;\n    font-size: 14px;\n    width: 100%;\n  }\n}\n\n.p2p-create-post-btn-secondary {\n  padding: 14px 24px;\n  background: transparent;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: auto;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-btn-secondary {\n    padding: 14px 20px;\n    font-size: 14px;\n    width: 100%;\n  }\n}\n\n.p2p-create-post-preview-card {\n  background: #12121a;\n  border-radius: 16px;\n  border: 1px solid #1e1e2d;\n  position: sticky;\n  top: 20px;\n}\n\n@media (max-width: 1023px) {\n  .p2p-create-post-preview-card {\n    position: relative;\n    top: 0;\n  }\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-card {\n    border-radius: 12px;\n  }\n}\n\n.p2p-create-post-preview-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-header {\n    padding: 16px;\n  }\n}\n\n.p2p-create-post-preview-title {\n  font-size: 16px;\n  color: #888;\n  margin: 0;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-title {\n    font-size: 14px;\n  }\n}\n\n.p2p-create-post-preview-highlight {\n  font-weight: 600;\n}\n\n.p2p-create-post-preview-highlight.buy {\n  color: #22c55e;\n}\n\n.p2p-create-post-preview-highlight.sell {\n  color: #ef4444;\n}\n\n.p2p-create-post-preview-body {\n  padding: 24px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-body {\n    padding: 16px;\n  }\n}\n\n.p2p-create-post-preview-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-row {\n    margin-bottom: 12px;\n  }\n}\n\n.p2p-create-post-preview-label {\n  color: #aaa;\n  font-size: 14px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-label {\n    font-size: 13px;\n  }\n}\n\n.p2p-create-post-preview-value {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: right;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-value {\n    font-size: 13px;\n  }\n}\n\n.p2p-create-post-preview-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.p2p-create-post-preview-badge {\n  padding: 6px 12px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.3);\n  border-radius: 6px;\n  color: #a8b4c4;\n  font-size: 12px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-badge {\n    padding: 4px 10px;\n    font-size: 11px;\n  }\n}\n\n.p2p-create-post-preview-remarks {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #1e1e2d;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-remarks {\n    margin-top: 16px;\n    padding-top: 16px;\n  }\n}\n\n.p2p-create-post-preview-remarks-title {\n  color: #888;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-remarks-title {\n    font-size: 12px;\n  }\n\n  .pricehigh_box_item_container {\n    gap: 24px;\n  }\n\n}\n\n.p2p-create-post-preview-remarks-text {\n  color: #ccc;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-remarks-text {\n    font-size: 12px;\n  }\n}\n\n.p2p-create-post-agreement-box {\n  background: #0d0d14;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  transition: all 0.2s ease;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-agreement-box {\n    padding: 12px;\n  }\n}\n\n.p2p-create-post-agreement-box.error {\n  background: rgba(239, 68, 68, 0.05);\n  border: 1px solid #ef4444;\n}\n\n.p2p-create-post-helper-text {\n  color: #949AA4;\n  font-size: 12px;\n  margin-top: 6px;\n}\n\n.p2p-create-post-fee-total-box {\n  margin-top: 6px;\n}\n\n.p2p-create-post-fee-total-box .p2p-create-post-helper-text {\n  margin-top: 4px;\n}\n\n.p2p-create-post-fee-breakdown-box {\n  margin-top: 12px;\n  background: rgba(42, 42, 58, 0.5);\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  padding: 12px 14px;\n  max-width: 320px;\n}\n\n.p2p-create-post-fee-breakdown-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n  color: #949AA4;\n  padding: 4px 0;\n}\n\n.p2p-create-post-fee-breakdown-row span:last-child {\n  color: #fff;\n  font-weight: 500;\n}\n\n.p2p-create-post-fee-breakdown-total {\n  margin-top: 6px;\n  padding-top: 8px;\n  border-top: 1px solid #2a2a3a;\n  color: #F3BB2B;\n  font-weight: 500;\n}\n\n.p2p-create-post-fee-breakdown-total span:last-child {\n  color: #F3BB2B;\n}\n\n.p2p-create-post-fee-breakdown-box .p2p-create-post-insufficient-funds {\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.p2p-create-post-total-required {\n  color: #F3BB2B;\n  font-weight: 500;\n}\n\n.p2p-create-post-insufficient-funds {\n  color: #ef4444;\n  font-size: 12px;\n  font-weight: 500;\n  margin-top: 8px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-fee-breakdown-box {\n    padding: 10px 12px;\n    margin-top: 10px;\n  }\n\n  .p2p-create-post-fee-breakdown-row {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-helper-text {\n    font-size: 11px;\n  }\n}\n\n.p2p-create-post-mobile-preview-toggle {\n  display: none;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #0d0d14;\n  border-radius: 10px;\n  margin-bottom: 16px;\n  cursor: pointer;\n  border: 1px solid #2a2a3a;\n}\n\n@media (max-width: 1023px) {\n  .p2p-create-post-mobile-preview-toggle {\n    display: flex;\n  }\n}\n\n.p2p-create-post-grid-two-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-grid-two-col {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n}\n\n.p2p-create-post-payment-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-payment-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n}\n\n.p2p-create-post-field-error {\n  color: #ef4444;\n  font-size: 12px;\n  margin-top: 6px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-field-error {\n    font-size: 11px;\n  }\n}\n\n.p2p-create-post-preview-header-gradient {\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-header-gradient {\n    padding: 16px;\n  }\n}\n\n.p2p-create-post-preview-header-gradient.buy {\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.05) 100%);\n}\n\n.p2p-create-post-preview-header-gradient.sell {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.05) 100%);\n}\n\n.p2p-create-post-preview-price-section {\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n  text-align: center;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-price-section {\n    padding: 16px;\n  }\n}\n\n.p2p-create-post-preview-price-label {\n  color: #aaa;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.p2p-create-post-preview-price-value {\n  font-size: 32px;\n  font-weight: 700;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-price-value {\n    font-size: 28px;\n  }\n}\n\n.p2p-create-post-preview-price-value.buy {\n  color: #22c55e;\n}\n\n.p2p-create-post-preview-price-value.sell {\n  color: #ef4444;\n}\n\n.p2p-create-post-preview-price-currency {\n  font-size: 16px;\n  color: #888;\n}\n\n.p2p-create-post-preview-market-price {\n  color: #aaa;\n  font-size: 11px;\n  margin-top: 4px;\n  display: block;\n}\n\n.p2p-create-post-preview-stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  padding: 20px 24px;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-stats-grid {\n    padding: 16px;\n  }\n}\n\n.p2p-create-post-preview-stat-box {\n  background: #0d0d14;\n  padding: 12px;\n  border-radius: 10px;\n}\n\n.p2p-create-post-preview-stat-label {\n  color: #aaa;\n  font-size: 11px;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.p2p-create-post-preview-stat-value {\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-stat-value {\n    font-size: 15px;\n  }\n}\n\n.p2p-create-post-preview-stat-currency {\n  color: #888;\n  font-size: 12px;\n}\n\n.p2p-create-post-preview-payment-time {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-payment-time {\n    padding: 16px;\n  }\n}\n\n.p2p-create-post-preview-payment-time-label {\n  color: #aaa;\n  font-size: 13px;\n}\n\n.p2p-create-post-preview-payment-time-value {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.p2p-create-post-preview-payment-methods {\n  margin-bottom: 16px;\n}\n\n.p2p-create-post-preview-payment-methods-label {\n  color: #aaa;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.p2p-create-post-preview-payment-methods-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.p2p-create-post-preview-payment-method-badge {\n  padding: 6px 12px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.3);\n  border-radius: 6px;\n  color: #a8b4c4;\n  font-size: 12px;\n}\n\n.p2p-create-post-preview-payment-methods-empty {\n  color: #aaa;\n  font-size: 12px;\n  padding: 6px 12px;\n}\n\n.p2p-create-post-preview-counterparty-label {\n  color: #aaa;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.p2p-create-post-preview-counterparty-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.p2p-create-post-preview-counterparty-badge {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.p2p-create-post-preview-counterparty-badge.kyc {\n  background: rgba(34, 197, 94, 0.1);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  color: #22c55e;\n}\n\n.p2p-create-post-preview-counterparty-badge.registered {\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  color: #f59e0b;\n}\n\n.p2p-create-post-preview-remarks-box {\n  padding: 12px;\n  background: #0d0d14;\n  border-radius: 10px;\n}\n\n.p2p-create-post-preview-remarks-label {\n  color: #aaa;\n  font-size: 11px;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.p2p-create-post-preview-remarks-content {\n  color: #aaa;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.p2p-create-post-preview-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #1e1e2d;\n  background: #0a0a0f;\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-preview-footer {\n    padding: 16px;\n  }\n}\n\n.p2p-create-post-preview-footer-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.p2p-create-post-preview-footer-fee {\n  color: #aaa;\n  font-size: 11px;\n}\n\n.p2p-create-post-preview-footer-available {\n  color: #888;\n  font-size: 11px;\n}\n\n/* Radio Button Styles */\n.p2p-radio-group {\n  margin-top: 8px;\n}\n\n.p2p-radio-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n}\n\n.p2p-radio-input {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 20px;\n  height: 20px;\n  border: 5px solid #aaa;\n  border-radius: 50%;\n  margin: 0;\n  margin-right: 12px;\n  position: relative;\n  cursor: pointer;\n  background-color: transparent;\n  transition: all 0.2s ease;\n}\n\n.p2p-radio-input:checked {\n  border-color: #D9D9D9;\n  background-color: transparent;\n}\n\n.p2p-radio-input:checked::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #222;\n}\n\n.p2p-radio-input:hover {\n  border-color: #999;\n}\n\n.p2p-radio-input:checked:hover {\n  border-color: #fff;\n}\n\n.p2p-radio-text {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n/* Light Theme Radio Button */\nbody.light_theme .p2p-radio-input {\n  border-color: #ccc;\n}\n\nbody.light_theme .p2p-radio-input:checked {\n  border-color: #333;\n}\n\nbody.light_theme .p2p-radio-input:checked::after {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .p2p-radio-input:hover {\n  border-color: #999;\n}\n\nbody.light_theme .p2p-radio-input:checked:hover {\n  border-color: #333;\n}\n\nbody.light_theme .p2p-radio-text {\n  color: #333;\n}\n\n/* Payment Method Styles */\n.p2p-payment-methods-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.p2p-payment-method-card {\n  background: #373f4d;\n  border: 1px solid #373f4d;\n  border-radius: 10px;\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n@media (min-width: 768px) {\n  .p2p-payment-method-card {\n    padding: 16px;\n  }\n}\n\n.p2p-payment-method-card.selected {\n  border-color: #ffdc88;\n  background: rgba(255, 220, 136, 0.1);\n}\n\n.p2p-payment-method-card.error {\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n.p2p-payment-method-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.p2p-payment-method-header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-payment-method-name {\n  color: #ffdc88;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n@media (min-width: 768px) {\n  .p2p-payment-method-name {\n    font-size: 15px;\n  }\n}\n\n.p2p-payment-method-type-badge {\n  color: #aaa;\n  font-size: 11px;\n  background: #373f4d;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.p2p-payment-method-fields-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n}\n\n@media (min-width: 768px) {\n  .p2p-payment-method-fields-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.p2p-payment-method-field {\n  font-size: 12px;\n}\n\n.p2p-payment-method-field-label {\n  color: #aaa;\n}\n\n.p2p-payment-method-field-value {\n  color: #aaa;\n}\n\n.p2p-payment-method-qr-section {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #2a2a3a40;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-payment-method-qr-image {\n  width: 60px;\n  height: 60px;\n  object-fit: contain;\n  border-radius: 8px;\n  background: #fff;\n  padding: 4px;\n}\n\n@media (min-width: 768px) {\n  .p2p-payment-method-qr-image {\n    width: 80px;\n    height: 80px;\n  }\n}\n\n.p2p-payment-method-qr-label {\n  color: #aaa;\n  font-size: 11px;\n}\n\n.p2p-payment-methods-empty {\n  color: #888;\n  font-size: 13px;\n  padding: 20px;\n  text-align: center;\n  background: #373f4d;\n  border-radius: 10px;\n  border: 1px solid #373f4d;\n}\n\n.p2p-payment-methods-empty.error {\n  border-color: #ef4444;\n}\n\n.p2p-payment-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.p2p-payment-method-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  background: #373F4D;\n  border: 1px solid #373F4D;\n  border-radius: 10px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n@media (min-width: 768px) {\n  .p2p-payment-method-item {\n    padding: 14px 16px;\n  }\n}\n\n.p2p-payment-method-item.selected {\n  border-color: #FFFFFF60;\n}\n\n.p2p-payment-method-item.error {\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n.p2p-payment-method-item-text {\n  color: #fff;\n  font-size: 13px;\n}\n\n.p2p-payment-method-item input[type=\"checkbox\"] {\n  display: none;\n  accent-color: #303234 !important;\n}\n\n.p2p-payment-method-item.selected input[type=\"checkbox\"] {\n  display: block;\n}\n\n.p2p-add-method-button {\n  color: #fff;\n}\n\n.p2p-add-method-button:hover {\n  background-color: transparent;\n}\n\n@media (min-width: 768px) {\n  .p2p-payment-method-item-text {\n    font-size: 14px;\n    color: #A2A9B6;\n  }\n}\n\n.p2p-payment-method-error {\n  color: #ef4444;\n  font-size: 11px;\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n@media (min-width: 768px) {\n  .p2p-payment-method-error {\n    font-size: 12px;\n  }\n}\n\n.p2p-add-method-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 300;\n  color: #fff;\n  background: transparent;\n  border: none;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 8px 0;\n}\n\n@media (min-width: 768px) {\n  .p2p-add-method-button {\n    font-size: 14px;\n  }\n}\n\n.p2p-add-method-button-icon {\n  font-size: 18px;\n}\n\n/* Light Theme Payment Method Styles */\nbody.light_theme .p2p-payment-method-card {\n  background: #ececec;\n  border-color: #E0E0E0;\n}\n\nbody.light_theme .p2p-payment-method-btn.delete {\n  color: #ae4e4e;\n}\n\nbody.light_theme button.p2p-profile-edit-btn:hover {\n  background-color: transparent;\n  color: #9b9b9b;\n  ;\n}\n\nbody.light_theme .p2p-payment-method-card.selected {\n  border-color: #F4B609;\n  background: rgba(244, 182, 9, 0.1);\n}\n\nbody.light_theme .p2p-payment-method-name {\n  color: #F4B609;\n}\n\nbody.light_theme .p2p-payment-method-type-badge {\n  color: #aaa;\n  background: #E8E8E8;\n}\n\nbody.light_theme .p2p-payment-method-field-label {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-payment-method-field-value {\n  color: #333;\n}\n\nbody.light_theme .p2p-payment-method-qr-label {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-payment-methods-empty {\n  background: #f5f5f5;\n  border-color: #E0E0E0;\n  color: #aaa;\n}\n\nbody.light_theme .p2p-payment-method-item {\n  background: #f5f5f5;\n  border-color: #E0E0E0;\n}\n\nbody.light_theme .p2p-payment-method-item.selected {\n  border-color: #F4B609;\n  background: rgba(244, 182, 9, 0.1);\n}\n\nbody.light_theme .p2p-payment-method-item-text {\n  color: #333;\n}\n\n/* Step 3 Styles */\n.p2p-create-post-section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 16px;\n}\n\n@media (min-width: 768px) {\n  .p2p-create-post-section-title {\n    font-size: 16px;\n    margin-bottom: 20px;\n  }\n}\n\n.p2p-create-post-section-icon {\n  color: #F3BB2B;\n}\n\n.p2p-create-post-textarea {\n  width: 100%;\n  padding: 12px 14px;\n  background: #373F4D;\n  border: 1px solid #ffffff40;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 13px;\n  outline: none;\n  min-height: 80px;\n  resize: vertical;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  font-family: inherit;\n}\n\n@media (min-width: 768px) {\n  .p2p-create-post-textarea {\n    padding: 14px 16px;\n    font-size: 14px;\n    min-height: 130px;\n  }\n}\n\n.p2p-create-post-step3-section {\n  margin-top: 24px;\n}\n\n@media (min-width: 768px) {\n  .p2p-create-post-step3-section {\n    margin-top: 32px;\n  }\n}\n\n.p2p-create-post-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #ccc;\n  font-size: 13px;\n  cursor: pointer;\n  margin-bottom: 16px;\n}\n\n@media (min-width: 768px) {\n  .p2p-create-post-checkbox-label {\n    font-size: 14px;\n  }\n}\n\n.p2p-create-post-checkbox-label-wrap {\n  flex-wrap: wrap;\n}\n\n.p2p-create-post-checkbox-label-no-margin {\n  margin-bottom: 0;\n}\n\n.p2p-create-post-checkbox {\n  width: 18px;\n  height: 18px;\n  accent-color: #f3bb2b;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n@media (min-width: 768px) {\n  .p2p-create-post-checkbox {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.p2p-create-post-registered-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 0;\n  margin-top: 8px;\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n  .p2p-create-post-registered-input-wrapper {\n    margin-left: 8px;\n    margin-top: 0;\n    width: auto;\n  }\n}\n\n.p2p-create-post-registered-input {\n  width: 80px;\n  padding: 8px 12px;\n  background: #373F4D;\n  border: 1px solid #373F4D;\n  border-radius: 10px;\n  color: #a1a1a1;\n  text-align: center;\n  font-size: 13px;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.p2p-create-post-registered-input.error {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.p2p-create-post-registered-label {\n  color: #D0D0D0;\n  font-size: 13px;\n}\n\n.p2p-create-post-radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.p2p-create-post-radio-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n}\n\n.p2p-create-post-radio-input {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #D9D9D9;\n  background-color: #000 !important;\n  border-radius: 50%;\n  margin: 0;\n  margin-right: 12px;\n  position: relative;\n  cursor: pointer;\n  background-color: transparent;\n  transition: all 0.2s ease;\n}\n\n.p2p-create-post-radio-input:checked {\n  border-color: #fff;\n  background-color: transparent !important;\n}\n\n.p2p-create-post-step3-section .p2p-create-post-radio-group {\n  flex-direction: row;\n  gap: 48px;\n}\n\n.p2p-layout-wrapper .p2p-create-post-radio-input:focus {\n  border: 5px solid #ffffff !important;\n}\n\n.userprofile_pop .modal-content {\n  background-color: #373E4B;\n}\n\n.userprofile_pop ul.list_upi {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.userprofile_pop ul.list_upi li {\n  display: flex;\n  justify-content: space-between;\n  gap: 15px;\n  position: relative;\n  font-weight: 300;\n  font-size: 13px;\n  color: #ffffff9e;\n}\n\n.userprofile_pop ul.list_upi li span {\n  color: #fff;\n}\n\n.userprofile_pop ul.list_upi li span.text-danger {\n  color: #ef4444;\n}\n\n.userprofile_pop ul.list_upi li span.text-success {\n  color: #22c55e;\n}\n\n.userprofile_pop.btnnextback button {\n  background-color: #474D59;\n}\n\n.userprofile_pop ul.list_upi li::before {\n  position: absolute;\n  left: -15px;\n  top: 0px;\n  content: \"\";\n  width: 10px;\n}\n\n.p2p-create-post-radio-input:checked::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #222;\n}\n\n.p2p-create-post-radio-input:hover {\n  border-color: #999;\n}\n\n.p2p-create-post-radio-input:checked:hover {\n  border-color: #fff;\n}\n\n.p2p-create-post-radio-text {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.p2p-create-post-agreement-box {\n  background: #0d0d14;\n  border-radius: 10px;\n  padding: 12px;\n  margin-top: 16px;\n}\n\n@media (min-width: 768px) {\n  .p2p-create-post-agreement-box {\n    padding: 16px;\n  }\n}\n\n.p2p-create-post-agreement-text {\n  font-size: 12px;\n}\n\n@media (min-width: 768px) {\n  .p2p-create-post-agreement-text {\n    font-size: 14px;\n  }\n}\n\n.p2p-create-post-field-error {\n  color: #ef4444;\n  font-size: 11px;\n  margin-top: 4px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n@media (min-width: 768px) {\n  .p2p-create-post-field-error {\n    font-size: 12px;\n  }\n}\n\n.p2p-create-post-field-error-agreement {\n  margin-top: -12px;\n}\n\n.p2p-create-post-button-group {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n@media (min-width: 768px) {\n  .p2p-create-post-button-group {\n    margin-top: 32px;\n  }\n}\n\n.p2p-create-post-btn-secondary {\n  flex: 1;\n  padding: 12px 20px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-create-post-btn-secondary:hover {\n  background: #1a1a2a;\n  border-color: #3a3a4a;\n}\n\n.p2p-create-post-btn-primary {\n  flex: 1;\n  padding: 12px 20px;\n  background: #22c55e;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-create-post-btn-primary:hover {\n  background: #20b855;\n}\n\n.p2p-create-post-btn-primary-sell {\n  background: #ef4444;\n}\n\n.p2p-create-post-btn-primary-sell:hover {\n  background: #dc2626;\n}\n\n.p2p-create-post-btn-primary-buy {\n  background: #22c55e;\n}\n\n.p2p-create-post-btn-primary-buy:hover {\n  background: #20b855;\n}\n\n/* Light Theme Step 3 Styles */\nbody.light_theme .p2p-create-post-section-title {\n  color: #333;\n}\n\nbody.light_theme .p2p-create-post-section-icon {\n  color: #F4B609;\n}\n\nbody.light_theme .p2p-create-post-textarea {\n  background: #f5f5f5;\n  border-color: #E0E0E0;\n  color: #333;\n}\n\nbody.light_theme .p2p-create-post-checkbox-label {\n  color: #333;\n}\n\nbody.light_theme .p2p-create-post-registered-input {\n  background: #f5f5f5;\n  border-color: #E0E0E0;\n  color: #333;\n}\n\nbody.light_theme .p2p-create-post-registered-label {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-create-post-radio-input {\n  border-color: #ccc;\n}\n\nbody.light_theme .p2p-create-post-radio-input:checked {\n  border-color: #333;\n}\n\nbody.light_theme .p2p-create-post-radio-input:checked::after {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .p2p-create-post-radio-text {\n  color: #333;\n}\n\nbody.light_theme .p2p-create-post-agreement-box {\n  background: #f5f5f5;\n}\n\nbody.light_theme .p2p-create-post-btn-secondary {\n  background: #f5f5f5;\n  border-color: #E0E0E0;\n  color: #333;\n}\n\nbody.light_theme .p2p-create-post-btn-secondary:hover {\n  background: #E8E8E8;\n}\n\n/* P2P My Ads Table Styles */\n.p2p-orders-table td {\n  padding: 12px 10px;\n}\n\n.p2p-orders-table td.p2p-myads-actions-cell {\n  text-align: right;\n}\n\n.p2p-row-expanded {\n  background: rgba(255, 220, 136, 0.03) !important;\n}\n\n.p2p-myads-asset-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-myads-side-badge {\n  padding: 5px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.p2p-myads-asset-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-myads-asset-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-myads-table-cell-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-myads-table-cell-content-gap {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.p2p-myads-price-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e5e5e5;\n}\n\n.p2p-myads-volume-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-myads-limits-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-payment-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.p2p-payment-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.2);\n}\n\n.p2p-payment-badge-count {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  background: #5EBA8920;\n  color: #9ca3af;\n  border: 1px solid rgba(107, 114, 128, 0.2);\n}\n\n.p2p-myads-status-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.p2p-myads-status {\n  font-size: 13px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.05);\n  display: inline-block;\n}\n\n.p2p-myads-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.p2p-myads-action-btn {\n  padding: 3px 12px;\n  min-height: 24px;\n  border-radius: 6px;\n  font-weight: 500;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  color: #a1a1aa;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.p2p-myads-action-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.15);\n  color: #e5e5e5;\n}\n\n.p2p-myads-action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.p2p-myads-action-btn-view {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.p2p-myads-action-btn-view.active {\n  background: rgba(255, 220, 136, 0.2);\n}\n\n.p2p-myads-action-btn-view:hover {\n  background: rgba(255, 220, 136, 0.15);\n  border-color: rgba(255, 220, 136, 0.3);\n  color: #e5e5e5;\n}\n\n.p2p-myads-action-btn-view.active:hover {\n  background: rgba(255, 220, 136, 0.2);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.p2p-myads-action-btn-close {\n  background: rgba(239, 68, 68, 0.1);\n  border-color: rgba(239, 68, 68, 0.2);\n}\n\n.p2p-myads-action-btn-close:hover {\n  background: rgba(239, 68, 68, 0.15);\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.p2p-myads-action-btn-icon {\n  font-size: 14px;\n}\n\n.p2p-myads-action-btn-icon-online {\n  color: #4ade80;\n}\n\n/* Expanded Row Styles */\n.p2p-myads-expanded-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.p2p-myads-expanded-section {\n  margin-bottom: 20px;\n}\n\n.p2p-myads-expanded-title {\n  margin-bottom: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-myads-expanded-title-count {\n  font-size: 12px;\n  color: #6b7280;\n  margin-left: 6px;\n  font-weight: 400;\n}\n\n.p2p-myads-expanded-content-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.p2p-myads-expanded-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 8px;\n}\n\n.p2p-myads-expanded-item-label {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.p2p-myads-expanded-item-value {\n  font-size: 14px;\n  color: #e5e5e5;\n  font-weight: 500;\n}\n\n.p2p-myads-expanded-item-value-small {\n  font-size: 12px;\n  color: #e5e5e5;\n  font-family: monospace;\n}\n\n.p2p-myads-fee-value {\n  color: #F3BB2B;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.p2p-orders-fee-value {\n  color: #F3BB2B;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.p2p-myads-expanded-payments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.p2p-payment-badge-expanded {\n  font-size: 12px;\n  padding: 6px 10px;\n}\n\n.p2p-myads-expanded-section-border {\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.p2p-myads-expanded-title-large {\n  margin-bottom: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-myads-online-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.p2p-myads-online-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.p2p-myads-online-badge.online .p2p-myads-online-dot {\n  background: #4ade80;\n}\n\n.p2p-myads-online-badge.offline .p2p-myads-online-dot {\n  background: #6b7280;\n}\n\n/* Light Theme Table Styles */\nbody.light_theme .p2p-myads-asset-name {\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-price-text,\nbody.light_theme .p2p-myads-volume-text,\nbody.light_theme .p2p-myads-limits-text {\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-status {\n  background: rgba(0, 0, 0, 0.05);\n}\n\nbody.light_theme .p2p-myads-action-btn {\n  background: rgba(0, 0, 0, 0.04);\n  border-color: rgba(0, 0, 0, 0.1);\n  color: #aaa;\n}\n\nbody.light_theme .p2p-myads-action-btn:hover {\n  background: rgba(0, 0, 0, 0.08);\n  border-color: rgba(0, 0, 0, 0.15);\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-action-btn-view.active {\n  background: rgba(244, 182, 9, 0.2);\n}\n\nbody.light_theme .p2p-myads-action-btn-view:hover {\n  background: rgba(244, 182, 9, 0.15);\n  border-color: rgba(244, 182, 9, 0.3);\n}\n\nbody.light_theme .p2p-myads-expanded-title {\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-expanded-item {\n  background: rgba(0, 0, 0, 0.03);\n}\n\nbody.light_theme .p2p-myads-expanded-item-label {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-myads-expanded-item-value {\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-expanded-item-value-small {\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-expanded-section-border {\n  border-top-color: rgba(0, 0, 0, 0.1);\n}\n\nbody.light_theme .p2p-row-expanded {\n  background: rgba(244, 182, 9, 0.03) !important;\n}\n\n@media (max-width: 1200px) {\n\n  .p2p-create-post-container {\n    grid-template-columns: 1fr 80px;\n  }\n\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  }\n\n\n}\n\n\n@media (max-width:767px) {\n\n  .payment_method_pop.modal.fade .modal-dialog {\n    min-width: 100%;\n  }\n\n  .userprofile_pop ul.list_upi li {\n    font-size: 12px;\n  }\n\n  .userprofile_pop ul.list_upi {\n    gap: 10px;\n  }\n\n  .p2p-create-post-container {\n    grid-template-columns: 1fr 0px;\n    gap: 0px;\n  }\n\n  .p2p-payment-method-item {\n    margin-bottom: 5px;\n    padding: 8px 12px;\n  }\n\n  .pricehigh_box_item_title {\n    font-size: 18px;\n  }\n\n  .pricehigh_box_item_title span {\n    font-size: 10px;\n  }\n\n\n  .btnnextback button {\n    font-size: 13px;\n    padding: 10px 15px;\n  }\n\n  .p2p-profile-container .p2p-profile-header {\n    padding: 20px;\n  }\n\n  .p2p-profile-tabs.paymentprofiletabs {\n    padding: 0px 15px 20px;\n  }\n\n  .rightalien {\n    text-align: center;\n  }\n\n  .p2p-profile-container .p2p-empty-state-card i {\n    font-size: 26px;\n  }\n\n  .p2p-profile-name {\n    font-size: 18px;\n  }\n\n  .p2p-myads-stat-card {\n    border-right: none;\n    padding: 10px 5px;\n  }\n\n  .p2p-empty-state-mobile {\n    margin: 0px;\n  }\n\n  .p2p-empty-state-mobile .p2p-create-ad-btn-small {\n    padding: 10px 24px;\n    font-size: 12px;\n    margin: 0 auto;\n  }\n\n  .p2p-filter-section.myadsfillter {\n    background: #3f4856;\n    padding: 20px;\n  }\n\n}\n\n@media (max-width: 767px) {\n  .p2p-create-post-title {\n    font-size: 18px;\n  }\n\n  .p2p-create-post-radio-text {\n    font-size: 12px;\n  }\n\n  .p2p-create-post-radio-input {\n    width: 16px;\n    height: 16px;\n  }\n\n}\n\n\n@media (max-width: 660px) {\n\n  .pricehigh_box_item_title {\n    font-size: 18px;\n  }\n\n  .pricehigh_box_item_title span {\n    font-size: 10px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 13px;\n  }\n\n  .p2p-profile-container .p2p-myads-stats-grid {\n    gap: 10px;\n    padding: 10px 15px;\n  }\n\n  .p2p-profile-container .p2p-myads-stat-card-label {\n    font-size: 11px;\n    text-align: left;\n    padding-bottom: 0px;\n    margin-bottom: 0px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 11px;\n  }\n\n\n  .pricehigh_box {\n    padding: 15px;\n    margin-top: 15px;\n    align-items: start;\n    gap: 12px;\n    flex-direction: column;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
